import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Attribute value custom scalar type */
  AttributeValue: any;
  AttributeValueType: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: Date | string;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: Date | string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

/** A reporting attribute filter: the attribute, and the values selected on it. */
export type AiSummaryAttributeFilterInput = {
  id: Scalars['Int'];
  values: Array<Scalars['String']>;
};

/**
 * The reporting filters a summary was generated under. Only filters that change which responses are
 * summarized belong here — comparison selections leave the summarized data set untouched.
 */
export type AiSummaryFiltersInput = {
  attributes?: InputMaybe<Array<AiSummaryAttributeFilterInput>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  /** The reporting window a continuous survey is being viewed through. */
  timeframe?: InputMaybe<AiSummaryTimeframeInput>;
};

export type AiSummaryTimeframeInput = {
  endTimeUTC: Scalars['DateTime'];
  startTimeUTC: Scalars['DateTime'];
};

export type AiSurveySummary = {
  __typename?: 'AISurveySummary';
  areasOfOpportunity?: Maybe<Scalars['String']>;
  areasToWatch?: Maybe<Scalars['String']>;
  commentsSummary?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  errorText?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  participationRate?: Maybe<Scalars['String']>;
  qualitativeFeedback?: Maybe<Scalars['String']>;
  recommendedActions?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  strengths?: Maybe<Scalars['String']>;
  surveyShortSummary?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

/**
 * Read-only payload returned to the account-activation page for an invited
 * user. Used to greet the invitee and render the right language + SSO
 * treatment before they set a password.
 */
export type ActivationUser = {
  __typename?: 'ActivationUser';
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** True if the invitee's company has SSO configured — sign them in via SSO rather than asking for a password. */
  hasSSO?: Maybe<Scalars['Boolean']>;
  /** ISO language code of the invitee's preferred language (e.g. `en-ca`). */
  langISOCode?: Maybe<Scalars['String']>;
  preferredLanguageId?: Maybe<Scalars['Int']>;
};

/** Input for adding one or more employees to a messaging channel's do-not-contact list. */
export type AddEmployeeChannelToDoNotContactListInput = {
  channel: MessagingChannel;
  /** Database IDs (NOT HRIS employee ids) of the employees to opt out. */
  employeeIds: Array<Scalars['ID']>;
  /** Why these employees are being opted out. Recorded against every entry. */
  reason: Scalars['String'];
};

/** Stand for employee detail required by admin line by line export */
export type AdminSurveyEmployee = {
  __typename?: 'AdminSurveyEmployee';
  accessHash?: Maybe<Scalars['String']>;
  attributes?: Maybe<Array<Maybe<AdminSurveyEmployeeAttribute>>>;
  completed?: Maybe<Scalars['Boolean']>;
  inviteDate?: Maybe<Scalars['String']>;
  optionsQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeOptions>>>;
  scaleQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeScale>>>;
  snapshotId?: Maybe<Scalars['Int']>;
  surveyId?: Maybe<Scalars['Int']>;
  textQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeText>>>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** Stand for employee detail attributes required by admin line by line export */
export type AdminSurveyEmployeeAttribute = {
  __typename?: 'AdminSurveyEmployeeAttribute';
  attributeId?: Maybe<Scalars['Int']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['String']>;
};

/** Stand for employee detail options questions required by admin line by line export */
export type AdminSurveyEmployeeOptions = {
  __typename?: 'AdminSurveyEmployeeOptions';
  categoryName?: Maybe<Scalars['String']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  optionsQuestionAnswer?: Maybe<Scalars['String']>;
  optionsQuestionComment?: Maybe<Scalars['String']>;
  optionsQuestionId?: Maybe<Scalars['Int']>;
  optionsQuestionSentiment?: Maybe<Scalars['String']>;
  optionsQuestionText?: Maybe<Scalars['String']>;
  surveyElementId?: Maybe<Scalars['Int']>;
};

/** Stand for employee detail scale questions required by admin line by line export */
export type AdminSurveyEmployeeScale = {
  __typename?: 'AdminSurveyEmployeeScale';
  categoryName?: Maybe<Scalars['String']>;
  hasComment?: Maybe<Scalars['Boolean']>;
  scaleQuestionAnswer?: Maybe<Scalars['Int']>;
  scaleQuestionComment?: Maybe<Scalars['String']>;
  scaleQuestionId?: Maybe<Scalars['Int']>;
  scaleQuestionSentiment?: Maybe<Scalars['String']>;
  scaleQuestionText?: Maybe<Scalars['String']>;
  surveyElementId?: Maybe<Scalars['Int']>;
};

/** Stand for employee detail text questions required by admin line by line export */
export type AdminSurveyEmployeeText = {
  __typename?: 'AdminSurveyEmployeeText';
  categoryName?: Maybe<Scalars['String']>;
  textQuestionAnswer?: Maybe<Scalars['String']>;
  textQuestionId?: Maybe<Scalars['Int']>;
  textQuestionText?: Maybe<Scalars['String']>;
};

/** Represents one point(X,Y) for the chart result for aggregated trends, Reporting ->  Trends Tab */
export type AggregatedTrendDataset = {
  __typename?: 'AggregatedTrendDataset';
  count?: Maybe<Scalars['Float']>;
  countDetractors?: Maybe<Scalars['Float']>;
  countFavorable?: Maybe<Scalars['Float']>;
  countNeutral?: Maybe<Scalars['Float']>;
  countPassives?: Maybe<Scalars['Float']>;
  countPromoters?: Maybe<Scalars['Float']>;
  countUnfavorable?: Maybe<Scalars['Float']>;
  enpsScore?: Maybe<Scalars['Float']>;
  ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  label?: Maybe<Scalars['String']>;
  percentDetractors?: Maybe<Scalars['Float']>;
  percentFavorable?: Maybe<Scalars['Float']>;
  percentNeutral?: Maybe<Scalars['Float']>;
  percentPassives?: Maybe<Scalars['Float']>;
  percentPromoters?: Maybe<Scalars['Float']>;
  percentUnfavorable?: Maybe<Scalars['Float']>;
  scoreAverage?: Maybe<Scalars['Float']>;
};

/** list of stats results representing a factor or a question for aggregated trends, Reporting ->  Trends Tab */
export type AggregatedTrendDatasetCollection = {
  __typename?: 'AggregatedTrendDatasetCollection';
  datasets?: Maybe<Array<Maybe<AggregatedTrendDataset>>>;
  factorId?: Maybe<Scalars['Int']>;
  factorName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Collection of factors and questions for aggregated trends, Reporting ->  Trends Tab */
export type AggregatedTrendResult = {
  __typename?: 'AggregatedTrendResult';
  factors?: Maybe<Array<Maybe<AggregatedTrendDatasetCollection>>>;
  questions?: Maybe<Array<Maybe<AggregatedTrendDatasetCollection>>>;
};

export type AssociatedAttribute = {
  __typename?: 'AssociatedAttribute';
  id?: Maybe<Scalars['Int']>;
  names?: Maybe<Scalars['JSON']>;
};

export type AssociatedQuestion = {
  __typename?: 'AssociatedQuestion';
  questionId: Scalars['Int'];
  questionText: Scalars['String'];
  surveyCount: Scalars['Int'];
  surveyYears: Array<Maybe<Scalars['Int']>>;
};

/** This represents the details of the Attribute model */
export type Attribute = {
  __typename?: 'Attribute';
  attributeNames?: Maybe<Array<Maybe<AttributeName>>>;
  baseAttributeId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isPhone?: Maybe<Scalars['Boolean']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  isReportingAttribute?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  isUnique?: Maybe<Scalars['Boolean']>;
  type?: Maybe<AttributeType>;
  updated?: Maybe<Scalars['String']>;
};

/**
 * The users and roles whose permissions would be impacted by archiving an attribute.
 * Each entry lists which permission categories would be emptied for that user or role.
 */
export type AttributeArchiveImpact = {
  __typename?: 'AttributeArchiveImpact';
  affectedRoles: Array<AttributeArchiveImpactEntry>;
  affectedUsers: Array<AttributeArchiveImpactEntry>;
};

/** A category of attribute-based permission that could be emptied by archiving an attribute. */
export enum AttributeArchiveImpactBucket {
  /** Controls which attributes a user can compare survey results against. */
  Compare = 'COMPARE',
  /** Controls which attributes scope the data a user can access. */
  Dataset = 'DATASET',
  /** Controls which attributes a user can see in survey results. */
  Visible = 'VISIBLE'
}

/**
 * A single affected user or role, scoped to one survey type, along with the
 * permission categories that would be emptied by the archive.
 */
export type AttributeArchiveImpactEntry = {
  __typename?: 'AttributeArchiveImpactEntry';
  /** The permission categories that would have zero attributes left after the archive. */
  emptiedBuckets: Array<AttributeArchiveImpactBucket>;
  id: Scalars['Int'];
  name: Scalars['String'];
  surveyTypeId: Scalars['Int'];
  surveyTypeName: Scalars['String'];
};

/** AttributeFilterValues */
export type AttributeFilterValues = {
  __typename?: 'AttributeFilterValues';
  anonymized?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  nCount?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Send back data about attributeNames and Values available for filtering */
export type AttributeFilters = {
  __typename?: 'AttributeFilters';
  attributes?: Maybe<Array<Maybe<FilterAttributes>>>;
};

/** input for Attribute model */
export type AttributeInput = {
  baseAttributeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  isPhone?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isReportingAttribute?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  names: Array<InputMaybe<AttributeNameInput>>;
  type: AttributeTypeInput;
};

export type AttributeName = {
  __typename?: 'AttributeName';
  attributeId: Scalars['Int'];
  companyId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Language>;
  languageId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export enum AttributeNameActionEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** input for AttributeName model */
export type AttributeNameInput = {
  language: LanguageInput;
  name: Scalars['String'];
};

/** input for AttributeName model */
export type AttributeNameUpdateInput = {
  action?: InputMaybe<AttributeNameActionEnum>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<LanguageInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** Searching Input for Attribute model */
export type AttributeSearchInput = {
  baseAttributeId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<InputMaybe<AttributeNameInput>>>;
  type?: InputMaybe<AttributeTypeInput>;
};

export type AttributeToBenchmarkAttribute = {
  __typename?: 'AttributeToBenchmarkAttribute';
  attributeId: Scalars['Int'];
  benchmarkAttributeId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  names?: Maybe<Scalars['JSON']>;
  updated: Scalars['DateTime'];
};

/** This represents the details of the AttributeType model */
export type AttributeType = {
  __typename?: 'AttributeType';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

export enum AttributeTypeEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Email = 'EMAIL',
  Number = 'NUMBER',
  String = 'STRING'
}

/** input for AttributeName model */
export type AttributeTypeInput = {
  name: Scalars['String'];
};

/** searching Input for Attribute model */
export type AttributeUpdateInput = {
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPhone?: InputMaybe<Scalars['Boolean']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  isReportingAttribute?: InputMaybe<Scalars['Boolean']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<InputMaybe<AttributeNameUpdateInput>>>;
};

/** Attribute value item for Responses Rates Tab */
export type AttributeValueResponseRatesStatistics = {
  __typename?: 'AttributeValueResponseRatesStatistics';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AttributeValuesSearchInput = {
  id: Scalars['Int'];
  type?: InputMaybe<AttributeTypeEnum>;
  values: Array<InputMaybe<Scalars['AttributeValue']>>;
};

/** Attribute input with id and values */
export type AttributeWithValueInput = {
  id: Scalars['Int'];
  values: Array<InputMaybe<Scalars['AttributeValueType']>>;
};

/** Searching attribute input with values */
export type AttributeWithValuesSearchInput = {
  id: Scalars['Int'];
  type: AttributeTypeEnum;
  values: Array<InputMaybe<Scalars['AttributeValueType']>>;
};

/** Search Input for the query attributesRatingResponsesInput */
export type AttributesRatingResponsesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  skipUserPermission?: InputMaybe<Scalars['Boolean']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};

export type AttributesWithValueUpdateInput = {
  action?: InputMaybe<UpdateActions>;
  id: Scalars['Int'];
  type: AttributeTypeEnum;
  value?: InputMaybe<Scalars['AttributeValue']>;
};

export type AutomaticSurveyReminderInput = {
  automaticSurveyReminderLanguages: Array<AutomaticSurveyReminderLanguageInput>;
  id?: InputMaybe<Scalars['Int']>;
  reminderFrequencyDays: Scalars['Int'];
  sendTime: Scalars['String'];
  status: Scalars['String'];
  surveyId: Scalars['Int'];
};

export type AutomaticSurveyReminderLanguageInput = {
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
  languageId: Scalars['Int'];
};

export type BaseSurveyType = {
  __typename?: 'BaseSurveyType';
  id: Scalars['Int'];
  surveyTypeNames: Array<SurveyTypeNames>;
  threshold: Scalars['Int'];
};

export type Benchmark = {
  __typename?: 'Benchmark';
  averageScore?: Maybe<Scalars['Float']>;
  benchmarkPeriod: Scalars['String'];
  benchmarkQuestionId: Scalars['Int'];
  companiesCount: Scalars['Int'];
  countryValueId?: Maybe<Scalars['Int']>;
  detractor?: Maybe<Scalars['Float']>;
  eNPSScore?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  industryValueId?: Maybe<Scalars['Int']>;
  negativePercent?: Maybe<Scalars['Float']>;
  neutralPercent?: Maybe<Scalars['Float']>;
  passive?: Maybe<Scalars['Float']>;
  positivePercent?: Maybe<Scalars['Float']>;
  promoter?: Maybe<Scalars['Float']>;
  questionId: Scalars['Int'];
  regionValueId?: Maybe<Scalars['Int']>;
  scope: BenchmarkScope;
  sectorValueId?: Maybe<Scalars['Int']>;
  sizeValueId?: Maybe<Scalars['Int']>;
  surveyType: Scalars['String'];
  totalCount: Scalars['Int'];
};

export type BenchmarkAttribute = {
  __typename?: 'BenchmarkAttribute';
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  lastRefreshed?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  translationKey: Scalars['String'];
  updated: Scalars['DateTime'];
  values?: Maybe<Array<BenchmarkAttributeValue>>;
};

export type BenchmarkAttributeSetting = {
  __typename?: 'BenchmarkAttributeSetting';
  benchmarkAttributeId: Scalars['Int'];
  benchmarkAttributeName: Scalars['String'];
  defaultValueId: Scalars['Int'];
  defaultValueName: Scalars['String'];
};

export type BenchmarkAttributeValue = {
  __typename?: 'BenchmarkAttributeValue';
  altNames: Array<Maybe<Scalars['String']>>;
  benchmarkAttributeId: Scalars['Int'];
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type BenchmarkAttributeValueAltName = {
  __typename?: 'BenchmarkAttributeValueAltName';
  benchmarkAttributeValueId: Scalars['Int'];
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  updated: Scalars['DateTime'];
};

export type BenchmarkAttributeValueHierarchy = {
  __typename?: 'BenchmarkAttributeValueHierarchy';
  childAttributeValueId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  parentAttributeValueId: Scalars['Int'];
  updated: Scalars['DateTime'];
};

export type BenchmarkInput = {
  benchmarkAttributeValueIds: ValueIds;
  benchmarkPeriod: Scalars['String'];
  questionIds: Array<Scalars['Int']>;
  scope: BenchmarkScope;
  surveyId: Scalars['Int'];
};

export type BenchmarkQuestion = {
  __typename?: 'BenchmarkQuestion';
  questionId: Scalars['Int'];
  questionText: Scalars['String'];
  surveyCount: Scalars['Int'];
  surveyYears: Array<Maybe<Scalars['Int']>>;
  taggedQuestionCount: Scalars['Int'];
};

export enum BenchmarkScope {
  All = 'ALL',
  Top25 = 'TOP25'
}

/** Search Input for the query categoriesAndQuestionScaleRatingResponses */
export type CategoriesAndQuestionScaleRatingResponsesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  calculateAttribute?: Scalars['Boolean'];
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};

export type Category = {
  __typename?: 'Category';
  categoryNames?: Maybe<Array<Maybe<CategoryName>>>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isBaseCategory?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
};

export type CategoryIdInput = {
  id: Scalars['Int'];
};

/** This represents the question categories */
export type CategoryInput = {
  isBaseCategory?: InputMaybe<Scalars['Boolean']>;
  names: Array<InputMaybe<CategoryNameInput>>;
};

export type CategoryLanguageInput = {
  languageId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** This represents the details of the CategoryName model */
export type CategoryName = {
  __typename?: 'CategoryName';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Language>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

/** This represents the question categories names per language */
export type CategoryNameInput = {
  language: LanguageInput;
  name: Scalars['String'];
};

/** input for AttributeName model */
export type CategoryNameUpdateInput = {
  action?: InputMaybe<UpdateActionsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<LanguageInput>;
  name?: InputMaybe<Scalars['String']>;
};

/** This represents the question categories */
export type CategoryUpdateInput = {
  isBaseCategory?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<InputMaybe<CategoryNameUpdateInput>>>;
};

export type CoachCommentsInput = {
  attributes?: InputMaybe<Array<AttributeValuesSearchInput>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<Scalars['String']>>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyElementIds?: InputMaybe<Array<Scalars['Int']>>;
  surveyIds: Array<Scalars['Int']>;
};

export type Comment = {
  __typename?: 'Comment';
  anonymousConversation?: Maybe<Scalars['Boolean']>;
  conversationId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  employeeResponseQuestionOptionsId?: Maybe<Scalars['Int']>;
  employeeResponseQuestionScaleId?: Maybe<Scalars['Int']>;
  employeeResponseQuestionTextId?: Maybe<Scalars['Int']>;
  greatIdea?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  like?: Maybe<Scalars['Int']>;
  reactedGreatIdea?: Maybe<Scalars['Boolean']>;
  reactedLike?: Maybe<Scalars['Boolean']>;
  reactedWorkingOnIt?: Maybe<Scalars['Boolean']>;
  sentiment?: Maybe<Scalars['String']>;
  surveyTypeId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  themes?: Maybe<Array<Maybe<Theme>>>;
  workingOnIt?: Maybe<Scalars['Int']>;
};

export type CommentAnalysis = {
  __typename?: 'CommentAnalysis';
  changedByUserId?: Maybe<Scalars['Int']>;
  confidence?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  sentiment?: Maybe<Scalars['String']>;
  sentimentProvider?: Maybe<Scalars['String']>;
  snapshotId: Scalars['Int'];
  surveyElementId: Scalars['Int'];
  theme?: Maybe<Scalars['String']>;
};

export type CommentSortInput = {
  column?: InputMaybe<Scalars['String']>;
  order: Scalars['String'];
};

export type CommentWithThemes = {
  __typename?: 'CommentWithThemes';
  commentId: Scalars['Int'];
  themes?: Maybe<Array<Maybe<Theme>>>;
};

export type Comments = {
  __typename?: 'Comments';
  commentCount: Scalars['Int'];
  comments: Array<Maybe<Comment>>;
  surveyElementId?: Maybe<Scalars['Int']>;
};

export type CommentsAnalysisInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
};

export type CommentsInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  entityFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  questionId: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sort?: InputMaybe<CommentSortInput>;
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
  themeFilter?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CommentsSummary = {
  __typename?: 'CommentsSummary';
  created: Scalars['String'];
  id: Scalars['Int'];
  languageId: Scalars['Int'];
  negativeSummary?: Maybe<Scalars['String']>;
  overallSummary?: Maybe<Scalars['String']>;
  positiveSummary?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Scalars['String']>;
  surveyElementId: Scalars['Int'];
};

export type CommentsSummaryInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
};

export type CommentsWithThemes = {
  __typename?: 'CommentsWithThemes';
  commentsWithThemes: Array<Maybe<CommentWithThemes>>;
  surveyElementId: Scalars['Int'];
  themes?: Maybe<Array<Maybe<ThemeWithCount>>>;
};

export type CommonInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  questionId: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
};

/**
 * Company entity — full definition lives in the legacy schema. Declared here
 * as a minimal stub so the user SDL can reference it as a field type; all
 * Company fields are resolved via the `companyById` stitch merge config.
 */
export type Company = {
  __typename?: 'Company';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  categories?: Maybe<Array<Maybe<Category>>>;
  companyFeatureSettings?: Maybe<CompanyFeatureSettings>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Maybe<Employee>>>;
  excludeFinalSubmitButton?: Maybe<Scalars['Boolean']>;
  hasSso?: Maybe<Scalars['Boolean']>;
  icons?: Maybe<Array<Maybe<Icon>>>;
  id?: Maybe<Scalars['Int']>;
  industry?: Maybe<Scalars['String']>;
  isDemoAccount?: Maybe<Scalars['Boolean']>;
  kioskAttributeId?: Maybe<Scalars['Int']>;
  kioskId?: Maybe<Scalars['String']>;
  kioskSubdomain?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  logoFileName?: Maybe<Scalars['String']>;
  minimumResultsRequired?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  preferredLanguage?: Maybe<Language>;
  preferredTimezone?: Maybe<Timezone>;
  region?: Maybe<Scalars['String']>;
  regressionEnabled?: Maybe<Scalars['Boolean']>;
  reportingAverageOn?: Maybe<Scalars['Boolean']>;
  reportingDistributionOn?: Maybe<Scalars['Boolean']>;
  reportingEngagementRatioOn?: Maybe<Scalars['Boolean']>;
  reportingNpsOn?: Maybe<Scalars['Boolean']>;
  reportingPercentPositiveOn?: Maybe<Scalars['Boolean']>;
  salesforceId?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  sendingDomains?: Maybe<Array<Maybe<SendingDomain>>>;
  surveyTimeoutMs?: Maybe<Scalars['Int']>;
  surveyTypes?: Maybe<Array<Maybe<SurveyType>>>;
  surveys?: Maybe<Array<Maybe<Survey>>>;
  timezones?: Maybe<Array<Maybe<Timezone>>>;
  topbarColorHex?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
  workspace?: Maybe<Scalars['String']>;
};

/** This represents the details of the Company-Attribute pair along with the attribute values */
export type CompanyAttributeValues = {
  __typename?: 'CompanyAttributeValues';
  attribute?: Maybe<Attribute>;
  attributeValues?: Maybe<Array<Maybe<Scalars['AttributeValueType']>>>;
  company?: Maybe<Company>;
};

export type CompanyBenchmarkAttributeValue = {
  __typename?: 'CompanyBenchmarkAttributeValue';
  benchmarkAttributeId: Scalars['Int'];
  benchmarkAttributeValueId: Scalars['Int'];
  companyId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  ungroupedValue?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
};

export type CompanyBenchmarkSetting = {
  __typename?: 'CompanyBenchmarkSetting';
  associatedAttribute?: Maybe<AssociatedAttribute>;
  benchmarkAttributeId: Scalars['Int'];
  companyId: Scalars['Int'];
  companyName: Scalars['String'];
  defaultValue?: Maybe<BenchmarkAttributeValue>;
  ungroupedValue?: Maybe<Scalars['String']>;
};

export type CompanyBenchmarkSettings = {
  __typename?: 'CompanyBenchmarkSettings';
  benchmarkAttributes: Array<Maybe<BenchmarkAttributeSetting>>;
  companyId: Scalars['Int'];
};

/** This represents the details of the Company brand information */
export type CompanyBrand = {
  __typename?: 'CompanyBrand';
  id?: Maybe<Scalars['Int']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  logoFileName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preferredTimezone?: Maybe<Timezone>;
  timezones?: Maybe<Array<Maybe<Timezone>>>;
  topbarColorHex?: Maybe<Scalars['String']>;
};

/** This represents the details of the Company configurable details */
export type CompanyConfigDetails = {
  __typename?: 'CompanyConfigDetails';
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  id?: Maybe<Scalars['Int']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  name?: Maybe<Scalars['String']>;
  preferredLanguage?: Maybe<Language>;
  sendingDomains?: Maybe<Array<Maybe<SendingDomain>>>;
  surveyTypes?: Maybe<Array<Maybe<SurveyType>>>;
  timezones?: Maybe<Array<Maybe<Timezone>>>;
};

/**
 * Per-company configuration flags that are plain admin settings, not DevCycle
 * feature flags. Named distinctly from the legacy schema's Company and
 * CompanyFeatureSettings types on purpose: reusing either name would make this
 * a cross-schema merged type, and merging a field onto a type that already
 * exists (by name) in the legacy schema silently fails to resolve — the legacy
 * schema's own version of the field wins and this schema's addition is never
 * reached, since GraphQL type merging resolves a shared field name from a
 * single source rather than recursing into it. A distinct type name sidesteps
 * that entirely.
 */
export type CompanyConfigs = {
  __typename?: 'CompanyConfigs';
  companyId: Scalars['Int'];
  /** Controls whether Shared Link (Open Survey) audience mode can be used to create new surveys for this company. Does not affect surveys already created. */
  openSurveysEnabled?: Maybe<Scalars['Boolean']>;
};

/** This represents the toggle settings of all company features */
export type CompanyFeatureSettings = {
  __typename?: 'CompanyFeatureSettings';
  COMMENT_SENTIMENT_AND_SUMMARY?: Maybe<Scalars['Boolean']>;
};

/** Input for Company */
export type CompanyInput = {
  excludeFinalSubmitButton?: InputMaybe<Scalars['Boolean']>;
  isDemoAccount?: InputMaybe<Scalars['Boolean']>;
  kioskId?: InputMaybe<Scalars['String']>;
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoFileName?: InputMaybe<Scalars['String']>;
  minimumResultsRequired?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  preferredLanguage: LanguageInput;
  preferredTimezone: TimezoneInput;
  regressionEnabled?: InputMaybe<Scalars['Boolean']>;
  reportingAverageOn?: InputMaybe<Scalars['Boolean']>;
  reportingDistributionOn?: InputMaybe<Scalars['Boolean']>;
  reportingEngagementRatioOn?: InputMaybe<Scalars['Boolean']>;
  reportingNpsOn?: InputMaybe<Scalars['Boolean']>;
  reportingPercentPositiveOn?: InputMaybe<Scalars['Boolean']>;
  surveyTimeoutMs?: InputMaybe<Scalars['Int']>;
  surveyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  timezoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  topbarColorHex?: InputMaybe<Scalars['String']>;
};

/**
 * Non-secret view of a company's messaging configuration for a single channel.
 * Credentials (configJson) are NEVER exposed through the API.
 *
 * Managed by company admins (COMPANY_CONFIGURATION) or super admins; sendTestSms is super-admin only.
 */
export type CompanyMessagingConfig = {
  __typename?: 'CompanyMessagingConfig';
  channel: MessagingChannel;
  companyId: Scalars['Int'];
  created?: Maybe<Scalars['DateTime']>;
  /** Admin pause/resume gate — when false, the channel is configured but won't send. */
  enabled: Scalars['Boolean'];
  /** Whether the channel has the credentials it needs to send (always true for SMS, which uses env-level Twilio config). */
  isConnected: Scalars['Boolean'];
  updated?: Maybe<Scalars['DateTime']>;
};

/** Search Input for Company */
export type CompanySearchInput = {
  excludeFinalSubmitButton?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isDemoAccount?: InputMaybe<Scalars['Boolean']>;
  kioskId?: InputMaybe<Scalars['String']>;
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  logoFileName?: InputMaybe<Scalars['String']>;
  minimumResultsRequired?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<LanguageSearchInput>;
  preferredTimezone?: InputMaybe<TimezoneSearchInput>;
  regressionEnabled?: InputMaybe<Scalars['Boolean']>;
  reportingAverageOn?: InputMaybe<Scalars['Boolean']>;
  reportingDistributionOn?: InputMaybe<Scalars['Boolean']>;
  reportingEngagementRatioOn?: InputMaybe<Scalars['Boolean']>;
  reportingNpsOn?: InputMaybe<Scalars['Boolean']>;
  reportingPercentPositiveOn?: InputMaybe<Scalars['Boolean']>;
  surveyTimeoutMs?: InputMaybe<Scalars['Int']>;
  surveyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  timezoneIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  topbarColorHex?: InputMaybe<Scalars['String']>;
};

/** This represents the details of the Company-SurveyType pair */
export type CompanySurveyType = {
  __typename?: 'CompanySurveyType';
  categories?: Maybe<Array<Maybe<CompanySurveyTypeCategory>>>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  names?: Maybe<Array<Maybe<CompanySurveyTypeName>>>;
  threshold?: Maybe<Scalars['Int']>;
};

/** This represents the details of the CompanySurveyType-Category pair */
export type CompanySurveyTypeCategory = {
  __typename?: 'CompanySurveyTypeCategory';
  categoryId?: Maybe<Scalars['Int']>;
  isBaseCategory?: Maybe<Scalars['Boolean']>;
  isKeyFactor?: Maybe<Scalars['Boolean']>;
  names?: Maybe<Array<Maybe<CompanySurveyTypeName>>>;
};

/** This represent the details of Company SurveyType categories */
export type CompanySurveyTypeInput = {
  categories?: InputMaybe<Array<InputMaybe<SurveyTypeCategoryInput>>>;
};

/** This represents the details of the Company-SurveyType-Languae relationship */
export type CompanySurveyTypeName = {
  __typename?: 'CompanySurveyTypeName';
  languageId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** This represent the details of Company SurveyType name */
export type CompanySurveyTypeNameInput = {
  languageId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyToBenchmarkAttributes = {
  __typename?: 'CompanyToBenchmarkAttributes';
  benchmarkAttributeValues: Array<Maybe<CompanyBenchmarkAttributeValue>>;
  companyId: Scalars['Int'];
};

/** Update Input for Company */
export type CompanyUpdateInput = {
  excludeFinalSubmitButton?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  isDemoAccount?: InputMaybe<Scalars['Boolean']>;
  kioskAttributeId?: InputMaybe<Scalars['Int']>;
  languageActionIds?: InputMaybe<Array<InputMaybe<CreateOrDeleteIdActionCompanyInput>>>;
  logoFileName?: InputMaybe<Scalars['String']>;
  minimumResultsRequired?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<LanguageSearchInput>;
  preferredTimezone?: InputMaybe<TimezoneSearchInput>;
  regressionEnabled?: InputMaybe<Scalars['Boolean']>;
  reportingAverageOn?: InputMaybe<Scalars['Boolean']>;
  reportingDistributionOn?: InputMaybe<Scalars['Boolean']>;
  reportingEngagementRatioOn?: InputMaybe<Scalars['Boolean']>;
  reportingNpsOn?: InputMaybe<Scalars['Boolean']>;
  reportingPercentPositiveOn?: InputMaybe<Scalars['Boolean']>;
  surveyTimeoutMs?: InputMaybe<Scalars['Int']>;
  surveyTypeActionIds?: InputMaybe<Array<InputMaybe<CreateOrDeleteIdActionCompanyInput>>>;
  timezoneActionIds?: InputMaybe<Array<InputMaybe<CreateOrDeleteIdActionCompanyInput>>>;
  topbarColorHex?: InputMaybe<Scalars['String']>;
};

export enum CompareStatisticsEndpointEnum {
  CategoriesQuestionsScale = 'CATEGORIES_QUESTIONS_SCALE',
  OverallAttributes = 'OVERALL_ATTRIBUTES',
  QuestionsScale = 'QUESTIONS_SCALE',
  ResponseRates = 'RESPONSE_RATES'
}

/** Comparing Statistics Item */
export type CompareStatisticsItem = {
  __typename?: 'CompareStatisticsItem';
  attributeId?: Maybe<Scalars['Int']>;
  attributeValueId?: Maybe<Scalars['String']>;
  factorId?: Maybe<Scalars['Int']>;
  questionId?: Maybe<Scalars['Int']>;
  scoreAverage?: Maybe<Scalars['Float']>;
  scoreEnps?: Maybe<Scalars['Float']>;
  scorePercentage?: Maybe<Scalars['Float']>;
};

export enum CompareStatisticsTypeEnum {
  CompanyWide = 'COMPANY_WIDE',
  Surveys = 'SURVEYS',
  Timeframe = 'TIMEFRAME'
}

export type ContinuousSurveyCommentSummaryInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedTimeframe: TimeframeInput;
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
};

export type Conversation = {
  __typename?: 'Conversation';
  accessCode: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeResponseQuestionOptionsId?: Maybe<Scalars['Int']>;
  employeeResponseQuestionScaleId?: Maybe<Scalars['Int']>;
  employeeResponseQuestionTextId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  messages?: Maybe<Array<Maybe<MinimalConversationMessage>>>;
  optionResponse?: Maybe<EmployeeResponseQuestion>;
  reactions?: Maybe<Array<Maybe<ConversationReaction>>>;
  response: EmployeeResponseQuestion;
  scaleResponse?: Maybe<EmployeeResponseQuestion>;
  textResponse?: Maybe<EmployeeResponseQuestion>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type ConversationAuth = {
  __typename?: 'ConversationAuth';
  token?: Maybe<Scalars['String']>;
};

export type ConversationInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  optionResponseId?: InputMaybe<Scalars['Int']>;
  scaleResponseId?: InputMaybe<Scalars['Int']>;
  textResponseId?: InputMaybe<Scalars['Int']>;
};

export type ConversationMessage = {
  __typename?: 'ConversationMessage';
  conversation: Conversation;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

export type ConversationMessageInput = {
  conversationId: Scalars['Int'];
  text: Scalars['String'];
};

export type ConversationMessageSearchInput = {
  conversation?: InputMaybe<ConversationSearchInput>;
  conversationId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
  userInfo?: InputMaybe<UserSearchInput>;
};

export type ConversationReaction = {
  __typename?: 'ConversationReaction';
  conversation: Conversation;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  greatIdea: Scalars['Boolean'];
  id?: Maybe<Scalars['Int']>;
  like: Scalars['Boolean'];
  updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  workingOnIt: Scalars['Boolean'];
};

export type ConversationReactionInput = {
  conversationId: Scalars['Int'];
  greatIdea?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['Boolean']>;
  workingOnIt?: InputMaybe<Scalars['Boolean']>;
};

export type ConversationReactionSearchInput = {
  conversation?: InputMaybe<ConversationSearchInput>;
  conversationId?: InputMaybe<Scalars['Int']>;
  greatIdea?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  like?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['Int']>;
  userInfo?: InputMaybe<UserSearchInput>;
  workingOnIt?: InputMaybe<Scalars['Boolean']>;
};

export type ConversationResponse = {
  __typename?: 'ConversationResponse';
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type ConversationSearchInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  optionResponse?: InputMaybe<EmployeeResponseQuestionSearchInput>;
  scaleResponse?: InputMaybe<EmployeeResponseQuestionSearchInput>;
  textResponse?: InputMaybe<EmployeeResponseQuestionSearchInput>;
};

export type ConversationsListItem = {
  __typename?: 'ConversationsListItem';
  anonymized?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  reactedGreatIdea?: Maybe<Scalars['Boolean']>;
  reactedLike?: Maybe<Scalars['Boolean']>;
  reactedWorkingOnIt?: Maybe<Scalars['Boolean']>;
  response?: Maybe<ConversationResponse>;
  surveyId: Scalars['Int'];
  surveyName: Scalars['String'];
};

export enum CreateOrDeleteActionsEnum {
  Create = 'CREATE',
  Delete = 'DELETE'
}

/** Pair action-id for many-to-many Company-related relationships */
export type CreateOrDeleteIdActionCompanyInput = {
  action?: InputMaybe<CreateOrDeleteActionsEnum>;
  id: Scalars['Int'];
};

export type CronjobInfo = {
  __typename?: 'CronjobInfo';
  description: Scalars['String'];
  name: Scalars['String'];
  period: Scalars['Int'];
  periodUnit: Scalars['String'];
};

export type CronjobRunStatus = {
  __typename?: 'CronjobRunStatus';
  lastDurationMs: Scalars['Int'];
  lastRunAt: Scalars['String'];
  lastRunByUser?: Maybe<CronjobRunUser>;
  lastStatus: Scalars['String'];
  name: Scalars['String'];
};

export type CronjobRunUser = {
  __typename?: 'CronjobRunUser';
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastname?: Maybe<Scalars['String']>;
};

/** This represents the details of the Survey model used on the frontend surveys list */
export type DashboardSurvey = {
  __typename?: 'DashboardSurvey';
  audienceMode?: Maybe<Scalars['String']>;
  /** employee survey snapshots who have completed the survey */
  completedCount?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  disableEmailSending?: Maybe<Scalars['Boolean']>;
  endTimeUTC?: Maybe<Scalars['String']>;
  hashCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isContinuous?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  /** Number of reminders that the survey has */
  remindersCount?: Maybe<Scalars['Int']>;
  /** % of responses for the survey */
  responseRate?: Maybe<Scalars['Float']>;
  startTimeUTC?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  /** List of support languages for current survey */
  supportLanguages?: Maybe<Array<Maybe<Scalars['Int']>>>;
  surveyName?: Maybe<Scalars['String']>;
  surveyStatusId?: Maybe<Scalars['Int']>;
  surveyType?: Maybe<SurveyType>;
  timezoneId?: Maybe<Scalars['Int']>;
  timezoneName?: Maybe<Scalars['String']>;
  /** employee survey snapshots who were invited to the survey */
  totalCount?: Maybe<Scalars['Int']>;
  typeId?: Maybe<Scalars['Int']>;
};

/** This represents the details of the result of dashboard surveys */
export type DashboardSurveysResult = {
  __typename?: 'DashboardSurveysResult';
  count?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<DashboardSurvey>>>;
};

export type DateInput = {
  eq?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
};

export type DefaultContextAndPrompt = {
  __typename?: 'DefaultContextAndPrompt';
  analysisType: Scalars['String'];
  context: Scalars['String'];
  guardPrompt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeleteDynamicAttributeRecipeResponse = {
  __typename?: 'DeleteDynamicAttributeRecipeResponse';
  /** The id of the deleted recipe, so clients can evict it from their cache. */
  id: Scalars['Int'];
  success: Scalars['Boolean'];
};

/** A stored transformation that derives one attribute's value from another, scoped to a company. */
export type DynamicAttributeRecipe = {
  __typename?: 'DynamicAttributeRecipe';
  created: Scalars['DateTime'];
  /** Type-specific payload: group maps, default values, prepend and append text. `{}` for COPY. */
  definition: Scalars['JSON'];
  id: Scalars['Int'];
  name: Scalars['String'];
  recipeType: DynamicAttributeRecipeType;
  /** Attribute the transformation reads its input value from. */
  sourceAttributeId: Scalars['Int'];
  /**
   * Resolved live through the sourceAttribute relation, never stored on the recipe. Null when the
   * attribute has no name for the requesting user's language.
   */
  sourceAttributeName?: Maybe<Scalars['String']>;
  /** Attribute the transformation writes its derived value to. */
  targetAttributeId: Scalars['Int'];
  /**
   * Resolved live through the targetAttribute relation, never stored on the recipe. Null when the
   * attribute has no name for the requesting user's language.
   */
  targetAttributeName?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
};

/** How a recipe derives its target value from its source attribute's value. */
export enum DynamicAttributeRecipeType {
  Copy = 'COPY',
  DateToNumericGroup = 'DATE_TO_NUMERIC_GROUP',
  GroupByNumeric = 'GROUP_BY_NUMERIC',
  GroupByText = 'GROUP_BY_TEXT',
  Replace = 'REPLACE'
}

export type Employee = {
  __typename?: 'Employee';
  attributesWithValues?: Maybe<Array<Maybe<EmployeeAttributeWithValues>>>;
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  languageId?: Maybe<Scalars['Int']>;
  legacyId?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
};

export type EmployeeAttribute = {
  __typename?: 'EmployeeAttribute';
  attributeNames: Array<AttributeName>;
  attributeTypeId: Scalars['Int'];
  baseAttributeId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  isPrivate: Scalars['Boolean'];
  isReportingAllowed: Scalars['Boolean'];
  isReportingAttribute: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  isUnique: Scalars['Boolean'];
  legacyId?: Maybe<Scalars['String']>;
  transformationId?: Maybe<Scalars['Int']>;
  updated: Scalars['DateTime'];
};

export type EmployeeAttributeObject = {
  __typename?: 'EmployeeAttributeObject';
  id: Scalars['Int'];
  value?: Maybe<Scalars['AttributeValue']>;
};

export type EmployeeAttributeValue = {
  __typename?: 'EmployeeAttributeValue';
  attributeId: Scalars['Int'];
  attributeValue: Scalars['AttributeValue'];
  created: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  employeeId: Scalars['Int'];
  id: Scalars['Int'];
  updated: Scalars['DateTime'];
};

export type EmployeeAttributeWithValueInput = {
  id: Scalars['Int'];
  value?: InputMaybe<Scalars['AttributeValue']>;
};

export type EmployeeAttributeWithValues = {
  __typename?: 'EmployeeAttributeWithValues';
  attribute: EmployeeAttribute;
  attributeValues: Array<Maybe<Scalars['AttributeValue']>>;
};

/** An employee currently opted out of a messaging channel, with the reason and who added them. */
export type EmployeeChannelDoNotContactEntry = {
  __typename?: 'EmployeeChannelDoNotContactEntry';
  addedAtTimeUTC: Scalars['String'];
  addedByUser?: Maybe<OutputAddedByUser>;
  channel: MessagingChannel;
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  reason: Scalars['String'];
};

/** Filter options for the do-not-contact list. */
export type EmployeeChannelDoNotContactListFilter = {
  channel: MessagingChannel;
  /** Filter by employee name (first + last) containing this string (case-insensitive). */
  employeeName?: InputMaybe<Scalars['String']>;
};

export type EmployeeChannelDoNotContactListResult = {
  __typename?: 'EmployeeChannelDoNotContactListResult';
  entries: Array<EmployeeChannelDoNotContactEntry>;
  total: Scalars['Int'];
};

export type EmployeeDetail = {
  __typename?: 'EmployeeDetail';
  attributes?: Maybe<Array<Maybe<EmployeeAttributeObject>>>;
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  hasRole?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isPrimaryEmployee?: Maybe<Scalars['Boolean']>;
  isUser?: Maybe<Scalars['Boolean']>;
  languageId?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  user?: Maybe<UserDetails>;
};

export type EmployeeDetails = {
  __typename?: 'EmployeeDetails';
  count?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<EmployeeDetail>>>;
};

export type EmployeeDetailsInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  batchSearch?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  enabledEmployee?: InputMaybe<Scalars['Boolean']>;
  includeDummyEmployees?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

export type EmployeeEditInput = {
  attributesWithValues?: InputMaybe<Array<InputMaybe<AttributesWithValueUpdateInput>>>;
  enabled: Scalars['Boolean'];
  languageId?: InputMaybe<Scalars['Int']>;
};

export enum EmployeeFileImportTaskStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

/** A per-company mapping from a raw HRIS export column header to a WorkTango employee field or attribute. */
export type EmployeeImportColumnMapping = {
  __typename?: 'EmployeeImportColumnMapping';
  created: Scalars['DateTime'];
  /**
   * True when the raw column should be dropped from the row entirely instead of renamed or passed
   * through. Mutually exclusive with targetCoreField/targetAttributeId, which are both null here.
   */
  excluded: Scalars['Boolean'];
  id: Scalars['Int'];
  /** The customer's raw HRIS export column header, matched case-insensitively. */
  sourceColumnName: Scalars['String'];
  /** Set when the mapping targets a company attribute -- built-in (Email, First Name, Last Name) or custom. */
  targetAttributeId?: Maybe<Scalars['Int']>;
  /**
   * Resolved live through the targetAttribute relation, never stored on the mapping. Null when
   * targetCoreField is set instead, or the attribute has no name for the requesting user's language.
   */
  targetAttributeName?: Maybe<Scalars['String']>;
  /** Set when the mapping targets a fixed EmployeeImportInput field rather than an attribute. */
  targetCoreField?: Maybe<EmployeeImportCoreField>;
  updated: Scalars['DateTime'];
};

/** A fixed EmployeeImportInput scalar field a column mapping can target, instead of a company attribute. */
export enum EmployeeImportCoreField {
  EmployeeId = 'EMPLOYEE_ID',
  Enabled = 'ENABLED',
  LanguageId = 'LANGUAGE_ID',
  Role = 'ROLE'
}

export type EmployeeImportInput = {
  attributes: Array<InputMaybe<EmployeeAttributeWithValueInput>>;
  employeeId: Scalars['String'];
  enabled: Scalars['Boolean'];
  languageId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
};

export type EmployeeImportIssue = {
  __typename?: 'EmployeeImportIssue';
  message: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
  severity: EmployeeImportIssueSeverity;
};

export enum EmployeeImportIssueSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum EmployeeImportMode {
  Append = 'APPEND',
  Overwrite = 'OVERWRITE'
}

export type EmployeeImportResult = {
  __typename?: 'EmployeeImportResult';
  conflicts?: Maybe<Array<Maybe<EmployeeUniqueConflict>>>;
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type EmployeeImportTask = {
  __typename?: 'EmployeeImportTask';
  created: Scalars['DateTime'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  originLabel: Scalars['String'];
  output?: Maybe<EmployeeImportTaskOutput>;
  sourceId: Scalars['String'];
  status: EmployeeFileImportTaskStatus;
  updated: Scalars['DateTime'];
  uploaderName?: Maybe<Scalars['String']>;
};

export type EmployeeImportTaskOutput = {
  __typename?: 'EmployeeImportTaskOutput';
  errorMessage?: Maybe<Scalars['String']>;
  issues?: Maybe<Array<EmployeeImportIssue>>;
};

export type EmployeeImportTasks = {
  __typename?: 'EmployeeImportTasks';
  count: Scalars['Int'];
  results: Array<EmployeeImportTask>;
};

export type EmployeeImportTasksInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<EmployeeFileImportTaskStatus>;
};

/** Which custom transformation type an EmployeeImportTransformation applies. */
export enum EmployeeImportTransformType {
  Concatenate = 'CONCATENATE',
  Conditional = 'CONDITIONAL',
  FirstNonNull = 'FIRST_NON_NULL',
  FixedValue = 'FIXED_VALUE',
  GenerationCohort = 'GENERATION_COHORT',
  Replace = 'REPLACE',
  TenureRange = 'TENURE_RANGE'
}

/**
 * A company-scoped custom transformation applied during employee import, operating on raw parsed
 * row columns rather than persisted attributes -- unlike DynamicAttributeRecipe, some inputs (e.g.
 * a birthday column) are never persisted as attributes at all.
 */
export type EmployeeImportTransformation = {
  __typename?: 'EmployeeImportTransformation';
  created: Scalars['DateTime'];
  /** Type-specific payload -- shape depends on transformType. See the employee-import-pipeline package. */
  definition: Scalars['JSON'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** Set when the transformation targets a company attribute -- built-in or custom. */
  targetAttributeId?: Maybe<Scalars['Int']>;
  /**
   * Resolved live through the targetAttribute relation, never stored on the transformation. Null
   * when targetCoreField is set instead, or the attribute has no name for the requesting user's
   * language.
   */
  targetAttributeName?: Maybe<Scalars['String']>;
  /** Set when the transformation targets a fixed EmployeeImportInput field rather than an attribute. */
  targetCoreField?: Maybe<EmployeeImportCoreField>;
  transformType: EmployeeImportTransformType;
  updated: Scalars['DateTime'];
};

export type EmployeeResponseQuestion = {
  __typename?: 'EmployeeResponseQuestion';
  id?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
};

export type EmployeeResponseQuestionSearchInput = {
  id: Scalars['Int'];
};

/** Survey elements used by employees taking the survey */
export type EmployeeSurvey = {
  __typename?: 'EmployeeSurvey';
  anonymityThreshold?: Maybe<Scalars['Int']>;
  anonymousConversation?: Maybe<Scalars['Boolean']>;
  answers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  companyId?: Maybe<Scalars['Int']>;
  employeePreferredLanguageId?: Maybe<Scalars['Int']>;
  expired?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isPreview?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  name?: Maybe<Scalars['String']>;
  questionLogics?: Maybe<Array<Maybe<QuestionLogic>>>;
  questions?: Maybe<Array<Maybe<SurveyElement>>>;
  showResults?: Maybe<Scalars['Boolean']>;
  status?: Maybe<SurveyStatus>;
  submitted?: Maybe<Scalars['Boolean']>;
};

export type EmployeeUniqueConflict = {
  __typename?: 'EmployeeUniqueConflict';
  attributeId?: Maybe<Scalars['Int']>;
  attributeValue?: Maybe<Scalars['String']>;
  companyEmployeeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Entities = {
  __typename?: 'Entities';
  entities?: Maybe<Array<Maybe<Entity>>>;
  entityCount?: Maybe<Scalars['Int']>;
};

export type Entity = {
  __typename?: 'Entity';
  repeatCount?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum FileUploadTypeEnum {
  CompanyLogo = 'COMPANY_LOGO',
  Employee = 'EMPLOYEE',
  User = 'USER'
}

/** FilterAttributes */
export type FilterAttributes = {
  __typename?: 'FilterAttributes';
  attributeId?: Maybe<Scalars['String']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeValues?: Maybe<Array<Maybe<AttributeFilterValues>>>;
  isEmpty?: Maybe<Scalars['Boolean']>;
};

export type FloatMinMax = {
  __typename?: 'FloatMinMax';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

/** This represents the details of the ForgotPasswordResult model */
export type ForgotPasswordResult = {
  __typename?: 'ForgotPasswordResult';
  result?: Maybe<Scalars['String']>;
};

export type GenThemesResponse = {
  __typename?: 'GenThemesResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GetQuestionCommentsInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  entityFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surveyElementIds: Array<Scalars['Int']>;
  surveyIds: Array<Scalars['Int']>;
  themeFilter?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type GetQuestionThemesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  entityFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchText?: InputMaybe<Scalars['String']>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
  themeFilter?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type GlobalAction = {
  __typename?: 'GlobalAction';
  action?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type Icon = {
  __typename?: 'Icon';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isBaseIcon?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  surveyElementTypeId?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

export type IconInput = {
  id?: InputMaybe<Scalars['Int']>;
  isBaseIcon?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
};

export type InputAddToDoNotContactList = {
  employeeId: Scalars['Int'];
  reason: Scalars['String'];
};

export type InputAdminApprover = {
  userId: Scalars['Int'];
};

export type InputAttributes = {
  attributeId: Scalars['Int'];
  attributeValue: Scalars['AttributeValueType'];
};

export type InputLanguages = {
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type InputLifecycleSurveyRecipients = {
  addToDoNotContact?: InputMaybe<Scalars['Boolean']>;
  doNotContactReason?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  inviteImmediately?: InputMaybe<Scalars['Boolean']>;
  isApprovedToAdd?: InputMaybe<Scalars['Boolean']>;
  removeFromList?: InputMaybe<Scalars['Boolean']>;
};

export type InputLifecycleSurveyTrigger = {
  adminApprovers: Array<InputMaybe<InputAdminApprover>>;
  attributeAudience?: InputMaybe<Array<InputMaybe<InputAttributes>>>;
  audienceType: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  invitationOffsetDays: Scalars['Int'];
  languages: Array<InputLanguages>;
  lifecycleSurveyTypeId: Scalars['Int'];
  requireAdminApproval: Scalars['Boolean'];
  status?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['Int'];
  timeOfDayEndUTC: Scalars['String'];
  timeOfDayStartUTC: Scalars['String'];
  triggerAttributeId: Scalars['Int'];
};

export type InputLifecycleSurveyTriggerType = {
  id?: InputMaybe<Scalars['Int']>;
  isEnabled: Scalars['Boolean'];
  type: Scalars['String'];
};

export type InputSurveyElement = {
  orderIndex: Scalars['Int'];
  surveyElementId: Scalars['Int'];
};

export type InputSurveyTemplateEmail = {
  emailContent: Scalars['String'];
  emailSubject: Scalars['String'];
  languageId: Scalars['Int'];
};

export type InputSurveyTemplateFilters = {
  status?: InputMaybe<Scalars['String']>;
  surveyTemplateName?: InputMaybe<Scalars['String']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

export type InputSurveyTemplateNames = {
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type KeyPhrase = {
  __typename?: 'KeyPhrase';
  repeatCount?: Maybe<Scalars['Int']>;
  sentiment?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type KeyPhrases = {
  __typename?: 'KeyPhrases';
  keyPhraseCount?: Maybe<Scalars['Int']>;
  keyPhrases?: Maybe<Array<Maybe<KeyPhrase>>>;
};

export type KioskCompany = {
  __typename?: 'KioskCompany';
  id?: Maybe<Scalars['Int']>;
  idTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  kioskId?: Maybe<Scalars['String']>;
  kioskWelcomeText?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Maybe<Language>>>;
  logoFileName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  preferredLanguageId?: Maybe<Scalars['Int']>;
  topbarColorHex?: Maybe<Scalars['String']>;
};

export type KioskSurvey = {
  __typename?: 'KioskSurvey';
  companyId?: Maybe<Scalars['Int']>;
  langISOCode?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  previewCode?: Maybe<Scalars['String']>;
  surveyCode?: Maybe<Scalars['String']>;
};

export type Language = {
  __typename?: 'Language';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  langISOCode: Scalars['String'];
  updated?: Maybe<Scalars['String']>;
};

export type LanguageInput = {
  id?: InputMaybe<Scalars['Int']>;
  langISOCode?: InputMaybe<Scalars['String']>;
};

/** Search Input for Language */
export type LanguageSearchInput = {
  id?: InputMaybe<Scalars['String']>;
  langISOCode?: InputMaybe<Scalars['String']>;
};

/** Input for SurveyElementType */
export type LegacySurveyElementInput = {
  attributes?: InputMaybe<Array<InputMaybe<SurveyElementAttributeInput>>>;
  category?: InputMaybe<CategoryIdInput>;
  choices?: InputMaybe<Array<InputMaybe<SurveyElementChoicesInput>>>;
  copiedLibraryId?: InputMaybe<Scalars['Int']>;
  hideReporting?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<IconInput>;
  id?: InputMaybe<Scalars['Int']>;
  isAttributeBased?: InputMaybe<Scalars['Boolean']>;
  isLibraryQuestion?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  maxSelectedOption?: InputMaybe<Scalars['Int']>;
  messagesPerLanguage: Array<InputMaybe<SurveyElementMessagePerLanguageInput>>;
  minSelectedOption?: InputMaybe<Scalars['Int']>;
  orderIndex: Scalars['Int'];
  ratingOptionHighest?: InputMaybe<Scalars['Int']>;
  ratingOptionLowest?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  showDescription?: InputMaybe<Scalars['Boolean']>;
  showLabels?: InputMaybe<Scalars['Boolean']>;
  showSkipButton?: InputMaybe<Scalars['Boolean']>;
  showTextComment?: InputMaybe<Scalars['Boolean']>;
  type: SurveyElementTypeInput;
};

/** Search Input for SurveyElementType */
export type LegacySurveyElementSearchInput = {
  attributes?: InputMaybe<Array<InputMaybe<SurveyElementAttributeInput>>>;
  category?: InputMaybe<CategoryIdInput>;
  choices?: InputMaybe<Array<InputMaybe<SurveyElementChoicesInput>>>;
  hideReporting?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<IconInput>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isAttributeBased?: InputMaybe<Scalars['Boolean']>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']>;
  isLibraryQuestion?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  maxSelectedOption?: InputMaybe<Scalars['Int']>;
  messagesPerLanguage?: InputMaybe<Array<InputMaybe<SurveyElementMessagePerLanguageInput>>>;
  minSelectedOption?: InputMaybe<Scalars['Int']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  ratingOptionHighest?: InputMaybe<Scalars['Int']>;
  ratingOptionLowest?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  showDescription?: InputMaybe<Scalars['Boolean']>;
  showLabels?: InputMaybe<Scalars['Boolean']>;
  showSkipButton?: InputMaybe<Scalars['Boolean']>;
  showTextComment?: InputMaybe<Scalars['Boolean']>;
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<SurveyElementTypeInput>;
};

/** Update Input for SurveyElementType */
export type LegacySurveyElementUpdateInput = {
  action: AttributeNameActionEnum;
  surveyElement?: InputMaybe<LegacySurveyElementSearchInput>;
};

/** Identifies a library action */
export type LibraryAction = {
  __typename?: 'LibraryAction';
  categories?: Maybe<Array<Maybe<LibraryActionCategory>>>;
  description?: Maybe<Scalars['String']>;
  effectiveness?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** Library action's category */
export type LibraryActionCategory = {
  __typename?: 'LibraryActionCategory';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type LinkQuestionsForTrendingInput = {
  questionText: Scalars['String'];
  questionType: TrendingQuestionType;
  surveyIds: Array<Scalars['Int']>;
};

export type LinkQuestionsForTrendingResult = {
  __typename?: 'LinkQuestionsForTrendingResult';
  linkedQuestionId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  /** Non-null when success is false. e.g. RATING_LOWEST_MISMATCH, CATEGORY_MISMATCH, ALREADY_LINKED. */
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** External messaging channel a company can deliver survey invitations through. */
export enum MessagingChannel {
  Slack = 'SLACK',
  Sms = 'SMS',
  Teams = 'TEAMS'
}

/** The delivery channel a survey message is sent through. */
export enum MessagingChannelOptions {
  Slack = 'SLACK',
  Sms = 'SMS',
  Teams = 'TEAMS'
}

export type MigratedSurvey = {
  __typename?: 'MigratedSurvey';
  endTimeUTC?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  startTimeUTC?: Maybe<Scalars['DateTime']>;
  surveyStatusId: Scalars['Int'];
  timezoneId?: Maybe<Scalars['Int']>;
};

export type MinimalConversationMessage = {
  __typename?: 'MinimalConversationMessage';
  conversationId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
};

/** Statistics for Attribute multiple choice questions */
export type MultipleChoiceAttributeStatistics = {
  __typename?: 'MultipleChoiceAttributeStatistics';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<MultipleChoiceAttributeValueStatistics>>>;
};

/** Statistics for Attribute values multiple choice questions */
export type MultipleChoiceAttributeValueStatistics = {
  __typename?: 'MultipleChoiceAttributeValueStatistics';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  numberOfResponses?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<MultipleChoiceOptionStatistics>>>;
};

/** Statistics for Options of multiple choice questions */
export type MultipleChoiceOptionStatistics = {
  __typename?: 'MultipleChoiceOptionStatistics';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  numberOfResponses?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
};

/** Statistics for multiple choice questions */
export type MultipleChoiceQuestionStatistics = {
  __typename?: 'MultipleChoiceQuestionStatistics';
  attributes?: Maybe<Array<Maybe<MultipleChoiceAttributeStatistics>>>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  numberOfResponses?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<MultipleChoiceOptionStatistics>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateUser?: Maybe<User>;
  addAttribute?: Maybe<Attribute>;
  addAttributeType?: Maybe<AttributeType>;
  addBenchmarkAttribute: BenchmarkAttribute;
  addBenchmarkAttributeValue: BenchmarkAttributeValue;
  addBenchmarkAttributeValueAltNames: Array<Maybe<BenchmarkAttributeValueAltName>>;
  addBenchmarkAttributeValueHierarchy: BenchmarkAttributeValueHierarchy;
  addBenchmarkQuestions: Array<Maybe<NewBenchmarkQuestion>>;
  addCategory?: Maybe<Category>;
  addCompany?: Maybe<Company>;
  addConversationFromResponse?: Maybe<Conversation>;
  addConversationMessage?: Maybe<MinimalConversationMessage>;
  addConversationReaction?: Maybe<ConversationReaction>;
  addEmployee?: Maybe<Employee>;
  /** Opt employees out of a messaging channel and record the reason. Idempotent per employee/channel. */
  addEmployeeChannelToDoNotContactList: OutputResult;
  addEmployeeConversationMessage?: Maybe<MinimalConversationMessage>;
  addLanguage?: Maybe<Language>;
  addPreviousQuestion?: Maybe<SurveyElement>;
  addSurvey?: Maybe<Survey>;
  addSurveyElement?: Maybe<SurveyElement>;
  addSurveyTemplate: OutputSurveyTemplate;
  addSurveyType?: Maybe<SurveyType>;
  addToDoNotContactList: OutputResult;
  addUser?: Maybe<UserAuth>;
  addUserAction?: Maybe<UserAction>;
  addUserPermission?: Maybe<UserPermission>;
  approveMigratedSurvey?: Maybe<MigratedSurvey>;
  associateAttributeWithBenchmarkAttribute: AttributeToBenchmarkAttribute;
  associateSurveyQuestionsWithBenchmarkQuestion: QuestionToBenchmarkQuestion;
  clearCompanyCache?: Maybe<Scalars['Boolean']>;
  clearSurveyCache?: Maybe<Scalars['Boolean']>;
  cloneSurveyTemplate: OutputSurveyTemplate;
  convertSurveyToContinuous?: Maybe<SurveyConvertResponse>;
  createAutomaticSurveyReminder: OutputAutomaticSurveyReminder;
  createCompanySurveyType?: Maybe<SurveyType>;
  createOrUpdateSurveyReminder: SurveyReminderWithLanguageOutput;
  /** Creates an AI Assistant conversation pre-populated with a survey summary */
  createSurveySummaryConversation?: Maybe<SurveySummaryConversation>;
  deleteAttribute?: Maybe<Scalars['Boolean']>;
  deleteAttributeAssociation: Scalars['Int'];
  deleteAttributeType?: Maybe<Scalars['Boolean']>;
  deleteAutomaticSurveyReminder: Scalars['Int'];
  deleteBenchmarkAttribute: Scalars['Int'];
  deleteBenchmarkAttributeValue: Scalars['Int'];
  deleteBenchmarkAttributeValueAltName: Scalars['Int'];
  deleteBenchmarkAttributeValueFromCompany: Scalars['Int'];
  deleteBenchmarkAttributeValueHierarchy: Scalars['Int'];
  deleteBenchmarkQuestions: Scalars['Int'];
  deleteBouncedEmailRecipients?: Maybe<Scalars['Boolean']>;
  deleteCategory?: Maybe<Scalars['Boolean']>;
  deleteCommentAnalysis: Scalars['Boolean'];
  deleteCompany?: Maybe<Scalars['Boolean']>;
  /** Soft-delete a recipe belonging to the requesting user's company. */
  deleteDynamicAttributeRecipe: DeleteDynamicAttributeRecipeResponse;
  deleteFromLifecycleDoNotContactList: OutputResult;
  deleteLanguage?: Maybe<Scalars['Boolean']>;
  deleteLifecycleSurveyTrigger: OutputResult;
  deletePendingUsers?: Maybe<Scalars['Boolean']>;
  deleteSurvey?: Maybe<Scalars['Boolean']>;
  deleteSurveyElement?: Maybe<Scalars['Boolean']>;
  deleteSurveyQuestionAssociations: Scalars['Int'];
  deleteSurveyReminder: DeleteSurveyReminderOutput;
  deleteSurveyTemplate: OutputDeleteSurveyTemplateResponse;
  deleteSurveyType?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<Scalars['Boolean']>;
  deleteUserAction?: Maybe<Scalars['Boolean']>;
  deleteUserPermission?: Maybe<Scalars['Boolean']>;
  /** Clears the shared access code for an Open Survey, disabling the code requirement. */
  disableOpenSurveyAccessCode: Survey;
  duplicateSurvey?: Maybe<Survey>;
  executeScheduledReminders?: Maybe<SurveyReminderCountOutput>;
  exitImpersonation?: Maybe<UserAuth>;
  forgotPassword?: Maybe<ForgotPasswordResult>;
  genCommentsAnalysis: Array<Maybe<Comment>>;
  genCommentsSummaryForContinuousSurvey: CommentsSummary;
  genThemesAnalysis: GenThemesResponse;
  generateCommentsSummary: CommentsSummary;
  /** Mints a new shared access code for an Open Survey, overwriting any existing one immediately. */
  generateOpenSurveyAccessCode: Survey;
  impersonateUser?: Maybe<UserAuth>;
  importEmployees?: Maybe<EmployeeImportResult>;
  inviteUser?: Maybe<Scalars['Boolean']>;
  /** Links identical questions across surveys so they trend together. Super admin only. */
  linkQuestionsForTrending: LinkQuestionsForTrendingResult;
  login?: Maybe<UserAuth>;
  loginEmployee?: Maybe<ConversationAuth>;
  logout?: Maybe<UserAuth>;
  migrateSurvey?: Maybe<MigratedSurvey>;
  populateThemesAnalysis: ThemesAnalysisResponse;
  privateAttributeExportedNotifier: Scalars['Boolean'];
  rateContent?: Maybe<LearningContent>;
  readContent?: Maybe<LearningContent>;
  /** Allows a user to regenerate the AI summary for a survey if that summary is in COMPLETED state. */
  regenerateAISummary?: Maybe<Scalars['Boolean']>;
  /** Opt employees back in to a messaging channel, soft-deleting their do-not-contact entries. */
  removeEmployeeChannelFromDoNotContactList: OutputResult;
  resendSurveyInvitation?: Maybe<ResendResult>;
  /** Allows a user with RECEIVES_SUMMARY_EMAIL permission to schedule a new AI summary for a survey. Pass `filters` to summarize only the data set those reporting filters select. */
  scheduleAISurveySummary: AiSurveySummary;
  scheduleEmployeeImport: ScheduleEmployeeImportResult;
  scheduleSurveyReminder?: Maybe<ScheduleReminderResult>;
  /**
   * Super-admin only. Sends a one-off Slack DM through the company's connected workspace, resolving
   * the recipient by email, to verify the integration end to end. Does not create or modify any
   * survey message delivery.
   */
  sendTestSlack: SendTestSlackResult;
  /**
   * Super-admin only. Sends a one-off SMS through Twilio to verify the integration end to end.
   * Does not create or modify any survey message delivery.
   */
  sendTestSms: SendTestSmsResult;
  sendTestSurvey?: Maybe<Scalars['Boolean']>;
  setNewPasswordWithToken?: Maybe<ForgotPasswordResult>;
  /** Replaces an Open Survey's shared access code with one the admin chose. */
  setOpenSurveyAccessCode: Survey;
  /** Sets a company's Open Survey monthly response limit. WorkTango super admins only; never editable by the company's own admins. */
  setOpenSurveyMonthlyResponseLimit: OpenSurveyMonthlyResponseLimit;
  setRehireAttribute: Scalars['Int'];
  starContent?: Maybe<LearningContent>;
  submitMultipleQuestion?: Maybe<SubmitResult>;
  /** Public: submits one respondent's answers for an Open Survey in a single atomic call. A repeat call with the same idempotencyKey returns the prior result instead of writing again. */
  submitOpenSurveyResponse: SubmitOpenSurveyResponsePayload;
  submitScaleQuestion?: Maybe<SubmitResult>;
  submitSurvey?: Maybe<SubmitResult>;
  submitTextQuestion?: Maybe<SubmitResult>;
  switchAccount?: Maybe<UserAuth>;
  triggerCronjob: TriggerCronjobResult;
  updateAttribute?: Maybe<Attribute>;
  updateAttributeType?: Maybe<AttributeType>;
  updateAutomaticSurveyReminder: OutputAutomaticSurveyReminder;
  updateBenchmarkAttribute: BenchmarkAttribute;
  updateBenchmarkAttributeValue: BenchmarkAttributeValue;
  updateCategory?: Maybe<Category>;
  updateCommentSentiment: CommentAnalysis;
  updateCompany?: Maybe<Company>;
  updateCompanyBenchmarkAttributeValue: CompanyBenchmarkAttributeValue;
  updateCompanyEmployeeIds?: Maybe<UpdateResult>;
  /**
   * Company admins (COMPANY_CONFIGURATION) and super admins only. Encrypts and stores per-channel
   * credentials and toggles `enabled` for the acting user's company (derived from context).
   */
  updateCompanyMessagingConfig: CompanyMessagingConfig;
  updateCompanySurveyType?: Maybe<SurveyType>;
  updateConversationReaction?: Maybe<ConversationReaction>;
  updateEmployee?: Maybe<Employee>;
  updateLifecycleSurveyRecipients: OutputResult;
  updateRecipientList?: Maybe<SurveyEmployees>;
  updateSurvey?: Maybe<Survey>;
  updateSurveyElement?: Maybe<SurveyElement>;
  updateSurveyQuestionsSorting?: Maybe<Scalars['Boolean']>;
  updateSurveyTemplate: OutputSurveyTemplate;
  updateSurveyTemplateStatus: OutputUpdateSurveyTemplateStatus;
  updateUserPermission?: Maybe<UserPermission>;
  updateUsersStatus?: Maybe<Array<Maybe<User>>>;
  /** Create a recipe, or update it when the input carries an id. */
  upsertDynamicAttributeRecipe: DynamicAttributeRecipe;
  upsertLifecycleSurveyTrigger: OutputLifecycleSurveyTrigger;
  upsertLifecycleSurveyTriggerTypes?: Maybe<Array<Maybe<OutputLifecycleSurveyTriggerTypes>>>;
  /**
   * Creates or updates per-survey channel enablement and the selected message variation.
   * Enabling a channel creates (or reuses) its status row with enabled = true; disabling
   * flips enabled = false (the row persists) for pre-launch surveys and is rejected for
   * in-progress surveys.
   */
  upsertSurveyMessaging: SurveyMessaging;
};


export type MutationActivateUserArgs = {
  token: Scalars['String'];
  user: UserToUpdateInput;
};


export type MutationAddAttributeArgs = {
  attribute: AttributeInput;
  companyId: Scalars['Int'];
};


export type MutationAddAttributeTypeArgs = {
  name: Scalars['String'];
};


export type MutationAddBenchmarkAttributeArgs = {
  name: Scalars['String'];
  translationKey: Scalars['String'];
};


export type MutationAddBenchmarkAttributeValueArgs = {
  benchmarkAttributeId: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationAddBenchmarkAttributeValueAltNamesArgs = {
  benchmarkAttributeValueId: Scalars['Int'];
  names: Array<Scalars['String']>;
};


export type MutationAddBenchmarkAttributeValueHierarchyArgs = {
  childValue: Scalars['String'];
  parentValue: Scalars['String'];
};


export type MutationAddBenchmarkQuestionsArgs = {
  questionIds: Array<Scalars['Int']>;
};


export type MutationAddCategoryArgs = {
  category: CategoryInput;
};


export type MutationAddCompanyArgs = {
  company: CompanyInput;
};


export type MutationAddConversationFromResponseArgs = {
  conversation: ConversationInput;
};


export type MutationAddConversationMessageArgs = {
  conversationMessage: ConversationMessageInput;
};


export type MutationAddConversationReactionArgs = {
  conversationReaction: ConversationReactionInput;
};


export type MutationAddEmployeeArgs = {
  companyId: Scalars['Int'];
  employee: EmployeeEditInput;
};


export type MutationAddEmployeeChannelToDoNotContactListArgs = {
  input: AddEmployeeChannelToDoNotContactListInput;
};


export type MutationAddEmployeeConversationMessageArgs = {
  conversationMessage: ConversationMessageInput;
};


export type MutationAddLanguageArgs = {
  langISOCode: Scalars['String'];
};


export type MutationAddPreviousQuestionArgs = {
  orderIndex: Scalars['Int'];
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
};


export type MutationAddSurveyArgs = {
  survey: SurveyInput;
};


export type MutationAddSurveyElementArgs = {
  surveyElement: SurveyElementInput;
  surveyId: Scalars['Int'];
};


export type MutationAddSurveyTemplateArgs = {
  audienceMode?: InputMaybe<Scalars['String']>;
  lifecycleSurveyTypeId?: InputMaybe<Scalars['Int']>;
  names: Array<InputSurveyTemplateNames>;
  surveyElements?: InputMaybe<Array<InputMaybe<InputSurveyElement>>>;
  surveyTypeId: Scalars['Int'];
};


export type MutationAddSurveyTypeArgs = {
  surveyType: SurveyTypeInput;
};


export type MutationAddToDoNotContactListArgs = {
  employeesInput: Array<InputAddToDoNotContactList>;
};


export type MutationAddUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  preferredLanguageId: Scalars['Int'];
};


export type MutationAddUserActionArgs = {
  action: Scalars['String'];
};


export type MutationAddUserPermissionArgs = {
  userId: Scalars['Int'];
  userPermission: UserPermisionUpdateInput;
};


export type MutationApproveMigratedSurveyArgs = {
  surveyId: Scalars['Int'];
};


export type MutationAssociateAttributeWithBenchmarkAttributeArgs = {
  attributeId: Scalars['Int'];
  benchmarkAttributeId: Scalars['Int'];
};


export type MutationAssociateSurveyQuestionsWithBenchmarkQuestionArgs = {
  benchmarkQuestionId: Scalars['Int'];
  surveyQuestionIds: Array<Scalars['Int']>;
};


export type MutationClearCompanyCacheArgs = {
  companyId: Scalars['Int'];
};


export type MutationClearSurveyCacheArgs = {
  surveyId: Scalars['Int'];
};


export type MutationCloneSurveyTemplateArgs = {
  id: Scalars['Int'];
  names: Array<InputSurveyTemplateNames>;
};


export type MutationConvertSurveyToContinuousArgs = {
  continuousSurveyType: Scalars['String'];
  surveyId: Scalars['Int'];
};


export type MutationCreateAutomaticSurveyReminderArgs = {
  automaticSurveyReminder?: InputMaybe<AutomaticSurveyReminderInput>;
};


export type MutationCreateCompanySurveyTypeArgs = {
  baseSurveyTypeId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  surveyTypeNames: Array<InputMaybe<CompanySurveyTypeNameInput>>;
};


export type MutationCreateOrUpdateSurveyReminderArgs = {
  surveyReminder: CreateOrUpdateSurveyReminderInput;
};


export type MutationCreateSurveySummaryConversationArgs = {
  surveyId: Scalars['Int'];
};


export type MutationDeleteAttributeArgs = {
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationDeleteAttributeAssociationArgs = {
  attributeId: Scalars['Int'];
  benchmarkAttributeId: Scalars['Int'];
};


export type MutationDeleteAttributeTypeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteAutomaticSurveyReminderArgs = {
  reminderId: Scalars['Int'];
};


export type MutationDeleteBenchmarkAttributeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBenchmarkAttributeValueArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteBenchmarkAttributeValueAltNameArgs = {
  benchmarkAttributeValueId: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationDeleteBenchmarkAttributeValueFromCompanyArgs = {
  benchmarkAttributeValueId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type MutationDeleteBenchmarkAttributeValueHierarchyArgs = {
  childValue: Scalars['String'];
  parentValue: Scalars['String'];
};


export type MutationDeleteBenchmarkQuestionsArgs = {
  questionIds: Array<Scalars['Int']>;
};


export type MutationDeleteBouncedEmailRecipientsArgs = {
  emails: Array<InputMaybe<Scalars['String']>>;
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCommentAnalysisArgs = {
  input?: InputMaybe<CommentsSummaryInput>;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDynamicAttributeRecipeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteFromLifecycleDoNotContactListArgs = {
  employeeId: Scalars['Int'];
};


export type MutationDeleteLanguageArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteLifecycleSurveyTriggerArgs = {
  id: Scalars['Int'];
  shouldClearPendingEmployees?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeletePendingUsersArgs = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};


export type MutationDeleteSurveyArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  languageId?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['Int'];
};


export type MutationDeleteSurveyElementArgs = {
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
};


export type MutationDeleteSurveyQuestionAssociationsArgs = {
  benchmarkQuestionId: Scalars['Int'];
  surveyQuestionIds: Array<Scalars['Int']>;
};


export type MutationDeleteSurveyReminderArgs = {
  reminderId: Scalars['Int'];
};


export type MutationDeleteSurveyTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteSurveyTypeArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserActionArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteUserPermissionArgs = {
  id: Scalars['Int'];
};


export type MutationDisableOpenSurveyAccessCodeArgs = {
  surveyId: Scalars['Int'];
};


export type MutationDuplicateSurveyArgs = {
  clientTimezone?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  languageId?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['Int'];
  surveyName: Scalars['String'];
};


export type MutationExecuteScheduledRemindersArgs = {
  reminderId?: InputMaybe<Scalars['Int']>;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenCommentsAnalysisArgs = {
  input?: InputMaybe<CommentsAnalysisInput>;
};


export type MutationGenCommentsSummaryForContinuousSurveyArgs = {
  input: ContinuousSurveyCommentSummaryInput;
};


export type MutationGenThemesAnalysisArgs = {
  surveyElementId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']>;
};


export type MutationGenerateCommentsSummaryArgs = {
  input: CommentsSummaryInput;
};


export type MutationGenerateOpenSurveyAccessCodeArgs = {
  surveyId: Scalars['Int'];
};


export type MutationImpersonateUserArgs = {
  userId: Scalars['Int'];
};


export type MutationImportEmployeesArgs = {
  companyId: Scalars['Int'];
  employees: Array<EmployeeImportInput>;
  hasRoleUpdate?: InputMaybe<Scalars['Boolean']>;
  isUpdate: Scalars['Boolean'];
};


export type MutationInviteUserArgs = {
  companyId: Scalars['Int'];
  preferredLanguageId: Scalars['Int'];
  userEmails: Array<InputMaybe<Scalars['String']>>;
  userPermissions: Array<InputMaybe<UserPermisionUpdateInput>>;
};


export type MutationLinkQuestionsForTrendingArgs = {
  input: LinkQuestionsForTrendingInput;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginEmployeeArgs = {
  accessCode: Scalars['String'];
};


export type MutationMigrateSurveyArgs = {
  companyId: Scalars['Int'];
  fileUrl: Scalars['String'];
  overwriteSurveyData: Scalars['Boolean'];
  surveyConfig: SurveyConfigInput;
};


export type MutationPopulateThemesAnalysisArgs = {
  input: ThemesAnalysisInput;
};


export type MutationPrivateAttributeExportedNotifierArgs = {
  companyId: Scalars['Int'];
};


export type MutationRateContentArgs = {
  contentId: Scalars['Int'];
  rating: Scalars['Int'];
};


export type MutationReadContentArgs = {
  contentId: Scalars['Int'];
};


export type MutationRegenerateAiSummaryArgs = {
  surveyId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationRemoveEmployeeChannelFromDoNotContactListArgs = {
  input: RemoveEmployeeChannelFromDoNotContactListInput;
};


export type MutationResendSurveyInvitationArgs = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  surveyId: Scalars['Int'];
};


export type MutationScheduleAiSurveySummaryArgs = {
  filters?: InputMaybe<AiSummaryFiltersInput>;
  surveyId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationScheduleEmployeeImportArgs = {
  companyId: Scalars['Int'];
  fileContents: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
  mode: EmployeeImportMode;
};


export type MutationScheduleSurveyReminderArgs = {
  reminderTexts?: InputMaybe<Array<InputMaybe<SurveyReminderInput>>>;
  surveyId: Scalars['Int'];
};


export type MutationSendTestSlackArgs = {
  input: SendTestSlackInput;
};


export type MutationSendTestSmsArgs = {
  input: SendTestSmsInput;
};


export type MutationSendTestSurveyArgs = {
  surveyId: Scalars['Int'];
};


export type MutationSetNewPasswordWithTokenArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSetOpenSurveyAccessCodeArgs = {
  accessCode: Scalars['String'];
  surveyId: Scalars['Int'];
};


export type MutationSetOpenSurveyMonthlyResponseLimitArgs = {
  companyId: Scalars['Int'];
  limit: Scalars['Int'];
};


export type MutationSetRehireAttributeArgs = {
  attributeId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type MutationStarContentArgs = {
  contentId: Scalars['Int'];
  starred: Scalars['Boolean'];
};


export type MutationSubmitMultipleQuestionArgs = {
  answerTimestamp: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  hashCode: Scalars['String'];
  questionId: Scalars['Int'];
  selectedOptions?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  skippedQuestion?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitOpenSurveyResponseArgs = {
  answers: Array<OpenSurveyAnswerInput>;
  clientToken: Scalars['String'];
  idempotencyKey: Scalars['String'];
  openSurveyAccessCode?: InputMaybe<Scalars['String']>;
  openSurveyExternalId: Scalars['String'];
};


export type MutationSubmitScaleQuestionArgs = {
  answerTimestamp: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  hashCode: Scalars['String'];
  questionId: Scalars['Int'];
  rating?: InputMaybe<Scalars['Int']>;
  skippedQuestion?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitSurveyArgs = {
  hashCode: Scalars['String'];
};


export type MutationSubmitTextQuestionArgs = {
  answerText?: InputMaybe<Scalars['String']>;
  answerTimestamp: Scalars['String'];
  hashCode: Scalars['String'];
  questionId: Scalars['Int'];
  skippedQuestion?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSwitchAccountArgs = {
  companyId: Scalars['Int'];
};


export type MutationTriggerCronjobArgs = {
  name: Scalars['String'];
};


export type MutationUpdateAttributeArgs = {
  attribute: AttributeUpdateInput;
  companyId: Scalars['Int'];
  id: Scalars['Int'];
};


export type MutationUpdateAttributeTypeArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationUpdateAutomaticSurveyReminderArgs = {
  automaticSurveyReminder?: InputMaybe<AutomaticSurveyReminderInput>;
};


export type MutationUpdateBenchmarkAttributeArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  translationKey?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBenchmarkAttributeValueArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type MutationUpdateCategoryArgs = {
  category: CategoryUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateCommentSentimentArgs = {
  newSentiment: Scalars['String'];
  snapshotId: Scalars['Int'];
  surveyElementId: Scalars['Int'];
};


export type MutationUpdateCompanyArgs = {
  company: CompanyUpdateInput;
  id: Scalars['Int'];
};


export type MutationUpdateCompanyBenchmarkAttributeValueArgs = {
  benchmarkAttributeValueId: Scalars['Int'];
  companyId: Scalars['Int'];
  ungroupedValue?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateCompanyEmployeeIdsArgs = {
  companyId: Scalars['Int'];
  updateEmployeeIdInput: Array<UpdateEmployeeIds>;
};


export type MutationUpdateCompanyMessagingConfigArgs = {
  input: UpdateCompanyMessagingConfigInput;
};


export type MutationUpdateCompanySurveyTypeArgs = {
  companyId: Scalars['Int'];
  surveyType?: InputMaybe<CompanySurveyTypeInput>;
  surveyTypeId: Scalars['Int'];
  surveyTypeNames?: InputMaybe<Array<InputMaybe<CompanySurveyTypeNameInput>>>;
};


export type MutationUpdateConversationReactionArgs = {
  conversationReaction: ConversationReactionInput;
};


export type MutationUpdateEmployeeArgs = {
  companyId: Scalars['Int'];
  employee: EmployeeEditInput;
  employeeId: Scalars['Int'];
};


export type MutationUpdateLifecycleSurveyRecipientsArgs = {
  lifecycleSurveyRecipients: Array<InputLifecycleSurveyRecipients>;
};


export type MutationUpdateRecipientListArgs = {
  employeeIds: Array<InputMaybe<Scalars['Int']>>;
  surveyId: Scalars['Int'];
};


export type MutationUpdateSurveyArgs = {
  id: Scalars['Int'];
  survey: SurveyUpdateInput;
};


export type MutationUpdateSurveyElementArgs = {
  surveyElement: SurveyElementUpdateInput;
  surveyId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateSurveyQuestionsSortingArgs = {
  id: Scalars['Int'];
  survey: SurveyUpdateInput;
};


export type MutationUpdateSurveyTemplateArgs = {
  audienceMode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<InputSurveyTemplateEmail>;
  id: Scalars['Int'];
  lifecycleSurveyTypeId?: InputMaybe<Scalars['Int']>;
  names?: InputMaybe<Array<InputMaybe<InputSurveyTemplateNames>>>;
  status?: InputMaybe<Scalars['String']>;
  surveyElements?: InputMaybe<Array<InputMaybe<InputSurveyElement>>>;
};


export type MutationUpdateSurveyTemplateStatusArgs = {
  newStatus: SurveyTemplateStatus;
  templateId: Scalars['Int'];
};


export type MutationUpdateUserPermissionArgs = {
  permissionId: Scalars['Int'];
  userId: Scalars['Int'];
  userPermission: UserPermisionUpdateInput;
};


export type MutationUpdateUsersStatusArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  status: UserStatusEnum;
};


export type MutationUpsertDynamicAttributeRecipeArgs = {
  input: UpsertDynamicAttributeRecipeInput;
};


export type MutationUpsertLifecycleSurveyTriggerArgs = {
  lifecycleSurveyTrigger: InputLifecycleSurveyTrigger;
};


export type MutationUpsertLifecycleSurveyTriggerTypesArgs = {
  lifecycleSurveyTriggerTypes: Array<InputLifecycleSurveyTriggerType>;
};


export type MutationUpsertSurveyMessagingArgs = {
  input: UpsertSurveyMessagingInput;
};

export type Name = {
  __typename?: 'Name';
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type NewBenchmarkQuestion = {
  __typename?: 'NewBenchmarkQuestion';
  associatedQuestions: Array<Maybe<AssociatedQuestion>>;
  questionId: Scalars['Int'];
  questionText: Scalars['String'];
  surveyCount: Scalars['Int'];
  surveyYears: Array<Maybe<Scalars['Int']>>;
};

export type NotInvitedManager = {
  __typename?: 'NotInvitedManager';
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['String'];
  employeeSurveySnapshotId?: Maybe<Scalars['Int']>;
  fullName?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
};

export type OpenSurvey = {
  __typename?: 'OpenSurvey';
  id: Scalars['Int'];
  name: Scalars['String'];
  /** The questions to render, in survey order. */
  questions: Array<SurveyElement>;
};

export type OpenSurveyAccess = {
  __typename?: 'OpenSurveyAccess';
  status: OpenSurveyAccessStatus;
  /** Present only when the status is ACCESSIBLE. */
  survey?: Maybe<OpenSurvey>;
};

export enum OpenSurveyAccessStatus {
  Accessible = 'ACCESSIBLE',
  AccessCodeIncorrect = 'ACCESS_CODE_INCORRECT',
  AccessCodeRequired = 'ACCESS_CODE_REQUIRED',
  /** An unknown external id, a survey that has not started, or one that has closed, so the query never confirms which ids are real. */
  Unavailable = 'UNAVAILABLE'
}

/**
 * One question's answer within a submitOpenSurveyResponse call. Exactly one of selectedChoiceIds /
 * scaleValue / textValue is populated, matching the question's own type - except when notDisclosed is
 * true, in which case all three are empty.
 */
export type OpenSurveyAnswerInput = {
  /** Optional free text attached alongside a DROPDOWN/YES_NO/MULTIPLE or SCALE-like answer, mirroring the real response tables' comment column. */
  comment?: InputMaybe<Scalars['String']>;
  /** True if the respondent reached this question and chose not to answer it, rather than never reaching it. When true, selectedChoiceIds/scaleValue/textValue are all empty. */
  notDisclosed?: InputMaybe<Scalars['Boolean']>;
  /** The rating given, for a SCALE-like question (SLIDING, YES_NO, FIXED, or NPS). */
  scaleValue?: InputMaybe<Scalars['Int']>;
  /** The chosen option(s), for a DROPDOWN, YES_NO, or MULTIPLE question. A single-select question always has exactly one entry. Empty for SCALE/OPEN questions. */
  selectedChoiceIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Which question this answer is for. */
  surveyElementId: Scalars['Int'];
  /** The free-text answer, for an OPEN (text) question. */
  textValue?: InputMaybe<Scalars['String']>;
};

/** A survey-scoped attribute whose value a respondent gives by answering one Open Survey question. */
export type OpenSurveyAttribute = {
  __typename?: 'OpenSurveyAttribute';
  id: Scalars['Int'];
  name: Scalars['String'];
  sourceAttributeId?: Maybe<Scalars['Int']>;
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
};

export type OpenSurveyAttributeInput = {
  /** Label for the attribute in reporting. Unique within the survey. */
  name: Scalars['String'];
  /** The company attribute whose values seeded the question's answer options. */
  sourceAttributeId?: InputMaybe<Scalars['Int']>;
};

/**
 * Coarse, non-identifying totals for the "N responses from M devices" indicator. Exposes counts only,
 * never a per-device or per-respondent value.
 */
export type OpenSurveyDeviceCount = {
  __typename?: 'OpenSurveyDeviceCount';
  /** Null when no device information was recorded, for example responses submitted before device counting existed. */
  deviceCount?: Maybe<Scalars['Int']>;
  responseCount: Scalars['Int'];
};

export type OpenSurveyMonthlyResponseLimit = {
  __typename?: 'OpenSurveyMonthlyResponseLimit';
  companyId: Scalars['Int'];
  /** Most responses one Open Survey of the company accepts per calendar month (UTC). */
  limit: Scalars['Int'];
};

export type OpenSurveyResponseUsage = {
  __typename?: 'OpenSurveyResponseUsage';
  /** The most responses the survey accepts per calendar month. Set per company by WorkTango; not editable by the company. */
  limit: Scalars['Int'];
  remaining: Scalars['Int'];
  used: Scalars['Int'];
};

export type OutputAddedByUser = {
  __typename?: 'OutputAddedByUser';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['Int'];
};

export type OutputAdminApprover = {
  __typename?: 'OutputAdminApprover';
  userId: Scalars['Int'];
};

export type OutputAttributes = {
  __typename?: 'OutputAttributes';
  attributeId: Scalars['Int'];
  attributeValue: Scalars['String'];
};

export type OutputAutomaticSurveyReminder = {
  __typename?: 'OutputAutomaticSurveyReminder';
  automaticSurveyReminderLanguages?: Maybe<Array<Maybe<OutputAutomaticSurveyReminderLanguage>>>;
  id: Scalars['Int'];
  reminderFrequencyDays: Scalars['Int'];
  sendTime: Scalars['String'];
  status: Scalars['String'];
  surveyId: Scalars['Int'];
};

export type OutputAutomaticSurveyReminderLanguage = {
  __typename?: 'OutputAutomaticSurveyReminderLanguage';
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
  languageId: Scalars['Int'];
};

export type OutputDeleteSurveyTemplateResponse = {
  __typename?: 'OutputDeleteSurveyTemplateResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OutputLanguages = {
  __typename?: 'OutputLanguages';
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type OutputLifecycleSurveyDoNotContactList = {
  __typename?: 'OutputLifecycleSurveyDoNotContactList';
  addedAtTimeUTC: Scalars['String'];
  addedByUser?: Maybe<OutputAddedByUser>;
  doNotContactReason?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['Int'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

export type OutputLifecycleSurveyRecipients = {
  __typename?: 'OutputLifecycleSurveyRecipients';
  addedToListDate: Scalars['String'];
  employeeId: Scalars['Int'];
  exitDate?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  isApprovedToAdd: Scalars['Boolean'];
  lastName: Scalars['String'];
  lifecycleSurveyTriggerId: Scalars['Int'];
  requireAdminApproval: Scalars['Boolean'];
  startDate?: Maybe<Scalars['String']>;
  targetInvitationDate: Scalars['String'];
  targetSurvey?: Maybe<OutputSurvey>;
  triggerTypeId?: Maybe<Scalars['Int']>;
};

export type OutputLifecycleSurveyRecipientsUpdate = {
  __typename?: 'OutputLifecycleSurveyRecipientsUpdate';
  addToDoNotContact?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  inviteImmediately?: Maybe<Scalars['Boolean']>;
  isApprovedToAdd?: Maybe<Scalars['Boolean']>;
  removeFromList?: Maybe<Scalars['Boolean']>;
};

export type OutputLifecycleSurveyTrigger = {
  __typename?: 'OutputLifecycleSurveyTrigger';
  adminApprovers?: Maybe<Array<Maybe<OutputAdminApprover>>>;
  attributeAudience?: Maybe<Array<Maybe<OutputAttributes>>>;
  audienceType: Scalars['String'];
  id: Scalars['Int'];
  invitationOffsetDays: Scalars['Int'];
  languages?: Maybe<Array<Maybe<OutputLanguages>>>;
  lifecycleSurveyTypeId: Scalars['Int'];
  requireAdminApproval: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  superAdminApprovers?: Maybe<Array<Maybe<OutputAdminApprover>>>;
  surveyId: Scalars['Int'];
  timeOfDayEndUTC: Scalars['String'];
  timeOfDayStartUTC: Scalars['String'];
  triggerAttributeId: Scalars['Int'];
};

export type OutputLifecycleSurveyTriggerTypes = {
  __typename?: 'OutputLifecycleSurveyTriggerTypes';
  id: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
  type: Scalars['String'];
};

export type OutputLifecycleSurveyType = {
  __typename?: 'OutputLifecycleSurveyType';
  id: Scalars['Int'];
  type: Scalars['String'];
};

export type OutputResult = {
  __typename?: 'OutputResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OutputSurvey = {
  __typename?: 'OutputSurvey';
  id: Scalars['Int'];
  name: Scalars['String'];
  surveyId: Scalars['Int'];
};

export type OutputSurveyElement = {
  __typename?: 'OutputSurveyElement';
  orderIndex: Scalars['Int'];
  surveyElementId: Scalars['Int'];
};

export type OutputSurveyTemplate = {
  __typename?: 'OutputSurveyTemplate';
  audienceMode: Scalars['String'];
  id: Scalars['Int'];
  lifecycleSurveyTypeId?: Maybe<Scalars['Int']>;
  names: Array<OutputSurveyTemplateNames>;
  status: Scalars['String'];
  surveyElements?: Maybe<Array<Maybe<SurveyElement>>>;
  surveyTemplateLanguages?: Maybe<Array<OutputSurveyTemplateLanguage>>;
  surveyType: SurveyType;
  surveyTypeId: Scalars['Int'];
  updated: Scalars['DateTime'];
};

export type OutputSurveyTemplateLanguage = {
  __typename?: 'OutputSurveyTemplateLanguage';
  emailContent: Scalars['String'];
  emailSubject: Scalars['String'];
  languageId: Scalars['Int'];
};

export type OutputSurveyTemplateNames = {
  __typename?: 'OutputSurveyTemplateNames';
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type OutputUpdateSurveyTemplateStatus = {
  __typename?: 'OutputUpdateSurveyTemplateStatus';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  updated: Scalars['DateTime'];
};

/** Overall Attribute item for Reporting -> Analyze Tab */
export type OverallAttribute = {
  __typename?: 'OverallAttribute';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  spread?: Maybe<OverallAttributeSpread>;
  values?: Maybe<Array<Maybe<StatisticsAttributeValue>>>;
};

/** Overall Spread item for Reporting -> Analyze Tab */
export type OverallAttributeSpread = {
  __typename?: 'OverallAttributeSpread';
  distribution?: Maybe<OverallAttributeSpreadDistribution>;
  score?: Maybe<OverallAttributeSpreadScore>;
};

/** Overall Spread Distribution item for Reporting -> Analyze Tab */
export type OverallAttributeSpreadDistribution = {
  __typename?: 'OverallAttributeSpreadDistribution';
  enps?: Maybe<FloatMinMax>;
  percentage?: Maybe<FloatMinMax>;
};

/** Overall Spread Score item for Reporting -> Analyze Tab */
export type OverallAttributeSpreadScore = {
  __typename?: 'OverallAttributeSpreadScore';
  average?: Maybe<FloatMinMax>;
  enps?: Maybe<FloatMinMax>;
  positive?: Maybe<FloatMinMax>;
};

/** Overall Attributes list for both ENPS and NON ENPS factor types */
export type OverallAttributesWithAllFactors = {
  __typename?: 'OverallAttributesWithAllFactors';
  enpsOverallAttributes?: Maybe<Array<Maybe<OverallAttribute>>>;
  nonEnpsOverallAttributes?: Maybe<Array<Maybe<OverallAttribute>>>;
};

/** Overall result for Reporting ->  Result Tab */
export type OverallQuestionResult = {
  __typename?: 'OverallQuestionResult';
  addedDateUTC?: Maybe<Scalars['DateTime']>;
  aggregatedCommentSentiments?: Maybe<OverallResultAggregatedCommentSentiments>;
  average?: Maybe<Scalars['Float']>;
  discontinuedDateUTC?: Maybe<Scalars['DateTime']>;
  iconPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  maxRating?: Maybe<Scalars['Int']>;
  minRating?: Maybe<Scalars['Int']>;
  numberOfComments?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<OverallResultOption>>>;
  ratings?: Maybe<Array<Maybe<OverallResultRating>>>;
  surveyElementId?: Maybe<Scalars['Int']>;
  surveyElementTypeName?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  totalAnswered?: Maybe<Scalars['Int']>;
  totalRespondents?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Overall result aggregated comment sentiments for text questions -> Result Tab */
export type OverallResultAggregatedCommentSentiments = {
  __typename?: 'OverallResultAggregatedCommentSentiments';
  numberOfNegativeComments?: Maybe<Scalars['Int']>;
  numberOfNeutralComments?: Maybe<Scalars['Int']>;
  numberOfPositiveComments?: Maybe<Scalars['Int']>;
  numberOfUnknownComments?: Maybe<Scalars['Int']>;
};

/** Overall result option for Reporting ->  Result Tab */
export type OverallResultOption = {
  __typename?: 'OverallResultOption';
  id?: Maybe<Scalars['Int']>;
  numberOfComments?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  totalAnswered?: Maybe<Scalars['Int']>;
};

/** Overall result rating for Reporting ->  Result Tab */
export type OverallResultRating = {
  __typename?: 'OverallResultRating';
  numberOfComments?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  rating?: Maybe<Scalars['Int']>;
  totalAnswered?: Maybe<Scalars['Int']>;
};

/** Search Input for the query overallSpreadAttributes */
export type OverallSpreadAttributesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};

/** One channel's send status for a survey participant. */
export type ParticipantChannel = {
  __typename?: 'ParticipantChannel';
  channel: ParticipantChannelType;
  /** Timestamp of the latest successful send on this channel; null unless status is SENT. */
  lastSentAt?: Maybe<Scalars['DateTime']>;
  status: ParticipantChannelStatus;
};

/**
 * The delivery state of one channel for one participant. A row handed to the provider
 * (waiting/failure/success) is SENT; a row still queued locally (NOT_SENT/SENDING) is
 * WAITING; no send record at all is NOT_SENT (not invited). Delivery failures are folded
 * into SENT — there is no failed state.
 */
export enum ParticipantChannelStatus {
  NotSent = 'NOT_SENT',
  Sent = 'SENT',
  Waiting = 'WAITING'
}

/**
 * A messaging channel a survey participant can be reached on. Includes EMAIL alongside
 * the external channels so the participant list can render one status per channel.
 */
export enum ParticipantChannelType {
  Email = 'EMAIL',
  Slack = 'SLACK',
  Sms = 'SMS',
  Teams = 'TEAMS'
}

/** Lightweight employee record used to populate the preview impersonation combobox */
export type PreviewEmployee = {
  __typename?: 'PreviewEmployee';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _dummy?: Maybe<Scalars['String']>;
  /** List all active WorkTango admin users (worktangoAdmin = true, not deleted). */
  adminUsers?: Maybe<Array<Maybe<User>>>;
  attribute?: Maybe<Attribute>;
  /**
   * Lists the users and roles whose attribute-based permissions would be left with no
   * attributes if the given attribute were archived. Use this to warn admins before
   * they archive an attribute that other people's permissions depend on.
   */
  attributeArchiveImpact: AttributeArchiveImpact;
  attributeType?: Maybe<AttributeType>;
  attributeTypes?: Maybe<Array<Maybe<AttributeType>>>;
  attributes?: Maybe<Array<Maybe<Attribute>>>;
  attributesRatingResponses?: Maybe<RatingResponsesStats>;
  categoriesAndQuestionScaleRatingResponses?: Maybe<SlideRatingStatistics>;
  category?: Maybe<Category>;
  categoryById?: Maybe<Category>;
  coachComments: Comments;
  comments: Comments;
  commentsSummary?: Maybe<CommentsSummary>;
  companies?: Maybe<Array<Maybe<Company>>>;
  company?: Maybe<Company>;
  companyById?: Maybe<Company>;
  /** Config for the caller's own company (from the authenticated request context) — there is no cross-company use case for this today. */
  companyConfigs?: Maybe<CompanyConfigs>;
  /**
   * Company admins (COMPANY_CONFIGURATION) and super admins only. Returns every channel config for
   * the acting user's company (derived from context), with credentials stripped.
   */
  companyMessagingConfigs: Array<CompanyMessagingConfig>;
  companySurveyTypes?: Maybe<Array<Maybe<CompanySurveyType>>>;
  compareStatistics?: Maybe<Array<Maybe<CompareStatisticsItem>>>;
  contentTypes?: Maybe<Array<Maybe<ContentType>>>;
  continuousSurveyTrendsAnalysis: TimeframeTrendsResults;
  conversationByToken?: Maybe<Conversation>;
  conversationsList?: Maybe<Array<Maybe<ConversationsListItem>>>;
  conversationsMessages?: Maybe<Array<Maybe<MinimalConversationMessage>>>;
  conversationsReactions?: Maybe<Array<Maybe<ConversationReaction>>>;
  dashboardSurveys?: Maybe<DashboardSurveysResult>;
  /** Every transformation recipe for the requesting user's company. */
  dynamicAttributeRecipes: Array<DynamicAttributeRecipe>;
  employee?: Maybe<Employee>;
  /** Employees opted out of the given messaging channel for the requesting user's company. */
  employeeChannelDoNotContactList: EmployeeChannelDoNotContactListResult;
  employeeDetails?: Maybe<EmployeeDetails>;
  /** Every column mapping configured for the requesting user's company. */
  employeeImportColumnMappings: Array<EmployeeImportColumnMapping>;
  employeeImportTask: EmployeeImportTask;
  employeeImportTasks?: Maybe<EmployeeImportTasks>;
  /** Every custom transformation configured for the requesting user's company. */
  employeeImportTransformations: Array<EmployeeImportTransformation>;
  employeeSurvey?: Maybe<EmployeeSurvey>;
  employeeSurveyResult?: Maybe<Array<Maybe<OverallQuestionResult>>>;
  entities?: Maybe<Entities>;
  findAllBenchmarkAttributes: Array<BenchmarkAttribute>;
  findAllCompaniesBenchmarkSettings: Array<Maybe<CompanyBenchmarkSetting>>;
  findAllRegionsWithCountries: Array<RegionToCountriesHierarchy>;
  findAltNamesForValueById: Array<Maybe<BenchmarkAttributeValueAltName>>;
  findAttributeSampleValues: Array<Maybe<Scalars['String']>>;
  findAvailableBenchmarks: Array<Maybe<Scalars['String']>>;
  findBenchmarkAttributeById: BenchmarkAttribute;
  findBenchmarkQuestions: Array<Maybe<BenchmarkQuestion>>;
  findBenchmarks: Array<Maybe<Benchmark>>;
  findCompanyBenchmarkAttributeValues: Array<Maybe<CompanyBenchmarkAttributeValue>>;
  findCompanyBenchmarkSettings: CompanyBenchmarkSettings;
  findCompanyEmployeeAttributes: Array<Maybe<EmployeeAttribute>>;
  findCountriesForRegionByName: RegionToCountriesHierarchy;
  findMappedQuestionsForBenchmarkQuestion: Array<Maybe<SurveyQuestion>>;
  /**
   * The benchmark attribute values this survey can be compared against for a period, used to populate
   * the comparison picker on the Analyze page. Only values with at least five contributing companies
   * are returned, since reporting suppresses anything below that.
   */
  findSelectableBenchmarkValues: Array<SelectableBenchmarkAttribute>;
  findSurveyReminderByReminderId: SurveyReminderWithLanguageOutput;
  findSurveyReminderCountBySurveyId: SurveyReminderCountOutput;
  findSurveyRemindersBySurveyId: Array<SurveyReminderOutput>;
  findUnmappedAttributeValues: Array<Maybe<Scalars['String']>>;
  findUntaggedSurveyQuestions?: Maybe<SurveyQuestionsResult>;
  findUsersByEmail: Array<UserByEmailResult>;
  /** Returns the summary generated for the given reporting filters. Omit `filters` for the whole-survey summary. */
  getAISummary?: Maybe<AiSurveySummary>;
  /**
   * Look up the activation payload for an invitation `token`. Used by the
   * account-activation flow to render the welcome page; returns
   * language + company details without requiring the user to be signed in.
   */
  getActivationUser?: Maybe<ActivationUser>;
  getAttributeEmployeeId?: Maybe<Attribute>;
  getAttributeFilters?: Maybe<AttributeFilters>;
  getAutomaticSurveyReminders: Array<Maybe<OutputAutomaticSurveyReminder>>;
  getBaseSurveyTypes: Array<Maybe<BaseSurveyType>>;
  getCompanyAttributeValues?: Maybe<CompanyAttributeValues>;
  getCompanyBrand?: Maybe<CompanyBrand>;
  getCompanyConfigDetails?: Maybe<CompanyConfigDetails>;
  getCompanyEmployeeIdsInSurvey?: Maybe<Array<Maybe<Scalars['String']>>>;
  getCompanyUsers?: Maybe<Array<Maybe<User>>>;
  getCronjobRunStatuses: Array<CronjobRunStatus>;
  getCronjobs: Array<CronjobInfo>;
  getDefaultContextsAndPrompts: Array<Maybe<DefaultContextAndPrompt>>;
  getFailedSurveyMigrationTasks?: Maybe<Array<Maybe<SurveyMigrationTask>>>;
  getLifecycleSurveyDoNotContactList?: Maybe<Array<Maybe<OutputLifecycleSurveyDoNotContactList>>>;
  getLifecycleSurveyRecipients?: Maybe<Array<Maybe<OutputLifecycleSurveyRecipients>>>;
  getLifecycleSurveyTrigger?: Maybe<OutputLifecycleSurveyTrigger>;
  getLifecycleSurveyTriggerTypes?: Maybe<Array<Maybe<OutputLifecycleSurveyTriggerTypes>>>;
  getLifecycleSurveyTriggers?: Maybe<Array<Maybe<OutputLifecycleSurveyTrigger>>>;
  getLifecycleSurveyTypes: Array<Maybe<OutputLifecycleSurveyType>>;
  getPrimaryAttributes?: Maybe<Array<Maybe<Attribute>>>;
  getQuestionComments: Array<Maybe<Comments>>;
  getQuestionThemes: QuestionTheme;
  getRehireAttribute?: Maybe<RehireAttribute>;
  getSurveyAttributeHierarchy?: Maybe<SurveyAttributeHierarchy>;
  getSurveyParticipants: Array<Maybe<SurveyParticipants>>;
  getSurveyTemplate: OutputSurveyTemplate;
  getSurveyTemplates: Array<Maybe<OutputSurveyTemplate>>;
  /**
   * Fetch the deep permission shape (userActions, visible/compare attributes,
   * attribute-based permissions) only for the requested `userIds`. Used by
   * the UserEdit page so the company-wide list can stay on the cheap summary
   * path. Caller is the logged-in user; `companyId` scopes the lookup.
   */
  getUsersWithPermissions?: Maybe<Array<Maybe<User>>>;
  globalActions?: Maybe<Array<Maybe<GlobalAction>>>;
  icons?: Maybe<Array<Maybe<Icon>>>;
  keyPhrases?: Maybe<KeyPhrases>;
  kioskCompany?: Maybe<KioskCompany>;
  kioskSurveys?: Maybe<Array<Maybe<KioskSurvey>>>;
  language?: Maybe<Language>;
  languages?: Maybe<Array<Maybe<Language>>>;
  learningContent?: Maybe<Array<Maybe<LearningContent>>>;
  libraryQuestions?: Maybe<SurveyElementCount>;
  /** Public: a respondent has no session, so the external id and access code are the only credentials. */
  openSurvey: OpenSurveyAccess;
  openSurveyAttributes: Array<OpenSurveyAttribute>;
  /** Rough device count behind an Open Survey's responses, for the admin results view. Requires permission to manage the survey. */
  openSurveyDeviceCount: OpenSurveyDeviceCount;
  /** How many responses an Open Survey has accepted this calendar month (UTC) against its company's monthly limit. */
  openSurveyResponseUsage: OpenSurveyResponseUsage;
  overallSpreadAttributes?: Maybe<OverallAttributesWithAllFactors>;
  overallSurveyResults?: Maybe<Array<Maybe<OverallQuestionResult>>>;
  previewEmployeeSearch?: Maybe<Array<Maybe<PreviewEmployee>>>;
  previousQuestions?: Maybe<SurveyElementCount>;
  questionMultipleChoiceResponsesByAttributes?: Maybe<Array<Maybe<MultipleChoiceQuestionStatistics>>>;
  questionScaleRatingResponses?: Maybe<SlideRatingStatistics>;
  questionsKeyPhrases: Array<Maybe<QuestionKeyPhrases>>;
  savedCommentsSummary?: Maybe<CommentsSummary>;
  /** Company admins (COMPANY_CONFIGURATION) and super admins only. Returns a generated URL from slack. Going to that URL will allow the admin at a company to authorize the WorkTango Slack App for their internal slack instance. */
  slackOAuthAuthorizeUrl: Scalars['String'];
  survey?: Maybe<Survey>;
  surveyElement?: Maybe<SurveyElement>;
  surveyElementById?: Maybe<SurveyElement>;
  surveyElementLanguages?: Maybe<Array<Maybe<SurveyElementQuestionLanguage>>>;
  surveyElementOptionChoicesById?: Maybe<SurveyElementOptionsChoices>;
  surveyElements?: Maybe<SurveyElementCount>;
  /**
   * The saved messaging state for every external channel (SMS, Slack, Teams) on a survey,
   * used to hydrate the share page. Channels with no configuration come back disabled with
   * a null variationKey.
   */
  surveyMessagingChannels: Array<SurveyMessaging>;
  /**
   * Per-recipient send status (email + SMS) for a single page of survey recipients, used to
   * render the participant list's invitation-channel column. Pass exactly the `employeeIds`
   * currently visible on the page — the result is scoped to those recipients rather than the
   * whole survey. Ids outside the survey's company are ignored; ids with no send record (e.g.
   * recipients the admin has added but not yet saved) come back as NOT_SENT.
   */
  surveyParticipantChannelStatuses: Array<SurveyParticipantChannels>;
  /**
   * SMS reachability (opt-out + phone-on-file) for every recipient of a survey. Covers all
   * saved recipients plus any additional (unsaved) `employeeIds`, because the pre-send summary
   * needs the full list — both the recipients already on the survey and the ones being added.
   *
   * `smsAttributeId` previews reachability against a phone attribute the caller is considering
   * on the Share step but has not saved yet; when omitted it falls back to the attribute
   * persisted on the survey's SMS message batch. Ids outside the survey's company are ignored.
   */
  surveyParticipantSmsReachability: Array<SurveyParticipantSmsReachability>;
  surveyResponsesExport?: Maybe<SurveyResponsesExport>;
  surveyType?: Maybe<SurveyType>;
  surveyTypeAttributes?: Maybe<Array<Maybe<Attribute>>>;
  surveyTypeById?: Maybe<SurveyType>;
  surveyTypeCategories?: Maybe<Array<Maybe<Category>>>;
  surveyTypes?: Maybe<Array<Maybe<SurveyType>>>;
  surveys?: Maybe<Array<Maybe<Survey>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Returns questions eligible to be linked for trending across the given surveys. Super admin only. */
  trendingLinkCandidates: Array<TrendingLinkCandidate>;
  trendsResult?: Maybe<AggregatedTrendResult>;
  /**
   * Fetch a single user by id. Caller must have permission to access the
   * target user (`areUsersAccessible`); otherwise the query is rejected.
   */
  user?: Maybe<User>;
  /** Fetch a single user-action row by id. */
  userAction?: Maybe<UserAction>;
  /** List user-action rows, optionally filtered by `search`. */
  userActions?: Maybe<Array<Maybe<UserAction>>>;
  /**
   * Internal stitching entry-point: fetch a user by id without permission
   * checks. Used by the gateway's `User` merge config to hydrate the full
   * User shape when another subschema returns a stub `{ id }`.
   * Application code should prefer `user(id)` so the permission check runs.
   */
  userById?: Maybe<User>;
  /**
   * Fetch a single user-permission row by id. Caller must have permission
   * to access the target user-permission (`canAccessUserPermission`).
   */
  userPermission?: Maybe<UserPermission>;
  /**
   * List user-permission rows the caller can access. Always filtered to
   * ids returned by `getAccessibleUserPermissionIds`.
   */
  userPermissions?: Maybe<Array<Maybe<UserPermission>>>;
  /**
   * List users the caller can access. Always filtered to ids returned by
   * `getAccessibleUserIds`. The `search` input narrows the list further.
   * Returned users never include the password hash.
   */
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryAttributeArgs = {
  id: Scalars['Int'];
};


export type QueryAttributeArchiveImpactArgs = {
  attributeId: Scalars['Int'];
  companyId: Scalars['Int'];
};


export type QueryAttributeTypeArgs = {
  id: Scalars['Int'];
};


export type QueryAttributeTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<AttributeTypeInput>;
};


export type QueryAttributesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<AttributeSearchInput>;
};


export type QueryAttributesRatingResponsesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  skipUserPermission?: InputMaybe<Scalars['Boolean']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryCategoriesAndQuestionScaleRatingResponsesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  calculateAttribute?: Scalars['Boolean'];
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int'];
};


export type QueryCategoryByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryCoachCommentsArgs = {
  input: CoachCommentsInput;
};


export type QueryCommentsArgs = {
  input: CommentsInput;
};


export type QueryCommentsSummaryArgs = {
  input: CommentsSummaryInput;
};


export type QueryCompaniesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<CompanySearchInput>;
};


export type QueryCompanyArgs = {
  id: Scalars['Int'];
};


export type QueryCompanyByIdArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryCompanySurveyTypesArgs = {
  companyId: Scalars['Int'];
  includeBase?: InputMaybe<Scalars['Boolean']>;
  languageIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryCompareStatisticsArgs = {
  attributesRatingResponsesInput?: InputMaybe<AttributesRatingResponsesInput>;
  categoriesAndQuestionScaleRatingResponsesInput?: InputMaybe<CategoriesAndQuestionScaleRatingResponsesInput>;
  compareAttributes?: InputMaybe<Array<InputMaybe<AttributeWithValueInput>>>;
  compareEndpoint: CompareStatisticsEndpointEnum;
  compareSurveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  compareType: CompareStatisticsTypeEnum;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  overallSpreadAttributesInput?: InputMaybe<OverallSpreadAttributesInput>;
  questionScaleRatingResponsesInput?: InputMaybe<QuestionScaleRatingResponsesInput>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  selectedCompareTimeframe?: InputMaybe<TimeframeInput>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
};


export type QueryContinuousSurveyTrendsAnalysisArgs = {
  input: TimeframeTrendsInput;
};


export type QueryConversationByTokenArgs = {
  token: Scalars['String'];
};


export type QueryConversationsListArgs = {
  languageId: Scalars['Int'];
};


export type QueryConversationsMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<ConversationMessageSearchInput>;
};


export type QueryConversationsReactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<ConversationReactionSearchInput>;
};


export type QueryDashboardSurveysArgs = {
  companyId: Scalars['Int'];
  isASC?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<SurveyDashboardSearchInput>;
};


export type QueryEmployeeArgs = {
  id: Scalars['Int'];
};


export type QueryEmployeeChannelDoNotContactListArgs = {
  filter: EmployeeChannelDoNotContactListFilter;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployeeDetailsArgs = {
  employeeDetailsInput?: InputMaybe<EmployeeDetailsInput>;
};


export type QueryEmployeeImportTaskArgs = {
  id: Scalars['Int'];
};


export type QueryEmployeeImportTasksArgs = {
  input: EmployeeImportTasksInput;
};


export type QueryEmployeeSurveyArgs = {
  hashCode?: InputMaybe<Scalars['String']>;
  previewEmployeeId?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployeeSurveyResultArgs = {
  companyId: Scalars['Int'];
  hashCode: Scalars['String'];
};


export type QueryEntitiesArgs = {
  input: CommonInput;
};


export type QueryFindAllCompaniesBenchmarkSettingsArgs = {
  benchmarkAttributeId: Scalars['Int'];
};


export type QueryFindAltNamesForValueByIdArgs = {
  valueId: Scalars['Int'];
};


export type QueryFindAttributeSampleValuesArgs = {
  attributeId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFindBenchmarkAttributeByIdArgs = {
  id: Scalars['Int'];
};


export type QueryFindBenchmarkQuestionsArgs = {
  surveyTypeId: Scalars['Int'];
};


export type QueryFindBenchmarksArgs = {
  queryInput: BenchmarkInput;
};


export type QueryFindCompanyBenchmarkAttributeValuesArgs = {
  companyId: Scalars['Int'];
};


export type QueryFindCompanyBenchmarkSettingsArgs = {
  companyId: Scalars['Int'];
};


export type QueryFindCompanyEmployeeAttributesArgs = {
  companyId: Scalars['Int'];
};


export type QueryFindCountriesForRegionByNameArgs = {
  regionName: Scalars['String'];
};


export type QueryFindMappedQuestionsForBenchmarkQuestionArgs = {
  benchmarkQuestionId: Scalars['Int'];
};


export type QueryFindSelectableBenchmarkValuesArgs = {
  benchmarkPeriod: Scalars['String'];
  surveyId: Scalars['Int'];
};


export type QueryFindSurveyReminderByReminderIdArgs = {
  reminderId: Scalars['Int'];
};


export type QueryFindSurveyReminderCountBySurveyIdArgs = {
  surveyId: Scalars['Int'];
};


export type QueryFindSurveyRemindersBySurveyIdArgs = {
  surveyId: Scalars['Int'];
};


export type QueryFindUnmappedAttributeValuesArgs = {
  benchmarkAttributeId: Scalars['Int'];
};


export type QueryFindUntaggedSurveyQuestionsArgs = {
  surveyQuestionInput: SurveyQuestionInput;
};


export type QueryFindUsersByEmailArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryGetAiSummaryArgs = {
  filters?: InputMaybe<AiSummaryFiltersInput>;
  surveyId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type QueryGetActivationUserArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetAttributeEmployeeIdArgs = {
  companyId: Scalars['Int'];
};


export type QueryGetAttributeFiltersArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryGetAutomaticSurveyRemindersArgs = {
  surveyId: Scalars['Int'];
};


export type QueryGetCompanyAttributeValuesArgs = {
  attributeId: Scalars['Int'];
  companyId: Scalars['Int'];
  includeSnapshotValues?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  onlyEnabledEmployees?: InputMaybe<Scalars['Boolean']>;
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompanyBrandArgs = {
  id: Scalars['Int'];
};


export type QueryGetCompanyConfigDetailsArgs = {
  id: Scalars['Int'];
  includePrivateAttributes?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetCompanyEmployeeIdsInSurveyArgs = {
  surveyId: Scalars['Int'];
};


export type QueryGetCompanyUsersArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFailedSurveyMigrationTasksArgs = {
  companyId: Scalars['Int'];
};


export type QueryGetLifecycleSurveyRecipientsArgs = {
  surveyId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetLifecycleSurveyTriggerArgs = {
  id: Scalars['Int'];
};


export type QueryGetPrimaryAttributesArgs = {
  companyId: Scalars['Int'];
};


export type QueryGetQuestionCommentsArgs = {
  input: GetQuestionCommentsInput;
};


export type QueryGetQuestionThemesArgs = {
  input: GetQuestionThemesInput;
};


export type QueryGetRehireAttributeArgs = {
  companyId: Scalars['Int'];
};


export type QueryGetSurveyAttributeHierarchyArgs = {
  surveyId: Scalars['Int'];
};


export type QueryGetSurveyParticipantsArgs = {
  surveyId: Scalars['Int'];
};


export type QueryGetSurveyTemplateArgs = {
  id: Scalars['Int'];
};


export type QueryGetSurveyTemplatesArgs = {
  filterOptions?: InputMaybe<InputSurveyTemplateFilters>;
};


export type QueryGetUsersWithPermissionsArgs = {
  companyId: Scalars['Int'];
  userIds: Array<Scalars['Int']>;
};


export type QueryIconsArgs = {
  surveyElementTypeId: Scalars['Int'];
};


export type QueryKeyPhrasesArgs = {
  input: CommonInput;
};


export type QueryKioskCompanyArgs = {
  field: Scalars['String'];
  languageISOCode?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};


export type QueryKioskSurveysArgs = {
  companyId: Scalars['Int'];
  id: Scalars['String'];
};


export type QueryLanguageArgs = {
  id: Scalars['Int'];
};


export type QueryLanguagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<LanguageInput>;
};


export type QueryLibraryQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: VendorQuestionsSearchInput;
};


export type QueryOpenSurveyArgs = {
  openSurveyAccessCode?: InputMaybe<Scalars['String']>;
  openSurveyExternalId: Scalars['String'];
};


export type QueryOpenSurveyAttributesArgs = {
  surveyId: Scalars['Int'];
};


export type QueryOpenSurveyDeviceCountArgs = {
  surveyId: Scalars['Int'];
};


export type QueryOpenSurveyResponseUsageArgs = {
  surveyId: Scalars['Int'];
};


export type QueryOverallSpreadAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryOverallSurveyResultsArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryPreviewEmployeeSearchArgs = {
  hashCode: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryPreviousQuestionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: VendorQuestionsSearchInput;
};


export type QueryQuestionMultipleChoiceResponsesByAttributesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryQuestionScaleRatingResponsesArgs = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  calculateAttribute?: Scalars['Boolean'];
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeYesNoQuestion?: InputMaybe<Scalars['Boolean']>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryQuestionsKeyPhrasesArgs = {
  input: QuestionKeyPhrasesInput;
};


export type QuerySavedCommentsSummaryArgs = {
  input: CommentsSummaryInput;
};


export type QuerySurveyArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveyElementArgs = {
  id: Scalars['Int'];
};


export type QuerySurveyElementByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySurveyElementLanguagesArgs = {
  benchmarkedQuestionLanguages?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};


export type QuerySurveyElementOptionChoicesByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySurveyElementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SurveyElementSearchInput>;
};


export type QuerySurveyMessagingChannelsArgs = {
  surveyId: Scalars['ID'];
};


export type QuerySurveyParticipantChannelStatusesArgs = {
  employeeIds: Array<Scalars['ID']>;
  surveyId: Scalars['ID'];
};


export type QuerySurveyParticipantSmsReachabilityArgs = {
  employeeIds?: InputMaybe<Array<Scalars['ID']>>;
  smsAttributeId?: InputMaybe<Scalars['ID']>;
  surveyId: Scalars['ID'];
};


export type QuerySurveyResponsesExportArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  includePrivateAttributes?: InputMaybe<Scalars['Boolean']>;
  includeResponses?: InputMaybe<Scalars['Boolean']>;
  includeSurveyMetaData?: InputMaybe<Scalars['Boolean']>;
  languageId?: InputMaybe<Scalars['Int']>;
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QuerySurveyTypeArgs = {
  id: Scalars['Int'];
};


export type QuerySurveyTypeAttributesArgs = {
  companyId: Scalars['Int'];
  includePrivateAttributes?: InputMaybe<Scalars['Boolean']>;
  surveyTypeId: Scalars['Int'];
};


export type QuerySurveyTypeByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySurveyTypeCategoriesArgs = {
  companyId?: InputMaybe<Scalars['Int']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};


export type QuerySurveyTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SurveyTypeSearchInput>;
};


export type QuerySurveysArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SurveySearchInput>;
};


export type QueryTrendingLinkCandidatesArgs = {
  surveyIds: Array<Scalars['Int']>;
};


export type QueryTrendsResultArgs = {
  aggregationType: TrendsAggregationEnum;
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryUserArgs = {
  id: Scalars['Int'];
};


export type QueryUserActionArgs = {
  id: Scalars['Int'];
};


export type QueryUserActionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<UserActionInput>;
};


export type QueryUserByIdArgs = {
  id: Scalars['Int'];
};


export type QueryUserPermissionArgs = {
  id: Scalars['Int'];
};


export type QueryUserPermissionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<UserPermissionSearchInput>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<UserSearchInput>;
};

/** A previous answer for a question provided by the requesting employee */
export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answerText?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  selectedOptions?: Maybe<Array<Maybe<Scalars['Int']>>>;
  skippedQuestion?: Maybe<Scalars['Boolean']>;
};

export enum QuestionFilter {
  QuestionId = 'QUESTION_ID',
  QuestionText = 'QUESTION_TEXT'
}

export type QuestionInput = {
  questionIndex: Scalars['Int'];
  questionText: Scalars['String'];
};

export type QuestionKeyPhrases = {
  __typename?: 'QuestionKeyPhrases';
  keyPhrases?: Maybe<KeyPhrases>;
  surveyElementId: Scalars['Int'];
};

export type QuestionKeyPhrasesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  companyId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortByDescCount?: InputMaybe<Scalars['Boolean']>;
  surveyElementIds: Array<Scalars['Int']>;
  surveyIds: Array<Scalars['Int']>;
};

export type QuestionLanguage = {
  __typename?: 'QuestionLanguage';
  languageId: Scalars['Int'];
  questionText: Scalars['String'];
};

/** This represents the details of the Question Logic model */
export type QuestionLogic = {
  __typename?: 'QuestionLogic';
  affectedSurveyElementId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEqualsTo?: Maybe<Scalars['Boolean']>;
  isHigherThan?: Maybe<Scalars['Boolean']>;
  isLowerThan?: Maybe<Scalars['Boolean']>;
  mainSurveyElementId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  surveyElementQuestionOptionsChoiceId?: Maybe<Scalars['Int']>;
  surveyId?: Maybe<Scalars['Int']>;
};

/** Search Input for the query questionScaleRatingResponses */
export type QuestionScaleRatingResponsesInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>>>;
  calculateAttribute?: Scalars['Boolean'];
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  includeYesNoQuestion?: InputMaybe<Scalars['Boolean']>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>>;
};

export type QuestionTheme = {
  __typename?: 'QuestionTheme';
  surveyElementId: Scalars['Int'];
  themes?: Maybe<Array<Maybe<ThemeWithCount>>>;
};

export type QuestionToBenchmarkQuestion = {
  __typename?: 'QuestionToBenchmarkQuestion';
  benchmarkQuestionId: Scalars['Int'];
  newMappings: Array<Maybe<AssociatedQuestion>>;
};

/** Overall Attribute item for Reporting ->  Rating Responses Tab */
export type RatingResponseAttribute = {
  __typename?: 'RatingResponseAttribute';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  spread?: Maybe<FloatMinMax>;
  values?: Maybe<Array<Maybe<AttributeValueResponseRatesStatistics>>>;
};

/** Overall Survey stats for Reporting ->  Rating Responses Tab */
export type RatingResponseSurvey = {
  __typename?: 'RatingResponseSurvey';
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Overall result for Reporting ->  Rating Responses Tab */
export type RatingResponsesStats = {
  __typename?: 'RatingResponsesStats';
  attributes?: Maybe<Array<Maybe<RatingResponseAttribute>>>;
  surveys?: Maybe<Array<Maybe<RatingResponseSurvey>>>;
};

export type RegionToCountriesHierarchy = {
  __typename?: 'RegionToCountriesHierarchy';
  countries: Array<BenchmarkAttributeValue>;
  regionId: Scalars['Int'];
  regionName: Scalars['String'];
};

export type RehireAttribute = {
  __typename?: 'RehireAttribute';
  attributeId: Scalars['Int'];
  names: Array<Maybe<Name>>;
};

/** Input for removing one or more employees from a messaging channel's do-not-contact list (opting them back in). */
export type RemoveEmployeeChannelFromDoNotContactListInput = {
  channel: MessagingChannel;
  employeeIds: Array<Scalars['ID']>;
};

/** This represents the a ResendResult */
export type ResendResult = {
  __typename?: 'ResendResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ScheduleEmployeeImportResult = {
  __typename?: 'ScheduleEmployeeImportResult';
  taskId: Scalars['Int'];
};

/** This represents the a ScheduleReminderResult */
export type ScheduleReminderResult = {
  __typename?: 'ScheduleReminderResult';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

/** A benchmark attribute (region, country, industry, sector, size) with the values it can compare against, ordered by name. */
export type SelectableBenchmarkAttribute = {
  __typename?: 'SelectableBenchmarkAttribute';
  benchmarkAttributeId: Scalars['Int'];
  benchmarkAttributeName: Scalars['String'];
  translationKey: Scalars['String'];
  values: Array<SelectableBenchmarkValue>;
};

export type SelectableBenchmarkValue = {
  __typename?: 'SelectableBenchmarkValue';
  valueId: Scalars['Int'];
  valueName: Scalars['String'];
};

export type SelectedTimeframeInput = {
  endTimeUTC: Scalars['DateTime'];
  option: Scalars['String'];
  startTimeUTC: Scalars['DateTime'];
};

/** Recipient email + body for a one-off diagnostic Slack DM. */
export type SendTestSlackInput = {
  /** Message body to send. */
  body: Scalars['String'];
  /** Company whose connected Slack workspace the test send should go through. */
  companyId: Scalars['Int'];
  /** Recipient work email; resolved to a Slack user via users.lookupByEmail. */
  to: Scalars['String'];
};

/**
 * Outcome of a manual test Slack DM. Mirrors the provider's send result; does not touch any survey
 * delivery state.
 */
export type SendTestSlackResult = {
  __typename?: 'SendTestSlackResult';
  /** Provider error code when the send failed. */
  errorCode?: Maybe<Scalars['String']>;
  /** Human-readable provider error when the send failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Slack `channel:ts` message id when the send succeeded; null otherwise. */
  providerMessageId?: Maybe<Scalars['String']>;
  /** Send status. */
  status: SlackStatus;
};

/** Recipient + body for a one-off diagnostic SMS send. */
export type SendTestSmsInput = {
  /** Message body to send. */
  body: Scalars['String'];
  /** Company whose provisioned Twilio sub-account the test send should go through. */
  companyId: Scalars['Int'];
  /** Recipient phone number in E.164 format (e.g. +15551234567). */
  to: Scalars['String'];
};

/**
 * Outcome of a manual test SMS. Mirrors the provider's send result; does not touch any survey
 * delivery state.
 */
export type SendTestSmsResult = {
  __typename?: 'SendTestSmsResult';
  /** Provider error code when the send failed. */
  errorCode?: Maybe<Scalars['String']>;
  /** Human-readable provider error when the send failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Twilio message SID when the send was accepted; null otherwise. */
  providerMessageId?: Maybe<Scalars['String']>;
  /** Send status. */
  status: SmsStatus;
};

/** This represents the details of the SendingDomain model */
export type SendingDomain = {
  __typename?: 'SendingDomain';
  allowAllLocalParts?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  sendingEmailAddress?: Maybe<Array<Maybe<SendingEmailAddress>>>;
  updated?: Maybe<Scalars['String']>;
};

/** This represents the details of the SendingEmailAddress model */
export type SendingEmailAddress = {
  __typename?: 'SendingEmailAddress';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  localPart?: Maybe<Scalars['String']>;
  sendingDomain?: Maybe<SendingDomain>;
  updated?: Maybe<Scalars['String']>;
};

/** Slack OAuth credentials. Required when configuring the SLACK channel for the first time. */
export type SlackMessagingConfigInput = {
  botToken: Scalars['String'];
  botUserId: Scalars['String'];
  workspaceId: Scalars['String'];
};

/** Terminal outcome of a single Slack send attempt. Slack delivery is synchronous, so there is no pending state like with SMS where we wait for confirmation of send. */
export enum SlackStatus {
  SentFailure = 'SENT_FAILURE',
  SentSuccess = 'SENT_SUCCESS'
}

/** Identifies a question along with its rating */
export type SlideRatingStatistics = {
  __typename?: 'SlideRatingStatistics';
  factors?: Maybe<Array<Maybe<StatisticsCategory>>>;
  keyFactors?: Maybe<Array<Maybe<StatisticsCategory>>>;
};

/** Terminal/in-flight outcome of a single SMS send attempt. */
export enum SmsStatus {
  /** The send failed. */
  SentFailure = 'SENT_FAILURE',
  /** Delivered successfully. */
  SentSuccess = 'SENT_SUCCESS',
  /** Accepted by the provider; awaiting a final delivery status callback. */
  SentWaiting = 'SENT_WAITING'
}

export type SnapshotInput = {
  completedSurvey: Scalars['String'];
  employeeAttributes: EmployeeAttributeWithValueInput;
  surveyResponses: SurveyResponseInput;
};

/** Identifies an attributeValue along with its rating */
export type StatisticsAttribute = {
  __typename?: 'StatisticsAttribute';
  anonymized?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<StatisticsAttributeValue>>>;
};

/** Identifies an attributeValue along with its rating */
export type StatisticsAttributeValue = {
  __typename?: 'StatisticsAttributeValue';
  anonymized?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  distribution?: Maybe<StatisticsDistribution>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  responseRates?: Maybe<StatisticsResponseRates>;
  score?: Maybe<StatisticsScore>;
};

/** Identifies a question along with its rating */
export type StatisticsCategory = {
  __typename?: 'StatisticsCategory';
  anonymized?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Array<Maybe<StatisticsAttribute>>>;
  count?: Maybe<Scalars['Int']>;
  distribution?: Maybe<StatisticsDistribution>;
  hasLargeDecrease?: Maybe<Scalars['Boolean']>;
  hasLargeIncrease?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isBottom25?: Maybe<Scalars['Boolean']>;
  isTop25?: Maybe<Scalars['Boolean']>;
  libraryActions?: Maybe<Array<Maybe<LibraryAction>>>;
  name?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<StatisticsQuestion>>>;
  score?: Maybe<StatisticsScore>;
  sinceLastMeasured?: Maybe<Scalars['Float']>;
};

/** Statistics Distribution object representing the number of ENPS responses */
export type StatisticsDistribution = {
  __typename?: 'StatisticsDistribution';
  count?: Maybe<StatisticsDistributionCount>;
  enps?: Maybe<StatisticsDistributionEnps>;
  percentage?: Maybe<StatisticsDistributionPercentage>;
};

/** Statistics Distribution object representing the number of responses */
export type StatisticsDistributionCount = {
  __typename?: 'StatisticsDistributionCount';
  favorable?: Maybe<Scalars['Int']>;
  neutral?: Maybe<Scalars['Int']>;
  unfavorable?: Maybe<Scalars['Int']>;
};

/** Statistics Distribution object representing the number of ENPS responses */
export type StatisticsDistributionEnpsCount = {
  __typename?: 'StatisticsDistributionENPSCount';
  detractors?: Maybe<Scalars['Int']>;
  passives?: Maybe<Scalars['Int']>;
  promoters?: Maybe<Scalars['Int']>;
};

/** Statistics Distribution object representing the ENPS distribution % */
export type StatisticsDistributionEnpsPercentage = {
  __typename?: 'StatisticsDistributionENPSPercentage';
  detractors?: Maybe<Scalars['Float']>;
  passives?: Maybe<Scalars['Float']>;
  promoters?: Maybe<Scalars['Float']>;
};

/** Statistics ENPS Distribution object */
export type StatisticsDistributionEnps = {
  __typename?: 'StatisticsDistributionEnps';
  count?: Maybe<StatisticsDistributionEnpsCount>;
  percentage?: Maybe<StatisticsDistributionEnpsPercentage>;
};

/** Statistics Distribution object representing the distribution % */
export type StatisticsDistributionPercentage = {
  __typename?: 'StatisticsDistributionPercentage';
  favorable?: Maybe<Scalars['Float']>;
  neutral?: Maybe<Scalars['Float']>;
  unfavorable?: Maybe<Scalars['Float']>;
};

/** Identifies a question along with its rating */
export type StatisticsQuestion = {
  __typename?: 'StatisticsQuestion';
  anonymized?: Maybe<Scalars['Boolean']>;
  attributes?: Maybe<Array<Maybe<StatisticsAttribute>>>;
  count?: Maybe<Scalars['Int']>;
  distribution?: Maybe<StatisticsDistribution>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  responseRates?: Maybe<StatisticsResponseRates>;
  score?: Maybe<StatisticsScore>;
  surveyElementId?: Maybe<Scalars['Int']>;
};

/** Statistics Response Rates Count */
export type StatisticsResponseRateCount = {
  __typename?: 'StatisticsResponseRateCount';
  rating?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** Statistics Response Rates Percentage */
export type StatisticsResponseRatePercentage = {
  __typename?: 'StatisticsResponseRatePercentage';
  rating?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

/** Statistics Response Rates */
export type StatisticsResponseRates = {
  __typename?: 'StatisticsResponseRates';
  count?: Maybe<Array<Maybe<StatisticsResponseRateCount>>>;
  percentage?: Maybe<Array<Maybe<StatisticsResponseRatePercentage>>>;
};

/** Statistics Score */
export type StatisticsScore = {
  __typename?: 'StatisticsScore';
  average?: Maybe<Scalars['Float']>;
  enps?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
};

export type SubmitOpenSurveyResponsePayload = {
  __typename?: 'SubmitOpenSurveyResponsePayload';
  success: Scalars['Boolean'];
};

/** Object indicating the result of this submit */
export type SubmitResult = {
  __typename?: 'SubmitResult';
  error?: Maybe<Scalars['String']>;
  expired?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Survey = {
  __typename?: 'Survey';
  anonymousConversation?: Maybe<Scalars['Boolean']>;
  audienceMode?: Maybe<Scalars['String']>;
  combineLanguages?: Maybe<Scalars['Boolean']>;
  companyEmployeeIdsInSurvey?: Maybe<Array<Maybe<Scalars['String']>>>;
  disableEmailSending?: Maybe<Scalars['Boolean']>;
  employees?: Maybe<Array<Maybe<SurveyEmployee>>>;
  endTimeUTC?: Maybe<Scalars['String']>;
  fromEmailName?: Maybe<Scalars['String']>;
  hashCode?: Maybe<Scalars['String']>;
  /** Nullable to match the legacy Survey type's id field exactly, so schema stitching merges the two Survey definitions without a canonical-nullability mismatch warning. */
  id?: Maybe<Scalars['Int']>;
  invitationExpiryIn?: Maybe<Scalars['Int']>;
  isContinuous?: Maybe<Scalars['Boolean']>;
  lifecycleSurveyTypeId?: Maybe<Scalars['Int']>;
  namesPerLanguage?: Maybe<Array<Maybe<SurveyLanguage>>>;
  /** Shared access code required to respond to an Open Survey. Null when no code is enabled. */
  openSurveyAccessCode?: Maybe<Scalars['String']>;
  openSurveyUuid?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<SurveyElement>>>;
  sendingEmail?: Maybe<SurveyStatus>;
  sendingEmailAddress?: Maybe<SendingEmailAddress>;
  showResults?: Maybe<Scalars['Boolean']>;
  startTimeUTC?: Maybe<Scalars['String']>;
  status?: Maybe<SurveyStatus>;
  timezone?: Maybe<Timezone>;
  types?: Maybe<Array<Maybe<SurveyType>>>;
};

export type SurveyAttributeHierarchy = {
  __typename?: 'SurveyAttributeHierarchy';
  attributeHierarchy?: Maybe<Array<Maybe<SurveyAttributeHierarchyEntry>>>;
  notInvitedManagers?: Maybe<Array<Maybe<NotInvitedManager>>>;
  snapshotHierarchy?: Maybe<Array<Maybe<SurveySnapshotHierarchyEntry>>>;
};

export type SurveyAttributeHierarchyEntry = {
  __typename?: 'SurveyAttributeHierarchyEntry';
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['String'];
  employeeSurveySnapshotId: Scalars['Int'];
  fullName?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
};

export type SurveyConfigInput = {
  expiryTime: Scalars['String'];
  startTime: Scalars['String'];
  surveyId: Scalars['Int'];
  timezoneId: Scalars['Int'];
};

export type SurveyConvertResponse = {
  __typename?: 'SurveyConvertResponse';
  isContinuous: Scalars['Boolean'];
  lifecycleSurveyTypeId: Scalars['Int'];
  surveyId: Scalars['Int'];
};

/** Search Input for Survey */
export type SurveyDashboardSearchInput = {
  endTimeUTC?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  startTimeUTC?: InputMaybe<Scalars['String']>;
  surveyStatusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

export type SurveyElement = {
  __typename?: 'SurveyElement';
  addedDateUTC?: Maybe<Scalars['DateTime']>;
  attributes?: Maybe<Array<Maybe<SurveyElementAttribute>>>;
  companyId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discontinuedDateUTC?: Maybe<Scalars['DateTime']>;
  hideReporting?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  isAttributeBased?: Maybe<Scalars['Boolean']>;
  isBenchmarkedQuestion?: Maybe<Scalars['Boolean']>;
  isDiscontinued?: Maybe<Scalars['Boolean']>;
  isFilterable: Scalars['Boolean'];
  isLibraryQuestion?: Maybe<Scalars['Boolean']>;
  isPreviousQuestion?: Maybe<Scalars['Boolean']>;
  lastSent?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  orderIndex?: Maybe<Scalars['Int']>;
  question?: Maybe<SurveyElementQuestion>;
  sentTimes?: Maybe<Scalars['Int']>;
  showSkipButton?: Maybe<Scalars['Boolean']>;
  surveyTypeId?: Maybe<Scalars['Int']>;
  type?: Maybe<SurveyElementType>;
  updated?: Maybe<Scalars['DateTime']>;
};


export type SurveyElementAddedDateUtcArgs = {
  surveyId?: InputMaybe<Scalars['Int']>;
};


export type SurveyElementDiscontinuedDateUtcArgs = {
  surveyId?: InputMaybe<Scalars['Int']>;
};


export type SurveyElementIsDiscontinuedArgs = {
  surveyId?: InputMaybe<Scalars['Int']>;
};


export type SurveyElementLastSentArgs = {
  isPreviousQuestion?: InputMaybe<Scalars['Boolean']>;
};


export type SurveyElementSentTimesArgs = {
  isPreviousQuestion?: InputMaybe<Scalars['Boolean']>;
};

export type SurveyElementAttribute = {
  __typename?: 'SurveyElementAttribute';
  attributeId?: Maybe<Scalars['Int']>;
  attributeValue?: Maybe<Scalars['String']>;
};

export type SurveyElementAttributeInput = {
  attributeId: Scalars['Int'];
  attributeValue: Scalars['String'];
};

export type SurveyElementChoicesInput = {
  id?: InputMaybe<Scalars['Int']>;
  messagesPerLanguage?: InputMaybe<Array<InputMaybe<SurveyElementMessagePerLanguageInput>>>;
  orderIndex?: InputMaybe<Scalars['Int']>;
};

export type SurveyElementCount = {
  __typename?: 'SurveyElementCount';
  count?: Maybe<Scalars['Int']>;
  fields?: Maybe<Array<Maybe<SurveyElement>>>;
};

export type SurveyElementInput = {
  attributes?: InputMaybe<Array<InputMaybe<SurveyElementAttributeInput>>>;
  category?: InputMaybe<CategoryIdInput>;
  choices?: InputMaybe<Array<InputMaybe<SurveyElementChoicesInput>>>;
  copiedLibraryId?: InputMaybe<Scalars['Int']>;
  hideReporting?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<IconInput>;
  id?: InputMaybe<Scalars['Int']>;
  isAttributeBased?: InputMaybe<Scalars['Boolean']>;
  isFilterable?: InputMaybe<Scalars['Boolean']>;
  isLibraryQuestion?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  maxSelectedOption?: InputMaybe<Scalars['Int']>;
  messagesPerLanguage: Array<InputMaybe<SurveyElementMessagePerLanguageInput>>;
  minSelectedOption?: InputMaybe<Scalars['Int']>;
  openSurveyAttribute?: InputMaybe<OpenSurveyAttributeInput>;
  orderIndex: Scalars['Int'];
  ratingOptionHighest?: InputMaybe<Scalars['Int']>;
  ratingOptionLowest?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  showDescription?: InputMaybe<Scalars['Boolean']>;
  showLabels?: InputMaybe<Scalars['Boolean']>;
  showSkipButton: Scalars['Boolean'];
  showTextComment?: InputMaybe<Scalars['Boolean']>;
  type: SurveyElementTypeInput;
};

export type SurveyElementMessage = {
  __typename?: 'SurveyElementMessage';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  messagesPerLanguage?: Maybe<Array<Maybe<SurveyElementMessagePerLanguage>>>;
  surveyElement?: Maybe<SurveyElementType>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementMessagePerLanguage = {
  __typename?: 'SurveyElementMessagePerLanguage';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  labelAfter?: Maybe<Scalars['String']>;
  labelBefore?: Maybe<Scalars['String']>;
  language?: Maybe<Language>;
  message?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementMessagePerLanguageInput = {
  description?: InputMaybe<Scalars['String']>;
  labelAfter?: InputMaybe<Scalars['String']>;
  labelBefore?: InputMaybe<Scalars['String']>;
  language: LanguageInput;
  message: Scalars['String'];
};

export type SurveyElementOptionsChoices = {
  __typename?: 'SurveyElementOptionsChoices';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  legacyId?: Maybe<Scalars['String']>;
  messagesPerLanguage?: Maybe<Array<Maybe<SurveyElementMessagePerLanguage>>>;
  orderIndex?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestion = SurveyElementMessage | SurveyElementQuestionOptions | SurveyElementQuestionScale | SurveyElementQuestionText;

export type SurveyElementQuestionLanguage = SurveyElementQuestionOptionLanguage | SurveyElementQuestionScaleLanguage | SurveyElementQuestionTextLanguage;

export type SurveyElementQuestionOptionLanguage = {
  __typename?: 'SurveyElementQuestionOptionLanguage';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  languageId?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  surveyElementQuestionOptionsId?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestionOptions = {
  __typename?: 'SurveyElementQuestionOptions';
  category?: Maybe<Category>;
  choices?: Maybe<Array<Maybe<SurveyElementOptionsChoices>>>;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  maxSelectedOption?: Maybe<Scalars['Int']>;
  messagesPerLanguage?: Maybe<Array<Maybe<SurveyElementMessagePerLanguage>>>;
  minSelectedOption?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  showDescription?: Maybe<Scalars['Boolean']>;
  showTextComment?: Maybe<Scalars['Boolean']>;
  surveyElement?: Maybe<SurveyElementType>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestionScale = {
  __typename?: 'SurveyElementQuestionScale';
  category?: Maybe<Category>;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Icon>;
  id?: Maybe<Scalars['Int']>;
  locked?: Maybe<Scalars['Boolean']>;
  messagesPerLanguage?: Maybe<Array<Maybe<SurveyElementMessagePerLanguage>>>;
  ratingOptionHighest?: Maybe<Scalars['Int']>;
  ratingOptionLowest?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  showDescription?: Maybe<Scalars['Boolean']>;
  showLabels?: Maybe<Scalars['Boolean']>;
  showTextComment?: Maybe<Scalars['Boolean']>;
  surveyElement?: Maybe<SurveyElementType>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestionScaleLanguage = {
  __typename?: 'SurveyElementQuestionScaleLanguage';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  labelAfter?: Maybe<Scalars['String']>;
  labelBefore?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  surveyElementQuestionScaleId?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestionText = {
  __typename?: 'SurveyElementQuestionText';
  category?: Maybe<Category>;
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  locked?: Maybe<Scalars['Boolean']>;
  messagesPerLanguage?: Maybe<Array<Maybe<SurveyElementMessagePerLanguage>>>;
  required?: Maybe<Scalars['Boolean']>;
  showDescription?: Maybe<Scalars['Boolean']>;
  surveyElement?: Maybe<SurveyElementType>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementQuestionTextLanguage = {
  __typename?: 'SurveyElementQuestionTextLanguage';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  languageId?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  surveyElementQuestionTextId?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementSearchInput = {
  attributes?: InputMaybe<Array<InputMaybe<SurveyElementAttributeInput>>>;
  category?: InputMaybe<CategoryIdInput>;
  choices?: InputMaybe<Array<InputMaybe<SurveyElementChoicesInput>>>;
  hideReporting?: InputMaybe<Scalars['Boolean']>;
  icon?: InputMaybe<IconInput>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isAttributeBased?: InputMaybe<Scalars['Boolean']>;
  isDiscontinued?: InputMaybe<Scalars['Boolean']>;
  isFilterable?: InputMaybe<Scalars['Boolean']>;
  isLibraryQuestion?: InputMaybe<Scalars['Boolean']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  maxSelectedOption?: InputMaybe<Scalars['Int']>;
  messagesPerLanguage?: InputMaybe<Array<InputMaybe<SurveyElementMessagePerLanguageInput>>>;
  minSelectedOption?: InputMaybe<Scalars['Int']>;
  orderIndex?: InputMaybe<Scalars['Int']>;
  ratingOptionHighest?: InputMaybe<Scalars['Int']>;
  ratingOptionLowest?: InputMaybe<Scalars['Int']>;
  required?: InputMaybe<Scalars['Boolean']>;
  showDescription?: InputMaybe<Scalars['Boolean']>;
  showLabels?: InputMaybe<Scalars['Boolean']>;
  showSkipButton?: InputMaybe<Scalars['Boolean']>;
  showTextComment?: InputMaybe<Scalars['Boolean']>;
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  type?: InputMaybe<SurveyElementTypeInput>;
};

export type SurveyElementType = {
  __typename?: 'SurveyElementType';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyElementTypeInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type SurveyElementUpdateInput = {
  action: AttributeNameActionEnum;
  /**
   * The question's Open Survey Attribute on the survey being edited. Omit it to leave the configuration
   * unchanged, or pass null to remove it. It cannot change once the survey has started.
   */
  openSurveyAttribute?: InputMaybe<OpenSurveyAttributeInput>;
  surveyElement: SurveyElementSearchInput;
};

/** This represents an Employee details, refer type from new Employee schema */
export type SurveyEmployee = {
  __typename?: 'SurveyEmployee';
  addedDate?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  surveyInviteDate?: Maybe<Scalars['String']>;
};

/** This represents the recipients of a Survey */
export type SurveyEmployees = {
  __typename?: 'SurveyEmployees';
  employees?: Maybe<Array<Maybe<SurveyEmployee>>>;
};

/** Update input for Survey Employees */
export type SurveyEmployeesUpdateInput = {
  action?: InputMaybe<UpdateActionsEnum>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Input for Survey */
export type SurveyInput = {
  anonymousConversation?: InputMaybe<Scalars['Boolean']>;
  combineLanguages?: InputMaybe<Scalars['Boolean']>;
  companyIds: Array<InputMaybe<Scalars['Int']>>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endTimeUTC?: InputMaybe<Scalars['String']>;
  namesPerLanguage: Array<InputMaybe<SurveyLanguageInput>>;
  questions?: InputMaybe<Array<InputMaybe<LegacySurveyElementInput>>>;
  sendingEmailAddressId?: InputMaybe<Scalars['Int']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  startTimeUTC?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SurveyStatusInput>;
  timezone?: InputMaybe<TimezoneInput>;
  types: Array<InputMaybe<SurveyTypeInput>>;
};

/** This represents the details of the SurveyLanguage model */
export type SurveyLanguage = {
  __typename?: 'SurveyLanguage';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  emailBody?: Maybe<Scalars['String']>;
  emailReminderBody?: Maybe<Scalars['String']>;
  emailReminderSubject?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Language>;
  survey?: Maybe<Survey>;
  surveyName?: Maybe<Scalars['String']>;
  surveySlackText?: Maybe<Scalars['String']>;
  surveySmsText?: Maybe<Scalars['String']>;
  surveyTeamsText?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

/** Input for SurveyLanguage model */
export type SurveyLanguageInput = {
  created?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  language: LanguageInput;
  surveyName: Scalars['String'];
  surveySlackText?: InputMaybe<Scalars['String']>;
  surveySmsText?: InputMaybe<Scalars['String']>;
  surveyTeamsText?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

/** The current state of a survey's messaging channel after an upsert. */
export type SurveyMessaging = {
  __typename?: 'SurveyMessaging';
  channel: MessagingChannelOptions;
  /** True when the channel's status row has enabled = true. */
  enabled: Scalars['Boolean'];
  smsAttributeId?: Maybe<Scalars['ID']>;
  surveyId: Scalars['ID'];
  /** Translation key of the currently selected message variation, or null if none is set. */
  variationKey?: Maybe<Scalars['String']>;
};

export type SurveyMigrationTask = {
  __typename?: 'SurveyMigrationTask';
  companyId: Scalars['Int'];
  id: Scalars['Int'];
  importType: Scalars['String'];
  status: Scalars['String'];
  surveyId: Scalars['Int'];
  user: UserInfo;
};

/** A survey recipient together with their per-channel send status (email + SMS). */
export type SurveyParticipantChannels = {
  __typename?: 'SurveyParticipantChannels';
  channels: Array<ParticipantChannel>;
  employeeId: Scalars['ID'];
};

/**
 * SMS reachability for one survey participant: whether they've opted out of the number the
 * survey would text and whether they have a value for the survey's chosen phone attribute.
 * Kept separate from send status because reachability is a whole-survey concern (it drives the
 * pre-send summary), while send status is rendered a page at a time.
 */
export type SurveyParticipantSmsReachability = {
  __typename?: 'SurveyParticipantSmsReachability';
  employeeId: Scalars['ID'];
  /** The participant has a value for the survey's chosen phone attribute. */
  hasPhone: Scalars['Boolean'];
  /** The participant is on the do-not-contact list for the number this survey would text. */
  optedOut: Scalars['Boolean'];
};

export type SurveyParticipants = {
  __typename?: 'SurveyParticipants';
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['String'];
  employeeSurveySnapshotId: Scalars['Int'];
  firstName?: Maybe<Scalars['String']>;
  /** Null when the recipient was added to the survey but never invited. */
  invitedDate?: Maybe<Scalars['Date']>;
  lastName?: Maybe<Scalars['String']>;
  submittedResponseDate?: Maybe<Scalars['Date']>;
};

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  companyIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  questionId: Scalars['Int'];
  questionText: Scalars['String'];
  surveyCount: Scalars['Int'];
  surveyYears: Array<Maybe<Scalars['Int']>>;
};

export type SurveyQuestionInput = {
  benchmarkQuestionId: Scalars['Int'];
  companyId?: InputMaybe<Scalars['Int']>;
  filterText?: InputMaybe<Scalars['String']>;
  filterYear?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<QuestionFilter>;
  startYear: Scalars['Int'];
  surveyTypeId: Scalars['Int'];
};

export type SurveyQuestionsResult = {
  __typename?: 'SurveyQuestionsResult';
  allQuestionIds: Array<Maybe<Scalars['Int']>>;
  surveyQuestions: Array<Maybe<SurveyQuestion>>;
  totalCount: Scalars['Int'];
};

/** Input for SurveyReminder  */
export type SurveyReminderInput = {
  emailReminderBody?: InputMaybe<Scalars['String']>;
  emailReminderSubject?: InputMaybe<Scalars['String']>;
  language: LanguageInput;
};

export type SurveyResponseInput = {
  comment?: InputMaybe<Scalars['String']>;
  numberAnswer?: InputMaybe<Scalars['Int']>;
  questionIndex: Scalars['Int'];
  textAnswer?: InputMaybe<Scalars['String']>;
};

/** Stand for employee detail required by admin line by line export */
export type SurveyResponsesExport = {
  __typename?: 'SurveyResponsesExport';
  attributes?: Maybe<Array<Maybe<AdminSurveyEmployeeAttribute>>>;
  employees?: Maybe<Array<Maybe<AdminSurveyEmployee>>>;
  optionsQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeOptions>>>;
  scaleQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeScale>>>;
  textQuestions?: Maybe<Array<Maybe<AdminSurveyEmployeeText>>>;
};

/** Search Input for Survey */
export type SurveySearchInput = {
  anonymousConversation?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  endTimeUTC?: InputMaybe<DateInput>;
  id?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  languageId?: InputMaybe<Scalars['Int']>;
  languageIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sendingEmailAddressId?: InputMaybe<Scalars['Int']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  startTimeUTC?: InputMaybe<DateInput>;
  status?: InputMaybe<SurveyStatusSearchInput>;
  statusIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  timezone?: InputMaybe<TimezoneSearchInput>;
  typeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type SurveySnapshotHierarchyEntry = {
  __typename?: 'SurveySnapshotHierarchyEntry';
  email?: Maybe<Scalars['String']>;
  employeeId: Scalars['String'];
  employeeSurveySnapshotId?: Maybe<Scalars['Int']>;
  fullName?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
};

/** This represents the details of the SurveyStatus model */
export type SurveyStatus = {
  __typename?: 'SurveyStatus';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

/** Input for SurveyStatus */
export type SurveyStatusInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

/** Search Input for SurveyStatus */
export type SurveyStatusSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type SurveySummaryConversation = {
  __typename?: 'SurveySummaryConversation';
  conversationId: Scalars['String'];
  title: Scalars['String'];
};

export enum SurveyTemplateStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE'
}

export type SurveyType = {
  __typename?: 'SurveyType';
  category?: Maybe<Array<Maybe<SurveyTypeCategory>>>;
  companyId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  names?: Maybe<Array<Maybe<SurveyTypeName>>>;
  threshold?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

/** This represents the a category in companySurveyType */
export type SurveyTypeCategory = {
  __typename?: 'SurveyTypeCategory';
  category?: Maybe<Category>;
  isKeyFactor?: Maybe<Scalars['Boolean']>;
};

/** This represent the details of Survey Type categories */
export type SurveyTypeCategoryInput = {
  action?: InputMaybe<UpdateActionsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  isKeyFactor?: InputMaybe<Scalars['Boolean']>;
  names?: InputMaybe<Array<InputMaybe<CategoryLanguageInput>>>;
};

/** This represents the details of the SurveyType */
export type SurveyTypeInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

export type SurveyTypeName = {
  __typename?: 'SurveyTypeName';
  id?: Maybe<Scalars['Int']>;
  languageId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  surveyTypeId?: Maybe<Scalars['Int']>;
};

export type SurveyTypeNames = {
  __typename?: 'SurveyTypeNames';
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

/** Object to represent permissions for a survey type */
export type SurveyTypePermission = {
  __typename?: 'SurveyTypePermission';
  canAccessAll?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  surveyTypeId?: Maybe<Scalars['Int']>;
};

/** Input to search SurveyTypes */
export type SurveyTypeSearchInput = {
  companyId?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['String']>;
};

/** Input for Survey to be updated */
export type SurveyUpdateInput = {
  anonymousConversation?: InputMaybe<Scalars['Boolean']>;
  combineLanguages?: InputMaybe<Scalars['Boolean']>;
  employeeIds?: InputMaybe<Array<InputMaybe<SurveyEmployeesUpdateInput>>>;
  endTimeUTC?: InputMaybe<Scalars['String']>;
  fromEmailName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  namesPerLanguage?: InputMaybe<Array<InputMaybe<SurveyLanguageInput>>>;
  questions?: InputMaybe<Array<InputMaybe<LegacySurveyElementUpdateInput>>>;
  sendingEmailAddressId?: InputMaybe<Scalars['Int']>;
  showResults?: InputMaybe<Scalars['Boolean']>;
  startTimeUTC?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SurveyStatusInput>;
  timezone?: InputMaybe<TimezoneInput>;
  types?: InputMaybe<Array<InputMaybe<SurveyTypeInput>>>;
};

/** Tag name for learning content */
export type Tag = {
  __typename?: 'Tag';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Microsoft Teams credentials. Required when configuring the TEAMS channel for the first time. */
export type TeamsMessagingConfigInput = {
  serviceUrl: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Theme = {
  __typename?: 'Theme';
  id: Scalars['Int'];
  themeName: Scalars['String'];
  translations: Array<Maybe<Translation>>;
};

export type ThemeWithCount = {
  __typename?: 'ThemeWithCount';
  count: Scalars['Int'];
  id: Scalars['Int'];
  themeName: Scalars['String'];
  translations: Array<Translation>;
};

export type ThemesAnalysisInput = {
  regeneration?: InputMaybe<Scalars['Boolean']>;
  surveyElementIds?: InputMaybe<Array<Scalars['Int']>>;
  surveyId: Scalars['Int'];
};

export type ThemesAnalysisResponse = {
  __typename?: 'ThemesAnalysisResponse';
  errorMessage?: Maybe<Scalars['String']>;
  processedQuestions: Array<Maybe<Scalars['Int']>>;
  status: Scalars['String'];
};

export type Timeframe = {
  __typename?: 'Timeframe';
  endTimeUTC: Scalars['DateTime'];
  startTimeUTC: Scalars['DateTime'];
};

export type TimeframeInput = {
  endTimeUTC: Scalars['DateTime'];
  startTimeUTC: Scalars['DateTime'];
};

export type TimeframeTrendsInput = {
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>>>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  languageId: Scalars['Int'];
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  selectedTimeframes: Array<SelectedTimeframeInput>;
  surveyId: Scalars['Int'];
};

export type TimeframeTrendsResults = {
  __typename?: 'TimeframeTrendsResults';
  factors?: Maybe<Array<Maybe<TrendDatasetCollection>>>;
  questions?: Maybe<Array<Maybe<TrendDatasetCollection>>>;
};

/** This represents the details of the Timezone model */
export type Timezone = {
  __typename?: 'Timezone';
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['String']>;
};

/** Input for TimezoneInputType */
export type TimezoneInput = {
  timezone: Scalars['String'];
};

/** Search Input for TimezoneInputType */
export type TimezoneSearchInput = {
  id?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type Translation = {
  __typename?: 'Translation';
  languageId: Scalars['Int'];
  name: Scalars['String'];
};

export type TrendDataset = {
  __typename?: 'TrendDataset';
  count?: Maybe<Scalars['Int']>;
  countDetractors?: Maybe<Scalars['Int']>;
  countFavorable?: Maybe<Scalars['Int']>;
  countNeutral?: Maybe<Scalars['Int']>;
  countPassives?: Maybe<Scalars['Int']>;
  countPromoters?: Maybe<Scalars['Int']>;
  countUnfavorable?: Maybe<Scalars['Int']>;
  enpsScore?: Maybe<Scalars['Float']>;
  label: Scalars['String'];
  percentDetractors?: Maybe<Scalars['Float']>;
  percentFavorable: Scalars['Float'];
  percentNeutral: Scalars['Float'];
  percentPassives?: Maybe<Scalars['Float']>;
  percentPromoters?: Maybe<Scalars['Float']>;
  percentUnfavorable: Scalars['Float'];
  scoreAverage: Scalars['Float'];
  selectedTimeframeIndex: Scalars['Int'];
};

export type TrendDatasetCollection = {
  __typename?: 'TrendDatasetCollection';
  anonymized?: Maybe<Scalars['Boolean']>;
  datasets: Array<Maybe<TrendDataset>>;
  factorId?: Maybe<Scalars['Int']>;
  factorName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type TrendingLinkCandidate = {
  __typename?: 'TrendingLinkCandidate';
  /** Surveys outside the selected set that already share this question's trending element. */
  externalSurveys: Array<TrendingLinkCandidateExternalSurvey>;
  /** Non-empty when the surveys' copies of this question don't all have the same language coverage. Missing translations are copied onto the shared question when linking, so nothing is lost. */
  languageWarning: Array<TrendingLinkCandidateLanguageGap>;
  perSurvey: Array<TrendingLinkCandidateSurveyEntry>;
  questionText: Scalars['String'];
  questionType: TrendingQuestionType;
  validation: TrendingLinkCandidateValidation;
};

export type TrendingLinkCandidateExternalSurvey = {
  __typename?: 'TrendingLinkCandidateExternalSurvey';
  created: Scalars['DateTime'];
  surveyId: Scalars['Int'];
  surveyName: Scalars['String'];
};

export type TrendingLinkCandidateLanguageGap = {
  __typename?: 'TrendingLinkCandidateLanguageGap';
  /** ISO locale codes (e.g. fr-ca) present on at least one other survey's copy but missing from this survey's copy. */
  missingLanguageCodes: Array<Scalars['String']>;
  surveyId: Scalars['Int'];
};

export type TrendingLinkCandidateSurveyEntry = {
  __typename?: 'TrendingLinkCandidateSurveyEntry';
  questionId: Scalars['Int'];
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
};

export type TrendingLinkCandidateValidation = {
  __typename?: 'TrendingLinkCandidateValidation';
  ok: Scalars['Boolean'];
  /** Non-null when ok is false. e.g. RATING_LOWEST_MISMATCH, CATEGORY_MISMATCH. */
  reason?: Maybe<Scalars['String']>;
};

export enum TrendingQuestionType {
  Scale = 'SCALE',
  Text = 'TEXT'
}

export enum TrendsAggregationEnum {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Survey = 'SURVEY',
  Year = 'YEAR'
}

export type TriggerCronjobResult = {
  __typename?: 'TriggerCronjobResult';
  durationMs: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  logs: Array<Scalars['String']>;
  name: Scalars['String'];
  success: Scalars['Boolean'];
};

export enum UpdateActions {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** Discriminator for permission attribute mutations. Matches the legacy `UpdateActionsEnum`. */
export enum UpdateActionsEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/**
 * Upsert the acting user's company messaging config for a single channel. Provide the
 * matching {slack,teams}Config to set/rotate credentials; omit it to toggle `enabled` while
 * keeping existing credentials. SMS takes no credentials.
 */
export type UpdateCompanyMessagingConfigInput = {
  channel: MessagingChannel;
  enabled: Scalars['Boolean'];
  slackConfig?: InputMaybe<SlackMessagingConfigInput>;
  teamsConfig?: InputMaybe<TeamsMessagingConfigInput>;
};

export type UpdateEmployeeIdError = {
  __typename?: 'UpdateEmployeeIdError';
  failedId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  translationKey?: Maybe<Scalars['String']>;
};

export enum UpdateEmployeeIdStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Success = 'Success'
}

export type UpdateEmployeeIds = {
  currentEmployeeId: Scalars['String'];
  newEmployeeId: Scalars['String'];
};

export type UpdateResult = {
  __typename?: 'UpdateResult';
  error?: Maybe<UpdateEmployeeIdError>;
  status: UpdateEmployeeIdStatus;
};

/** Input for creating or updating a transformation recipe. */
export type UpsertDynamicAttributeRecipeInput = {
  /** Type-specific payload: group maps, default values, prepend and append text. `{}` for COPY. */
  definition: Scalars['JSON'];
  /** Omit to insert a new recipe. Supply an existing recipe id to update it in place. */
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  recipeType: DynamicAttributeRecipeType;
  /** Attribute the transformation reads its input value from. Must belong to the same company. */
  sourceAttributeId: Scalars['Int'];
  /** Attribute the transformation writes its derived value to. Must belong to the same company. */
  targetAttributeId: Scalars['Int'];
};

/** Input for enabling/disabling a survey messaging channel and selecting its message variation. */
export type UpsertSurveyMessagingInput = {
  channel: MessagingChannelOptions;
  enabled: Scalars['Boolean'];
  /** Required when enabling the SMS channel. Validated as a PHONE attribute belonging to the survey's company. */
  smsAttributeId?: InputMaybe<Scalars['ID']>;
  surveyId: Scalars['ID'];
  /**
   * Translation key of the selected fixed message variation (e.g.
   * `survey.schedule.messaging.preset.sms.1.body`). Required when enabling a channel.
   * Stored on the survey's language rows so the picked variation survives a reload and
   * resolves per-recipient locale at send time. SMS/Slack/Teams use fixed variations
   * rather than free text, so a key — not a body — is persisted.
   */
  variationKey?: InputMaybe<Scalars['String']>;
};

/** A signed-in user account. */
export type User = {
  __typename?: 'User';
  /** Avatar URL, or null if the user has not uploaded one. */
  avatar?: Maybe<Scalars['String']>;
  /** True if the user has the manage-mailing-list global permission. */
  canManageMailingList?: Maybe<Scalars['Boolean']>;
  /** Company the user belongs to, with companyFeatureSettings pre-attached. */
  company?: Maybe<Company>;
  /** ISO 8601 timestamp the row was created. */
  created?: Maybe<Scalars['String']>;
  /** ISO 8601 timestamp the row was soft-deleted, or null when active. */
  deletedAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  /** Linked employee record id, if this user is also an employee. */
  employeeId?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  /** Global (company-wide) action grants for this user. */
  globalActions?: Maybe<Array<Maybe<UserGlobalAction>>>;
  /**
   * Employee ids that report into this user (direct reports + transitive),
   * derived via the company's manager-employee-id attribute. Empty when the
   * user has no linked employee.
   */
  hierarchy?: Maybe<Array<Maybe<Scalars['Int']>>>;
  id?: Maybe<Scalars['Int']>;
  /**
   * True if the current session is a WorkTango admin impersonating this user,
   * derived from the requesting token rather than any client-stored state.
   */
  isImpersonating?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  /** Per-survey-type permission grants for this user. */
  permissions?: Maybe<Array<Maybe<UserPermission>>>;
  /** User's preferred display language for the app and outbound emails. */
  preferredLanguage?: Maybe<Language>;
  /** Account status: ACTIVE, INVITATION_PENDING, or DISABLED. */
  status?: Maybe<Scalars['String']>;
  /** ISO 8601 timestamp the row was last updated. */
  updated?: Maybe<Scalars['String']>;
  /** Active user-role assignment, if any. Falls back to the user-to-role mapping when not pre-loaded. */
  userRoleId?: Maybe<Scalars['Int']>;
  /** True if this user is a WorkTango internal admin (cross-company). */
  worktangoAdmin?: Maybe<Scalars['Boolean']>;
};

/**
 * An action a user is allowed to perform inside a permission grant
 * (e.g. `manage_surveys`, `view_reporting`). Joined onto UserPermission
 * to express survey-type-scoped capabilities.
 */
export type UserAction = {
  __typename?: 'UserAction';
  action?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

/** Filter for `userActions`. All fields are optional and combined as AND. */
export type UserActionInput = {
  action?: InputMaybe<Scalars['String']>;
};

/** This returns a login token */
export type UserAuth = {
  __typename?: 'UserAuth';
  globalPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  surveyTypePermissions?: Maybe<Array<Maybe<SurveyTypePermission>>>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserByEmailResult = {
  __typename?: 'UserByEmailResult';
  companyId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  status: Scalars['String'];
};

export type UserDetails = {
  __typename?: 'UserDetails';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  worktangoAdmin?: Maybe<Scalars['Boolean']>;
};

/** A row of the join table granting a global (company-wide) action to a user, e.g. `manage_users`. */
export type UserGlobalAction = {
  __typename?: 'UserGlobalAction';
  /** The granted action name (e.g. `manage_users`). Resolved from the joined GlobalAction record. */
  action?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  globalActionId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
};

/** Update Input for UserPermission */
export type UserPermisionUpdateInput = {
  accessAll?: InputMaybe<Scalars['Boolean']>;
  allAttributesVisible?: InputMaybe<Scalars['Boolean']>;
  attributeBased?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Array<InputMaybe<UserPermissionAttributeUpdateInput>>>;
  canCompareToAllAttributes?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Int']>;
  compareAttributes?: InputMaybe<Array<InputMaybe<UserPermissionAttributeUpdateInput>>>;
  globalActions?: InputMaybe<Array<InputMaybe<UserPermissionElementIdUpdateInput>>>;
  hierarchyBased?: InputMaybe<Scalars['Boolean']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
  userActions?: InputMaybe<Array<InputMaybe<UserPermissionElementIdUpdateInput>>>;
  visibleAttributes?: InputMaybe<Array<InputMaybe<UserPermissionElementIdUpdateInput>>>;
};

/** A grant of access to a survey type for a user, with attribute filters and visible/compare attributes attached. */
export type UserPermission = {
  __typename?: 'UserPermission';
  /** True if this grant gives access to all employees in the company. */
  accessAll?: Maybe<Scalars['Boolean']>;
  /** True if no `visibleAttributes` restriction applies — the user sees all attribute values. */
  allAttributesVisible?: Maybe<Scalars['Boolean']>;
  /** True if access scopes by attribute values (see `attributes`). */
  attributeBased?: Maybe<Scalars['Boolean']>;
  /** Attribute-value scopes restricting which employees this grant covers. */
  attributes?: Maybe<Array<Maybe<UserPermissionAttribute>>>;
  /** True if the user can compare across all attribute values (no compare-attribute restriction). */
  canCompareToAllAttributes?: Maybe<Scalars['Boolean']>;
  /** Company the permission is scoped to. */
  company?: Maybe<Company>;
  /** Compare-to attribute-value scopes restricting which other employees this user can benchmark against. */
  compareAttributes?: Maybe<Array<Maybe<UserPermissionAttribute>>>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  /** True if access scopes by manager hierarchy (the user only sees their direct/indirect reports). */
  hierarchyBased?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['Int']>;
  /**
   * Free-form hierarchy keys (in addition to the user's own employee hierarchy)
   * that this grant covers. Empty when not pre-populated by the service layer.
   */
  otherHierarchies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Convenience: the single survey type id when the permission targets one survey type. */
  surveyTypeId?: Maybe<Scalars['Int']>;
  /** Survey type(s) the permission grants access to. */
  surveyTypes?: Maybe<Array<Maybe<SurveyType>>>;
  updated?: Maybe<Scalars['String']>;
  /**
   * Attribute ids where this grant uses the granting user's own attribute value
   * (matched at request time) rather than a fixed value list.
   */
  useUserAttributeValue?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /**
   * Compare-attribute ids where the grant uses the user's own attribute value
   * rather than a fixed value list.
   */
  useUserAttributeValueCompare?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** The user this permission belongs to. */
  user?: Maybe<User>;
  /** Actions (capabilities) granted within the surveyType (e.g. manage / view). */
  userActions?: Maybe<Array<Maybe<UserAction>>>;
  /** Employee attributes the user can see values for in dashboards and exports. */
  visibleAttributes?: Maybe<Array<Maybe<VisibleAttribute>>>;
};

/** An attribute-value scope on a UserPermission — restricts the permission to the listed values of an attribute. */
export type UserPermissionAttribute = {
  __typename?: 'UserPermissionAttribute';
  id?: Maybe<Scalars['Int']>;
  /**
   * Display name of the attribute (e.g. `Department`), localized to the
   * requesting user's preferred language, falling back to English. Empty
   * string when no localized name exists.
   */
  name?: Maybe<Scalars['String']>;
  /** The attribute values included in the scope. */
  values?: Maybe<Array<Maybe<Scalars['AttributeValueType']>>>;
};

/**
 * Mutation-style update entry for a UserPermissionAttribute. `action` selects
 * CREATE / UPDATE / DELETE; `id` is required for UPDATE and DELETE; `values`
 * carries the attribute-value list for CREATE and UPDATE.
 */
export type UserPermissionAttributeUpdateInput = {
  action?: InputMaybe<UpdateActionsEnum>;
  id?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['AttributeValueType']>>>;
};

/** Update input for UserPermission element di */
export type UserPermissionElementIdUpdateInput = {
  action?: InputMaybe<UpdateActionsEnum>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Filter for `userPermissions`. All fields are optional and combined as AND. */
export type UserPermissionSearchInput = {
  accessAll?: InputMaybe<Scalars['Boolean']>;
  attributeBased?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Array<InputMaybe<UserPermissionAttributeUpdateInput>>>;
  companyId?: InputMaybe<Scalars['Int']>;
  compareAttributes?: InputMaybe<Array<InputMaybe<UserPermissionAttributeUpdateInput>>>;
  hierarchyBased?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  surveyTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  userActionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type UserSearchInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<LanguageInput>;
};

export enum UserStatusEnum {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Pending = 'PENDING'
}

/** Update Input for User */
export type UserToUpdateInput = {
  avatar?: InputMaybe<Scalars['String']>;
  currentPassword?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<LanguageInput>;
};

export type ValueIds = {
  countryValueId?: InputMaybe<Scalars['Int']>;
  industryValueId?: InputMaybe<Scalars['Int']>;
  regionValueId?: InputMaybe<Scalars['Int']>;
  sectorValueId?: InputMaybe<Scalars['Int']>;
  sizeValueId?: InputMaybe<Scalars['Int']>;
};

export type VendorQuestionsSearchInput = {
  categoryId?: InputMaybe<Scalars['Int']>;
  companyId: Scalars['Int'];
  filteredCategories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  languageIds: Array<InputMaybe<Scalars['Int']>>;
  questionTitle?: InputMaybe<Scalars['String']>;
  searchLanguageId?: InputMaybe<Scalars['Int']>;
  surveyId: Scalars['Int'];
  surveyTypeId?: InputMaybe<Scalars['Int']>;
};

/** An employee attribute the user is allowed to see values of in reporting and exports. */
export type VisibleAttribute = {
  __typename?: 'VisibleAttribute';
  attributeId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['String']>;
};

/** Content types for learning coach */
export type ContentType = {
  __typename?: 'contentType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CreateOrUpdateSurveyReminderInput = {
  id?: InputMaybe<Scalars['Int']>;
  languages: Array<InputMaybe<SurveyReminderLanguageInput>>;
  scheduledDateTime: Scalars['DateTime'];
  status?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['Int'];
};

export type DeleteSurveyReminderOutput = {
  __typename?: 'deleteSurveyReminderOutput';
  deleted?: Maybe<Scalars['Int']>;
};

/** This returns a learning content object */
export type LearningContent = {
  __typename?: 'learningContent';
  blurp?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageLink?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  read?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  starred?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type SurveyOutput = {
  __typename?: 'surveyOutput';
  endTimeUTC?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  startTimeUTC: Scalars['DateTime'];
  surveyStatusId?: Maybe<Scalars['Int']>;
};

export type SurveyReminderCountOutput = {
  __typename?: 'surveyReminderCountOutput';
  count: Scalars['Int'];
};

export type SurveyReminderLanguageInput = {
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
};

export type SurveyReminderLanguageOutput = {
  __typename?: 'surveyReminderLanguageOutput';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  languageId?: Maybe<Scalars['Int']>;
  surveyReminderId?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyReminderOutput = {
  __typename?: 'surveyReminderOutput';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  scheduledDateTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  surveyId?: Maybe<Scalars['Int']>;
  timezone?: Maybe<TimezoneOutput>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type SurveyReminderWithLanguageOutput = {
  __typename?: 'surveyReminderWithLanguageOutput';
  created?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  languages?: Maybe<Array<Maybe<SurveyReminderLanguageOutput>>>;
  scheduledDateTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  survey?: Maybe<SurveyOutput>;
  surveyId?: Maybe<Scalars['Int']>;
  timezone?: Maybe<TimezoneOutput>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type TimezoneOutput = {
  __typename?: 'timezoneOutput';
  id?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
};

export type ActivateUserMutationVariables = Exact<{
  token: Scalars['String'];
  user: UserToUpdateInput;
}>;


export type ActivateUserMutation = { __typename?: 'Mutation', activateUser?: { __typename?: 'User', id?: number | null } | null };

export type AddConversationMessageMutationVariables = Exact<{
  text: Scalars['String'];
  conversationId: Scalars['Int'];
}>;


export type AddConversationMessageMutation = { __typename?: 'Mutation', addConversationMessage?: { __typename?: 'MinimalConversationMessage', id?: number | null, text: string, conversationId?: number | null, created?: Date | string | null, user?: { __typename?: 'User', id?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null };

export type AddEmployeeChannelToDoNotContactListMutationVariables = Exact<{
  input: AddEmployeeChannelToDoNotContactListInput;
}>;


export type AddEmployeeChannelToDoNotContactListMutation = { __typename?: 'Mutation', addEmployeeChannelToDoNotContactList: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type AddSurveyTemplateMutationVariables = Exact<{
  names: Array<InputSurveyTemplateNames> | InputSurveyTemplateNames;
  surveyTypeId: Scalars['Int'];
  surveyElements?: InputMaybe<Array<InputMaybe<InputSurveyElement>> | InputMaybe<InputSurveyElement>>;
  audienceMode?: InputMaybe<Scalars['String']>;
  lifecycleSurveyTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type AddSurveyTemplateMutation = { __typename?: 'Mutation', addSurveyTemplate: { __typename?: 'OutputSurveyTemplate', id: number, surveyTypeId: number, audienceMode: string, lifecycleSurveyTypeId?: number | null, status: string, updated: Date | string, names: Array<{ __typename?: 'OutputSurveyTemplateNames', name: string, languageId: number }>, surveyElements?: Array<{ __typename?: 'SurveyElement', id?: number | null } | null> | null } };

export type AddToDoNotContactListMutationVariables = Exact<{
  employeesInput: Array<InputAddToDoNotContactList> | InputAddToDoNotContactList;
}>;


export type AddToDoNotContactListMutation = { __typename?: 'Mutation', addToDoNotContactList: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type AddTrendQuestionMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  surveyElementId: Scalars['Int'];
  orderIndex: Scalars['Int'];
}>;


export type AddTrendQuestionMutation = { __typename?: 'Mutation', addPreviousQuestion?: { __typename?: 'SurveyElement', id?: number | null } | null };

export type ApproveMigratedSurveyMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type ApproveMigratedSurveyMutation = { __typename?: 'Mutation', approveMigratedSurvey?: { __typename?: 'MigratedSurvey', id: number, surveyStatusId: number, timezoneId?: number | null, startTimeUTC?: Date | string | null, endTimeUTC?: Date | string | null } | null };

export type AssociateBenchmarkAttributeMutationVariables = Exact<{
  attributeId: Scalars['Int'];
  benchmarkAttributeId: Scalars['Int'];
}>;


export type AssociateBenchmarkAttributeMutation = { __typename?: 'Mutation', associateAttributeWithBenchmarkAttribute: { __typename?: 'AttributeToBenchmarkAttribute', id: number, attributeId: number, names?: any | null, benchmarkAttributeId: number } };

export type AssociateSurveyQuestionsWithBenchmarkQuestionMutationVariables = Exact<{
  surveyQuestionIds: Array<Scalars['Int']> | Scalars['Int'];
  benchmarkQuestionId: Scalars['Int'];
}>;


export type AssociateSurveyQuestionsWithBenchmarkQuestionMutation = { __typename?: 'Mutation', associateSurveyQuestionsWithBenchmarkQuestion: { __typename?: 'QuestionToBenchmarkQuestion', benchmarkQuestionId: number, newMappings: Array<{ __typename?: 'AssociatedQuestion', questionId: number, questionText: string, surveyCount: number, surveyYears: Array<number | null> } | null> } };

export type AttributeArchiveImpactQueryVariables = Exact<{
  companyId: Scalars['Int'];
  attributeId: Scalars['Int'];
}>;


export type AttributeArchiveImpactQuery = { __typename?: 'Query', attributeArchiveImpact: { __typename?: 'AttributeArchiveImpact', affectedUsers: Array<{ __typename?: 'AttributeArchiveImpactEntry', id: number, name: string, surveyTypeId: number, surveyTypeName: string, emptiedBuckets: Array<AttributeArchiveImpactBucket> }>, affectedRoles: Array<{ __typename?: 'AttributeArchiveImpactEntry', id: number, name: string, surveyTypeId: number, surveyTypeName: string, emptiedBuckets: Array<AttributeArchiveImpactBucket> }> } };

export type UpdateUsersStatusMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  status: UserStatusEnum;
}>;


export type UpdateUsersStatusMutation = { __typename?: 'Mutation', updateUsersStatus?: Array<{ __typename?: 'User', id?: number | null } | null> | null };

export type ClearCompanyCacheMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type ClearCompanyCacheMutation = { __typename?: 'Mutation', clearCompanyCache?: boolean | null };

export type ClearSurveyCacheMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type ClearSurveyCacheMutation = { __typename?: 'Mutation', clearSurveyCache?: boolean | null };

export type CloneSurveyTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  names: Array<InputSurveyTemplateNames> | InputSurveyTemplateNames;
}>;


export type CloneSurveyTemplateMutation = { __typename?: 'Mutation', cloneSurveyTemplate: { __typename?: 'OutputSurveyTemplate', id: number, status: string, updated: Date | string, surveyTypeId: number, names: Array<{ __typename?: 'OutputSurveyTemplateNames', languageId: number, name: string }>, surveyType: { __typename?: 'SurveyType', id?: number | null, name?: string | null, names?: Array<{ __typename?: 'SurveyTypeName', languageId?: number | null, name?: string | null } | null> | null } } };

export type CoachCommentsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']> | Scalars['Int'];
  surveyElementIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  attributes?: InputMaybe<Array<AttributeValuesSearchInput> | AttributeValuesSearchInput>;
  managerReportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
}>;


export type CoachCommentsQuery = { __typename?: 'Query', coachComments: { __typename?: 'Comments', commentCount: number, comments: Array<{ __typename?: 'Comment', id: number, text: string, created: Date | string } | null> } };

export type CommentsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  surveyIds: Array<Scalars['Int']> | Scalars['Int'];
  questionId: Scalars['Int'];
  surveyElementId: Scalars['Int'];
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>> | InputMaybe<AttributeValuesSearchInput>>;
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  keyword?: InputMaybe<Scalars['String']>;
  sentimentFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  themeFilter?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  entityFilter?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<CommentSortInput>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'Comments', commentCount: number, comments: Array<{ __typename?: 'Comment', id: number, sentiment?: string | null, text: string, created: Date | string, conversationId?: number | null, reactedLike?: boolean | null, reactedGreatIdea?: boolean | null, reactedWorkingOnIt?: boolean | null, like?: number | null, greatIdea?: number | null, workingOnIt?: number | null, surveyTypeId?: number | null, employeeResponseQuestionScaleId?: number | null, employeeResponseQuestionTextId?: number | null, employeeResponseQuestionOptionsId?: number | null, anonymousConversation?: boolean | null, themes?: Array<{ __typename?: 'Theme', id: number, themeName: string, translations: Array<{ __typename?: 'Translation', languageId: number, name: string } | null> } | null> | null } | null> } };

export type CompanyConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyConfigsQuery = { __typename?: 'Query', companyConfigs?: { __typename?: 'CompanyConfigs', companyId: number, openSurveysEnabled?: boolean | null } | null };

export type ContinuousSurveyTrendsAnalysisQueryVariables = Exact<{
  input: TimeframeTrendsInput;
}>;


export type ContinuousSurveyTrendsAnalysisQuery = { __typename?: 'Query', continuousSurveyTrendsAnalysis: { __typename?: 'TimeframeTrendsResults', factors?: Array<{ __typename?: 'TrendDatasetCollection', id: number, name: string, anonymized?: boolean | null, datasets: Array<{ __typename?: 'TrendDataset', selectedTimeframeIndex: number, label: string, scoreAverage: number, enpsScore?: number | null, percentUnfavorable: number, percentNeutral: number, percentFavorable: number, countUnfavorable?: number | null, countNeutral?: number | null, countFavorable?: number | null, count?: number | null } | null> } | null> | null, questions?: Array<{ __typename?: 'TrendDatasetCollection', id: number, name: string, factorId?: number | null, factorName?: string | null, anonymized?: boolean | null, datasets: Array<{ __typename?: 'TrendDataset', selectedTimeframeIndex: number, label: string, scoreAverage: number, enpsScore?: number | null, percentUnfavorable: number, percentNeutral: number, percentFavorable: number, countUnfavorable?: number | null, countNeutral?: number | null, countFavorable?: number | null, count?: number | null } | null> } | null> | null } };

export type ConvertSurveyToContinuousMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  continuousSurveyType: Scalars['String'];
}>;


export type ConvertSurveyToContinuousMutation = { __typename?: 'Mutation', convertSurveyToContinuous?: { __typename?: 'SurveyConvertResponse', surveyId: number, isContinuous: boolean, lifecycleSurveyTypeId: number } | null };

export type CreateAutomaticSurveyReminderMutationVariables = Exact<{
  automaticSurveyReminder?: InputMaybe<AutomaticSurveyReminderInput>;
}>;


export type CreateAutomaticSurveyReminderMutation = { __typename?: 'Mutation', createAutomaticSurveyReminder: { __typename?: 'OutputAutomaticSurveyReminder', id: number, surveyId: number, reminderFrequencyDays: number, status: string, automaticSurveyReminderLanguages?: Array<{ __typename?: 'OutputAutomaticSurveyReminderLanguage', languageId: number, emailSubject: string, emailBody: string } | null> | null } };

export type CreateEmployeeMutationVariables = Exact<{
  companyId: Scalars['Int'];
  employee: EmployeeEditInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', addEmployee?: { __typename?: 'Employee', id: number, enabled?: boolean | null, languageId?: number | null, attributesWithValues?: Array<{ __typename?: 'EmployeeAttributeWithValues', attributeValues: Array<any | null>, attribute: { __typename?: 'EmployeeAttribute', id: number, attributeNames: Array<{ __typename?: 'AttributeName', id?: number | null, name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null }> } } | null> | null } | null };

export type CreateEmployeeAttributeMutationVariables = Exact<{
  companyId: Scalars['Int'];
  attribute: AttributeInput;
}>;


export type CreateEmployeeAttributeMutation = { __typename?: 'Mutation', addAttribute?: { __typename?: 'Attribute', id?: number | null, baseAttributeId?: number | null, isReportingAttribute?: boolean | null, isPrivate?: boolean | null, isRequired?: boolean | null, isUnique?: boolean | null, isArchived?: boolean | null, isPhone?: boolean | null, type?: { __typename?: 'AttributeType', id?: number | null, name?: string | null } | null, attributeNames?: Array<{ __typename?: 'AttributeName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null };

export type CreateOrUpdateSurveyReminderMutationVariables = Exact<{
  surveyReminder: CreateOrUpdateSurveyReminderInput;
}>;


export type CreateOrUpdateSurveyReminderMutation = { __typename?: 'Mutation', createOrUpdateSurveyReminder: { __typename?: 'surveyReminderWithLanguageOutput', id?: number | null, created?: Date | string | null, updated?: Date | string | null, surveyId?: number | null, scheduledDateTime?: Date | string | null, status?: string | null, languages?: Array<{ __typename?: 'surveyReminderLanguageOutput', languageId?: number | null, emailSubject?: string | null, emailBody?: string | null } | null> | null, timezone?: { __typename?: 'timezoneOutput', id?: number | null, timezone?: string | null } | null } };

export type AddSurveyElementMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  surveyElement: SurveyElementInput;
}>;


export type AddSurveyElementMutation = { __typename?: 'Mutation', addSurveyElement?: { __typename?: 'SurveyElement', id?: number | null, companyId?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, isFilterable: boolean, isDiscontinued?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null } | null };

export type CreateSurveySummaryConversationMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type CreateSurveySummaryConversationMutation = { __typename?: 'Mutation', createSurveySummaryConversation?: { __typename?: 'SurveySummaryConversation', conversationId: string, title: string } | null };

export type DeleteBenchmarkAttributeAssociationMutationVariables = Exact<{
  attributeId: Scalars['Int'];
  benchmarkAttributeId: Scalars['Int'];
}>;


export type DeleteBenchmarkAttributeAssociationMutation = { __typename?: 'Mutation', deleteAttributeAssociation: number };

export type DeleteBenchmarkQuestionAssociationsMutationVariables = Exact<{
  surveyQuestionIds: Array<Scalars['Int']> | Scalars['Int'];
  benchmarkQuestionId: Scalars['Int'];
}>;


export type DeleteBenchmarkQuestionAssociationsMutation = { __typename?: 'Mutation', deleteSurveyQuestionAssociations: number };

export type DeleteBouncedEmailRecipientsMutationVariables = Exact<{
  emails: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type DeleteBouncedEmailRecipientsMutation = { __typename?: 'Mutation', deleteBouncedEmailRecipients?: boolean | null };

export type DeleteCommentAnalysisMutationVariables = Exact<{
  input?: InputMaybe<CommentsSummaryInput>;
}>;


export type DeleteCommentAnalysisMutation = { __typename?: 'Mutation', deleteCommentAnalysis: boolean };

export type DeleteFromLifecycleDoNotContactListMutationVariables = Exact<{
  employeeId: Scalars['Int'];
}>;


export type DeleteFromLifecycleDoNotContactListMutation = { __typename?: 'Mutation', deleteFromLifecycleDoNotContactList: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type DeleteLifecycleSurveyTriggerMutationVariables = Exact<{
  id: Scalars['Int'];
  shouldClearPendingEmployees: Scalars['Boolean'];
}>;


export type DeleteLifecycleSurveyTriggerMutation = { __typename?: 'Mutation', deleteLifecycleSurveyTrigger: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type DeletePendingUsersMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type DeletePendingUsersMutation = { __typename?: 'Mutation', deletePendingUsers?: boolean | null };

export type DeleteSurveyMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  companyId?: InputMaybe<Scalars['Int']>;
  languageId?: InputMaybe<Scalars['Int']>;
}>;


export type DeleteSurveyMutation = { __typename?: 'Mutation', deleteSurvey?: boolean | null };

export type DeleteSurveyElementMutationVariables = Exact<{
  surveyElementId: Scalars['Int'];
  surveyId: Scalars['Int'];
}>;


export type DeleteSurveyElementMutation = { __typename?: 'Mutation', deleteSurveyElement?: boolean | null };

export type DeleteSurveyReminderMutationVariables = Exact<{
  reminderId: Scalars['Int'];
}>;


export type DeleteSurveyReminderMutation = { __typename?: 'Mutation', deleteSurveyReminder: { __typename?: 'deleteSurveyReminderOutput', deleted?: number | null } };

export type DeleteSurveyTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteSurveyTemplateMutation = { __typename?: 'Mutation', deleteSurveyTemplate: { __typename?: 'OutputDeleteSurveyTemplateResponse', success: boolean } };

export type DisableOpenSurveyAccessCodeMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type DisableOpenSurveyAccessCodeMutation = { __typename?: 'Mutation', disableOpenSurveyAccessCode: { __typename?: 'Survey', id?: number | null, openSurveyAccessCode?: string | null } };

export type DuplicateSurveyMutationVariables = Exact<{
  surveyName: Scalars['String'];
  surveyId: Scalars['Int'];
  companyId?: InputMaybe<Scalars['Int']>;
  languageId?: InputMaybe<Scalars['Int']>;
  clientTimezone?: InputMaybe<Scalars['String']>;
}>;


export type DuplicateSurveyMutation = { __typename?: 'Mutation', duplicateSurvey?: { __typename?: 'Survey', id?: number | null } | null };

export type ExitImpersonationMutationVariables = Exact<{ [key: string]: never; }>;


export type ExitImpersonationMutation = { __typename?: 'Mutation', exitImpersonation?: { __typename?: 'UserAuth', token?: string | null } | null };

export type FetchAccountQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type FetchAccountQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: number | null, userRoleId?: number | null, employeeId?: number | null, hierarchy?: Array<number | null> | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, canManageMailingList?: boolean | null, isImpersonating?: boolean | null, company?: { __typename?: 'Company', id?: number | null, name?: string | null, workspace?: string | null, logoFileName?: string | null, topbarColorHex?: string | null, salesforceId?: string | null, hasSso?: boolean | null, created?: string | null, updated?: string | null, companyFeatureSettings?: { __typename?: 'CompanyFeatureSettings', COMMENT_SENTIMENT_AND_SUMMARY?: boolean | null } | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, preferredTimezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null, timezones?: Array<{ __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', id: number, langISOCode: string } | null> | null } | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, globalActions?: Array<{ __typename?: 'UserGlobalAction', id?: number | null, globalActionId?: number | null, companyId?: number | null } | null> | null, permissions?: Array<{ __typename?: 'UserPermission', id?: number | null, surveyTypeId?: number | null, accessAll?: boolean | null, allAttributesVisible?: boolean | null, canCompareToAllAttributes?: boolean | null, attributeBased?: boolean | null, hierarchyBased?: boolean | null, useUserAttributeValue?: Array<number | null> | null, useUserAttributeValueCompare?: Array<number | null> | null, created?: string | null, updated?: string | null, company?: { __typename?: 'Company', id?: number | null, name?: string | null, workspace?: string | null, logoFileName?: string | null, topbarColorHex?: string | null, salesforceId?: string | null, hasSso?: boolean | null, created?: string | null, updated?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, preferredTimezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null, timezones?: Array<{ __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', id: number, langISOCode: string } | null> | null } | null, userActions?: Array<{ __typename?: 'UserAction', id?: number | null, action?: string | null } | null> | null, visibleAttributes?: Array<{ __typename?: 'VisibleAttribute', id?: number | null, attributeId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null, compareAttributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null } | null> | null } | null };

export type FetchAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAdminUsersQuery = { __typename?: 'Query', adminUsers?: Array<{ __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null };

export type FetchAllBenchmarkAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllBenchmarkAttributesQuery = { __typename?: 'Query', findAllBenchmarkAttributes: Array<{ __typename?: 'BenchmarkAttribute', id: number, name: string, translationKey: string, lastRefreshed?: Date | string | null, values?: Array<{ __typename?: 'BenchmarkAttributeValue', id: number, name: string, altNames: Array<string | null> }> | null }> };

export type FetchAttributeResponsesQueryVariables = Exact<{
  companyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>> | InputMaybe<AttributeWithValuesSearchInput>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  skipUserPermission?: InputMaybe<Scalars['Boolean']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
}>;


export type FetchAttributeResponsesQuery = { __typename?: 'Query', attributesRatingResponses?: { __typename?: 'RatingResponsesStats', surveys?: Array<{ __typename?: 'RatingResponseSurvey', id?: number | null, name?: string | null, percentage?: number | null, count?: number | null, totalCount?: number | null } | null> | null, attributes?: Array<{ __typename?: 'RatingResponseAttribute', id?: number | null, name?: string | null, count?: number | null, spread?: { __typename?: 'FloatMinMax', min?: number | null, max?: number | null } | null, values?: Array<{ __typename?: 'AttributeValueResponseRatesStatistics', id?: string | null, label?: string | null, count?: number | null, totalCount?: number | null, percentage?: number | null } | null> | null } | null> | null } | null };

export type FetchAttributeSampleValuesQueryVariables = Exact<{
  attributeId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FetchAttributeSampleValuesQuery = { __typename?: 'Query', findAttributeSampleValues: Array<string | null> };

export type FetchAvailableBenchmarksQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAvailableBenchmarksQuery = { __typename?: 'Query', findAvailableBenchmarks: Array<string | null> };

export type FetchBasicSurveyListQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchBasicSurveyListQuery = { __typename?: 'Query', dashboardSurveys?: { __typename?: 'DashboardSurveysResult', count?: number | null, results?: Array<{ __typename?: 'DashboardSurvey', id?: number | null, surveyName?: string | null, typeId?: number | null, surveyStatusId?: number | null, startTimeUTC?: string | null, supportLanguages?: Array<number | null> | null, isContinuous?: boolean | null } | null> | null } | null };

export type FetchBenchmarkQuestionsQueryVariables = Exact<{
  surveyTypeId: Scalars['Int'];
}>;


export type FetchBenchmarkQuestionsQuery = { __typename?: 'Query', findBenchmarkQuestions: Array<{ __typename?: 'BenchmarkQuestion', questionId: number, questionText: string, taggedQuestionCount: number, surveyCount: number, surveyYears: Array<number | null> } | null> };

export type FetchBenchmarksQueryVariables = Exact<{
  queryInput: BenchmarkInput;
}>;


export type FetchBenchmarksQuery = { __typename?: 'Query', findBenchmarks: Array<{ __typename?: 'Benchmark', id: number, questionId: number, surveyType: string, benchmarkPeriod: string, benchmarkQuestionId: number, scope: BenchmarkScope, regionValueId?: number | null, countryValueId?: number | null, sizeValueId?: number | null, industryValueId?: number | null, sectorValueId?: number | null, averageScore?: number | null, positivePercent?: number | null, neutralPercent?: number | null, negativePercent?: number | null, promoter?: number | null, passive?: number | null, detractor?: number | null, eNPSScore?: number | null, totalCount: number, companiesCount: number } | null> };

export type FetchCommentsSummaryQueryVariables = Exact<{
  input: CommentsSummaryInput;
}>;


export type FetchCommentsSummaryQuery = { __typename?: 'Query', commentsSummary?: { __typename?: 'CommentsSummary', id: number, surveyElementId: number, languageId: number, overallSummary?: string | null, positiveSummary?: string | null, negativeSummary?: string | null, recommendations?: string | null, created: string } | null };

export type FetchCommentsSummaryForContinuousSurveyMutationVariables = Exact<{
  input: ContinuousSurveyCommentSummaryInput;
}>;


export type FetchCommentsSummaryForContinuousSurveyMutation = { __typename?: 'Mutation', genCommentsSummaryForContinuousSurvey: { __typename?: 'CommentsSummary', id: number, surveyElementId: number, languageId: number, overallSummary?: string | null, positiveSummary?: string | null, negativeSummary?: string | null, recommendations?: string | null, created: string } };

export type FetchCompaniesBenchmarkSettingsQueryVariables = Exact<{
  benchmarkAttributeId: Scalars['Int'];
}>;


export type FetchCompaniesBenchmarkSettingsQuery = { __typename?: 'Query', findAllCompaniesBenchmarkSettings: Array<{ __typename?: 'CompanyBenchmarkSetting', companyId: number, companyName: string, benchmarkAttributeId: number, ungroupedValue?: string | null, associatedAttribute?: { __typename?: 'AssociatedAttribute', id?: number | null, names?: any | null } | null, defaultValue?: { __typename?: 'BenchmarkAttributeValue', id: number, name: string } | null } | null> };

export type FetchCompanyQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id?: number | null, name?: string | null, workspace?: string | null, logoFileName?: string | null, topbarColorHex?: string | null, salesforceId?: string | null, hasSso?: boolean | null, created?: string | null, updated?: string | null, companyFeatureSettings?: { __typename?: 'CompanyFeatureSettings', COMMENT_SENTIMENT_AND_SUMMARY?: boolean | null } | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, preferredTimezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null, timezones?: Array<{ __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', id: number, langISOCode: string } | null> | null } | null };

export type FetchCompanyBenchmarkSettingsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchCompanyBenchmarkSettingsQuery = { __typename?: 'Query', findCompanyBenchmarkSettings: { __typename?: 'CompanyBenchmarkSettings', companyId: number, benchmarkAttributes: Array<{ __typename?: 'BenchmarkAttributeSetting', benchmarkAttributeId: number, benchmarkAttributeName: string, defaultValueId: number, defaultValueName: string } | null> } };

export type FetchCompanyEmployeeAttributesQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchCompanyEmployeeAttributesQuery = { __typename?: 'Query', findCompanyEmployeeAttributes: Array<{ __typename?: 'EmployeeAttribute', id: number, baseAttributeId?: number | null, isReportingAttribute: boolean, isPrivate: boolean, isRequired: boolean, isUnique: boolean, attributeTypeId: number, attributeNames: Array<{ __typename?: 'AttributeName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null }> } | null> };

export type FetchCompanyEmployeeIdsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
}>;


export type FetchCompanyEmployeeIdsQuery = { __typename?: 'Query', employeeDetails?: { __typename?: 'EmployeeDetails', count?: number | null, results?: Array<{ __typename?: 'EmployeeDetail', employeeId?: string | null, email?: string | null, lastName?: string | null } | null> | null } | null };

export type GetCompanyEmployeeIdsInSurveyQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type GetCompanyEmployeeIdsInSurveyQuery = { __typename?: 'Query', getCompanyEmployeeIdsInSurvey?: Array<string | null> | null };

export type FetchCompanyEmployeesAndUsersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  enabledEmployee?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchCompanyEmployeesAndUsersQuery = { __typename?: 'Query', employeeDetails?: { __typename?: 'EmployeeDetails', count?: number | null, results?: Array<{ __typename?: 'EmployeeDetail', employeeId?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, isUser?: boolean | null, hasRole?: boolean | null, enabled?: boolean | null, user?: { __typename?: 'UserDetails', firstName?: string | null, lastName?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null } | null } | null> | null } | null };

export type FetchCompanyMessagingConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCompanyMessagingConfigsQuery = { __typename?: 'Query', companyMessagingConfigs: Array<{ __typename?: 'CompanyMessagingConfig', companyId: number, channel: MessagingChannel, enabled: boolean, isConnected: boolean, created?: Date | string | null, updated?: Date | string | null }> };

export type FetchCompanyUserPermissionSummariesQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchCompanyUserPermissionSummariesQuery = { __typename?: 'Query', getCompanyUsers?: Array<{ __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, globalActions?: Array<{ __typename?: 'UserGlobalAction', globalActionId?: number | null } | null> | null, permissions?: Array<{ __typename?: 'UserPermission', surveyTypeId?: number | null } | null> | null } | null> | null };

export type FetchCompanyUsersQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchCompanyUsersQuery = { __typename?: 'Query', getCompanyUsers?: Array<{ __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null };

export type FetchDashboardSurveyQueryVariables = Exact<{
  companyId: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<SurveyDashboardSearchInput>;
  orderBy?: InputMaybe<Scalars['String']>;
  isAsc?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchDashboardSurveyQuery = { __typename?: 'Query', dashboardSurveys?: { __typename?: 'DashboardSurveysResult', count?: number | null, results?: Array<{ __typename?: 'DashboardSurvey', id?: number | null, hashCode?: string | null, statusId?: string | null, surveyName?: string | null, typeId?: number | null, completedCount?: number | null, totalCount?: number | null, responseRate?: number | null, created?: string | null, startTimeUTC?: string | null, endTimeUTC?: string | null, timezoneName?: string | null, remindersCount?: number | null, disableEmailSending?: boolean | null, isContinuous?: boolean | null, audienceMode?: string | null, surveyType?: { __typename?: 'SurveyType', names?: Array<{ __typename?: 'SurveyTypeName', name?: string | null } | null> | null } | null } | null> | null } | null };

export type FetchDefaultContextsAndPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchDefaultContextsAndPromptsQuery = { __typename?: 'Query', getDefaultContextsAndPrompts: Array<{ __typename?: 'DefaultContextAndPrompt', analysisType: string, context: string, guardPrompt?: string | null } | null> };

export type CompanyAttributeValuesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  attributeId: Scalars['Int'];
  languageId: Scalars['Int'];
  surveyTypeId?: InputMaybe<Scalars['Int']>;
  includeSnapshotValues?: InputMaybe<Scalars['Boolean']>;
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  onlyEnabledEmployees?: InputMaybe<Scalars['Boolean']>;
}>;


export type CompanyAttributeValuesQuery = { __typename?: 'Query', getCompanyAttributeValues?: { __typename?: 'CompanyAttributeValues', attributeValues?: Array<any | null> | null, attribute?: { __typename?: 'Attribute', id?: number | null } | null } | null };

export type FetchEmployeeAttributesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  includePrivateAttributes?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchEmployeeAttributesQuery = { __typename?: 'Query', getCompanyConfigDetails?: { __typename?: 'CompanyConfigDetails', attributes?: Array<{ __typename?: 'Attribute', id?: number | null, baseAttributeId?: number | null, isReportingAttribute?: boolean | null, isPrivate?: boolean | null, isRequired?: boolean | null, isUnique?: boolean | null, isArchived?: boolean | null, isPhone?: boolean | null, type?: { __typename?: 'AttributeType', id?: number | null, name?: string | null } | null, attributeNames?: Array<{ __typename?: 'AttributeName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null> | null, languages?: Array<{ __typename?: 'Language', id: number, langISOCode: string } | null> | null } | null };

export type FetchEmployeeImportColumnMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchEmployeeImportColumnMappingsQuery = { __typename?: 'Query', employeeImportColumnMappings: Array<{ __typename?: 'EmployeeImportColumnMapping', id: number, sourceColumnName: string, targetCoreField?: EmployeeImportCoreField | null, targetAttributeId?: number | null, targetAttributeName?: string | null, excluded: boolean }> };

export type FetchEmployeeImportTaskQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchEmployeeImportTaskQuery = { __typename?: 'Query', employeeImportTask: { __typename?: 'EmployeeImportTask', id: number, output?: { __typename?: 'EmployeeImportTaskOutput', errorMessage?: string | null, issues?: Array<{ __typename?: 'EmployeeImportIssue', severity: EmployeeImportIssueSeverity, message: string, rowNumber?: number | null }> | null } | null } };

export type FetchEmployeeImportTasksQueryVariables = Exact<{
  input: EmployeeImportTasksInput;
}>;


export type FetchEmployeeImportTasksQuery = { __typename?: 'Query', employeeImportTasks?: { __typename?: 'EmployeeImportTasks', count: number, results: Array<{ __typename?: 'EmployeeImportTask', id: number, status: EmployeeFileImportTaskStatus, sourceId: string, uploaderName?: string | null, originLabel: string, fileName?: string | null, created: Date | string, updated: Date | string }> } | null };

export type FetchEmployeeImportTransformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchEmployeeImportTransformationsQuery = { __typename?: 'Query', employeeImportTransformations: Array<{ __typename?: 'EmployeeImportTransformation', id: number, name: string, transformType: EmployeeImportTransformType, definition: any, targetCoreField?: EmployeeImportCoreField | null, targetAttributeId?: number | null, targetAttributeName?: string | null }> };

export type FetchEmployeesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>> | InputMaybe<AttributeValuesSearchInput>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  batchSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type FetchEmployeesQuery = { __typename?: 'Query', employeeDetails?: { __typename?: 'EmployeeDetails', count?: number | null, results?: Array<{ __typename?: 'EmployeeDetail', id: number, languageId?: number | null, enabled?: boolean | null, employeeId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, isUser?: boolean | null, attributes?: Array<{ __typename?: 'EmployeeAttributeObject', id: number, value?: any | null } | null> | null } | null> | null } | null };

export type FetchEmployeesWithoutAttributesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['Int']>;
  surveyTypeId?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Array<InputMaybe<AttributeValuesSearchInput>> | InputMaybe<AttributeValuesSearchInput>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  batchSearch?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type FetchEmployeesWithoutAttributesQuery = { __typename?: 'Query', employeeDetails?: { __typename?: 'EmployeeDetails', count?: number | null, results?: Array<{ __typename?: 'EmployeeDetail', id: number, enabled?: boolean | null, employeeId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, languageId?: number | null, isPrimaryEmployee?: boolean | null } | null> | null } | null };

export type FetchFailedSurveyMigrationTasksQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchFailedSurveyMigrationTasksQuery = { __typename?: 'Query', getFailedSurveyMigrationTasks?: Array<{ __typename?: 'SurveyMigrationTask', id: number, importType: string, status: string, companyId: number, surveyId: number, user: { __typename?: 'UserInfo', id: number, firstName: string, lastName: string, email: string } } | null> | null };

export type FetchHasCommentsSummaryQueryVariables = Exact<{
  input: CommentsSummaryInput;
}>;


export type FetchHasCommentsSummaryQuery = { __typename?: 'Query', savedCommentsSummary?: { __typename?: 'CommentsSummary', id: number, surveyElementId: number, languageId: number, overallSummary?: string | null, positiveSummary?: string | null, negativeSummary?: string | null, recommendations?: string | null, created: string } | null };

export type FetchMappedQuestionsForBenchmarkQuestionQueryVariables = Exact<{
  benchmarkQuestionId: Scalars['Int'];
}>;


export type FetchMappedQuestionsForBenchmarkQuestionQuery = { __typename?: 'Query', findMappedQuestionsForBenchmarkQuestion: Array<{ __typename?: 'SurveyQuestion', questionId: number, questionText: string, surveyCount: number, surveyYears: Array<number | null>, companyIds?: Array<number | null> | null } | null> };

export type FetchOpenSurveyAttributesQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type FetchOpenSurveyAttributesQuery = { __typename?: 'Query', openSurveyAttributes: Array<{ __typename?: 'OpenSurveyAttribute', id: number, surveyElementId: number, sourceAttributeId?: number | null, name: string }> };

export type FetchOpenSurveyDeviceCountQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type FetchOpenSurveyDeviceCountQuery = { __typename?: 'Query', openSurveyDeviceCount: { __typename?: 'OpenSurveyDeviceCount', responseCount: number, deviceCount?: number | null } };

export type FetchQuestionResultsQueryVariables = Exact<{
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>> | InputMaybe<AttributeWithValuesSearchInput>>;
  companyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
}>;


export type FetchQuestionResultsQuery = { __typename?: 'Query', overallSurveyResults?: Array<{ __typename?: 'OverallQuestionResult', id?: number | null, surveyElementId?: number | null, type?: string | null, text?: string | null, totalAnswered?: number | null, totalRespondents?: number | null, numberOfComments?: number | null, iconPath?: string | null, minRating?: number | null, maxRating?: number | null, average?: number | null, ratings?: Array<{ __typename?: 'OverallResultRating', rating?: number | null, totalAnswered?: number | null, numberOfComments?: number | null, percentage?: number | null } | null> | null, options?: Array<{ __typename?: 'OverallResultOption', id?: number | null, text?: string | null, totalAnswered?: number | null, numberOfComments?: number | null, percentage?: number | null } | null> | null, aggregatedCommentSentiments?: { __typename?: 'OverallResultAggregatedCommentSentiments', numberOfPositiveComments?: number | null, numberOfNeutralComments?: number | null, numberOfNegativeComments?: number | null, numberOfUnknownComments?: number | null } | null } | null> | null };

export type QuestionScaleRatingResponsesQueryVariables = Exact<{
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>> | InputMaybe<AttributeWithValuesSearchInput>>;
  companyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  inputAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  requestManagerHierarchyData?: InputMaybe<Scalars['Boolean']>;
  includeYesNoQuestion?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuestionScaleRatingResponsesQuery = { __typename?: 'Query', questionScaleRatingResponses?: { __typename?: 'SlideRatingStatistics', factors?: Array<{ __typename?: 'StatisticsCategory', questions?: Array<{ __typename?: 'StatisticsQuestion', id?: number | null, surveyElementId?: number | null, anonymized?: boolean | null, attributes?: Array<{ __typename?: 'StatisticsAttribute', id?: number | null, count?: number | null, anonymized?: boolean | null, values?: Array<{ __typename?: 'StatisticsAttributeValue', id?: string | null, label?: string | null, anonymized?: boolean | null, responseRates?: { __typename?: 'StatisticsResponseRates', count?: Array<{ __typename?: 'StatisticsResponseRateCount', rating?: string | null, value?: number | null } | null> | null, percentage?: Array<{ __typename?: 'StatisticsResponseRatePercentage', rating?: string | null, value?: number | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null, keyFactors?: Array<{ __typename?: 'StatisticsCategory', questions?: Array<{ __typename?: 'StatisticsQuestion', id?: number | null, surveyElementId?: number | null, anonymized?: boolean | null, attributes?: Array<{ __typename?: 'StatisticsAttribute', id?: number | null, count?: number | null, anonymized?: boolean | null, values?: Array<{ __typename?: 'StatisticsAttributeValue', id?: string | null, label?: string | null, anonymized?: boolean | null, responseRates?: { __typename?: 'StatisticsResponseRates', count?: Array<{ __typename?: 'StatisticsResponseRateCount', rating?: string | null, value?: number | null } | null> | null, percentage?: Array<{ __typename?: 'StatisticsResponseRatePercentage', rating?: string | null, value?: number | null } | null> | null } | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type FetchSavedCommentsSummaryQueryVariables = Exact<{
  input: CommentsSummaryInput;
}>;


export type FetchSavedCommentsSummaryQuery = { __typename?: 'Query', savedCommentsSummary?: { __typename?: 'CommentsSummary', id: number, surveyElementId: number, languageId: number, overallSummary?: string | null, positiveSummary?: string | null, negativeSummary?: string | null, recommendations?: string | null, created: string } | null };

export type FetchSelectableBenchmarkValuesQueryVariables = Exact<{
  surveyId: Scalars['Int'];
  benchmarkPeriod: Scalars['String'];
}>;


export type FetchSelectableBenchmarkValuesQuery = { __typename?: 'Query', findSelectableBenchmarkValues: Array<{ __typename?: 'SelectableBenchmarkAttribute', benchmarkAttributeId: number, benchmarkAttributeName: string, translationKey: string, values: Array<{ __typename?: 'SelectableBenchmarkValue', valueId: number, valueName: string }> }> };

export type FetchSendingEmailAddressesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchSendingEmailAddressesQuery = { __typename?: 'Query', getCompanyConfigDetails?: { __typename?: 'CompanyConfigDetails', id?: number | null, sendingDomains?: Array<{ __typename?: 'SendingDomain', domain?: string | null, sendingEmailAddress?: Array<{ __typename?: 'SendingEmailAddress', id?: number | null, localPart?: string | null } | null> | null } | null> | null } | null };

export type FetchSmsDoNotContactListQueryVariables = Exact<{
  employeeName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FetchSmsDoNotContactListQuery = { __typename?: 'Query', employeeChannelDoNotContactList: { __typename?: 'EmployeeChannelDoNotContactListResult', total: number, entries: Array<{ __typename?: 'EmployeeChannelDoNotContactEntry', employeeId: number, firstName: string, lastName: string, email?: string | null, channel: MessagingChannel, reason: string, addedAtTimeUTC: string, addedByUser?: { __typename?: 'OutputAddedByUser', userId: number, firstName: string, lastName: string } | null }> } };

export type FetchSurveyElementLanguagesQueryVariables = Exact<{
  surveyElementLanguagesId: Scalars['Int'];
  benchmarkedQuestionLanguages?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchSurveyElementLanguagesQuery = { __typename?: 'Query', surveyElementLanguages?: Array<{ __typename?: 'SurveyElementQuestionOptionLanguage', id?: number | null, surveyElementQuestionOptionsId?: number | null, languageId?: number | null, questionText?: string | null, description?: string | null, created?: Date | string | null, updated?: Date | string | null, deletedAt?: Date | string | null } | { __typename?: 'SurveyElementQuestionScaleLanguage', id?: number | null, surveyElementQuestionScaleId?: number | null, languageId?: number | null, questionText?: string | null, labelBefore?: string | null, labelAfter?: string | null, description?: string | null, created?: Date | string | null, updated?: Date | string | null, deletedAt?: Date | string | null } | { __typename?: 'SurveyElementQuestionTextLanguage', id?: number | null, surveyElementQuestionTextId?: number | null, languageId?: number | null, questionText?: string | null, description?: string | null, created?: Date | string | null, updated?: Date | string | null, deletedAt?: Date | string | null } | null> | null };

export type GetSurveysQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetSurveysQuery = { __typename?: 'Query', surveys?: Array<{ __typename?: 'Survey', id?: number | null, namesPerLanguage?: Array<{ __typename?: 'SurveyLanguage', surveyName?: string | null } | null> | null, types?: Array<{ __typename?: 'SurveyType', id?: number | null } | null> | null, questions?: Array<{ __typename?: 'SurveyElement', id?: number | null, companyId?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null } | null> | null } | null> | null };

export type FetchSurveyListWithTimezoneQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type FetchSurveyListWithTimezoneQuery = { __typename?: 'Query', dashboardSurveys?: { __typename?: 'DashboardSurveysResult', count?: number | null, results?: Array<{ __typename?: 'DashboardSurvey', id?: number | null, surveyName?: string | null, typeId?: number | null, surveyStatusId?: number | null, startTimeUTC?: string | null, supportLanguages?: Array<number | null> | null, timezoneId?: number | null } | null> | null } | null };

export type FetchSurveyMessagingChannelsQueryVariables = Exact<{
  surveyId: Scalars['ID'];
}>;


export type FetchSurveyMessagingChannelsQuery = { __typename?: 'Query', surveyMessagingChannels: Array<{ __typename?: 'SurveyMessaging', surveyId: string, channel: MessagingChannelOptions, enabled: boolean, smsAttributeId?: string | null, variationKey?: string | null }> };

export type FetchSurveyParticipantChannelStatusesQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  employeeIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FetchSurveyParticipantChannelStatusesQuery = { __typename?: 'Query', surveyParticipantChannelStatuses: Array<{ __typename?: 'SurveyParticipantChannels', employeeId: string, channels: Array<{ __typename?: 'ParticipantChannel', channel: ParticipantChannelType, status: ParticipantChannelStatus, lastSentAt?: Date | string | null }> }> };

export type FetchSurveyParticipantSmsReachabilityQueryVariables = Exact<{
  surveyId: Scalars['ID'];
  smsAttributeId?: InputMaybe<Scalars['ID']>;
  employeeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type FetchSurveyParticipantSmsReachabilityQuery = { __typename?: 'Query', surveyParticipantSmsReachability: Array<{ __typename?: 'SurveyParticipantSmsReachability', employeeId: string, optedOut: boolean, hasPhone: boolean }> };

export type FetchSurveyTemplateQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchSurveyTemplateQuery = { __typename?: 'Query', getSurveyTemplate: { __typename?: 'OutputSurveyTemplate', id: number, surveyTypeId: number, audienceMode: string, lifecycleSurveyTypeId?: number | null, status: string, updated: Date | string, names: Array<{ __typename?: 'OutputSurveyTemplateNames', name: string, languageId: number }>, surveyType: { __typename?: 'SurveyType', id?: number | null, name?: string | null, names?: Array<{ __typename?: 'SurveyTypeName', languageId?: number | null, name?: string | null } | null> | null }, surveyElements?: Array<{ __typename?: 'SurveyElement', id?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null } | null } | null> | null, surveyTemplateLanguages?: Array<{ __typename?: 'OutputSurveyTemplateLanguage', languageId: number, emailContent: string, emailSubject: string }> | null } };

export type FetchSurveyTemplateElementsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchSurveyTemplateElementsQuery = { __typename?: 'Query', getSurveyTemplate: { __typename?: 'OutputSurveyTemplate', id: number, audienceMode: string, lifecycleSurveyTypeId?: number | null, surveyElements?: Array<{ __typename?: 'SurveyElement', id?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, isFilterable: boolean, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null } | null } | null> | null } };

export type FetchSurveyTemplatesQueryVariables = Exact<{
  filterOptions?: InputMaybe<InputSurveyTemplateFilters>;
}>;


export type FetchSurveyTemplatesQuery = { __typename?: 'Query', getSurveyTemplates: Array<{ __typename?: 'OutputSurveyTemplate', id: number, status: string, updated: Date | string, surveyTypeId: number, audienceMode: string, lifecycleSurveyTypeId?: number | null, names: Array<{ __typename?: 'OutputSurveyTemplateNames', languageId: number, name: string }>, surveyType: { __typename?: 'SurveyType', id?: number | null, name?: string | null, names?: Array<{ __typename?: 'SurveyTypeName', languageId?: number | null, name?: string | null } | null> | null }, surveyTemplateLanguages?: Array<{ __typename?: 'OutputSurveyTemplateLanguage', emailContent: string, emailSubject: string, languageId: number }> | null } | null> };

export type GetSurveyTypeAttributesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  surveyTypeId: Scalars['Int'];
  includePrivateAttributes?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSurveyTypeAttributesQuery = { __typename?: 'Query', surveyTypeAttributes?: Array<{ __typename?: 'Attribute', id?: number | null, baseAttributeId?: number | null, companyId?: number | null, type?: { __typename?: 'AttributeType', id?: number | null, name?: string | null } | null, attributeNames?: Array<{ __typename?: 'AttributeName', id?: number | null, name?: string | null } | null> | null } | null> | null };

export type FetchSurveyTypesWithCategoriesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  languageIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  includeBase?: InputMaybe<Scalars['Boolean']>;
}>;


export type FetchSurveyTypesWithCategoriesQuery = { __typename?: 'Query', companySurveyTypes?: Array<{ __typename?: 'CompanySurveyType', id?: number | null, threshold?: number | null, names?: Array<{ __typename?: 'CompanySurveyTypeName', name?: string | null } | null> | null, categories?: Array<{ __typename?: 'CompanySurveyTypeCategory', categoryId?: number | null, isKeyFactor?: boolean | null, isBaseCategory?: boolean | null, names?: Array<{ __typename?: 'CompanySurveyTypeName', name?: string | null } | null> | null } | null> | null } | null> | null };

export type FetchSurveyWithSurveyElementsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type FetchSurveyWithSurveyElementsQuery = { __typename?: 'Query', survey?: { __typename?: 'Survey', id?: number | null, hashCode?: string | null, showResults?: boolean | null, anonymousConversation?: boolean | null, fromEmailName?: string | null, startTimeUTC?: string | null, endTimeUTC?: string | null, combineLanguages?: boolean | null, disableEmailSending?: boolean | null, isContinuous?: boolean | null, audienceMode?: string | null, openSurveyUuid?: string | null, openSurveyAccessCode?: string | null, invitationExpiryIn?: number | null, lifecycleSurveyTypeId?: number | null, companyEmployeeIdsInSurvey?: Array<string | null> | null, status?: { __typename?: 'SurveyStatus', id?: number | null, name?: string | null } | null, namesPerLanguage?: Array<{ __typename?: 'SurveyLanguage', surveyName?: string | null, emailSubject?: string | null, emailBody?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, sendingEmailAddress?: { __typename?: 'SendingEmailAddress', id?: number | null } | null, timezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null, employees?: Array<{ __typename?: 'SurveyEmployee', id: number, surveyInviteDate?: string | null, addedDate?: string | null } | null> | null, types?: Array<{ __typename?: 'SurveyType', id?: number | null } | null> | null, questions?: Array<{ __typename?: 'SurveyElement', id?: number | null, companyId?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, isFilterable: boolean, discontinuedDateUTC?: Date | string | null, addedDateUTC?: Date | string | null, isDiscontinued?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null } | null> | null } | null };

export type FetchSurveysStatusesQueryVariables = Exact<{
  surveyIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type FetchSurveysStatusesQuery = { __typename?: 'Query', surveys?: Array<{ __typename?: 'Survey', id?: number | null, status?: { __typename?: 'SurveyStatus', id?: number | null, name?: string | null } | null } | null> | null };

export type FetchTimezonesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FetchTimezonesQuery = { __typename?: 'Query', getCompanyConfigDetails?: { __typename?: 'CompanyConfigDetails', id?: number | null, timezones?: Array<{ __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null> | null } | null };

export type FetchTrendResultsQueryVariables = Exact<{
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>> | InputMaybe<AttributeWithValuesSearchInput>>;
  companyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
  surveyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  factorIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  questionIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  aggregationType: TrendsAggregationEnum;
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type FetchTrendResultsQuery = { __typename?: 'Query', trendsResult?: { __typename?: 'AggregatedTrendResult', factors?: Array<{ __typename?: 'AggregatedTrendDatasetCollection', id?: number | null, name?: string | null, datasets?: Array<{ __typename?: 'AggregatedTrendDataset', ids?: Array<number | null> | null, label?: string | null, scoreAverage?: number | null, enpsScore?: number | null, percentUnfavorable?: number | null, percentNeutral?: number | null, percentFavorable?: number | null, countUnfavorable?: number | null, countNeutral?: number | null, countFavorable?: number | null, count?: number | null } | null> | null } | null> | null, questions?: Array<{ __typename?: 'AggregatedTrendDatasetCollection', id?: number | null, name?: string | null, factorId?: number | null, factorName?: string | null, datasets?: Array<{ __typename?: 'AggregatedTrendDataset', ids?: Array<number | null> | null, label?: string | null, scoreAverage?: number | null, enpsScore?: number | null, percentUnfavorable?: number | null, percentNeutral?: number | null, percentFavorable?: number | null, countUnfavorable?: number | null, countNeutral?: number | null, countFavorable?: number | null, count?: number | null } | null> | null } | null> | null } | null };

export type FetchUnmappedAttributeValuesQueryVariables = Exact<{
  benchmarkAttributeId: Scalars['Int'];
}>;


export type FetchUnmappedAttributeValuesQuery = { __typename?: 'Query', findUnmappedAttributeValues: Array<string | null> };

export type FetchUntaggedSurveyQuestionsQueryVariables = Exact<{
  surveyQuestionInput: SurveyQuestionInput;
}>;


export type FetchUntaggedSurveyQuestionsQuery = { __typename?: 'Query', findUntaggedSurveyQuestions?: { __typename?: 'SurveyQuestionsResult', totalCount: number, surveyQuestions: Array<{ __typename?: 'SurveyQuestion', questionId: number, questionText: string, surveyCount: number, surveyYears: Array<number | null>, companyIds?: Array<number | null> | null } | null> } | null };

export type FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables = Exact<{
  surveyQuestionInput: SurveyQuestionInput;
}>;


export type FetchUntaggedSurveyQuestionsWithAllIdsQuery = { __typename?: 'Query', findUntaggedSurveyQuestions?: { __typename?: 'SurveyQuestionsResult', totalCount: number, allQuestionIds: Array<number | null>, surveyQuestions: Array<{ __typename?: 'SurveyQuestion', questionId: number, questionText: string, surveyCount: number, surveyYears: Array<number | null> } | null> } | null };

export type FetchUsersWithPermissionsQueryVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
  companyId: Scalars['Int'];
}>;


export type FetchUsersWithPermissionsQuery = { __typename?: 'Query', getUsersWithPermissions?: Array<{ __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, globalActions?: Array<{ __typename?: 'UserGlobalAction', id?: number | null, globalActionId?: number | null, companyId?: number | null } | null> | null, permissions?: Array<{ __typename?: 'UserPermission', id?: number | null, surveyTypeId?: number | null, accessAll?: boolean | null, allAttributesVisible?: boolean | null, canCompareToAllAttributes?: boolean | null, attributeBased?: boolean | null, hierarchyBased?: boolean | null, created?: string | null, updated?: string | null, otherHierarchies?: Array<string | null> | null, useUserAttributeValue?: Array<number | null> | null, useUserAttributeValueCompare?: Array<number | null> | null, company?: { __typename?: 'Company', id?: number | null, name?: string | null } | null, userActions?: Array<{ __typename?: 'UserAction', id?: number | null, action?: string | null } | null> | null, visibleAttributes?: Array<{ __typename?: 'VisibleAttribute', id?: number | null, attributeId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null, compareAttributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null } | null> | null } | null> | null };

export type FindSurveyReminderByReminderIdQueryVariables = Exact<{
  reminderId: Scalars['Int'];
}>;


export type FindSurveyReminderByReminderIdQuery = { __typename?: 'Query', findSurveyReminderByReminderId: { __typename?: 'surveyReminderWithLanguageOutput', id?: number | null, surveyId?: number | null, scheduledDateTime?: Date | string | null, status?: string | null, languages?: Array<{ __typename?: 'surveyReminderLanguageOutput', languageId?: number | null, emailSubject?: string | null, emailBody?: string | null } | null> | null, survey?: { __typename?: 'surveyOutput', id?: number | null, startTimeUTC: Date | string, endTimeUTC?: Date | string | null, surveyStatusId?: number | null } | null, timezone?: { __typename?: 'timezoneOutput', id?: number | null, timezone?: string | null } | null } };

export type FindSurveyReminderDetailsBySurveyIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type FindSurveyReminderDetailsBySurveyIdQuery = { __typename?: 'Query', survey?: { __typename?: 'Survey', id?: number | null, startTimeUTC?: string | null, endTimeUTC?: string | null, status?: { __typename?: 'SurveyStatus', id?: number | null } | null, namesPerLanguage?: Array<{ __typename?: 'SurveyLanguage', emailSubject?: string | null, emailBody?: string | null, emailReminderSubject?: string | null, emailReminderBody?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, timezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null } | null };

export type FindSurveyRemindersBySurveyIdQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type FindSurveyRemindersBySurveyIdQuery = { __typename?: 'Query', findSurveyRemindersBySurveyId: Array<{ __typename?: 'surveyReminderOutput', surveyId?: number | null, id?: number | null, scheduledDateTime?: Date | string | null, status?: string | null, timezone?: { __typename?: 'timezoneOutput', id?: number | null, timezone?: string | null } | null }> };

export type FindSurveysQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type FindSurveysQuery = { __typename?: 'Query', surveys?: Array<{ __typename?: 'Survey', id?: number | null, anonymousConversation?: boolean | null, startTimeUTC?: string | null, isContinuous?: boolean | null, audienceMode?: string | null, namesPerLanguage?: Array<{ __typename?: 'SurveyLanguage', id?: number | null, surveyName?: string | null, language?: { __typename?: 'Language', langISOCode: string } | null } | null> | null, types?: Array<{ __typename?: 'SurveyType', id?: number | null, threshold?: number | null } | null> | null } | null> | null };

export type FindUsersByEmailQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type FindUsersByEmailQuery = { __typename?: 'Query', findUsersByEmail: Array<{ __typename?: 'UserByEmailResult', email: string, status: string, companyName?: string | null, companyId?: number | null }> };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'ForgotPasswordResult', result?: string | null } | null };

export type CompanyFieldsFragment = { __typename?: 'Company', id?: number | null, name?: string | null, workspace?: string | null, logoFileName?: string | null, topbarColorHex?: string | null, salesforceId?: string | null, hasSso?: boolean | null, created?: string | null, updated?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, preferredTimezone?: { __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null, timezones?: Array<{ __typename?: 'Timezone', id?: number | null, timezone?: string | null } | null> | null, languages?: Array<{ __typename?: 'Language', id: number, langISOCode: string } | null> | null };

export type ConversationsMessagesFragment = { __typename?: 'MinimalConversationMessage', id?: number | null, text: string, conversationId?: number | null, created?: Date | string | null, user?: { __typename?: 'User', id?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null };

export type EmployeeAttributeFieldsFragment = { __typename?: 'Attribute', id?: number | null, baseAttributeId?: number | null, isReportingAttribute?: boolean | null, isPrivate?: boolean | null, isRequired?: boolean | null, isUnique?: boolean | null, isArchived?: boolean | null, isPhone?: boolean | null, type?: { __typename?: 'AttributeType', id?: number | null, name?: string | null } | null, attributeNames?: Array<{ __typename?: 'AttributeName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null };

export type PermissionFieldsFragment = { __typename?: 'UserPermission', id?: number | null, surveyTypeId?: number | null, accessAll?: boolean | null, allAttributesVisible?: boolean | null, canCompareToAllAttributes?: boolean | null, attributeBased?: boolean | null, hierarchyBased?: boolean | null, created?: string | null, updated?: string | null, otherHierarchies?: Array<string | null> | null, useUserAttributeValue?: Array<number | null> | null, useUserAttributeValueCompare?: Array<number | null> | null, company?: { __typename?: 'Company', id?: number | null, name?: string | null } | null, userActions?: Array<{ __typename?: 'UserAction', id?: number | null, action?: string | null } | null> | null, visibleAttributes?: Array<{ __typename?: 'VisibleAttribute', id?: number | null, attributeId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null, compareAttributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null };

export type SurveyElementFieldsFragment = { __typename?: 'SurveyElement', id?: number | null, companyId?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null };

export type SurveyTypePermissionFieldsFragment = { __typename?: 'SurveyTypePermission', surveyTypeId?: number | null, permissions?: Array<string | null> | null, canAccessAll?: boolean | null };

export type UserFieldsFragment = { __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null };

export type UserPermissionSummaryFieldsFragment = { __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, globalActions?: Array<{ __typename?: 'UserGlobalAction', globalActionId?: number | null } | null> | null, permissions?: Array<{ __typename?: 'UserPermission', surveyTypeId?: number | null } | null> | null };

export type UserWithPermissionsFieldsFragment = { __typename?: 'User', id?: number | null, employeeId?: number | null, userRoleId?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, email?: string | null, status?: string | null, worktangoAdmin?: boolean | null, updated?: string | null, created?: string | null, preferredLanguage?: { __typename?: 'Language', id: number, langISOCode: string } | null, globalActions?: Array<{ __typename?: 'UserGlobalAction', id?: number | null, globalActionId?: number | null, companyId?: number | null } | null> | null, permissions?: Array<{ __typename?: 'UserPermission', id?: number | null, surveyTypeId?: number | null, accessAll?: boolean | null, allAttributesVisible?: boolean | null, canCompareToAllAttributes?: boolean | null, attributeBased?: boolean | null, hierarchyBased?: boolean | null, created?: string | null, updated?: string | null, otherHierarchies?: Array<string | null> | null, useUserAttributeValue?: Array<number | null> | null, useUserAttributeValueCompare?: Array<number | null> | null, company?: { __typename?: 'Company', id?: number | null, name?: string | null } | null, userActions?: Array<{ __typename?: 'UserAction', id?: number | null, action?: string | null } | null> | null, visibleAttributes?: Array<{ __typename?: 'VisibleAttribute', id?: number | null, attributeId?: number | null } | null> | null, attributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null, compareAttributes?: Array<{ __typename?: 'UserPermissionAttribute', id?: number | null, name?: string | null, values?: Array<any | null> | null } | null> | null } | null> | null };

export type GenThemesAnalysisMutationVariables = Exact<{
  surveyIds: Array<Scalars['Int']> | Scalars['Int'];
  surveyElementId: Scalars['Int'];
}>;


export type GenThemesAnalysisMutation = { __typename?: 'Mutation', genThemesAnalysis: { __typename?: 'GenThemesResponse', errorMessage?: string | null, success: boolean } };

export type GenerateCommentsSummaryMutationVariables = Exact<{
  input: CommentsSummaryInput;
}>;


export type GenerateCommentsSummaryMutation = { __typename?: 'Mutation', generateCommentsSummary: { __typename?: 'CommentsSummary', id: number, surveyElementId: number, languageId: number, overallSummary?: string | null, positiveSummary?: string | null, negativeSummary?: string | null, recommendations?: string | null, created: string } };

export type GenerateOpenSurveyAccessCodeMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type GenerateOpenSurveyAccessCodeMutation = { __typename?: 'Mutation', generateOpenSurveyAccessCode: { __typename?: 'Survey', id?: number | null, openSurveyAccessCode?: string | null } };

export type GetAiSummaryQueryVariables = Exact<{
  userId: Scalars['Int'];
  surveyId: Scalars['Int'];
  filters?: InputMaybe<AiSummaryFiltersInput>;
}>;


export type GetAiSummaryQuery = { __typename?: 'Query', getAISummary?: { __typename?: 'AISurveySummary', id: number, commentsSummary?: string | null, surveyShortSummary?: string | null, status: string, participationRate?: string | null, strengths?: string | null, areasToWatch?: string | null, areasOfOpportunity?: string | null, qualitativeFeedback?: string | null, recommendedActions?: string | null, errorText?: string | null, created?: Date | string | null, updated?: Date | string | null } | null };

export type GetActivationUserQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetActivationUserQuery = { __typename?: 'Query', getActivationUser?: { __typename?: 'ActivationUser', email?: string | null, companyName?: string | null, preferredLanguageId?: number | null, langISOCode?: string | null, hasSSO?: boolean | null } | null };

export type GetAutomaticSurveyRemindersQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type GetAutomaticSurveyRemindersQuery = { __typename?: 'Query', getAutomaticSurveyReminders: Array<{ __typename?: 'OutputAutomaticSurveyReminder', id: number, surveyId: number, reminderFrequencyDays: number, sendTime: string, status: string, automaticSurveyReminderLanguages?: Array<{ __typename?: 'OutputAutomaticSurveyReminderLanguage', languageId: number, emailSubject: string, emailBody: string } | null> | null } | null> };

export type GetConversationMessagesQueryVariables = Exact<{
  conversationId: Scalars['Int'];
}>;


export type GetConversationMessagesQuery = { __typename?: 'Query', conversationsMessages?: Array<{ __typename?: 'MinimalConversationMessage', id?: number | null, text: string, conversationId?: number | null, created?: Date | string | null, user?: { __typename?: 'User', id?: number | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null> | null };

export type GetConversationsListQueryVariables = Exact<{
  languageId: Scalars['Int'];
}>;


export type GetConversationsListQuery = { __typename?: 'Query', conversationsList?: Array<{ __typename?: 'ConversationsListItem', id?: number | null, created?: Date | string | null, surveyId: number, surveyName: string, reactedLike?: boolean | null, reactedGreatIdea?: boolean | null, reactedWorkingOnIt?: boolean | null, response?: { __typename?: 'ConversationResponse', id?: number | null, title?: string | null, comment?: string | null } | null } | null> | null };

export type GetCronjobRunStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCronjobRunStatusesQuery = { __typename?: 'Query', getCronjobRunStatuses: Array<{ __typename?: 'CronjobRunStatus', name: string, lastRunAt: string, lastStatus: string, lastDurationMs: number, lastRunByUser?: { __typename?: 'CronjobRunUser', id: number, firstname?: string | null, lastname?: string | null, email?: string | null } | null }> };

export type GetCronjobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCronjobsQuery = { __typename?: 'Query', getCronjobs: Array<{ __typename?: 'CronjobInfo', name: string, description: string, period: number, periodUnit: string }> };

export type GetTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTagsQuery = { __typename?: 'Query', tags?: Array<{ __typename?: 'Tag', id?: number | null, name?: string | null } | null> | null };

export type GetLibraryQuestionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: VendorQuestionsSearchInput;
}>;


export type GetLibraryQuestionsQuery = { __typename?: 'Query', libraryQuestions?: { __typename?: 'SurveyElementCount', count?: number | null, fields?: Array<{ __typename?: 'SurveyElement', companyId?: number | null, id?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, surveyTypeId?: number | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage' } | { __typename?: 'SurveyElementQuestionOptions', required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type GetLifecycleSurveyDoNotContactListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLifecycleSurveyDoNotContactListQuery = { __typename?: 'Query', getLifecycleSurveyDoNotContactList?: Array<{ __typename?: 'OutputLifecycleSurveyDoNotContactList', id: number, employeeId: number, firstName: string, lastName: string, email?: string | null, addedAtTimeUTC: string, doNotContactReason?: string | null, addedByUser?: { __typename?: 'OutputAddedByUser', userId: number, firstName: string, lastName: string } | null } | null> | null };

export type GetLifecycleSurveyRecipientsQueryVariables = Exact<{
  surveyId?: InputMaybe<Scalars['Int']>;
}>;


export type GetLifecycleSurveyRecipientsQuery = { __typename?: 'Query', getLifecycleSurveyRecipients?: Array<{ __typename?: 'OutputLifecycleSurveyRecipients', id: number, employeeId: number, firstName: string, lastName: string, targetInvitationDate: string, addedToListDate: string, isApprovedToAdd: boolean, lifecycleSurveyTriggerId: number, triggerTypeId?: number | null, startDate?: string | null, exitDate?: string | null, requireAdminApproval: boolean, targetSurvey?: { __typename?: 'OutputSurvey', id: number, name: string, surveyId: number } | null } | null> | null };

export type GetLifecycleSurveyTriggerTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLifecycleSurveyTriggerTypesQuery = { __typename?: 'Query', getLifecycleSurveyTriggerTypes?: Array<{ __typename?: 'OutputLifecycleSurveyTriggerTypes', id: number, type: string, isEnabled: boolean } | null> | null };

export type GetLifecycleSurveyTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLifecycleSurveyTriggersQuery = { __typename?: 'Query', getLifecycleSurveyTriggers?: Array<{ __typename?: 'OutputLifecycleSurveyTrigger', id: number, lifecycleSurveyTypeId: number, surveyId: number, triggerAttributeId: number, audienceType: string, invitationOffsetDays: number, requireAdminApproval: boolean, timeOfDayStartUTC: string, timeOfDayEndUTC: string, status?: string | null, languages?: Array<{ __typename?: 'OutputLanguages', languageId: number, name: string } | null> | null, attributeAudience?: Array<{ __typename?: 'OutputAttributes', attributeId: number, attributeValue: string } | null> | null, adminApprovers?: Array<{ __typename?: 'OutputAdminApprover', userId: number } | null> | null, superAdminApprovers?: Array<{ __typename?: 'OutputAdminApprover', userId: number } | null> | null } | null> | null };

export type GetLifecycleSurveyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLifecycleSurveyTypesQuery = { __typename?: 'Query', getLifecycleSurveyTypes: Array<{ __typename?: 'OutputLifecycleSurveyType', id: number, type: string } | null> };

export type GetQuestionThemesQueryVariables = Exact<{
  input: GetQuestionThemesInput;
}>;


export type GetQuestionThemesQuery = { __typename?: 'Query', getQuestionThemes: { __typename?: 'QuestionTheme', surveyElementId: number, themes?: Array<{ __typename?: 'ThemeWithCount', id: number, count: number, themeName: string, translations: Array<{ __typename?: 'Translation', languageId: number, name: string }> } | null> | null } };

export type GetRehireAttributeQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type GetRehireAttributeQuery = { __typename?: 'Query', getRehireAttribute?: { __typename?: 'RehireAttribute', attributeId: number } | null };

export type GetSurveyAttributeHierarchyQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type GetSurveyAttributeHierarchyQuery = { __typename?: 'Query', getSurveyAttributeHierarchy?: { __typename?: 'SurveyAttributeHierarchy', attributeHierarchy?: Array<{ __typename?: 'SurveyAttributeHierarchyEntry', employeeId: string, managerId?: string | null, employeeSurveySnapshotId: number, email?: string | null, fullName?: string | null } | null> | null, snapshotHierarchy?: Array<{ __typename?: 'SurveySnapshotHierarchyEntry', employeeId: string, managerId?: string | null, employeeSurveySnapshotId?: number | null, email?: string | null, fullName?: string | null } | null> | null, notInvitedManagers?: Array<{ __typename?: 'NotInvitedManager', employeeId: string, managerId?: string | null, employeeSurveySnapshotId?: number | null, email?: string | null, fullName?: string | null } | null> | null } | null };

export type GetSurveyNameListQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type GetSurveyNameListQuery = { __typename?: 'Query', dashboardSurveys?: { __typename?: 'DashboardSurveysResult', count?: number | null, results?: Array<{ __typename?: 'DashboardSurvey', id?: number | null, surveyName?: string | null } | null> | null } | null };

export type GetSurveyParticipantsQueryVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type GetSurveyParticipantsQuery = { __typename?: 'Query', getSurveyParticipants: Array<{ __typename?: 'SurveyParticipants', firstName?: string | null, lastName?: string | null, email?: string | null, employeeId: string, employeeSurveySnapshotId: number, invitedDate?: Date | string | null, submittedResponseDate?: Date | string | null } | null> };

export type GetTrendQuestionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: VendorQuestionsSearchInput;
}>;


export type GetTrendQuestionsQuery = { __typename?: 'Query', previousQuestions?: { __typename?: 'SurveyElementCount', count?: number | null, fields?: Array<{ __typename?: 'SurveyElement', sentTimes?: number | null, lastSent?: string | null, companyId?: number | null, id?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage' } | { __typename?: 'SurveyElementQuestionOptions', required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null } | null } | null> | null } | null };

export type ImpersonateUserMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type ImpersonateUserMutation = { __typename?: 'Mutation', impersonateUser?: { __typename?: 'UserAuth', token?: string | null } | null };

export type ImportEmployeesMutationVariables = Exact<{
  employees: Array<EmployeeImportInput> | EmployeeImportInput;
  companyId: Scalars['Int'];
  isUpdate: Scalars['Boolean'];
  hasRoleUpdate: Scalars['Boolean'];
}>;


export type ImportEmployeesMutation = { __typename?: 'Mutation', importEmployees?: { __typename?: 'EmployeeImportResult', isSuccess?: boolean | null, conflicts?: Array<{ __typename?: 'EmployeeUniqueConflict', attributeId?: number | null, attributeValue?: string | null, companyEmployeeIds?: Array<string | null> | null } | null> | null } | null };

export type LinkQuestionsForTrendingMutationVariables = Exact<{
  input: LinkQuestionsForTrendingInput;
}>;


export type LinkQuestionsForTrendingMutation = { __typename?: 'Mutation', linkQuestionsForTrending: { __typename?: 'LinkQuestionsForTrendingResult', success: boolean, reason?: string | null, message?: string | null, linkedQuestionId?: number | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'UserAuth', token?: string | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'UserAuth', user?: { __typename?: 'User', id?: number | null } | null } | null };

export type MapValuesToBenchmarkAttributeValueMutationVariables = Exact<{
  benchmarkAttributeValueId: Scalars['Int'];
  names: Array<Scalars['String']> | Scalars['String'];
}>;


export type MapValuesToBenchmarkAttributeValueMutation = { __typename?: 'Mutation', addBenchmarkAttributeValueAltNames: Array<{ __typename?: 'BenchmarkAttributeValueAltName', id: number, name: string } | null> };

export type MigrateSurveyMutationVariables = Exact<{
  companyId: Scalars['Int'];
  surveyConfig: SurveyConfigInput;
  fileUrl: Scalars['String'];
  overwriteSurveyData: Scalars['Boolean'];
}>;


export type MigrateSurveyMutation = { __typename?: 'Mutation', migrateSurvey?: { __typename?: 'MigratedSurvey', id: number, surveyStatusId: number, timezoneId?: number | null, startTimeUTC?: Date | string | null, endTimeUTC?: Date | string | null } | null };

export type NotifyPrivateAttributeExportMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type NotifyPrivateAttributeExportMutation = { __typename?: 'Mutation', privateAttributeExportedNotifier: boolean };

export type OrderSurveyElementsMutationVariables = Exact<{
  id: Scalars['Int'];
  survey: SurveyUpdateInput;
}>;


export type OrderSurveyElementsMutation = { __typename?: 'Mutation', updateSurveyQuestionsSorting?: boolean | null };

export type OverallSurveyResultsQueryVariables = Exact<{
  attributes?: InputMaybe<Array<InputMaybe<AttributeWithValuesSearchInput>> | InputMaybe<AttributeWithValuesSearchInput>>;
  companyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  surveyIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  languageId: Scalars['Int'];
  isHierarchyReport?: InputMaybe<Scalars['Boolean']>;
  managerReportIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  selectedTimeframe?: InputMaybe<TimeframeInput>;
  selectedParticipantId?: InputMaybe<Scalars['Int']>;
}>;


export type OverallSurveyResultsQuery = { __typename?: 'Query', overallSurveyResults?: Array<{ __typename?: 'OverallQuestionResult', id?: number | null, surveyElementId?: number | null, type?: string | null, text?: string | null, totalAnswered?: number | null, totalRespondents?: number | null, numberOfComments?: number | null, iconPath?: string | null, minRating?: number | null, maxRating?: number | null, average?: number | null, addedDateUTC?: Date | string | null, discontinuedDateUTC?: Date | string | null, ratings?: Array<{ __typename?: 'OverallResultRating', rating?: number | null, totalAnswered?: number | null, numberOfComments?: number | null, percentage?: number | null } | null> | null, options?: Array<{ __typename?: 'OverallResultOption', id?: number | null, text?: string | null, totalAnswered?: number | null, numberOfComments?: number | null, percentage?: number | null } | null> | null, aggregatedCommentSentiments?: { __typename?: 'OverallResultAggregatedCommentSentiments', numberOfPositiveComments?: number | null, numberOfNeutralComments?: number | null, numberOfNegativeComments?: number | null, numberOfUnknownComments?: number | null } | null } | null> | null };

export type RemoveEmployeeAttributeMutationVariables = Exact<{
  employeeAttributeId: Scalars['Int'];
  companyId: Scalars['Int'];
}>;


export type RemoveEmployeeAttributeMutation = { __typename?: 'Mutation', deleteAttribute?: boolean | null };

export type RemoveEmployeeChannelFromDoNotContactListMutationVariables = Exact<{
  input: RemoveEmployeeChannelFromDoNotContactListInput;
}>;


export type RemoveEmployeeChannelFromDoNotContactListMutation = { __typename?: 'Mutation', removeEmployeeChannelFromDoNotContactList: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type ScheduleAiSurveySummaryMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  filters?: InputMaybe<AiSummaryFiltersInput>;
}>;


export type ScheduleAiSurveySummaryMutation = { __typename?: 'Mutation', scheduleAISurveySummary: { __typename?: 'AISurveySummary', commentsSummary?: string | null, surveyShortSummary?: string | null, status: string, participationRate?: string | null, strengths?: string | null, areasToWatch?: string | null, areasOfOpportunity?: string | null, qualitativeFeedback?: string | null, recommendedActions?: string | null, errorText?: string | null } };

export type ScheduleEmployeeImportMutationVariables = Exact<{
  companyId: Scalars['Int'];
  fileContents: Scalars['String'];
  mode: EmployeeImportMode;
  fileName?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleEmployeeImportMutation = { __typename?: 'Mutation', scheduleEmployeeImport: { __typename?: 'ScheduleEmployeeImportResult', taskId: number } };

export type SendTestSurveyMutationVariables = Exact<{
  surveyId: Scalars['Int'];
}>;


export type SendTestSurveyMutation = { __typename?: 'Mutation', sendTestSurvey?: boolean | null };

export type SetNewPasswordWithTokenMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type SetNewPasswordWithTokenMutation = { __typename?: 'Mutation', setNewPasswordWithToken?: { __typename?: 'ForgotPasswordResult', result?: string | null } | null };

export type SetOpenSurveyAccessCodeMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  accessCode: Scalars['String'];
}>;


export type SetOpenSurveyAccessCodeMutation = { __typename?: 'Mutation', setOpenSurveyAccessCode: { __typename?: 'Survey', id?: number | null, openSurveyAccessCode?: string | null } };

export type SetRehireAttributeMutationVariables = Exact<{
  companyId: Scalars['Int'];
  attributeId: Scalars['Int'];
}>;


export type SetRehireAttributeMutation = { __typename?: 'Mutation', setRehireAttribute: number };

export type SlackOAuthAuthorizeUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackOAuthAuthorizeUrlQuery = { __typename?: 'Query', slackOAuthAuthorizeUrl: string };

export type SwitchCompanyMutationVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type SwitchCompanyMutation = { __typename?: 'Mutation', switchAccount?: { __typename?: 'UserAuth', token?: string | null } | null };

export type TrendingLinkCandidatesQueryVariables = Exact<{
  surveyIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type TrendingLinkCandidatesQuery = { __typename?: 'Query', trendingLinkCandidates: Array<{ __typename?: 'TrendingLinkCandidate', questionText: string, questionType: TrendingQuestionType, perSurvey: Array<{ __typename?: 'TrendingLinkCandidateSurveyEntry', surveyId: number, surveyElementId: number, questionId: number }>, validation: { __typename?: 'TrendingLinkCandidateValidation', ok: boolean, reason?: string | null }, externalSurveys: Array<{ __typename?: 'TrendingLinkCandidateExternalSurvey', surveyId: number, surveyName: string, created: Date | string }>, languageWarning: Array<{ __typename?: 'TrendingLinkCandidateLanguageGap', surveyId: number, missingLanguageCodes: Array<string> }> }> };

export type TriggerCronjobMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type TriggerCronjobMutation = { __typename?: 'Mutation', triggerCronjob: { __typename?: 'TriggerCronjobResult', name: string, success: boolean, durationMs: number, error?: string | null, logs: Array<string> } };

export type UpdateAutomaticSurveyReminderMutationVariables = Exact<{
  automaticSurveyReminder?: InputMaybe<AutomaticSurveyReminderInput>;
}>;


export type UpdateAutomaticSurveyReminderMutation = { __typename?: 'Mutation', updateAutomaticSurveyReminder: { __typename?: 'OutputAutomaticSurveyReminder', id: number, surveyId: number, reminderFrequencyDays: number, status: string, automaticSurveyReminderLanguages?: Array<{ __typename?: 'OutputAutomaticSurveyReminderLanguage', languageId: number, emailSubject: string, emailBody: string } | null> | null } };

export type UpdateCompanyDefaultAttributeValueMutationVariables = Exact<{
  companyId: Scalars['Int'];
  benchmarkAttributeValueId: Scalars['Int'];
  ungroupedValue?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCompanyDefaultAttributeValueMutation = { __typename?: 'Mutation', updateCompanyBenchmarkAttributeValue: { __typename?: 'CompanyBenchmarkAttributeValue', id: number, benchmarkAttributeId: number, benchmarkAttributeValueId: number, name?: string | null, ungroupedValue?: string | null } };

export type UpdateCompanyEmployeeIdsMutationVariables = Exact<{
  companyId: Scalars['Int'];
  updateEmployeeIdInput: Array<UpdateEmployeeIds> | UpdateEmployeeIds;
}>;


export type UpdateCompanyEmployeeIdsMutation = { __typename?: 'Mutation', updateCompanyEmployeeIds?: { __typename?: 'UpdateResult', status: UpdateEmployeeIdStatus, error?: { __typename?: 'UpdateEmployeeIdError', message?: string | null, translationKey?: string | null, failedId?: string | null } | null } | null };

export type UpdateCompanyMessagingConfigMutationVariables = Exact<{
  input: UpdateCompanyMessagingConfigInput;
}>;


export type UpdateCompanyMessagingConfigMutation = { __typename?: 'Mutation', updateCompanyMessagingConfig: { __typename?: 'CompanyMessagingConfig', companyId: number, channel: MessagingChannel, enabled: boolean, isConnected: boolean, created?: Date | string | null, updated?: Date | string | null } };

export type UpdateEmployeeMutationVariables = Exact<{
  employeeId: Scalars['Int'];
  companyId: Scalars['Int'];
  employee: EmployeeEditInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee?: { __typename?: 'Employee', id: number, languageId?: number | null, enabled?: boolean | null, attributesWithValues?: Array<{ __typename?: 'EmployeeAttributeWithValues', attributeValues: Array<any | null>, attribute: { __typename?: 'EmployeeAttribute', id: number, attributeNames: Array<{ __typename?: 'AttributeName', id?: number | null, name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null }> } } | null> | null } | null };

export type UpdateEmployeeAttributeMutationVariables = Exact<{
  employeeAttributeId: Scalars['Int'];
  companyId: Scalars['Int'];
  attribute: AttributeUpdateInput;
}>;


export type UpdateEmployeeAttributeMutation = { __typename?: 'Mutation', updateAttribute?: { __typename?: 'Attribute', id?: number | null, baseAttributeId?: number | null, isReportingAttribute?: boolean | null, isPrivate?: boolean | null, isRequired?: boolean | null, isUnique?: boolean | null, isArchived?: boolean | null, isPhone?: boolean | null, type?: { __typename?: 'AttributeType', id?: number | null, name?: string | null } | null, attributeNames?: Array<{ __typename?: 'AttributeName', name?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | null };

export type UpdateLifecycleSurveyRecipientsMutationVariables = Exact<{
  lifecycleSurveyRecipients: Array<InputLifecycleSurveyRecipients> | InputLifecycleSurveyRecipients;
}>;


export type UpdateLifecycleSurveyRecipientsMutation = { __typename?: 'Mutation', updateLifecycleSurveyRecipients: { __typename?: 'OutputResult', success: boolean, message?: string | null } };

export type UpdateReactionsMutationVariables = Exact<{
  conversationReaction: ConversationReactionInput;
}>;


export type UpdateReactionsMutation = { __typename?: 'Mutation', updateConversationReaction?: { __typename?: 'ConversationReaction', like: boolean, greatIdea: boolean, workingOnIt: boolean, conversation: { __typename?: 'Conversation', id?: number | null } } | null };

export type UpdateRecipientListMutationVariables = Exact<{
  surveyId: Scalars['Int'];
  employeeIds: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateRecipientListMutation = { __typename?: 'Mutation', updateRecipientList?: { __typename?: 'SurveyEmployees', employees?: Array<{ __typename?: 'SurveyEmployee', id: number, surveyInviteDate?: string | null, addedDate?: string | null } | null> | null } | null };

export type UpdateSurveyMutationVariables = Exact<{
  id: Scalars['Int'];
  survey: SurveyUpdateInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey?: { __typename?: 'Survey', id?: number | null } | null };

export type UpdateSurveyElementMutationVariables = Exact<{
  surveyId?: InputMaybe<Scalars['Int']>;
  surveyElement: SurveyElementUpdateInput;
}>;


export type UpdateSurveyElementMutation = { __typename?: 'Mutation', updateSurveyElement?: { __typename?: 'SurveyElement', id?: number | null, companyId?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, isFilterable: boolean, discontinuedDateUTC?: Date | string | null, addedDateUTC?: Date | string | null, isDiscontinued?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, orderIndex?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null } | null };

export type UpdateSurveyTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
  names?: InputMaybe<Array<InputMaybe<InputSurveyTemplateNames>> | InputMaybe<InputSurveyTemplateNames>>;
  surveyElements?: InputMaybe<Array<InputMaybe<InputSurveyElement>> | InputMaybe<InputSurveyElement>>;
  status?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<InputSurveyTemplateEmail>;
  audienceMode?: InputMaybe<Scalars['String']>;
  lifecycleSurveyTypeId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateSurveyTemplateMutation = { __typename?: 'Mutation', updateSurveyTemplate: { __typename?: 'OutputSurveyTemplate', id: number, surveyTypeId: number, audienceMode: string, lifecycleSurveyTypeId?: number | null, status: string, updated: Date | string, names: Array<{ __typename?: 'OutputSurveyTemplateNames', name: string, languageId: number }>, surveyType: { __typename?: 'SurveyType', id?: number | null, name?: string | null, names?: Array<{ __typename?: 'SurveyTypeName', languageId?: number | null, name?: string | null } | null> | null }, surveyElements?: Array<{ __typename?: 'SurveyElement', id?: number | null, orderIndex?: number | null, isLibraryQuestion?: boolean | null, isPreviousQuestion?: boolean | null, isBenchmarkedQuestion?: boolean | null, showSkipButton?: boolean | null, isAttributeBased?: boolean | null, hideReporting?: boolean | null, type?: { __typename?: 'SurveyElementType', name?: string | null } | null, attributes?: Array<{ __typename?: 'SurveyElementAttribute', attributeId?: number | null, attributeValue?: string | null } | null> | null, question?: { __typename?: 'SurveyElementMessage', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null } | { __typename?: 'SurveyElementQuestionOptions', id?: number | null, required?: boolean | null, showDescription?: boolean | null, minSelectedOption?: number | null, maxSelectedOption?: number | null, showTextComment?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, choices?: Array<{ __typename?: 'SurveyElementOptionsChoices', id?: number | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, language?: { __typename?: 'Language', id: number } | null } | null> | null } | null> | null } | { __typename?: 'SurveyElementQuestionScale', id?: number | null, ratingOptionLowest?: number | null, ratingOptionHighest?: number | null, required?: boolean | null, showDescription?: boolean | null, showTextComment?: boolean | null, showLabels?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, labelBefore?: string | null, labelAfter?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null, categoryNames?: Array<{ __typename?: 'CategoryName', name?: string | null } | null> | null } | null, icon?: { __typename?: 'Icon', id?: number | null, name?: string | null } | null } | { __typename?: 'SurveyElementQuestionText', id?: number | null, required?: boolean | null, showDescription?: boolean | null, messagesPerLanguage?: Array<{ __typename?: 'SurveyElementMessagePerLanguage', message?: string | null, description?: string | null, language?: { __typename?: 'Language', id: number, langISOCode: string } | null } | null> | null, category?: { __typename?: 'Category', id?: number | null } | null } | null } | null> | null, surveyTemplateLanguages?: Array<{ __typename?: 'OutputSurveyTemplateLanguage', languageId: number, emailContent: string, emailSubject: string }> | null } };

export type UpdateSurveyTemplateStatusMutationVariables = Exact<{
  templateId: Scalars['Int'];
  newStatus: SurveyTemplateStatus;
}>;


export type UpdateSurveyTemplateStatusMutation = { __typename?: 'Mutation', updateSurveyTemplateStatus: { __typename?: 'OutputUpdateSurveyTemplateStatus', success: boolean, updated: Date | string } };

export type UpsertLifecycleSurveyTriggerMutationVariables = Exact<{
  lifecycleSurveyTrigger: InputLifecycleSurveyTrigger;
}>;


export type UpsertLifecycleSurveyTriggerMutation = { __typename?: 'Mutation', upsertLifecycleSurveyTrigger: { __typename?: 'OutputLifecycleSurveyTrigger', id: number, lifecycleSurveyTypeId: number, surveyId: number, triggerAttributeId: number, audienceType: string, invitationOffsetDays: number, requireAdminApproval: boolean, timeOfDayStartUTC: string, timeOfDayEndUTC: string, status?: string | null, languages?: Array<{ __typename?: 'OutputLanguages', languageId: number, name: string } | null> | null, attributeAudience?: Array<{ __typename?: 'OutputAttributes', attributeId: number, attributeValue: string } | null> | null, adminApprovers?: Array<{ __typename?: 'OutputAdminApprover', userId: number } | null> | null, superAdminApprovers?: Array<{ __typename?: 'OutputAdminApprover', userId: number } | null> | null } };

export type UpsertLifecycleSurveyTriggerTypesMutationVariables = Exact<{
  lifecycleSurveyTriggerTypes: Array<InputLifecycleSurveyTriggerType> | InputLifecycleSurveyTriggerType;
}>;


export type UpsertLifecycleSurveyTriggerTypesMutation = { __typename?: 'Mutation', upsertLifecycleSurveyTriggerTypes?: Array<{ __typename?: 'OutputLifecycleSurveyTriggerTypes', id: number, type: string, isEnabled: boolean } | null> | null };

export type UpsertSurveyMessagingMutationVariables = Exact<{
  input: UpsertSurveyMessagingInput;
}>;


export type UpsertSurveyMessagingMutation = { __typename?: 'Mutation', upsertSurveyMessaging: { __typename?: 'SurveyMessaging', surveyId: string, channel: MessagingChannelOptions, enabled: boolean, smsAttributeId?: string | null, variationKey?: string | null } };

export const CompanyFieldsFragmentDoc = gql`
    fragment companyFields on Company {
  id
  name
  workspace
  logoFileName
  topbarColorHex
  salesforceId
  preferredLanguage {
    id
    langISOCode
  }
  preferredTimezone {
    id
    timezone
  }
  timezones {
    id
    timezone
  }
  languages {
    id
    langISOCode
  }
  hasSso
  created
  updated
}
    `;
export const ConversationsMessagesFragmentDoc = gql`
    fragment conversationsMessages on MinimalConversationMessage {
  id
  text
  conversationId
  created
  user {
    id
    firstName
    lastName
    avatar
  }
}
    `;
export const EmployeeAttributeFieldsFragmentDoc = gql`
    fragment employeeAttributeFields on Attribute {
  id
  baseAttributeId
  isReportingAttribute
  isPrivate
  isRequired
  isUnique
  isArchived
  isPhone
  type {
    id
    name
  }
  attributeNames {
    name
    language {
      id
      langISOCode
    }
  }
}
    `;
export const SurveyElementFieldsFragmentDoc = gql`
    fragment surveyElementFields on SurveyElement {
  id
  companyId
  orderIndex
  isLibraryQuestion
  isPreviousQuestion
  isBenchmarkedQuestion
  type {
    name
  }
  showSkipButton
  isAttributeBased
  hideReporting
  attributes {
    attributeId
    attributeValue
  }
  question {
    ... on SurveyElementQuestionOptions {
      id
      messagesPerLanguage {
        language {
          id
          langISOCode
        }
        message
        description
      }
      category {
        id
        categoryNames {
          name
        }
      }
      required
      showDescription
      choices {
        id
        orderIndex
        messagesPerLanguage {
          language {
            id
          }
          message
        }
      }
      minSelectedOption
      maxSelectedOption
      showTextComment
    }
    ... on SurveyElementQuestionScale {
      id
      messagesPerLanguage {
        language {
          id
          langISOCode
        }
        message
        description
        labelBefore
        labelAfter
      }
      category {
        id
        categoryNames {
          name
        }
      }
      icon {
        id
        name
      }
      ratingOptionLowest
      ratingOptionHighest
      required
      showDescription
      showTextComment
      showLabels
    }
    ... on SurveyElementQuestionText {
      id
      messagesPerLanguage {
        language {
          id
          langISOCode
        }
        message
        description
      }
      category {
        id
      }
      required
      showDescription
    }
    ... on SurveyElementMessage {
      id
      messagesPerLanguage {
        language {
          id
          langISOCode
        }
        message
        description
      }
    }
  }
}
    `;
export const SurveyTypePermissionFieldsFragmentDoc = gql`
    fragment surveyTypePermissionFields on SurveyTypePermission {
  surveyTypeId
  permissions
  canAccessAll
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  employeeId
  userRoleId
  firstName
  lastName
  avatar
  email
  status
  worktangoAdmin
  updated
  created
  preferredLanguage {
    id
    langISOCode
  }
}
    `;
export const UserPermissionSummaryFieldsFragmentDoc = gql`
    fragment userPermissionSummaryFields on User {
  id
  employeeId
  userRoleId
  firstName
  lastName
  avatar
  email
  status
  worktangoAdmin
  updated
  created
  preferredLanguage {
    id
    langISOCode
  }
  globalActions {
    globalActionId
  }
  permissions {
    surveyTypeId
  }
}
    `;
export const PermissionFieldsFragmentDoc = gql`
    fragment permissionFields on UserPermission {
  id
  surveyTypeId
  accessAll
  allAttributesVisible
  canCompareToAllAttributes
  attributeBased
  hierarchyBased
  created
  updated
  company {
    id
    name
  }
  userActions {
    id
    action
  }
  visibleAttributes {
    id
    attributeId
  }
  attributes {
    id
    name
    values
  }
  otherHierarchies
  useUserAttributeValue
  compareAttributes {
    id
    name
    values
  }
  useUserAttributeValueCompare
}
    `;
export const UserWithPermissionsFieldsFragmentDoc = gql`
    fragment userWithPermissionsFields on User {
  id
  employeeId
  userRoleId
  firstName
  lastName
  avatar
  email
  status
  worktangoAdmin
  updated
  created
  preferredLanguage {
    id
    langISOCode
  }
  globalActions {
    id
    globalActionId
    companyId
  }
  permissions {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export const ActivateUserDocument = gql`
    mutation activateUser($token: String!, $user: UserToUpdateInput!) {
  activateUser(token: $token, user: $user) {
    id
  }
}
    `;
export type ActivateUserMutationFn = Apollo.MutationFunction<ActivateUserMutation, ActivateUserMutationVariables>;

/**
 * __useActivateUserMutation__
 *
 * To run a mutation, you first call `useActivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateUserMutation, { data, loading, error }] = useActivateUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useActivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateUserMutation, ActivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateUserMutation, ActivateUserMutationVariables>(ActivateUserDocument, options);
      }
export type ActivateUserMutationHookResult = ReturnType<typeof useActivateUserMutation>;
export type ActivateUserMutationResult = Apollo.MutationResult<ActivateUserMutation>;
export type ActivateUserMutationOptions = Apollo.BaseMutationOptions<ActivateUserMutation, ActivateUserMutationVariables>;
export const AddConversationMessageDocument = gql`
    mutation addConversationMessage($text: String!, $conversationId: Int!) {
  addConversationMessage(
    conversationMessage: {text: $text, conversationId: $conversationId}
  ) {
    ...conversationsMessages
  }
}
    ${ConversationsMessagesFragmentDoc}`;
export type AddConversationMessageMutationFn = Apollo.MutationFunction<AddConversationMessageMutation, AddConversationMessageMutationVariables>;

/**
 * __useAddConversationMessageMutation__
 *
 * To run a mutation, you first call `useAddConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConversationMessageMutation, { data, loading, error }] = useAddConversationMessageMutation({
 *   variables: {
 *      text: // value for 'text'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useAddConversationMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddConversationMessageMutation, AddConversationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddConversationMessageMutation, AddConversationMessageMutationVariables>(AddConversationMessageDocument, options);
      }
export type AddConversationMessageMutationHookResult = ReturnType<typeof useAddConversationMessageMutation>;
export type AddConversationMessageMutationResult = Apollo.MutationResult<AddConversationMessageMutation>;
export type AddConversationMessageMutationOptions = Apollo.BaseMutationOptions<AddConversationMessageMutation, AddConversationMessageMutationVariables>;
export const AddEmployeeChannelToDoNotContactListDocument = gql`
    mutation addEmployeeChannelToDoNotContactList($input: AddEmployeeChannelToDoNotContactListInput!) {
  addEmployeeChannelToDoNotContactList(input: $input) {
    success
    message
  }
}
    `;
export type AddEmployeeChannelToDoNotContactListMutationFn = Apollo.MutationFunction<AddEmployeeChannelToDoNotContactListMutation, AddEmployeeChannelToDoNotContactListMutationVariables>;

/**
 * __useAddEmployeeChannelToDoNotContactListMutation__
 *
 * To run a mutation, you first call `useAddEmployeeChannelToDoNotContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeChannelToDoNotContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeChannelToDoNotContactListMutation, { data, loading, error }] = useAddEmployeeChannelToDoNotContactListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddEmployeeChannelToDoNotContactListMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeChannelToDoNotContactListMutation, AddEmployeeChannelToDoNotContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeChannelToDoNotContactListMutation, AddEmployeeChannelToDoNotContactListMutationVariables>(AddEmployeeChannelToDoNotContactListDocument, options);
      }
export type AddEmployeeChannelToDoNotContactListMutationHookResult = ReturnType<typeof useAddEmployeeChannelToDoNotContactListMutation>;
export type AddEmployeeChannelToDoNotContactListMutationResult = Apollo.MutationResult<AddEmployeeChannelToDoNotContactListMutation>;
export type AddEmployeeChannelToDoNotContactListMutationOptions = Apollo.BaseMutationOptions<AddEmployeeChannelToDoNotContactListMutation, AddEmployeeChannelToDoNotContactListMutationVariables>;
export const AddSurveyTemplateDocument = gql`
    mutation addSurveyTemplate($names: [InputSurveyTemplateNames!]!, $surveyTypeId: Int!, $surveyElements: [InputSurveyElement], $audienceMode: String, $lifecycleSurveyTypeId: Int) {
  addSurveyTemplate(
    names: $names
    surveyTypeId: $surveyTypeId
    surveyElements: $surveyElements
    audienceMode: $audienceMode
    lifecycleSurveyTypeId: $lifecycleSurveyTypeId
  ) {
    id
    names {
      name
      languageId
    }
    surveyTypeId
    audienceMode
    lifecycleSurveyTypeId
    surveyElements {
      id
    }
    status
    updated
  }
}
    `;
export type AddSurveyTemplateMutationFn = Apollo.MutationFunction<AddSurveyTemplateMutation, AddSurveyTemplateMutationVariables>;

/**
 * __useAddSurveyTemplateMutation__
 *
 * To run a mutation, you first call `useAddSurveyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyTemplateMutation, { data, loading, error }] = useAddSurveyTemplateMutation({
 *   variables: {
 *      names: // value for 'names'
 *      surveyTypeId: // value for 'surveyTypeId'
 *      surveyElements: // value for 'surveyElements'
 *      audienceMode: // value for 'audienceMode'
 *      lifecycleSurveyTypeId: // value for 'lifecycleSurveyTypeId'
 *   },
 * });
 */
export function useAddSurveyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddSurveyTemplateMutation, AddSurveyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSurveyTemplateMutation, AddSurveyTemplateMutationVariables>(AddSurveyTemplateDocument, options);
      }
export type AddSurveyTemplateMutationHookResult = ReturnType<typeof useAddSurveyTemplateMutation>;
export type AddSurveyTemplateMutationResult = Apollo.MutationResult<AddSurveyTemplateMutation>;
export type AddSurveyTemplateMutationOptions = Apollo.BaseMutationOptions<AddSurveyTemplateMutation, AddSurveyTemplateMutationVariables>;
export const AddToDoNotContactListDocument = gql`
    mutation addToDoNotContactList($employeesInput: [InputAddToDoNotContactList!]!) {
  addToDoNotContactList(employeesInput: $employeesInput) {
    success
    message
  }
}
    `;
export type AddToDoNotContactListMutationFn = Apollo.MutationFunction<AddToDoNotContactListMutation, AddToDoNotContactListMutationVariables>;

/**
 * __useAddToDoNotContactListMutation__
 *
 * To run a mutation, you first call `useAddToDoNotContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToDoNotContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToDoNotContactListMutation, { data, loading, error }] = useAddToDoNotContactListMutation({
 *   variables: {
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useAddToDoNotContactListMutation(baseOptions?: Apollo.MutationHookOptions<AddToDoNotContactListMutation, AddToDoNotContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToDoNotContactListMutation, AddToDoNotContactListMutationVariables>(AddToDoNotContactListDocument, options);
      }
export type AddToDoNotContactListMutationHookResult = ReturnType<typeof useAddToDoNotContactListMutation>;
export type AddToDoNotContactListMutationResult = Apollo.MutationResult<AddToDoNotContactListMutation>;
export type AddToDoNotContactListMutationOptions = Apollo.BaseMutationOptions<AddToDoNotContactListMutation, AddToDoNotContactListMutationVariables>;
export const AddTrendQuestionDocument = gql`
    mutation addTrendQuestion($surveyId: Int!, $surveyElementId: Int!, $orderIndex: Int!) {
  addPreviousQuestion(
    surveyId: $surveyId
    surveyElementId: $surveyElementId
    orderIndex: $orderIndex
  ) {
    id
  }
}
    `;
export type AddTrendQuestionMutationFn = Apollo.MutationFunction<AddTrendQuestionMutation, AddTrendQuestionMutationVariables>;

/**
 * __useAddTrendQuestionMutation__
 *
 * To run a mutation, you first call `useAddTrendQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrendQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrendQuestionMutation, { data, loading, error }] = useAddTrendQuestionMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      surveyElementId: // value for 'surveyElementId'
 *      orderIndex: // value for 'orderIndex'
 *   },
 * });
 */
export function useAddTrendQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AddTrendQuestionMutation, AddTrendQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrendQuestionMutation, AddTrendQuestionMutationVariables>(AddTrendQuestionDocument, options);
      }
export type AddTrendQuestionMutationHookResult = ReturnType<typeof useAddTrendQuestionMutation>;
export type AddTrendQuestionMutationResult = Apollo.MutationResult<AddTrendQuestionMutation>;
export type AddTrendQuestionMutationOptions = Apollo.BaseMutationOptions<AddTrendQuestionMutation, AddTrendQuestionMutationVariables>;
export const ApproveMigratedSurveyDocument = gql`
    mutation approveMigratedSurvey($surveyId: Int!) {
  approveMigratedSurvey(surveyId: $surveyId) {
    id
    surveyStatusId
    timezoneId
    startTimeUTC
    endTimeUTC
  }
}
    `;
export type ApproveMigratedSurveyMutationFn = Apollo.MutationFunction<ApproveMigratedSurveyMutation, ApproveMigratedSurveyMutationVariables>;

/**
 * __useApproveMigratedSurveyMutation__
 *
 * To run a mutation, you first call `useApproveMigratedSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMigratedSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMigratedSurveyMutation, { data, loading, error }] = useApproveMigratedSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useApproveMigratedSurveyMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMigratedSurveyMutation, ApproveMigratedSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMigratedSurveyMutation, ApproveMigratedSurveyMutationVariables>(ApproveMigratedSurveyDocument, options);
      }
export type ApproveMigratedSurveyMutationHookResult = ReturnType<typeof useApproveMigratedSurveyMutation>;
export type ApproveMigratedSurveyMutationResult = Apollo.MutationResult<ApproveMigratedSurveyMutation>;
export type ApproveMigratedSurveyMutationOptions = Apollo.BaseMutationOptions<ApproveMigratedSurveyMutation, ApproveMigratedSurveyMutationVariables>;
export const AssociateBenchmarkAttributeDocument = gql`
    mutation associateBenchmarkAttribute($attributeId: Int!, $benchmarkAttributeId: Int!) {
  associateAttributeWithBenchmarkAttribute(
    attributeId: $attributeId
    benchmarkAttributeId: $benchmarkAttributeId
  ) {
    id
    attributeId
    names
    benchmarkAttributeId
  }
}
    `;
export type AssociateBenchmarkAttributeMutationFn = Apollo.MutationFunction<AssociateBenchmarkAttributeMutation, AssociateBenchmarkAttributeMutationVariables>;

/**
 * __useAssociateBenchmarkAttributeMutation__
 *
 * To run a mutation, you first call `useAssociateBenchmarkAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateBenchmarkAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateBenchmarkAttributeMutation, { data, loading, error }] = useAssociateBenchmarkAttributeMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      benchmarkAttributeId: // value for 'benchmarkAttributeId'
 *   },
 * });
 */
export function useAssociateBenchmarkAttributeMutation(baseOptions?: Apollo.MutationHookOptions<AssociateBenchmarkAttributeMutation, AssociateBenchmarkAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateBenchmarkAttributeMutation, AssociateBenchmarkAttributeMutationVariables>(AssociateBenchmarkAttributeDocument, options);
      }
export type AssociateBenchmarkAttributeMutationHookResult = ReturnType<typeof useAssociateBenchmarkAttributeMutation>;
export type AssociateBenchmarkAttributeMutationResult = Apollo.MutationResult<AssociateBenchmarkAttributeMutation>;
export type AssociateBenchmarkAttributeMutationOptions = Apollo.BaseMutationOptions<AssociateBenchmarkAttributeMutation, AssociateBenchmarkAttributeMutationVariables>;
export const AssociateSurveyQuestionsWithBenchmarkQuestionDocument = gql`
    mutation associateSurveyQuestionsWithBenchmarkQuestion($surveyQuestionIds: [Int!]!, $benchmarkQuestionId: Int!) {
  associateSurveyQuestionsWithBenchmarkQuestion(
    surveyQuestionIds: $surveyQuestionIds
    benchmarkQuestionId: $benchmarkQuestionId
  ) {
    benchmarkQuestionId
    newMappings {
      questionId
      questionText
      surveyCount
      surveyYears
    }
  }
}
    `;
export type AssociateSurveyQuestionsWithBenchmarkQuestionMutationFn = Apollo.MutationFunction<AssociateSurveyQuestionsWithBenchmarkQuestionMutation, AssociateSurveyQuestionsWithBenchmarkQuestionMutationVariables>;

/**
 * __useAssociateSurveyQuestionsWithBenchmarkQuestionMutation__
 *
 * To run a mutation, you first call `useAssociateSurveyQuestionsWithBenchmarkQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateSurveyQuestionsWithBenchmarkQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateSurveyQuestionsWithBenchmarkQuestionMutation, { data, loading, error }] = useAssociateSurveyQuestionsWithBenchmarkQuestionMutation({
 *   variables: {
 *      surveyQuestionIds: // value for 'surveyQuestionIds'
 *      benchmarkQuestionId: // value for 'benchmarkQuestionId'
 *   },
 * });
 */
export function useAssociateSurveyQuestionsWithBenchmarkQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AssociateSurveyQuestionsWithBenchmarkQuestionMutation, AssociateSurveyQuestionsWithBenchmarkQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateSurveyQuestionsWithBenchmarkQuestionMutation, AssociateSurveyQuestionsWithBenchmarkQuestionMutationVariables>(AssociateSurveyQuestionsWithBenchmarkQuestionDocument, options);
      }
export type AssociateSurveyQuestionsWithBenchmarkQuestionMutationHookResult = ReturnType<typeof useAssociateSurveyQuestionsWithBenchmarkQuestionMutation>;
export type AssociateSurveyQuestionsWithBenchmarkQuestionMutationResult = Apollo.MutationResult<AssociateSurveyQuestionsWithBenchmarkQuestionMutation>;
export type AssociateSurveyQuestionsWithBenchmarkQuestionMutationOptions = Apollo.BaseMutationOptions<AssociateSurveyQuestionsWithBenchmarkQuestionMutation, AssociateSurveyQuestionsWithBenchmarkQuestionMutationVariables>;
export const AttributeArchiveImpactDocument = gql`
    query attributeArchiveImpact($companyId: Int!, $attributeId: Int!) {
  attributeArchiveImpact(companyId: $companyId, attributeId: $attributeId) {
    affectedUsers {
      id
      name
      surveyTypeId
      surveyTypeName
      emptiedBuckets
    }
    affectedRoles {
      id
      name
      surveyTypeId
      surveyTypeName
      emptiedBuckets
    }
  }
}
    `;

/**
 * __useAttributeArchiveImpactQuery__
 *
 * To run a query within a React component, call `useAttributeArchiveImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeArchiveImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeArchiveImpactQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useAttributeArchiveImpactQuery(baseOptions: Apollo.QueryHookOptions<AttributeArchiveImpactQuery, AttributeArchiveImpactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeArchiveImpactQuery, AttributeArchiveImpactQueryVariables>(AttributeArchiveImpactDocument, options);
      }
export function useAttributeArchiveImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeArchiveImpactQuery, AttributeArchiveImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeArchiveImpactQuery, AttributeArchiveImpactQueryVariables>(AttributeArchiveImpactDocument, options);
        }
export type AttributeArchiveImpactQueryHookResult = ReturnType<typeof useAttributeArchiveImpactQuery>;
export type AttributeArchiveImpactLazyQueryHookResult = ReturnType<typeof useAttributeArchiveImpactLazyQuery>;
export type AttributeArchiveImpactQueryResult = Apollo.QueryResult<AttributeArchiveImpactQuery, AttributeArchiveImpactQueryVariables>;
export const UpdateUsersStatusDocument = gql`
    mutation updateUsersStatus($ids: [Int!], $status: UserStatusEnum!) {
  updateUsersStatus(status: $status, ids: $ids) {
    id
  }
}
    `;
export type UpdateUsersStatusMutationFn = Apollo.MutationFunction<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>;

/**
 * __useUpdateUsersStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUsersStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersStatusMutation, { data, loading, error }] = useUpdateUsersStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateUsersStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>(UpdateUsersStatusDocument, options);
      }
export type UpdateUsersStatusMutationHookResult = ReturnType<typeof useUpdateUsersStatusMutation>;
export type UpdateUsersStatusMutationResult = Apollo.MutationResult<UpdateUsersStatusMutation>;
export type UpdateUsersStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUsersStatusMutation, UpdateUsersStatusMutationVariables>;
export const ClearCompanyCacheDocument = gql`
    mutation clearCompanyCache($companyId: Int!) {
  clearCompanyCache(companyId: $companyId)
}
    `;
export type ClearCompanyCacheMutationFn = Apollo.MutationFunction<ClearCompanyCacheMutation, ClearCompanyCacheMutationVariables>;

/**
 * __useClearCompanyCacheMutation__
 *
 * To run a mutation, you first call `useClearCompanyCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearCompanyCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearCompanyCacheMutation, { data, loading, error }] = useClearCompanyCacheMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useClearCompanyCacheMutation(baseOptions?: Apollo.MutationHookOptions<ClearCompanyCacheMutation, ClearCompanyCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearCompanyCacheMutation, ClearCompanyCacheMutationVariables>(ClearCompanyCacheDocument, options);
      }
export type ClearCompanyCacheMutationHookResult = ReturnType<typeof useClearCompanyCacheMutation>;
export type ClearCompanyCacheMutationResult = Apollo.MutationResult<ClearCompanyCacheMutation>;
export type ClearCompanyCacheMutationOptions = Apollo.BaseMutationOptions<ClearCompanyCacheMutation, ClearCompanyCacheMutationVariables>;
export const ClearSurveyCacheDocument = gql`
    mutation clearSurveyCache($surveyId: Int!) {
  clearSurveyCache(surveyId: $surveyId)
}
    `;
export type ClearSurveyCacheMutationFn = Apollo.MutationFunction<ClearSurveyCacheMutation, ClearSurveyCacheMutationVariables>;

/**
 * __useClearSurveyCacheMutation__
 *
 * To run a mutation, you first call `useClearSurveyCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSurveyCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSurveyCacheMutation, { data, loading, error }] = useClearSurveyCacheMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useClearSurveyCacheMutation(baseOptions?: Apollo.MutationHookOptions<ClearSurveyCacheMutation, ClearSurveyCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearSurveyCacheMutation, ClearSurveyCacheMutationVariables>(ClearSurveyCacheDocument, options);
      }
export type ClearSurveyCacheMutationHookResult = ReturnType<typeof useClearSurveyCacheMutation>;
export type ClearSurveyCacheMutationResult = Apollo.MutationResult<ClearSurveyCacheMutation>;
export type ClearSurveyCacheMutationOptions = Apollo.BaseMutationOptions<ClearSurveyCacheMutation, ClearSurveyCacheMutationVariables>;
export const CloneSurveyTemplateDocument = gql`
    mutation cloneSurveyTemplate($id: Int!, $names: [InputSurveyTemplateNames!]!) {
  cloneSurveyTemplate(id: $id, names: $names) {
    id
    names {
      languageId
      name
    }
    status
    updated
    surveyTypeId
    surveyType {
      id
      name
      names {
        languageId
        name
      }
    }
  }
}
    `;
export type CloneSurveyTemplateMutationFn = Apollo.MutationFunction<CloneSurveyTemplateMutation, CloneSurveyTemplateMutationVariables>;

/**
 * __useCloneSurveyTemplateMutation__
 *
 * To run a mutation, you first call `useCloneSurveyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneSurveyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneSurveyTemplateMutation, { data, loading, error }] = useCloneSurveyTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      names: // value for 'names'
 *   },
 * });
 */
export function useCloneSurveyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CloneSurveyTemplateMutation, CloneSurveyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneSurveyTemplateMutation, CloneSurveyTemplateMutationVariables>(CloneSurveyTemplateDocument, options);
      }
export type CloneSurveyTemplateMutationHookResult = ReturnType<typeof useCloneSurveyTemplateMutation>;
export type CloneSurveyTemplateMutationResult = Apollo.MutationResult<CloneSurveyTemplateMutation>;
export type CloneSurveyTemplateMutationOptions = Apollo.BaseMutationOptions<CloneSurveyTemplateMutation, CloneSurveyTemplateMutationVariables>;
export const CoachCommentsDocument = gql`
    query coachComments($companyId: Int!, $surveyIds: [Int!]!, $surveyElementIds: [Int!], $attributes: [AttributeValuesSearchInput!], $managerReportIds: [String!], $isHierarchyReport: Boolean, $selectedTimeframe: TimeframeInput) {
  coachComments(
    input: {companyId: $companyId, surveyIds: $surveyIds, surveyElementIds: $surveyElementIds, attributes: $attributes, managerReportIds: $managerReportIds, isHierarchyReport: $isHierarchyReport, selectedTimeframe: $selectedTimeframe}
  ) {
    commentCount
    comments {
      id
      text
      created
    }
  }
}
    `;

/**
 * __useCoachCommentsQuery__
 *
 * To run a query within a React component, call `useCoachCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachCommentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyIds: // value for 'surveyIds'
 *      surveyElementIds: // value for 'surveyElementIds'
 *      attributes: // value for 'attributes'
 *      managerReportIds: // value for 'managerReportIds'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      selectedTimeframe: // value for 'selectedTimeframe'
 *   },
 * });
 */
export function useCoachCommentsQuery(baseOptions: Apollo.QueryHookOptions<CoachCommentsQuery, CoachCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachCommentsQuery, CoachCommentsQueryVariables>(CoachCommentsDocument, options);
      }
export function useCoachCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachCommentsQuery, CoachCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachCommentsQuery, CoachCommentsQueryVariables>(CoachCommentsDocument, options);
        }
export type CoachCommentsQueryHookResult = ReturnType<typeof useCoachCommentsQuery>;
export type CoachCommentsLazyQueryHookResult = ReturnType<typeof useCoachCommentsLazyQuery>;
export type CoachCommentsQueryResult = Apollo.QueryResult<CoachCommentsQuery, CoachCommentsQueryVariables>;
export const CommentsDocument = gql`
    query comments($companyId: Int!, $surveyIds: [Int!]!, $questionId: Int!, $surveyElementId: Int!, $attributes: [AttributeValuesSearchInput], $searchText: String, $limit: Int, $offset: Int, $keyword: String, $sentimentFilter: [String], $themeFilter: [Int], $entityFilter: [String], $managerReportIds: [String], $isHierarchyReport: Boolean, $selectedParticipantId: Int, $sort: CommentSortInput, $selectedTimeframe: TimeframeInput) {
  comments(
    input: {companyId: $companyId, surveyIds: $surveyIds, questionId: $questionId, surveyElementId: $surveyElementId, attributes: $attributes, searchText: $searchText, offset: $offset, limit: $limit, keyword: $keyword, sentimentFilter: $sentimentFilter, themeFilter: $themeFilter, entityFilter: $entityFilter, managerReportIds: $managerReportIds, isHierarchyReport: $isHierarchyReport, selectedParticipantId: $selectedParticipantId, sort: $sort, selectedTimeframe: $selectedTimeframe}
  ) {
    commentCount
    comments {
      id
      sentiment
      themes {
        id
        themeName
        translations {
          languageId
          name
        }
      }
      text
      created
      conversationId
      reactedLike
      reactedGreatIdea
      reactedWorkingOnIt
      like
      greatIdea
      workingOnIt
      surveyTypeId
      employeeResponseQuestionScaleId
      employeeResponseQuestionTextId
      employeeResponseQuestionOptionsId
      anonymousConversation
    }
  }
}
    `;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyIds: // value for 'surveyIds'
 *      questionId: // value for 'questionId'
 *      surveyElementId: // value for 'surveyElementId'
 *      attributes: // value for 'attributes'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      keyword: // value for 'keyword'
 *      sentimentFilter: // value for 'sentimentFilter'
 *      themeFilter: // value for 'themeFilter'
 *      entityFilter: // value for 'entityFilter'
 *      managerReportIds: // value for 'managerReportIds'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      selectedParticipantId: // value for 'selectedParticipantId'
 *      sort: // value for 'sort'
 *      selectedTimeframe: // value for 'selectedTimeframe'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const CompanyConfigsDocument = gql`
    query companyConfigs {
  companyConfigs {
    companyId
    openSurveysEnabled
  }
}
    `;

/**
 * __useCompanyConfigsQuery__
 *
 * To run a query within a React component, call `useCompanyConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyConfigsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyConfigsQuery, CompanyConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyConfigsQuery, CompanyConfigsQueryVariables>(CompanyConfigsDocument, options);
      }
export function useCompanyConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyConfigsQuery, CompanyConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyConfigsQuery, CompanyConfigsQueryVariables>(CompanyConfigsDocument, options);
        }
export type CompanyConfigsQueryHookResult = ReturnType<typeof useCompanyConfigsQuery>;
export type CompanyConfigsLazyQueryHookResult = ReturnType<typeof useCompanyConfigsLazyQuery>;
export type CompanyConfigsQueryResult = Apollo.QueryResult<CompanyConfigsQuery, CompanyConfigsQueryVariables>;
export const ContinuousSurveyTrendsAnalysisDocument = gql`
    query continuousSurveyTrendsAnalysis($input: TimeframeTrendsInput!) {
  continuousSurveyTrendsAnalysis(input: $input) {
    factors {
      id
      name
      anonymized
      datasets {
        selectedTimeframeIndex
        label
        scoreAverage
        enpsScore
        percentUnfavorable
        percentNeutral
        percentFavorable
        countUnfavorable
        countNeutral
        countFavorable
        count
      }
    }
    questions {
      id
      name
      factorId
      factorName
      anonymized
      datasets {
        selectedTimeframeIndex
        label
        scoreAverage
        enpsScore
        percentUnfavorable
        percentNeutral
        percentFavorable
        countUnfavorable
        countNeutral
        countFavorable
        count
      }
    }
  }
}
    `;

/**
 * __useContinuousSurveyTrendsAnalysisQuery__
 *
 * To run a query within a React component, call `useContinuousSurveyTrendsAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useContinuousSurveyTrendsAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContinuousSurveyTrendsAnalysisQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContinuousSurveyTrendsAnalysisQuery(baseOptions: Apollo.QueryHookOptions<ContinuousSurveyTrendsAnalysisQuery, ContinuousSurveyTrendsAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContinuousSurveyTrendsAnalysisQuery, ContinuousSurveyTrendsAnalysisQueryVariables>(ContinuousSurveyTrendsAnalysisDocument, options);
      }
export function useContinuousSurveyTrendsAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContinuousSurveyTrendsAnalysisQuery, ContinuousSurveyTrendsAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContinuousSurveyTrendsAnalysisQuery, ContinuousSurveyTrendsAnalysisQueryVariables>(ContinuousSurveyTrendsAnalysisDocument, options);
        }
export type ContinuousSurveyTrendsAnalysisQueryHookResult = ReturnType<typeof useContinuousSurveyTrendsAnalysisQuery>;
export type ContinuousSurveyTrendsAnalysisLazyQueryHookResult = ReturnType<typeof useContinuousSurveyTrendsAnalysisLazyQuery>;
export type ContinuousSurveyTrendsAnalysisQueryResult = Apollo.QueryResult<ContinuousSurveyTrendsAnalysisQuery, ContinuousSurveyTrendsAnalysisQueryVariables>;
export const ConvertSurveyToContinuousDocument = gql`
    mutation convertSurveyToContinuous($surveyId: Int!, $continuousSurveyType: String!) {
  convertSurveyToContinuous(
    surveyId: $surveyId
    continuousSurveyType: $continuousSurveyType
  ) {
    surveyId
    isContinuous
    lifecycleSurveyTypeId
  }
}
    `;
export type ConvertSurveyToContinuousMutationFn = Apollo.MutationFunction<ConvertSurveyToContinuousMutation, ConvertSurveyToContinuousMutationVariables>;

/**
 * __useConvertSurveyToContinuousMutation__
 *
 * To run a mutation, you first call `useConvertSurveyToContinuousMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertSurveyToContinuousMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertSurveyToContinuousMutation, { data, loading, error }] = useConvertSurveyToContinuousMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      continuousSurveyType: // value for 'continuousSurveyType'
 *   },
 * });
 */
export function useConvertSurveyToContinuousMutation(baseOptions?: Apollo.MutationHookOptions<ConvertSurveyToContinuousMutation, ConvertSurveyToContinuousMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertSurveyToContinuousMutation, ConvertSurveyToContinuousMutationVariables>(ConvertSurveyToContinuousDocument, options);
      }
export type ConvertSurveyToContinuousMutationHookResult = ReturnType<typeof useConvertSurveyToContinuousMutation>;
export type ConvertSurveyToContinuousMutationResult = Apollo.MutationResult<ConvertSurveyToContinuousMutation>;
export type ConvertSurveyToContinuousMutationOptions = Apollo.BaseMutationOptions<ConvertSurveyToContinuousMutation, ConvertSurveyToContinuousMutationVariables>;
export const CreateAutomaticSurveyReminderDocument = gql`
    mutation createAutomaticSurveyReminder($automaticSurveyReminder: AutomaticSurveyReminderInput) {
  createAutomaticSurveyReminder(automaticSurveyReminder: $automaticSurveyReminder) {
    id
    surveyId
    reminderFrequencyDays
    status
    automaticSurveyReminderLanguages {
      languageId
      emailSubject
      emailBody
    }
  }
}
    `;
export type CreateAutomaticSurveyReminderMutationFn = Apollo.MutationFunction<CreateAutomaticSurveyReminderMutation, CreateAutomaticSurveyReminderMutationVariables>;

/**
 * __useCreateAutomaticSurveyReminderMutation__
 *
 * To run a mutation, you first call `useCreateAutomaticSurveyReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomaticSurveyReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomaticSurveyReminderMutation, { data, loading, error }] = useCreateAutomaticSurveyReminderMutation({
 *   variables: {
 *      automaticSurveyReminder: // value for 'automaticSurveyReminder'
 *   },
 * });
 */
export function useCreateAutomaticSurveyReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomaticSurveyReminderMutation, CreateAutomaticSurveyReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomaticSurveyReminderMutation, CreateAutomaticSurveyReminderMutationVariables>(CreateAutomaticSurveyReminderDocument, options);
      }
export type CreateAutomaticSurveyReminderMutationHookResult = ReturnType<typeof useCreateAutomaticSurveyReminderMutation>;
export type CreateAutomaticSurveyReminderMutationResult = Apollo.MutationResult<CreateAutomaticSurveyReminderMutation>;
export type CreateAutomaticSurveyReminderMutationOptions = Apollo.BaseMutationOptions<CreateAutomaticSurveyReminderMutation, CreateAutomaticSurveyReminderMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($companyId: Int!, $employee: EmployeeEditInput!) {
  addEmployee(companyId: $companyId, employee: $employee) {
    id
    enabled
    languageId
    attributesWithValues {
      attribute {
        id
        attributeNames {
          id
          name
          language {
            id
            langISOCode
          }
        }
      }
      attributeValues
    }
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const CreateEmployeeAttributeDocument = gql`
    mutation createEmployeeAttribute($companyId: Int!, $attribute: AttributeInput!) {
  addAttribute(companyId: $companyId, attribute: $attribute) {
    ...employeeAttributeFields
  }
}
    ${EmployeeAttributeFieldsFragmentDoc}`;
export type CreateEmployeeAttributeMutationFn = Apollo.MutationFunction<CreateEmployeeAttributeMutation, CreateEmployeeAttributeMutationVariables>;

/**
 * __useCreateEmployeeAttributeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeAttributeMutation, { data, loading, error }] = useCreateEmployeeAttributeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      attribute: // value for 'attribute'
 *   },
 * });
 */
export function useCreateEmployeeAttributeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeAttributeMutation, CreateEmployeeAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeAttributeMutation, CreateEmployeeAttributeMutationVariables>(CreateEmployeeAttributeDocument, options);
      }
export type CreateEmployeeAttributeMutationHookResult = ReturnType<typeof useCreateEmployeeAttributeMutation>;
export type CreateEmployeeAttributeMutationResult = Apollo.MutationResult<CreateEmployeeAttributeMutation>;
export type CreateEmployeeAttributeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeAttributeMutation, CreateEmployeeAttributeMutationVariables>;
export const CreateOrUpdateSurveyReminderDocument = gql`
    mutation createOrUpdateSurveyReminder($surveyReminder: createOrUpdateSurveyReminderInput!) {
  createOrUpdateSurveyReminder(surveyReminder: $surveyReminder) {
    id
    created
    updated
    surveyId
    scheduledDateTime
    status
    languages {
      languageId
      emailSubject
      emailBody
    }
    timezone {
      id
      timezone
    }
  }
}
    `;
export type CreateOrUpdateSurveyReminderMutationFn = Apollo.MutationFunction<CreateOrUpdateSurveyReminderMutation, CreateOrUpdateSurveyReminderMutationVariables>;

/**
 * __useCreateOrUpdateSurveyReminderMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSurveyReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSurveyReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSurveyReminderMutation, { data, loading, error }] = useCreateOrUpdateSurveyReminderMutation({
 *   variables: {
 *      surveyReminder: // value for 'surveyReminder'
 *   },
 * });
 */
export function useCreateOrUpdateSurveyReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateSurveyReminderMutation, CreateOrUpdateSurveyReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateSurveyReminderMutation, CreateOrUpdateSurveyReminderMutationVariables>(CreateOrUpdateSurveyReminderDocument, options);
      }
export type CreateOrUpdateSurveyReminderMutationHookResult = ReturnType<typeof useCreateOrUpdateSurveyReminderMutation>;
export type CreateOrUpdateSurveyReminderMutationResult = Apollo.MutationResult<CreateOrUpdateSurveyReminderMutation>;
export type CreateOrUpdateSurveyReminderMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateSurveyReminderMutation, CreateOrUpdateSurveyReminderMutationVariables>;
export const AddSurveyElementDocument = gql`
    mutation AddSurveyElement($surveyId: Int!, $surveyElement: SurveyElementInput!) {
  addSurveyElement(surveyId: $surveyId, surveyElement: $surveyElement) {
    id
    companyId
    orderIndex
    isLibraryQuestion
    isPreviousQuestion
    isBenchmarkedQuestion
    type {
      name
    }
    showSkipButton
    isAttributeBased
    hideReporting
    isFilterable
    attributes {
      attributeId
      attributeValue
    }
    isDiscontinued(surveyId: $surveyId)
    question {
      ... on SurveyElementQuestionOptions {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
        category {
          id
          categoryNames {
            name
          }
        }
        required
        showDescription
        choices {
          id
          orderIndex
          messagesPerLanguage {
            language {
              id
            }
            message
          }
        }
        minSelectedOption
        maxSelectedOption
        showTextComment
      }
      ... on SurveyElementQuestionScale {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
          labelBefore
          labelAfter
        }
        category {
          id
          categoryNames {
            name
          }
        }
        icon {
          id
          name
        }
        ratingOptionLowest
        ratingOptionHighest
        required
        showDescription
        showTextComment
        showLabels
      }
      ... on SurveyElementQuestionText {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
        category {
          id
        }
        required
        showDescription
      }
      ... on SurveyElementMessage {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
      }
    }
  }
}
    `;
export type AddSurveyElementMutationFn = Apollo.MutationFunction<AddSurveyElementMutation, AddSurveyElementMutationVariables>;

/**
 * __useAddSurveyElementMutation__
 *
 * To run a mutation, you first call `useAddSurveyElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSurveyElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSurveyElementMutation, { data, loading, error }] = useAddSurveyElementMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      surveyElement: // value for 'surveyElement'
 *   },
 * });
 */
export function useAddSurveyElementMutation(baseOptions?: Apollo.MutationHookOptions<AddSurveyElementMutation, AddSurveyElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSurveyElementMutation, AddSurveyElementMutationVariables>(AddSurveyElementDocument, options);
      }
export type AddSurveyElementMutationHookResult = ReturnType<typeof useAddSurveyElementMutation>;
export type AddSurveyElementMutationResult = Apollo.MutationResult<AddSurveyElementMutation>;
export type AddSurveyElementMutationOptions = Apollo.BaseMutationOptions<AddSurveyElementMutation, AddSurveyElementMutationVariables>;
export const CreateSurveySummaryConversationDocument = gql`
    mutation createSurveySummaryConversation($surveyId: Int!) {
  createSurveySummaryConversation(surveyId: $surveyId) {
    conversationId
    title
  }
}
    `;
export type CreateSurveySummaryConversationMutationFn = Apollo.MutationFunction<CreateSurveySummaryConversationMutation, CreateSurveySummaryConversationMutationVariables>;

/**
 * __useCreateSurveySummaryConversationMutation__
 *
 * To run a mutation, you first call `useCreateSurveySummaryConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveySummaryConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveySummaryConversationMutation, { data, loading, error }] = useCreateSurveySummaryConversationMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useCreateSurveySummaryConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveySummaryConversationMutation, CreateSurveySummaryConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveySummaryConversationMutation, CreateSurveySummaryConversationMutationVariables>(CreateSurveySummaryConversationDocument, options);
      }
export type CreateSurveySummaryConversationMutationHookResult = ReturnType<typeof useCreateSurveySummaryConversationMutation>;
export type CreateSurveySummaryConversationMutationResult = Apollo.MutationResult<CreateSurveySummaryConversationMutation>;
export type CreateSurveySummaryConversationMutationOptions = Apollo.BaseMutationOptions<CreateSurveySummaryConversationMutation, CreateSurveySummaryConversationMutationVariables>;
export const DeleteBenchmarkAttributeAssociationDocument = gql`
    mutation deleteBenchmarkAttributeAssociation($attributeId: Int!, $benchmarkAttributeId: Int!) {
  deleteAttributeAssociation(
    attributeId: $attributeId
    benchmarkAttributeId: $benchmarkAttributeId
  )
}
    `;
export type DeleteBenchmarkAttributeAssociationMutationFn = Apollo.MutationFunction<DeleteBenchmarkAttributeAssociationMutation, DeleteBenchmarkAttributeAssociationMutationVariables>;

/**
 * __useDeleteBenchmarkAttributeAssociationMutation__
 *
 * To run a mutation, you first call `useDeleteBenchmarkAttributeAssociationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBenchmarkAttributeAssociationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBenchmarkAttributeAssociationMutation, { data, loading, error }] = useDeleteBenchmarkAttributeAssociationMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      benchmarkAttributeId: // value for 'benchmarkAttributeId'
 *   },
 * });
 */
export function useDeleteBenchmarkAttributeAssociationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBenchmarkAttributeAssociationMutation, DeleteBenchmarkAttributeAssociationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBenchmarkAttributeAssociationMutation, DeleteBenchmarkAttributeAssociationMutationVariables>(DeleteBenchmarkAttributeAssociationDocument, options);
      }
export type DeleteBenchmarkAttributeAssociationMutationHookResult = ReturnType<typeof useDeleteBenchmarkAttributeAssociationMutation>;
export type DeleteBenchmarkAttributeAssociationMutationResult = Apollo.MutationResult<DeleteBenchmarkAttributeAssociationMutation>;
export type DeleteBenchmarkAttributeAssociationMutationOptions = Apollo.BaseMutationOptions<DeleteBenchmarkAttributeAssociationMutation, DeleteBenchmarkAttributeAssociationMutationVariables>;
export const DeleteBenchmarkQuestionAssociationsDocument = gql`
    mutation deleteBenchmarkQuestionAssociations($surveyQuestionIds: [Int!]!, $benchmarkQuestionId: Int!) {
  deleteSurveyQuestionAssociations(
    surveyQuestionIds: $surveyQuestionIds
    benchmarkQuestionId: $benchmarkQuestionId
  )
}
    `;
export type DeleteBenchmarkQuestionAssociationsMutationFn = Apollo.MutationFunction<DeleteBenchmarkQuestionAssociationsMutation, DeleteBenchmarkQuestionAssociationsMutationVariables>;

/**
 * __useDeleteBenchmarkQuestionAssociationsMutation__
 *
 * To run a mutation, you first call `useDeleteBenchmarkQuestionAssociationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBenchmarkQuestionAssociationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBenchmarkQuestionAssociationsMutation, { data, loading, error }] = useDeleteBenchmarkQuestionAssociationsMutation({
 *   variables: {
 *      surveyQuestionIds: // value for 'surveyQuestionIds'
 *      benchmarkQuestionId: // value for 'benchmarkQuestionId'
 *   },
 * });
 */
export function useDeleteBenchmarkQuestionAssociationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBenchmarkQuestionAssociationsMutation, DeleteBenchmarkQuestionAssociationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBenchmarkQuestionAssociationsMutation, DeleteBenchmarkQuestionAssociationsMutationVariables>(DeleteBenchmarkQuestionAssociationsDocument, options);
      }
export type DeleteBenchmarkQuestionAssociationsMutationHookResult = ReturnType<typeof useDeleteBenchmarkQuestionAssociationsMutation>;
export type DeleteBenchmarkQuestionAssociationsMutationResult = Apollo.MutationResult<DeleteBenchmarkQuestionAssociationsMutation>;
export type DeleteBenchmarkQuestionAssociationsMutationOptions = Apollo.BaseMutationOptions<DeleteBenchmarkQuestionAssociationsMutation, DeleteBenchmarkQuestionAssociationsMutationVariables>;
export const DeleteBouncedEmailRecipientsDocument = gql`
    mutation deleteBouncedEmailRecipients($emails: [String]!) {
  deleteBouncedEmailRecipients(emails: $emails)
}
    `;
export type DeleteBouncedEmailRecipientsMutationFn = Apollo.MutationFunction<DeleteBouncedEmailRecipientsMutation, DeleteBouncedEmailRecipientsMutationVariables>;

/**
 * __useDeleteBouncedEmailRecipientsMutation__
 *
 * To run a mutation, you first call `useDeleteBouncedEmailRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBouncedEmailRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBouncedEmailRecipientsMutation, { data, loading, error }] = useDeleteBouncedEmailRecipientsMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useDeleteBouncedEmailRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBouncedEmailRecipientsMutation, DeleteBouncedEmailRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBouncedEmailRecipientsMutation, DeleteBouncedEmailRecipientsMutationVariables>(DeleteBouncedEmailRecipientsDocument, options);
      }
export type DeleteBouncedEmailRecipientsMutationHookResult = ReturnType<typeof useDeleteBouncedEmailRecipientsMutation>;
export type DeleteBouncedEmailRecipientsMutationResult = Apollo.MutationResult<DeleteBouncedEmailRecipientsMutation>;
export type DeleteBouncedEmailRecipientsMutationOptions = Apollo.BaseMutationOptions<DeleteBouncedEmailRecipientsMutation, DeleteBouncedEmailRecipientsMutationVariables>;
export const DeleteCommentAnalysisDocument = gql`
    mutation deleteCommentAnalysis($input: CommentsSummaryInput) {
  deleteCommentAnalysis(input: $input)
}
    `;
export type DeleteCommentAnalysisMutationFn = Apollo.MutationFunction<DeleteCommentAnalysisMutation, DeleteCommentAnalysisMutationVariables>;

/**
 * __useDeleteCommentAnalysisMutation__
 *
 * To run a mutation, you first call `useDeleteCommentAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentAnalysisMutation, { data, loading, error }] = useDeleteCommentAnalysisMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommentAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentAnalysisMutation, DeleteCommentAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentAnalysisMutation, DeleteCommentAnalysisMutationVariables>(DeleteCommentAnalysisDocument, options);
      }
export type DeleteCommentAnalysisMutationHookResult = ReturnType<typeof useDeleteCommentAnalysisMutation>;
export type DeleteCommentAnalysisMutationResult = Apollo.MutationResult<DeleteCommentAnalysisMutation>;
export type DeleteCommentAnalysisMutationOptions = Apollo.BaseMutationOptions<DeleteCommentAnalysisMutation, DeleteCommentAnalysisMutationVariables>;
export const DeleteFromLifecycleDoNotContactListDocument = gql`
    mutation deleteFromLifecycleDoNotContactList($employeeId: Int!) {
  deleteFromLifecycleDoNotContactList(employeeId: $employeeId) {
    success
    message
  }
}
    `;
export type DeleteFromLifecycleDoNotContactListMutationFn = Apollo.MutationFunction<DeleteFromLifecycleDoNotContactListMutation, DeleteFromLifecycleDoNotContactListMutationVariables>;

/**
 * __useDeleteFromLifecycleDoNotContactListMutation__
 *
 * To run a mutation, you first call `useDeleteFromLifecycleDoNotContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFromLifecycleDoNotContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFromLifecycleDoNotContactListMutation, { data, loading, error }] = useDeleteFromLifecycleDoNotContactListMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteFromLifecycleDoNotContactListMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFromLifecycleDoNotContactListMutation, DeleteFromLifecycleDoNotContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFromLifecycleDoNotContactListMutation, DeleteFromLifecycleDoNotContactListMutationVariables>(DeleteFromLifecycleDoNotContactListDocument, options);
      }
export type DeleteFromLifecycleDoNotContactListMutationHookResult = ReturnType<typeof useDeleteFromLifecycleDoNotContactListMutation>;
export type DeleteFromLifecycleDoNotContactListMutationResult = Apollo.MutationResult<DeleteFromLifecycleDoNotContactListMutation>;
export type DeleteFromLifecycleDoNotContactListMutationOptions = Apollo.BaseMutationOptions<DeleteFromLifecycleDoNotContactListMutation, DeleteFromLifecycleDoNotContactListMutationVariables>;
export const DeleteLifecycleSurveyTriggerDocument = gql`
    mutation deleteLifecycleSurveyTrigger($id: Int!, $shouldClearPendingEmployees: Boolean!) {
  deleteLifecycleSurveyTrigger(
    id: $id
    shouldClearPendingEmployees: $shouldClearPendingEmployees
  ) {
    success
    message
  }
}
    `;
export type DeleteLifecycleSurveyTriggerMutationFn = Apollo.MutationFunction<DeleteLifecycleSurveyTriggerMutation, DeleteLifecycleSurveyTriggerMutationVariables>;

/**
 * __useDeleteLifecycleSurveyTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteLifecycleSurveyTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLifecycleSurveyTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLifecycleSurveyTriggerMutation, { data, loading, error }] = useDeleteLifecycleSurveyTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      shouldClearPendingEmployees: // value for 'shouldClearPendingEmployees'
 *   },
 * });
 */
export function useDeleteLifecycleSurveyTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLifecycleSurveyTriggerMutation, DeleteLifecycleSurveyTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLifecycleSurveyTriggerMutation, DeleteLifecycleSurveyTriggerMutationVariables>(DeleteLifecycleSurveyTriggerDocument, options);
      }
export type DeleteLifecycleSurveyTriggerMutationHookResult = ReturnType<typeof useDeleteLifecycleSurveyTriggerMutation>;
export type DeleteLifecycleSurveyTriggerMutationResult = Apollo.MutationResult<DeleteLifecycleSurveyTriggerMutation>;
export type DeleteLifecycleSurveyTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteLifecycleSurveyTriggerMutation, DeleteLifecycleSurveyTriggerMutationVariables>;
export const DeletePendingUsersDocument = gql`
    mutation deletePendingUsers($ids: [Int]!) {
  deletePendingUsers(ids: $ids)
}
    `;
export type DeletePendingUsersMutationFn = Apollo.MutationFunction<DeletePendingUsersMutation, DeletePendingUsersMutationVariables>;

/**
 * __useDeletePendingUsersMutation__
 *
 * To run a mutation, you first call `useDeletePendingUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePendingUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePendingUsersMutation, { data, loading, error }] = useDeletePendingUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeletePendingUsersMutation(baseOptions?: Apollo.MutationHookOptions<DeletePendingUsersMutation, DeletePendingUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePendingUsersMutation, DeletePendingUsersMutationVariables>(DeletePendingUsersDocument, options);
      }
export type DeletePendingUsersMutationHookResult = ReturnType<typeof useDeletePendingUsersMutation>;
export type DeletePendingUsersMutationResult = Apollo.MutationResult<DeletePendingUsersMutation>;
export type DeletePendingUsersMutationOptions = Apollo.BaseMutationOptions<DeletePendingUsersMutation, DeletePendingUsersMutationVariables>;
export const DeleteSurveyDocument = gql`
    mutation deleteSurvey($surveyId: Int!, $companyId: Int, $languageId: Int) {
  deleteSurvey(
    surveyId: $surveyId
    companyId: $companyId
    languageId: $languageId
  )
}
    `;
export type DeleteSurveyMutationFn = Apollo.MutationFunction<DeleteSurveyMutation, DeleteSurveyMutationVariables>;

/**
 * __useDeleteSurveyMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyMutation, { data, loading, error }] = useDeleteSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      companyId: // value for 'companyId'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useDeleteSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyMutation, DeleteSurveyMutationVariables>(DeleteSurveyDocument, options);
      }
export type DeleteSurveyMutationHookResult = ReturnType<typeof useDeleteSurveyMutation>;
export type DeleteSurveyMutationResult = Apollo.MutationResult<DeleteSurveyMutation>;
export type DeleteSurveyMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyMutation, DeleteSurveyMutationVariables>;
export const DeleteSurveyElementDocument = gql`
    mutation deleteSurveyElement($surveyElementId: Int!, $surveyId: Int!) {
  deleteSurveyElement(surveyElementId: $surveyElementId, surveyId: $surveyId)
}
    `;
export type DeleteSurveyElementMutationFn = Apollo.MutationFunction<DeleteSurveyElementMutation, DeleteSurveyElementMutationVariables>;

/**
 * __useDeleteSurveyElementMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyElementMutation, { data, loading, error }] = useDeleteSurveyElementMutation({
 *   variables: {
 *      surveyElementId: // value for 'surveyElementId'
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useDeleteSurveyElementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyElementMutation, DeleteSurveyElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyElementMutation, DeleteSurveyElementMutationVariables>(DeleteSurveyElementDocument, options);
      }
export type DeleteSurveyElementMutationHookResult = ReturnType<typeof useDeleteSurveyElementMutation>;
export type DeleteSurveyElementMutationResult = Apollo.MutationResult<DeleteSurveyElementMutation>;
export type DeleteSurveyElementMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyElementMutation, DeleteSurveyElementMutationVariables>;
export const DeleteSurveyReminderDocument = gql`
    mutation deleteSurveyReminder($reminderId: Int!) {
  deleteSurveyReminder(reminderId: $reminderId) {
    deleted
  }
}
    `;
export type DeleteSurveyReminderMutationFn = Apollo.MutationFunction<DeleteSurveyReminderMutation, DeleteSurveyReminderMutationVariables>;

/**
 * __useDeleteSurveyReminderMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyReminderMutation, { data, loading, error }] = useDeleteSurveyReminderMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useDeleteSurveyReminderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyReminderMutation, DeleteSurveyReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyReminderMutation, DeleteSurveyReminderMutationVariables>(DeleteSurveyReminderDocument, options);
      }
export type DeleteSurveyReminderMutationHookResult = ReturnType<typeof useDeleteSurveyReminderMutation>;
export type DeleteSurveyReminderMutationResult = Apollo.MutationResult<DeleteSurveyReminderMutation>;
export type DeleteSurveyReminderMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyReminderMutation, DeleteSurveyReminderMutationVariables>;
export const DeleteSurveyTemplateDocument = gql`
    mutation deleteSurveyTemplate($id: Int!) {
  deleteSurveyTemplate(id: $id) {
    success
  }
}
    `;
export type DeleteSurveyTemplateMutationFn = Apollo.MutationFunction<DeleteSurveyTemplateMutation, DeleteSurveyTemplateMutationVariables>;

/**
 * __useDeleteSurveyTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyTemplateMutation, { data, loading, error }] = useDeleteSurveyTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSurveyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyTemplateMutation, DeleteSurveyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyTemplateMutation, DeleteSurveyTemplateMutationVariables>(DeleteSurveyTemplateDocument, options);
      }
export type DeleteSurveyTemplateMutationHookResult = ReturnType<typeof useDeleteSurveyTemplateMutation>;
export type DeleteSurveyTemplateMutationResult = Apollo.MutationResult<DeleteSurveyTemplateMutation>;
export type DeleteSurveyTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyTemplateMutation, DeleteSurveyTemplateMutationVariables>;
export const DisableOpenSurveyAccessCodeDocument = gql`
    mutation disableOpenSurveyAccessCode($surveyId: Int!) {
  disableOpenSurveyAccessCode(surveyId: $surveyId) {
    id
    openSurveyAccessCode
  }
}
    `;
export type DisableOpenSurveyAccessCodeMutationFn = Apollo.MutationFunction<DisableOpenSurveyAccessCodeMutation, DisableOpenSurveyAccessCodeMutationVariables>;

/**
 * __useDisableOpenSurveyAccessCodeMutation__
 *
 * To run a mutation, you first call `useDisableOpenSurveyAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableOpenSurveyAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableOpenSurveyAccessCodeMutation, { data, loading, error }] = useDisableOpenSurveyAccessCodeMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useDisableOpenSurveyAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<DisableOpenSurveyAccessCodeMutation, DisableOpenSurveyAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableOpenSurveyAccessCodeMutation, DisableOpenSurveyAccessCodeMutationVariables>(DisableOpenSurveyAccessCodeDocument, options);
      }
export type DisableOpenSurveyAccessCodeMutationHookResult = ReturnType<typeof useDisableOpenSurveyAccessCodeMutation>;
export type DisableOpenSurveyAccessCodeMutationResult = Apollo.MutationResult<DisableOpenSurveyAccessCodeMutation>;
export type DisableOpenSurveyAccessCodeMutationOptions = Apollo.BaseMutationOptions<DisableOpenSurveyAccessCodeMutation, DisableOpenSurveyAccessCodeMutationVariables>;
export const DuplicateSurveyDocument = gql`
    mutation duplicateSurvey($surveyName: String!, $surveyId: Int!, $companyId: Int, $languageId: Int, $clientTimezone: String) {
  duplicateSurvey(
    surveyName: $surveyName
    surveyId: $surveyId
    companyId: $companyId
    languageId: $languageId
    clientTimezone: $clientTimezone
  ) {
    id
  }
}
    `;
export type DuplicateSurveyMutationFn = Apollo.MutationFunction<DuplicateSurveyMutation, DuplicateSurveyMutationVariables>;

/**
 * __useDuplicateSurveyMutation__
 *
 * To run a mutation, you first call `useDuplicateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateSurveyMutation, { data, loading, error }] = useDuplicateSurveyMutation({
 *   variables: {
 *      surveyName: // value for 'surveyName'
 *      surveyId: // value for 'surveyId'
 *      companyId: // value for 'companyId'
 *      languageId: // value for 'languageId'
 *      clientTimezone: // value for 'clientTimezone'
 *   },
 * });
 */
export function useDuplicateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateSurveyMutation, DuplicateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateSurveyMutation, DuplicateSurveyMutationVariables>(DuplicateSurveyDocument, options);
      }
export type DuplicateSurveyMutationHookResult = ReturnType<typeof useDuplicateSurveyMutation>;
export type DuplicateSurveyMutationResult = Apollo.MutationResult<DuplicateSurveyMutation>;
export type DuplicateSurveyMutationOptions = Apollo.BaseMutationOptions<DuplicateSurveyMutation, DuplicateSurveyMutationVariables>;
export const ExitImpersonationDocument = gql`
    mutation exitImpersonation {
  exitImpersonation {
    token
  }
}
    `;
export type ExitImpersonationMutationFn = Apollo.MutationFunction<ExitImpersonationMutation, ExitImpersonationMutationVariables>;

/**
 * __useExitImpersonationMutation__
 *
 * To run a mutation, you first call `useExitImpersonationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExitImpersonationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exitImpersonationMutation, { data, loading, error }] = useExitImpersonationMutation({
 *   variables: {
 *   },
 * });
 */
export function useExitImpersonationMutation(baseOptions?: Apollo.MutationHookOptions<ExitImpersonationMutation, ExitImpersonationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExitImpersonationMutation, ExitImpersonationMutationVariables>(ExitImpersonationDocument, options);
      }
export type ExitImpersonationMutationHookResult = ReturnType<typeof useExitImpersonationMutation>;
export type ExitImpersonationMutationResult = Apollo.MutationResult<ExitImpersonationMutation>;
export type ExitImpersonationMutationOptions = Apollo.BaseMutationOptions<ExitImpersonationMutation, ExitImpersonationMutationVariables>;
export const FetchAccountDocument = gql`
    query fetchAccount($userId: Int!) {
  user(id: $userId) {
    id
    userRoleId
    employeeId
    hierarchy
    firstName
    lastName
    avatar
    email
    status
    worktangoAdmin
    employeeId
    updated
    created
    canManageMailingList
    isImpersonating
    company {
      ...companyFields
      companyFeatureSettings {
        COMMENT_SENTIMENT_AND_SUMMARY
      }
    }
    preferredLanguage {
      id
      langISOCode
    }
    globalActions {
      id
      globalActionId
      companyId
    }
    permissions {
      id
      surveyTypeId
      accessAll
      allAttributesVisible
      canCompareToAllAttributes
      attributeBased
      hierarchyBased
      useUserAttributeValue
      useUserAttributeValueCompare
      created
      updated
      company {
        ...companyFields
      }
      userActions {
        id
        action
      }
      visibleAttributes {
        id
        attributeId
      }
      attributes {
        id
        name
        values
      }
      compareAttributes {
        id
        name
        values
      }
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;

/**
 * __useFetchAccountQuery__
 *
 * To run a query within a React component, call `useFetchAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAccountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchAccountQuery(baseOptions: Apollo.QueryHookOptions<FetchAccountQuery, FetchAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAccountQuery, FetchAccountQueryVariables>(FetchAccountDocument, options);
      }
export function useFetchAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAccountQuery, FetchAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAccountQuery, FetchAccountQueryVariables>(FetchAccountDocument, options);
        }
export type FetchAccountQueryHookResult = ReturnType<typeof useFetchAccountQuery>;
export type FetchAccountLazyQueryHookResult = ReturnType<typeof useFetchAccountLazyQuery>;
export type FetchAccountQueryResult = Apollo.QueryResult<FetchAccountQuery, FetchAccountQueryVariables>;
export const FetchAdminUsersDocument = gql`
    query fetchAdminUsers {
  adminUsers {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useFetchAdminUsersQuery__
 *
 * To run a query within a React component, call `useFetchAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>(FetchAdminUsersDocument, options);
      }
export function useFetchAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>(FetchAdminUsersDocument, options);
        }
export type FetchAdminUsersQueryHookResult = ReturnType<typeof useFetchAdminUsersQuery>;
export type FetchAdminUsersLazyQueryHookResult = ReturnType<typeof useFetchAdminUsersLazyQuery>;
export type FetchAdminUsersQueryResult = Apollo.QueryResult<FetchAdminUsersQuery, FetchAdminUsersQueryVariables>;
export const FetchAllBenchmarkAttributesDocument = gql`
    query fetchAllBenchmarkAttributes {
  findAllBenchmarkAttributes {
    id
    name
    translationKey
    lastRefreshed
    values {
      id
      name
      altNames
    }
  }
}
    `;

/**
 * __useFetchAllBenchmarkAttributesQuery__
 *
 * To run a query within a React component, call `useFetchAllBenchmarkAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllBenchmarkAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllBenchmarkAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllBenchmarkAttributesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllBenchmarkAttributesQuery, FetchAllBenchmarkAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllBenchmarkAttributesQuery, FetchAllBenchmarkAttributesQueryVariables>(FetchAllBenchmarkAttributesDocument, options);
      }
export function useFetchAllBenchmarkAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllBenchmarkAttributesQuery, FetchAllBenchmarkAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllBenchmarkAttributesQuery, FetchAllBenchmarkAttributesQueryVariables>(FetchAllBenchmarkAttributesDocument, options);
        }
export type FetchAllBenchmarkAttributesQueryHookResult = ReturnType<typeof useFetchAllBenchmarkAttributesQuery>;
export type FetchAllBenchmarkAttributesLazyQueryHookResult = ReturnType<typeof useFetchAllBenchmarkAttributesLazyQuery>;
export type FetchAllBenchmarkAttributesQueryResult = Apollo.QueryResult<FetchAllBenchmarkAttributesQuery, FetchAllBenchmarkAttributesQueryVariables>;
export const FetchAttributeResponsesDocument = gql`
    query fetchAttributeResponses($companyIds: [Int]!, $surveyIds: [Int]!, $languageId: Int!, $attributes: [AttributeWithValuesSearchInput], $isHierarchyReport: Boolean, $managerReportIds: [String], $requestManagerHierarchyData: Boolean, $skipUserPermission: Boolean, $selectedTimeframe: TimeframeInput) {
  attributesRatingResponses(
    companyIds: $companyIds
    surveyIds: $surveyIds
    languageId: $languageId
    attributes: $attributes
    isHierarchyReport: $isHierarchyReport
    managerReportIds: $managerReportIds
    requestManagerHierarchyData: $requestManagerHierarchyData
    skipUserPermission: $skipUserPermission
    selectedTimeframe: $selectedTimeframe
  ) {
    surveys {
      id
      name
      percentage
      count
      totalCount
    }
    attributes {
      id
      name
      spread {
        min
        max
      }
      count
      values {
        id
        label
        count
        totalCount
        percentage
      }
    }
  }
}
    `;

/**
 * __useFetchAttributeResponsesQuery__
 *
 * To run a query within a React component, call `useFetchAttributeResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAttributeResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAttributeResponsesQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      surveyIds: // value for 'surveyIds'
 *      languageId: // value for 'languageId'
 *      attributes: // value for 'attributes'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      managerReportIds: // value for 'managerReportIds'
 *      requestManagerHierarchyData: // value for 'requestManagerHierarchyData'
 *      skipUserPermission: // value for 'skipUserPermission'
 *      selectedTimeframe: // value for 'selectedTimeframe'
 *   },
 * });
 */
export function useFetchAttributeResponsesQuery(baseOptions: Apollo.QueryHookOptions<FetchAttributeResponsesQuery, FetchAttributeResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAttributeResponsesQuery, FetchAttributeResponsesQueryVariables>(FetchAttributeResponsesDocument, options);
      }
export function useFetchAttributeResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAttributeResponsesQuery, FetchAttributeResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAttributeResponsesQuery, FetchAttributeResponsesQueryVariables>(FetchAttributeResponsesDocument, options);
        }
export type FetchAttributeResponsesQueryHookResult = ReturnType<typeof useFetchAttributeResponsesQuery>;
export type FetchAttributeResponsesLazyQueryHookResult = ReturnType<typeof useFetchAttributeResponsesLazyQuery>;
export type FetchAttributeResponsesQueryResult = Apollo.QueryResult<FetchAttributeResponsesQuery, FetchAttributeResponsesQueryVariables>;
export const FetchAttributeSampleValuesDocument = gql`
    query fetchAttributeSampleValues($attributeId: Int!, $limit: Int) {
  findAttributeSampleValues(attributeId: $attributeId, limit: $limit)
}
    `;

/**
 * __useFetchAttributeSampleValuesQuery__
 *
 * To run a query within a React component, call `useFetchAttributeSampleValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAttributeSampleValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAttributeSampleValuesQuery({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchAttributeSampleValuesQuery(baseOptions: Apollo.QueryHookOptions<FetchAttributeSampleValuesQuery, FetchAttributeSampleValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAttributeSampleValuesQuery, FetchAttributeSampleValuesQueryVariables>(FetchAttributeSampleValuesDocument, options);
      }
export function useFetchAttributeSampleValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAttributeSampleValuesQuery, FetchAttributeSampleValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAttributeSampleValuesQuery, FetchAttributeSampleValuesQueryVariables>(FetchAttributeSampleValuesDocument, options);
        }
export type FetchAttributeSampleValuesQueryHookResult = ReturnType<typeof useFetchAttributeSampleValuesQuery>;
export type FetchAttributeSampleValuesLazyQueryHookResult = ReturnType<typeof useFetchAttributeSampleValuesLazyQuery>;
export type FetchAttributeSampleValuesQueryResult = Apollo.QueryResult<FetchAttributeSampleValuesQuery, FetchAttributeSampleValuesQueryVariables>;
export const FetchAvailableBenchmarksDocument = gql`
    query fetchAvailableBenchmarks {
  findAvailableBenchmarks
}
    `;

/**
 * __useFetchAvailableBenchmarksQuery__
 *
 * To run a query within a React component, call `useFetchAvailableBenchmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAvailableBenchmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAvailableBenchmarksQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAvailableBenchmarksQuery(baseOptions?: Apollo.QueryHookOptions<FetchAvailableBenchmarksQuery, FetchAvailableBenchmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAvailableBenchmarksQuery, FetchAvailableBenchmarksQueryVariables>(FetchAvailableBenchmarksDocument, options);
      }
export function useFetchAvailableBenchmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAvailableBenchmarksQuery, FetchAvailableBenchmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAvailableBenchmarksQuery, FetchAvailableBenchmarksQueryVariables>(FetchAvailableBenchmarksDocument, options);
        }
export type FetchAvailableBenchmarksQueryHookResult = ReturnType<typeof useFetchAvailableBenchmarksQuery>;
export type FetchAvailableBenchmarksLazyQueryHookResult = ReturnType<typeof useFetchAvailableBenchmarksLazyQuery>;
export type FetchAvailableBenchmarksQueryResult = Apollo.QueryResult<FetchAvailableBenchmarksQuery, FetchAvailableBenchmarksQueryVariables>;
export const FetchBasicSurveyListDocument = gql`
    query fetchBasicSurveyList($companyId: Int!) {
  dashboardSurveys(search: {}, companyId: $companyId) {
    count
    results {
      id
      surveyName
      typeId
      surveyStatusId
      startTimeUTC
      supportLanguages
      isContinuous
    }
  }
}
    `;

/**
 * __useFetchBasicSurveyListQuery__
 *
 * To run a query within a React component, call `useFetchBasicSurveyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBasicSurveyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBasicSurveyListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchBasicSurveyListQuery(baseOptions: Apollo.QueryHookOptions<FetchBasicSurveyListQuery, FetchBasicSurveyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBasicSurveyListQuery, FetchBasicSurveyListQueryVariables>(FetchBasicSurveyListDocument, options);
      }
export function useFetchBasicSurveyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBasicSurveyListQuery, FetchBasicSurveyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBasicSurveyListQuery, FetchBasicSurveyListQueryVariables>(FetchBasicSurveyListDocument, options);
        }
export type FetchBasicSurveyListQueryHookResult = ReturnType<typeof useFetchBasicSurveyListQuery>;
export type FetchBasicSurveyListLazyQueryHookResult = ReturnType<typeof useFetchBasicSurveyListLazyQuery>;
export type FetchBasicSurveyListQueryResult = Apollo.QueryResult<FetchBasicSurveyListQuery, FetchBasicSurveyListQueryVariables>;
export const FetchBenchmarkQuestionsDocument = gql`
    query fetchBenchmarkQuestions($surveyTypeId: Int!) {
  findBenchmarkQuestions(surveyTypeId: $surveyTypeId) {
    questionId
    questionText
    taggedQuestionCount
    surveyCount
    surveyYears
  }
}
    `;

/**
 * __useFetchBenchmarkQuestionsQuery__
 *
 * To run a query within a React component, call `useFetchBenchmarkQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBenchmarkQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBenchmarkQuestionsQuery({
 *   variables: {
 *      surveyTypeId: // value for 'surveyTypeId'
 *   },
 * });
 */
export function useFetchBenchmarkQuestionsQuery(baseOptions: Apollo.QueryHookOptions<FetchBenchmarkQuestionsQuery, FetchBenchmarkQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBenchmarkQuestionsQuery, FetchBenchmarkQuestionsQueryVariables>(FetchBenchmarkQuestionsDocument, options);
      }
export function useFetchBenchmarkQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBenchmarkQuestionsQuery, FetchBenchmarkQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBenchmarkQuestionsQuery, FetchBenchmarkQuestionsQueryVariables>(FetchBenchmarkQuestionsDocument, options);
        }
export type FetchBenchmarkQuestionsQueryHookResult = ReturnType<typeof useFetchBenchmarkQuestionsQuery>;
export type FetchBenchmarkQuestionsLazyQueryHookResult = ReturnType<typeof useFetchBenchmarkQuestionsLazyQuery>;
export type FetchBenchmarkQuestionsQueryResult = Apollo.QueryResult<FetchBenchmarkQuestionsQuery, FetchBenchmarkQuestionsQueryVariables>;
export const FetchBenchmarksDocument = gql`
    query fetchBenchmarks($queryInput: BenchmarkInput!) {
  findBenchmarks(queryInput: $queryInput) {
    id
    questionId
    surveyType
    benchmarkPeriod
    benchmarkQuestionId
    scope
    regionValueId
    countryValueId
    sizeValueId
    industryValueId
    sectorValueId
    averageScore
    positivePercent
    neutralPercent
    negativePercent
    promoter
    passive
    detractor
    eNPSScore
    totalCount
    companiesCount
  }
}
    `;

/**
 * __useFetchBenchmarksQuery__
 *
 * To run a query within a React component, call `useFetchBenchmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBenchmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBenchmarksQuery({
 *   variables: {
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useFetchBenchmarksQuery(baseOptions: Apollo.QueryHookOptions<FetchBenchmarksQuery, FetchBenchmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBenchmarksQuery, FetchBenchmarksQueryVariables>(FetchBenchmarksDocument, options);
      }
export function useFetchBenchmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBenchmarksQuery, FetchBenchmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBenchmarksQuery, FetchBenchmarksQueryVariables>(FetchBenchmarksDocument, options);
        }
export type FetchBenchmarksQueryHookResult = ReturnType<typeof useFetchBenchmarksQuery>;
export type FetchBenchmarksLazyQueryHookResult = ReturnType<typeof useFetchBenchmarksLazyQuery>;
export type FetchBenchmarksQueryResult = Apollo.QueryResult<FetchBenchmarksQuery, FetchBenchmarksQueryVariables>;
export const FetchCommentsSummaryDocument = gql`
    query fetchCommentsSummary($input: CommentsSummaryInput!) {
  commentsSummary(input: $input) {
    id
    surveyElementId
    languageId
    overallSummary
    positiveSummary
    negativeSummary
    recommendations
    created
  }
}
    `;

/**
 * __useFetchCommentsSummaryQuery__
 *
 * To run a query within a React component, call `useFetchCommentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCommentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCommentsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchCommentsSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchCommentsSummaryQuery, FetchCommentsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCommentsSummaryQuery, FetchCommentsSummaryQueryVariables>(FetchCommentsSummaryDocument, options);
      }
export function useFetchCommentsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCommentsSummaryQuery, FetchCommentsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCommentsSummaryQuery, FetchCommentsSummaryQueryVariables>(FetchCommentsSummaryDocument, options);
        }
export type FetchCommentsSummaryQueryHookResult = ReturnType<typeof useFetchCommentsSummaryQuery>;
export type FetchCommentsSummaryLazyQueryHookResult = ReturnType<typeof useFetchCommentsSummaryLazyQuery>;
export type FetchCommentsSummaryQueryResult = Apollo.QueryResult<FetchCommentsSummaryQuery, FetchCommentsSummaryQueryVariables>;
export const FetchCommentsSummaryForContinuousSurveyDocument = gql`
    mutation fetchCommentsSummaryForContinuousSurvey($input: ContinuousSurveyCommentSummaryInput!) {
  genCommentsSummaryForContinuousSurvey(input: $input) {
    id
    surveyElementId
    languageId
    overallSummary
    positiveSummary
    negativeSummary
    recommendations
    created
  }
}
    `;
export type FetchCommentsSummaryForContinuousSurveyMutationFn = Apollo.MutationFunction<FetchCommentsSummaryForContinuousSurveyMutation, FetchCommentsSummaryForContinuousSurveyMutationVariables>;

/**
 * __useFetchCommentsSummaryForContinuousSurveyMutation__
 *
 * To run a mutation, you first call `useFetchCommentsSummaryForContinuousSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchCommentsSummaryForContinuousSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchCommentsSummaryForContinuousSurveyMutation, { data, loading, error }] = useFetchCommentsSummaryForContinuousSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchCommentsSummaryForContinuousSurveyMutation(baseOptions?: Apollo.MutationHookOptions<FetchCommentsSummaryForContinuousSurveyMutation, FetchCommentsSummaryForContinuousSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchCommentsSummaryForContinuousSurveyMutation, FetchCommentsSummaryForContinuousSurveyMutationVariables>(FetchCommentsSummaryForContinuousSurveyDocument, options);
      }
export type FetchCommentsSummaryForContinuousSurveyMutationHookResult = ReturnType<typeof useFetchCommentsSummaryForContinuousSurveyMutation>;
export type FetchCommentsSummaryForContinuousSurveyMutationResult = Apollo.MutationResult<FetchCommentsSummaryForContinuousSurveyMutation>;
export type FetchCommentsSummaryForContinuousSurveyMutationOptions = Apollo.BaseMutationOptions<FetchCommentsSummaryForContinuousSurveyMutation, FetchCommentsSummaryForContinuousSurveyMutationVariables>;
export const FetchCompaniesBenchmarkSettingsDocument = gql`
    query fetchCompaniesBenchmarkSettings($benchmarkAttributeId: Int!) {
  findAllCompaniesBenchmarkSettings(benchmarkAttributeId: $benchmarkAttributeId) {
    companyId
    companyName
    benchmarkAttributeId
    associatedAttribute {
      id
      names
    }
    defaultValue {
      id
      name
    }
    ungroupedValue
  }
}
    `;

/**
 * __useFetchCompaniesBenchmarkSettingsQuery__
 *
 * To run a query within a React component, call `useFetchCompaniesBenchmarkSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompaniesBenchmarkSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompaniesBenchmarkSettingsQuery({
 *   variables: {
 *      benchmarkAttributeId: // value for 'benchmarkAttributeId'
 *   },
 * });
 */
export function useFetchCompaniesBenchmarkSettingsQuery(baseOptions: Apollo.QueryHookOptions<FetchCompaniesBenchmarkSettingsQuery, FetchCompaniesBenchmarkSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompaniesBenchmarkSettingsQuery, FetchCompaniesBenchmarkSettingsQueryVariables>(FetchCompaniesBenchmarkSettingsDocument, options);
      }
export function useFetchCompaniesBenchmarkSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompaniesBenchmarkSettingsQuery, FetchCompaniesBenchmarkSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompaniesBenchmarkSettingsQuery, FetchCompaniesBenchmarkSettingsQueryVariables>(FetchCompaniesBenchmarkSettingsDocument, options);
        }
export type FetchCompaniesBenchmarkSettingsQueryHookResult = ReturnType<typeof useFetchCompaniesBenchmarkSettingsQuery>;
export type FetchCompaniesBenchmarkSettingsLazyQueryHookResult = ReturnType<typeof useFetchCompaniesBenchmarkSettingsLazyQuery>;
export type FetchCompaniesBenchmarkSettingsQueryResult = Apollo.QueryResult<FetchCompaniesBenchmarkSettingsQuery, FetchCompaniesBenchmarkSettingsQueryVariables>;
export const FetchCompanyDocument = gql`
    query fetchCompany($companyId: Int!) {
  company(id: $companyId) {
    ...companyFields
    companyFeatureSettings {
      COMMENT_SENTIMENT_AND_SUMMARY
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;

/**
 * __useFetchCompanyQuery__
 *
 * To run a query within a React component, call `useFetchCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyQuery, FetchCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyQuery, FetchCompanyQueryVariables>(FetchCompanyDocument, options);
      }
export function useFetchCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyQuery, FetchCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyQuery, FetchCompanyQueryVariables>(FetchCompanyDocument, options);
        }
export type FetchCompanyQueryHookResult = ReturnType<typeof useFetchCompanyQuery>;
export type FetchCompanyLazyQueryHookResult = ReturnType<typeof useFetchCompanyLazyQuery>;
export type FetchCompanyQueryResult = Apollo.QueryResult<FetchCompanyQuery, FetchCompanyQueryVariables>;
export const FetchCompanyBenchmarkSettingsDocument = gql`
    query fetchCompanyBenchmarkSettings($companyId: Int!) {
  findCompanyBenchmarkSettings(companyId: $companyId) {
    companyId
    benchmarkAttributes {
      benchmarkAttributeId
      benchmarkAttributeName
      defaultValueId
      defaultValueName
    }
  }
}
    `;

/**
 * __useFetchCompanyBenchmarkSettingsQuery__
 *
 * To run a query within a React component, call `useFetchCompanyBenchmarkSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyBenchmarkSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyBenchmarkSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyBenchmarkSettingsQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyBenchmarkSettingsQuery, FetchCompanyBenchmarkSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyBenchmarkSettingsQuery, FetchCompanyBenchmarkSettingsQueryVariables>(FetchCompanyBenchmarkSettingsDocument, options);
      }
export function useFetchCompanyBenchmarkSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyBenchmarkSettingsQuery, FetchCompanyBenchmarkSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyBenchmarkSettingsQuery, FetchCompanyBenchmarkSettingsQueryVariables>(FetchCompanyBenchmarkSettingsDocument, options);
        }
export type FetchCompanyBenchmarkSettingsQueryHookResult = ReturnType<typeof useFetchCompanyBenchmarkSettingsQuery>;
export type FetchCompanyBenchmarkSettingsLazyQueryHookResult = ReturnType<typeof useFetchCompanyBenchmarkSettingsLazyQuery>;
export type FetchCompanyBenchmarkSettingsQueryResult = Apollo.QueryResult<FetchCompanyBenchmarkSettingsQuery, FetchCompanyBenchmarkSettingsQueryVariables>;
export const FetchCompanyEmployeeAttributesDocument = gql`
    query fetchCompanyEmployeeAttributes($companyId: Int!) {
  findCompanyEmployeeAttributes(companyId: $companyId) {
    id
    baseAttributeId
    isReportingAttribute
    isPrivate
    isRequired
    isUnique
    attributeTypeId
    attributeNames {
      name
      language {
        id
        langISOCode
      }
    }
  }
}
    `;

/**
 * __useFetchCompanyEmployeeAttributesQuery__
 *
 * To run a query within a React component, call `useFetchCompanyEmployeeAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyEmployeeAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyEmployeeAttributesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyEmployeeAttributesQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyEmployeeAttributesQuery, FetchCompanyEmployeeAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyEmployeeAttributesQuery, FetchCompanyEmployeeAttributesQueryVariables>(FetchCompanyEmployeeAttributesDocument, options);
      }
export function useFetchCompanyEmployeeAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyEmployeeAttributesQuery, FetchCompanyEmployeeAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyEmployeeAttributesQuery, FetchCompanyEmployeeAttributesQueryVariables>(FetchCompanyEmployeeAttributesDocument, options);
        }
export type FetchCompanyEmployeeAttributesQueryHookResult = ReturnType<typeof useFetchCompanyEmployeeAttributesQuery>;
export type FetchCompanyEmployeeAttributesLazyQueryHookResult = ReturnType<typeof useFetchCompanyEmployeeAttributesLazyQuery>;
export type FetchCompanyEmployeeAttributesQueryResult = Apollo.QueryResult<FetchCompanyEmployeeAttributesQuery, FetchCompanyEmployeeAttributesQueryVariables>;
export const FetchCompanyEmployeeIdsDocument = gql`
    query fetchCompanyEmployeeIds($companyId: Int) {
  employeeDetails(employeeDetailsInput: {companyId: $companyId}) {
    results {
      employeeId
      email
      lastName
    }
    count
  }
}
    `;

/**
 * __useFetchCompanyEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useFetchCompanyEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyEmployeeIdsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyEmployeeIdsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCompanyEmployeeIdsQuery, FetchCompanyEmployeeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyEmployeeIdsQuery, FetchCompanyEmployeeIdsQueryVariables>(FetchCompanyEmployeeIdsDocument, options);
      }
export function useFetchCompanyEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyEmployeeIdsQuery, FetchCompanyEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyEmployeeIdsQuery, FetchCompanyEmployeeIdsQueryVariables>(FetchCompanyEmployeeIdsDocument, options);
        }
export type FetchCompanyEmployeeIdsQueryHookResult = ReturnType<typeof useFetchCompanyEmployeeIdsQuery>;
export type FetchCompanyEmployeeIdsLazyQueryHookResult = ReturnType<typeof useFetchCompanyEmployeeIdsLazyQuery>;
export type FetchCompanyEmployeeIdsQueryResult = Apollo.QueryResult<FetchCompanyEmployeeIdsQuery, FetchCompanyEmployeeIdsQueryVariables>;
export const GetCompanyEmployeeIdsInSurveyDocument = gql`
    query getCompanyEmployeeIdsInSurvey($surveyId: Int!) {
  getCompanyEmployeeIdsInSurvey(surveyId: $surveyId)
}
    `;

/**
 * __useGetCompanyEmployeeIdsInSurveyQuery__
 *
 * To run a query within a React component, call `useGetCompanyEmployeeIdsInSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyEmployeeIdsInSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyEmployeeIdsInSurveyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetCompanyEmployeeIdsInSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyEmployeeIdsInSurveyQuery, GetCompanyEmployeeIdsInSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyEmployeeIdsInSurveyQuery, GetCompanyEmployeeIdsInSurveyQueryVariables>(GetCompanyEmployeeIdsInSurveyDocument, options);
      }
export function useGetCompanyEmployeeIdsInSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyEmployeeIdsInSurveyQuery, GetCompanyEmployeeIdsInSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyEmployeeIdsInSurveyQuery, GetCompanyEmployeeIdsInSurveyQueryVariables>(GetCompanyEmployeeIdsInSurveyDocument, options);
        }
export type GetCompanyEmployeeIdsInSurveyQueryHookResult = ReturnType<typeof useGetCompanyEmployeeIdsInSurveyQuery>;
export type GetCompanyEmployeeIdsInSurveyLazyQueryHookResult = ReturnType<typeof useGetCompanyEmployeeIdsInSurveyLazyQuery>;
export type GetCompanyEmployeeIdsInSurveyQueryResult = Apollo.QueryResult<GetCompanyEmployeeIdsInSurveyQuery, GetCompanyEmployeeIdsInSurveyQueryVariables>;
export const FetchCompanyEmployeesAndUsersDocument = gql`
    query fetchCompanyEmployeesAndUsers($companyId: Int, $enabledEmployee: Boolean) {
  employeeDetails(
    employeeDetailsInput: {companyId: $companyId, enabledEmployee: $enabledEmployee}
  ) {
    results {
      employeeId
      email
      firstName
      lastName
      isUser
      hasRole
      enabled
      user {
        firstName
        lastName
        email
        status
        worktangoAdmin
      }
    }
    count
  }
}
    `;

/**
 * __useFetchCompanyEmployeesAndUsersQuery__
 *
 * To run a query within a React component, call `useFetchCompanyEmployeesAndUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyEmployeesAndUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyEmployeesAndUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      enabledEmployee: // value for 'enabledEmployee'
 *   },
 * });
 */
export function useFetchCompanyEmployeesAndUsersQuery(baseOptions?: Apollo.QueryHookOptions<FetchCompanyEmployeesAndUsersQuery, FetchCompanyEmployeesAndUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyEmployeesAndUsersQuery, FetchCompanyEmployeesAndUsersQueryVariables>(FetchCompanyEmployeesAndUsersDocument, options);
      }
export function useFetchCompanyEmployeesAndUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyEmployeesAndUsersQuery, FetchCompanyEmployeesAndUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyEmployeesAndUsersQuery, FetchCompanyEmployeesAndUsersQueryVariables>(FetchCompanyEmployeesAndUsersDocument, options);
        }
export type FetchCompanyEmployeesAndUsersQueryHookResult = ReturnType<typeof useFetchCompanyEmployeesAndUsersQuery>;
export type FetchCompanyEmployeesAndUsersLazyQueryHookResult = ReturnType<typeof useFetchCompanyEmployeesAndUsersLazyQuery>;
export type FetchCompanyEmployeesAndUsersQueryResult = Apollo.QueryResult<FetchCompanyEmployeesAndUsersQuery, FetchCompanyEmployeesAndUsersQueryVariables>;
export const FetchCompanyMessagingConfigsDocument = gql`
    query fetchCompanyMessagingConfigs {
  companyMessagingConfigs {
    companyId
    channel
    enabled
    isConnected
    created
    updated
  }
}
    `;

/**
 * __useFetchCompanyMessagingConfigsQuery__
 *
 * To run a query within a React component, call `useFetchCompanyMessagingConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyMessagingConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyMessagingConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCompanyMessagingConfigsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCompanyMessagingConfigsQuery, FetchCompanyMessagingConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyMessagingConfigsQuery, FetchCompanyMessagingConfigsQueryVariables>(FetchCompanyMessagingConfigsDocument, options);
      }
export function useFetchCompanyMessagingConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyMessagingConfigsQuery, FetchCompanyMessagingConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyMessagingConfigsQuery, FetchCompanyMessagingConfigsQueryVariables>(FetchCompanyMessagingConfigsDocument, options);
        }
export type FetchCompanyMessagingConfigsQueryHookResult = ReturnType<typeof useFetchCompanyMessagingConfigsQuery>;
export type FetchCompanyMessagingConfigsLazyQueryHookResult = ReturnType<typeof useFetchCompanyMessagingConfigsLazyQuery>;
export type FetchCompanyMessagingConfigsQueryResult = Apollo.QueryResult<FetchCompanyMessagingConfigsQuery, FetchCompanyMessagingConfigsQueryVariables>;
export const FetchCompanyUserPermissionSummariesDocument = gql`
    query fetchCompanyUserPermissionSummaries($companyId: Int!) {
  getCompanyUsers(companyId: $companyId) {
    ...userPermissionSummaryFields
  }
}
    ${UserPermissionSummaryFieldsFragmentDoc}`;

/**
 * __useFetchCompanyUserPermissionSummariesQuery__
 *
 * To run a query within a React component, call `useFetchCompanyUserPermissionSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyUserPermissionSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyUserPermissionSummariesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyUserPermissionSummariesQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyUserPermissionSummariesQuery, FetchCompanyUserPermissionSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyUserPermissionSummariesQuery, FetchCompanyUserPermissionSummariesQueryVariables>(FetchCompanyUserPermissionSummariesDocument, options);
      }
export function useFetchCompanyUserPermissionSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyUserPermissionSummariesQuery, FetchCompanyUserPermissionSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyUserPermissionSummariesQuery, FetchCompanyUserPermissionSummariesQueryVariables>(FetchCompanyUserPermissionSummariesDocument, options);
        }
export type FetchCompanyUserPermissionSummariesQueryHookResult = ReturnType<typeof useFetchCompanyUserPermissionSummariesQuery>;
export type FetchCompanyUserPermissionSummariesLazyQueryHookResult = ReturnType<typeof useFetchCompanyUserPermissionSummariesLazyQuery>;
export type FetchCompanyUserPermissionSummariesQueryResult = Apollo.QueryResult<FetchCompanyUserPermissionSummariesQuery, FetchCompanyUserPermissionSummariesQueryVariables>;
export const FetchCompanyUsersDocument = gql`
    query fetchCompanyUsers($companyId: Int!) {
  getCompanyUsers(companyId: $companyId) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useFetchCompanyUsersQuery__
 *
 * To run a query within a React component, call `useFetchCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompanyUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>(FetchCompanyUsersDocument, options);
      }
export function useFetchCompanyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>(FetchCompanyUsersDocument, options);
        }
export type FetchCompanyUsersQueryHookResult = ReturnType<typeof useFetchCompanyUsersQuery>;
export type FetchCompanyUsersLazyQueryHookResult = ReturnType<typeof useFetchCompanyUsersLazyQuery>;
export type FetchCompanyUsersQueryResult = Apollo.QueryResult<FetchCompanyUsersQuery, FetchCompanyUsersQueryVariables>;
export const FetchDashboardSurveyDocument = gql`
    query fetchDashboardSurvey($companyId: Int!, $offset: Int, $limit: Int, $search: SurveyDashboardSearchInput, $orderBy: String, $isAsc: Boolean) {
  dashboardSurveys(
    limit: $limit
    offset: $offset
    search: $search
    companyId: $companyId
    orderBy: $orderBy
    isASC: $isAsc
  ) {
    count
    results {
      id
      hashCode
      statusId
      surveyName
      typeId
      completedCount
      totalCount
      responseRate
      created
      startTimeUTC
      endTimeUTC
      timezoneName
      remindersCount
      disableEmailSending
      isContinuous
      audienceMode
      surveyType {
        names {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFetchDashboardSurveyQuery__
 *
 * To run a query within a React component, call `useFetchDashboardSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDashboardSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDashboardSurveyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      isAsc: // value for 'isAsc'
 *   },
 * });
 */
export function useFetchDashboardSurveyQuery(baseOptions: Apollo.QueryHookOptions<FetchDashboardSurveyQuery, FetchDashboardSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDashboardSurveyQuery, FetchDashboardSurveyQueryVariables>(FetchDashboardSurveyDocument, options);
      }
export function useFetchDashboardSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDashboardSurveyQuery, FetchDashboardSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDashboardSurveyQuery, FetchDashboardSurveyQueryVariables>(FetchDashboardSurveyDocument, options);
        }
export type FetchDashboardSurveyQueryHookResult = ReturnType<typeof useFetchDashboardSurveyQuery>;
export type FetchDashboardSurveyLazyQueryHookResult = ReturnType<typeof useFetchDashboardSurveyLazyQuery>;
export type FetchDashboardSurveyQueryResult = Apollo.QueryResult<FetchDashboardSurveyQuery, FetchDashboardSurveyQueryVariables>;
export const FetchDefaultContextsAndPromptsDocument = gql`
    query fetchDefaultContextsAndPrompts {
  getDefaultContextsAndPrompts {
    analysisType
    context
    guardPrompt
  }
}
    `;

/**
 * __useFetchDefaultContextsAndPromptsQuery__
 *
 * To run a query within a React component, call `useFetchDefaultContextsAndPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultContextsAndPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDefaultContextsAndPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDefaultContextsAndPromptsQuery(baseOptions?: Apollo.QueryHookOptions<FetchDefaultContextsAndPromptsQuery, FetchDefaultContextsAndPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDefaultContextsAndPromptsQuery, FetchDefaultContextsAndPromptsQueryVariables>(FetchDefaultContextsAndPromptsDocument, options);
      }
export function useFetchDefaultContextsAndPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDefaultContextsAndPromptsQuery, FetchDefaultContextsAndPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDefaultContextsAndPromptsQuery, FetchDefaultContextsAndPromptsQueryVariables>(FetchDefaultContextsAndPromptsDocument, options);
        }
export type FetchDefaultContextsAndPromptsQueryHookResult = ReturnType<typeof useFetchDefaultContextsAndPromptsQuery>;
export type FetchDefaultContextsAndPromptsLazyQueryHookResult = ReturnType<typeof useFetchDefaultContextsAndPromptsLazyQuery>;
export type FetchDefaultContextsAndPromptsQueryResult = Apollo.QueryResult<FetchDefaultContextsAndPromptsQuery, FetchDefaultContextsAndPromptsQueryVariables>;
export const CompanyAttributeValuesDocument = gql`
    query companyAttributeValues($companyId: Int!, $attributeId: Int!, $languageId: Int!, $surveyTypeId: Int, $includeSnapshotValues: Boolean, $surveyIds: [Int], $onlyEnabledEmployees: Boolean) {
  getCompanyAttributeValues(
    companyId: $companyId
    attributeId: $attributeId
    languageId: $languageId
    surveyTypeId: $surveyTypeId
    includeSnapshotValues: $includeSnapshotValues
    surveyIds: $surveyIds
    onlyEnabledEmployees: $onlyEnabledEmployees
  ) {
    attribute {
      id
    }
    attributeValues
  }
}
    `;

/**
 * __useCompanyAttributeValuesQuery__
 *
 * To run a query within a React component, call `useCompanyAttributeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAttributeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAttributeValuesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      attributeId: // value for 'attributeId'
 *      languageId: // value for 'languageId'
 *      surveyTypeId: // value for 'surveyTypeId'
 *      includeSnapshotValues: // value for 'includeSnapshotValues'
 *      surveyIds: // value for 'surveyIds'
 *      onlyEnabledEmployees: // value for 'onlyEnabledEmployees'
 *   },
 * });
 */
export function useCompanyAttributeValuesQuery(baseOptions: Apollo.QueryHookOptions<CompanyAttributeValuesQuery, CompanyAttributeValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAttributeValuesQuery, CompanyAttributeValuesQueryVariables>(CompanyAttributeValuesDocument, options);
      }
export function useCompanyAttributeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAttributeValuesQuery, CompanyAttributeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAttributeValuesQuery, CompanyAttributeValuesQueryVariables>(CompanyAttributeValuesDocument, options);
        }
export type CompanyAttributeValuesQueryHookResult = ReturnType<typeof useCompanyAttributeValuesQuery>;
export type CompanyAttributeValuesLazyQueryHookResult = ReturnType<typeof useCompanyAttributeValuesLazyQuery>;
export type CompanyAttributeValuesQueryResult = Apollo.QueryResult<CompanyAttributeValuesQuery, CompanyAttributeValuesQueryVariables>;
export const FetchEmployeeAttributesDocument = gql`
    query fetchEmployeeAttributes($companyId: Int!, $includePrivateAttributes: Boolean) {
  getCompanyConfigDetails(
    id: $companyId
    includePrivateAttributes: $includePrivateAttributes
  ) {
    attributes {
      ...employeeAttributeFields
    }
    languages {
      id
      langISOCode
    }
  }
}
    ${EmployeeAttributeFieldsFragmentDoc}`;

/**
 * __useFetchEmployeeAttributesQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeAttributesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      includePrivateAttributes: // value for 'includePrivateAttributes'
 *   },
 * });
 */
export function useFetchEmployeeAttributesQuery(baseOptions: Apollo.QueryHookOptions<FetchEmployeeAttributesQuery, FetchEmployeeAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeeAttributesQuery, FetchEmployeeAttributesQueryVariables>(FetchEmployeeAttributesDocument, options);
      }
export function useFetchEmployeeAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeeAttributesQuery, FetchEmployeeAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeeAttributesQuery, FetchEmployeeAttributesQueryVariables>(FetchEmployeeAttributesDocument, options);
        }
export type FetchEmployeeAttributesQueryHookResult = ReturnType<typeof useFetchEmployeeAttributesQuery>;
export type FetchEmployeeAttributesLazyQueryHookResult = ReturnType<typeof useFetchEmployeeAttributesLazyQuery>;
export type FetchEmployeeAttributesQueryResult = Apollo.QueryResult<FetchEmployeeAttributesQuery, FetchEmployeeAttributesQueryVariables>;
export const FetchEmployeeImportColumnMappingsDocument = gql`
    query fetchEmployeeImportColumnMappings {
  employeeImportColumnMappings {
    id
    sourceColumnName
    targetCoreField
    targetAttributeId
    targetAttributeName
    excluded
  }
}
    `;

/**
 * __useFetchEmployeeImportColumnMappingsQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeImportColumnMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeImportColumnMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeImportColumnMappingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchEmployeeImportColumnMappingsQuery(baseOptions?: Apollo.QueryHookOptions<FetchEmployeeImportColumnMappingsQuery, FetchEmployeeImportColumnMappingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeeImportColumnMappingsQuery, FetchEmployeeImportColumnMappingsQueryVariables>(FetchEmployeeImportColumnMappingsDocument, options);
      }
export function useFetchEmployeeImportColumnMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeeImportColumnMappingsQuery, FetchEmployeeImportColumnMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeeImportColumnMappingsQuery, FetchEmployeeImportColumnMappingsQueryVariables>(FetchEmployeeImportColumnMappingsDocument, options);
        }
export type FetchEmployeeImportColumnMappingsQueryHookResult = ReturnType<typeof useFetchEmployeeImportColumnMappingsQuery>;
export type FetchEmployeeImportColumnMappingsLazyQueryHookResult = ReturnType<typeof useFetchEmployeeImportColumnMappingsLazyQuery>;
export type FetchEmployeeImportColumnMappingsQueryResult = Apollo.QueryResult<FetchEmployeeImportColumnMappingsQuery, FetchEmployeeImportColumnMappingsQueryVariables>;
export const FetchEmployeeImportTaskDocument = gql`
    query fetchEmployeeImportTask($id: Int!) {
  employeeImportTask(id: $id) {
    id
    output {
      errorMessage
      issues {
        severity
        message
        rowNumber
      }
    }
  }
}
    `;

/**
 * __useFetchEmployeeImportTaskQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeImportTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeImportTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeImportTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchEmployeeImportTaskQuery(baseOptions: Apollo.QueryHookOptions<FetchEmployeeImportTaskQuery, FetchEmployeeImportTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeeImportTaskQuery, FetchEmployeeImportTaskQueryVariables>(FetchEmployeeImportTaskDocument, options);
      }
export function useFetchEmployeeImportTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeeImportTaskQuery, FetchEmployeeImportTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeeImportTaskQuery, FetchEmployeeImportTaskQueryVariables>(FetchEmployeeImportTaskDocument, options);
        }
export type FetchEmployeeImportTaskQueryHookResult = ReturnType<typeof useFetchEmployeeImportTaskQuery>;
export type FetchEmployeeImportTaskLazyQueryHookResult = ReturnType<typeof useFetchEmployeeImportTaskLazyQuery>;
export type FetchEmployeeImportTaskQueryResult = Apollo.QueryResult<FetchEmployeeImportTaskQuery, FetchEmployeeImportTaskQueryVariables>;
export const FetchEmployeeImportTasksDocument = gql`
    query fetchEmployeeImportTasks($input: EmployeeImportTasksInput!) {
  employeeImportTasks(input: $input) {
    count
    results {
      id
      status
      sourceId
      uploaderName
      originLabel
      fileName
      created
      updated
    }
  }
}
    `;

/**
 * __useFetchEmployeeImportTasksQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeImportTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeImportTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeImportTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchEmployeeImportTasksQuery(baseOptions: Apollo.QueryHookOptions<FetchEmployeeImportTasksQuery, FetchEmployeeImportTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeeImportTasksQuery, FetchEmployeeImportTasksQueryVariables>(FetchEmployeeImportTasksDocument, options);
      }
export function useFetchEmployeeImportTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeeImportTasksQuery, FetchEmployeeImportTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeeImportTasksQuery, FetchEmployeeImportTasksQueryVariables>(FetchEmployeeImportTasksDocument, options);
        }
export type FetchEmployeeImportTasksQueryHookResult = ReturnType<typeof useFetchEmployeeImportTasksQuery>;
export type FetchEmployeeImportTasksLazyQueryHookResult = ReturnType<typeof useFetchEmployeeImportTasksLazyQuery>;
export type FetchEmployeeImportTasksQueryResult = Apollo.QueryResult<FetchEmployeeImportTasksQuery, FetchEmployeeImportTasksQueryVariables>;
export const FetchEmployeeImportTransformationsDocument = gql`
    query fetchEmployeeImportTransformations {
  employeeImportTransformations {
    id
    name
    transformType
    definition
    targetCoreField
    targetAttributeId
    targetAttributeName
  }
}
    `;

/**
 * __useFetchEmployeeImportTransformationsQuery__
 *
 * To run a query within a React component, call `useFetchEmployeeImportTransformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeeImportTransformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeeImportTransformationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchEmployeeImportTransformationsQuery(baseOptions?: Apollo.QueryHookOptions<FetchEmployeeImportTransformationsQuery, FetchEmployeeImportTransformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeeImportTransformationsQuery, FetchEmployeeImportTransformationsQueryVariables>(FetchEmployeeImportTransformationsDocument, options);
      }
export function useFetchEmployeeImportTransformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeeImportTransformationsQuery, FetchEmployeeImportTransformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeeImportTransformationsQuery, FetchEmployeeImportTransformationsQueryVariables>(FetchEmployeeImportTransformationsDocument, options);
        }
export type FetchEmployeeImportTransformationsQueryHookResult = ReturnType<typeof useFetchEmployeeImportTransformationsQuery>;
export type FetchEmployeeImportTransformationsLazyQueryHookResult = ReturnType<typeof useFetchEmployeeImportTransformationsLazyQuery>;
export type FetchEmployeeImportTransformationsQueryResult = Apollo.QueryResult<FetchEmployeeImportTransformationsQuery, FetchEmployeeImportTransformationsQueryVariables>;
export const FetchEmployeesDocument = gql`
    query fetchEmployees($companyId: Int, $surveyTypeId: Int, $attributes: [AttributeValuesSearchInput], $enabled: Boolean, $search: String, $batchSearch: String, $limit: Int, $offset: Int, $employeeIds: [Int]) {
  employeeDetails(
    employeeDetailsInput: {companyId: $companyId, surveyTypeId: $surveyTypeId, attributes: $attributes, enabledEmployee: $enabled, search: $search, batchSearch: $batchSearch, limit: $limit, offset: $offset, employeeIds: $employeeIds}
  ) {
    results {
      id
      languageId
      enabled
      employeeId
      firstName
      lastName
      email
      isUser
      attributes {
        id
        value
      }
    }
    count
  }
}
    `;

/**
 * __useFetchEmployeesQuery__
 *
 * To run a query within a React component, call `useFetchEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyTypeId: // value for 'surveyTypeId'
 *      attributes: // value for 'attributes'
 *      enabled: // value for 'enabled'
 *      search: // value for 'search'
 *      batchSearch: // value for 'batchSearch'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useFetchEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<FetchEmployeesQuery, FetchEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeesQuery, FetchEmployeesQueryVariables>(FetchEmployeesDocument, options);
      }
export function useFetchEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeesQuery, FetchEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeesQuery, FetchEmployeesQueryVariables>(FetchEmployeesDocument, options);
        }
export type FetchEmployeesQueryHookResult = ReturnType<typeof useFetchEmployeesQuery>;
export type FetchEmployeesLazyQueryHookResult = ReturnType<typeof useFetchEmployeesLazyQuery>;
export type FetchEmployeesQueryResult = Apollo.QueryResult<FetchEmployeesQuery, FetchEmployeesQueryVariables>;
export const FetchEmployeesWithoutAttributesDocument = gql`
    query fetchEmployeesWithoutAttributes($companyId: Int, $surveyTypeId: Int, $attributes: [AttributeValuesSearchInput], $enabled: Boolean, $search: String, $batchSearch: String, $limit: Int, $offset: Int, $employeeIds: [Int]) {
  employeeDetails(
    employeeDetailsInput: {companyId: $companyId, surveyTypeId: $surveyTypeId, attributes: $attributes, enabledEmployee: $enabled, search: $search, batchSearch: $batchSearch, limit: $limit, offset: $offset, employeeIds: $employeeIds, includeDummyEmployees: true}
  ) {
    results {
      id
      enabled
      employeeId
      firstName
      lastName
      email
      languageId
      isPrimaryEmployee
    }
    count
  }
}
    `;

/**
 * __useFetchEmployeesWithoutAttributesQuery__
 *
 * To run a query within a React component, call `useFetchEmployeesWithoutAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchEmployeesWithoutAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchEmployeesWithoutAttributesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyTypeId: // value for 'surveyTypeId'
 *      attributes: // value for 'attributes'
 *      enabled: // value for 'enabled'
 *      search: // value for 'search'
 *      batchSearch: // value for 'batchSearch'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useFetchEmployeesWithoutAttributesQuery(baseOptions?: Apollo.QueryHookOptions<FetchEmployeesWithoutAttributesQuery, FetchEmployeesWithoutAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchEmployeesWithoutAttributesQuery, FetchEmployeesWithoutAttributesQueryVariables>(FetchEmployeesWithoutAttributesDocument, options);
      }
export function useFetchEmployeesWithoutAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchEmployeesWithoutAttributesQuery, FetchEmployeesWithoutAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchEmployeesWithoutAttributesQuery, FetchEmployeesWithoutAttributesQueryVariables>(FetchEmployeesWithoutAttributesDocument, options);
        }
export type FetchEmployeesWithoutAttributesQueryHookResult = ReturnType<typeof useFetchEmployeesWithoutAttributesQuery>;
export type FetchEmployeesWithoutAttributesLazyQueryHookResult = ReturnType<typeof useFetchEmployeesWithoutAttributesLazyQuery>;
export type FetchEmployeesWithoutAttributesQueryResult = Apollo.QueryResult<FetchEmployeesWithoutAttributesQuery, FetchEmployeesWithoutAttributesQueryVariables>;
export const FetchFailedSurveyMigrationTasksDocument = gql`
    query fetchFailedSurveyMigrationTasks($companyId: Int!) {
  getFailedSurveyMigrationTasks(companyId: $companyId) {
    id
    importType
    status
    companyId
    surveyId
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useFetchFailedSurveyMigrationTasksQuery__
 *
 * To run a query within a React component, call `useFetchFailedSurveyMigrationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchFailedSurveyMigrationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchFailedSurveyMigrationTasksQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchFailedSurveyMigrationTasksQuery(baseOptions: Apollo.QueryHookOptions<FetchFailedSurveyMigrationTasksQuery, FetchFailedSurveyMigrationTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchFailedSurveyMigrationTasksQuery, FetchFailedSurveyMigrationTasksQueryVariables>(FetchFailedSurveyMigrationTasksDocument, options);
      }
export function useFetchFailedSurveyMigrationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchFailedSurveyMigrationTasksQuery, FetchFailedSurveyMigrationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchFailedSurveyMigrationTasksQuery, FetchFailedSurveyMigrationTasksQueryVariables>(FetchFailedSurveyMigrationTasksDocument, options);
        }
export type FetchFailedSurveyMigrationTasksQueryHookResult = ReturnType<typeof useFetchFailedSurveyMigrationTasksQuery>;
export type FetchFailedSurveyMigrationTasksLazyQueryHookResult = ReturnType<typeof useFetchFailedSurveyMigrationTasksLazyQuery>;
export type FetchFailedSurveyMigrationTasksQueryResult = Apollo.QueryResult<FetchFailedSurveyMigrationTasksQuery, FetchFailedSurveyMigrationTasksQueryVariables>;
export const FetchHasCommentsSummaryDocument = gql`
    query fetchHasCommentsSummary($input: CommentsSummaryInput!) {
  savedCommentsSummary(input: $input) {
    id
    surveyElementId
    languageId
    overallSummary
    positiveSummary
    negativeSummary
    recommendations
    created
  }
}
    `;

/**
 * __useFetchHasCommentsSummaryQuery__
 *
 * To run a query within a React component, call `useFetchHasCommentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchHasCommentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchHasCommentsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchHasCommentsSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchHasCommentsSummaryQuery, FetchHasCommentsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchHasCommentsSummaryQuery, FetchHasCommentsSummaryQueryVariables>(FetchHasCommentsSummaryDocument, options);
      }
export function useFetchHasCommentsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchHasCommentsSummaryQuery, FetchHasCommentsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchHasCommentsSummaryQuery, FetchHasCommentsSummaryQueryVariables>(FetchHasCommentsSummaryDocument, options);
        }
export type FetchHasCommentsSummaryQueryHookResult = ReturnType<typeof useFetchHasCommentsSummaryQuery>;
export type FetchHasCommentsSummaryLazyQueryHookResult = ReturnType<typeof useFetchHasCommentsSummaryLazyQuery>;
export type FetchHasCommentsSummaryQueryResult = Apollo.QueryResult<FetchHasCommentsSummaryQuery, FetchHasCommentsSummaryQueryVariables>;
export const FetchMappedQuestionsForBenchmarkQuestionDocument = gql`
    query fetchMappedQuestionsForBenchmarkQuestion($benchmarkQuestionId: Int!) {
  findMappedQuestionsForBenchmarkQuestion(
    benchmarkQuestionId: $benchmarkQuestionId
  ) {
    questionId
    questionText
    surveyCount
    surveyYears
    companyIds
  }
}
    `;

/**
 * __useFetchMappedQuestionsForBenchmarkQuestionQuery__
 *
 * To run a query within a React component, call `useFetchMappedQuestionsForBenchmarkQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMappedQuestionsForBenchmarkQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMappedQuestionsForBenchmarkQuestionQuery({
 *   variables: {
 *      benchmarkQuestionId: // value for 'benchmarkQuestionId'
 *   },
 * });
 */
export function useFetchMappedQuestionsForBenchmarkQuestionQuery(baseOptions: Apollo.QueryHookOptions<FetchMappedQuestionsForBenchmarkQuestionQuery, FetchMappedQuestionsForBenchmarkQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMappedQuestionsForBenchmarkQuestionQuery, FetchMappedQuestionsForBenchmarkQuestionQueryVariables>(FetchMappedQuestionsForBenchmarkQuestionDocument, options);
      }
export function useFetchMappedQuestionsForBenchmarkQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMappedQuestionsForBenchmarkQuestionQuery, FetchMappedQuestionsForBenchmarkQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMappedQuestionsForBenchmarkQuestionQuery, FetchMappedQuestionsForBenchmarkQuestionQueryVariables>(FetchMappedQuestionsForBenchmarkQuestionDocument, options);
        }
export type FetchMappedQuestionsForBenchmarkQuestionQueryHookResult = ReturnType<typeof useFetchMappedQuestionsForBenchmarkQuestionQuery>;
export type FetchMappedQuestionsForBenchmarkQuestionLazyQueryHookResult = ReturnType<typeof useFetchMappedQuestionsForBenchmarkQuestionLazyQuery>;
export type FetchMappedQuestionsForBenchmarkQuestionQueryResult = Apollo.QueryResult<FetchMappedQuestionsForBenchmarkQuestionQuery, FetchMappedQuestionsForBenchmarkQuestionQueryVariables>;
export const FetchOpenSurveyAttributesDocument = gql`
    query FetchOpenSurveyAttributes($surveyId: Int!) {
  openSurveyAttributes(surveyId: $surveyId) {
    id
    surveyElementId
    sourceAttributeId
    name
  }
}
    `;

/**
 * __useFetchOpenSurveyAttributesQuery__
 *
 * To run a query within a React component, call `useFetchOpenSurveyAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOpenSurveyAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOpenSurveyAttributesQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useFetchOpenSurveyAttributesQuery(baseOptions: Apollo.QueryHookOptions<FetchOpenSurveyAttributesQuery, FetchOpenSurveyAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOpenSurveyAttributesQuery, FetchOpenSurveyAttributesQueryVariables>(FetchOpenSurveyAttributesDocument, options);
      }
export function useFetchOpenSurveyAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOpenSurveyAttributesQuery, FetchOpenSurveyAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOpenSurveyAttributesQuery, FetchOpenSurveyAttributesQueryVariables>(FetchOpenSurveyAttributesDocument, options);
        }
export type FetchOpenSurveyAttributesQueryHookResult = ReturnType<typeof useFetchOpenSurveyAttributesQuery>;
export type FetchOpenSurveyAttributesLazyQueryHookResult = ReturnType<typeof useFetchOpenSurveyAttributesLazyQuery>;
export type FetchOpenSurveyAttributesQueryResult = Apollo.QueryResult<FetchOpenSurveyAttributesQuery, FetchOpenSurveyAttributesQueryVariables>;
export const FetchOpenSurveyDeviceCountDocument = gql`
    query fetchOpenSurveyDeviceCount($surveyId: Int!) {
  openSurveyDeviceCount(surveyId: $surveyId) {
    responseCount
    deviceCount
  }
}
    `;

/**
 * __useFetchOpenSurveyDeviceCountQuery__
 *
 * To run a query within a React component, call `useFetchOpenSurveyDeviceCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOpenSurveyDeviceCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOpenSurveyDeviceCountQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useFetchOpenSurveyDeviceCountQuery(baseOptions: Apollo.QueryHookOptions<FetchOpenSurveyDeviceCountQuery, FetchOpenSurveyDeviceCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchOpenSurveyDeviceCountQuery, FetchOpenSurveyDeviceCountQueryVariables>(FetchOpenSurveyDeviceCountDocument, options);
      }
export function useFetchOpenSurveyDeviceCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchOpenSurveyDeviceCountQuery, FetchOpenSurveyDeviceCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchOpenSurveyDeviceCountQuery, FetchOpenSurveyDeviceCountQueryVariables>(FetchOpenSurveyDeviceCountDocument, options);
        }
export type FetchOpenSurveyDeviceCountQueryHookResult = ReturnType<typeof useFetchOpenSurveyDeviceCountQuery>;
export type FetchOpenSurveyDeviceCountLazyQueryHookResult = ReturnType<typeof useFetchOpenSurveyDeviceCountLazyQuery>;
export type FetchOpenSurveyDeviceCountQueryResult = Apollo.QueryResult<FetchOpenSurveyDeviceCountQuery, FetchOpenSurveyDeviceCountQueryVariables>;
export const FetchQuestionResultsDocument = gql`
    query fetchQuestionResults($attributes: [AttributeWithValuesSearchInput], $companyIds: [Int]!, $surveyIds: [Int]!, $languageId: Int!, $isHierarchyReport: Boolean, $managerReportIds: [String!], $selectedTimeframe: TimeframeInput) {
  overallSurveyResults(
    attributes: $attributes
    companyIds: $companyIds
    surveyIds: $surveyIds
    languageId: $languageId
    isHierarchyReport: $isHierarchyReport
    managerReportIds: $managerReportIds
    selectedTimeframe: $selectedTimeframe
  ) {
    id
    surveyElementId
    type
    text
    totalAnswered
    totalRespondents
    numberOfComments
    iconPath
    minRating
    maxRating
    average
    ratings {
      rating
      totalAnswered
      numberOfComments
      percentage
    }
    options {
      id
      text
      totalAnswered
      numberOfComments
      percentage
    }
    aggregatedCommentSentiments {
      numberOfPositiveComments
      numberOfNeutralComments
      numberOfNegativeComments
      numberOfUnknownComments
    }
  }
}
    `;

/**
 * __useFetchQuestionResultsQuery__
 *
 * To run a query within a React component, call `useFetchQuestionResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchQuestionResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchQuestionResultsQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      companyIds: // value for 'companyIds'
 *      surveyIds: // value for 'surveyIds'
 *      languageId: // value for 'languageId'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      managerReportIds: // value for 'managerReportIds'
 *      selectedTimeframe: // value for 'selectedTimeframe'
 *   },
 * });
 */
export function useFetchQuestionResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchQuestionResultsQuery, FetchQuestionResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchQuestionResultsQuery, FetchQuestionResultsQueryVariables>(FetchQuestionResultsDocument, options);
      }
export function useFetchQuestionResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchQuestionResultsQuery, FetchQuestionResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchQuestionResultsQuery, FetchQuestionResultsQueryVariables>(FetchQuestionResultsDocument, options);
        }
export type FetchQuestionResultsQueryHookResult = ReturnType<typeof useFetchQuestionResultsQuery>;
export type FetchQuestionResultsLazyQueryHookResult = ReturnType<typeof useFetchQuestionResultsLazyQuery>;
export type FetchQuestionResultsQueryResult = Apollo.QueryResult<FetchQuestionResultsQuery, FetchQuestionResultsQueryVariables>;
export const QuestionScaleRatingResponsesDocument = gql`
    query questionScaleRatingResponses($attributes: [AttributeWithValuesSearchInput], $companyIds: [Int]!, $surveyIds: [Int]!, $languageId: Int!, $factorIds: [Int], $questionIds: [Int], $inputAttributeIds: [Int], $isHierarchyReport: Boolean, $managerReportIds: [String], $requestManagerHierarchyData: Boolean, $includeYesNoQuestion: Boolean) {
  questionScaleRatingResponses(
    attributes: $attributes
    companyIds: $companyIds
    surveyIds: $surveyIds
    languageId: $languageId
    factorIds: $factorIds
    questionIds: $questionIds
    inputAttributeIds: $inputAttributeIds
    isHierarchyReport: $isHierarchyReport
    managerReportIds: $managerReportIds
    requestManagerHierarchyData: $requestManagerHierarchyData
    includeYesNoQuestion: $includeYesNoQuestion
  ) {
    factors {
      questions {
        id
        surveyElementId
        anonymized
        attributes {
          id
          count
          anonymized
          values {
            id
            label
            anonymized
            responseRates {
              count {
                rating
                value
              }
              percentage {
                rating
                value
              }
            }
          }
        }
      }
    }
    keyFactors {
      questions {
        id
        surveyElementId
        anonymized
        attributes {
          id
          count
          anonymized
          values {
            id
            label
            anonymized
            responseRates {
              count {
                rating
                value
              }
              percentage {
                rating
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuestionScaleRatingResponsesQuery__
 *
 * To run a query within a React component, call `useQuestionScaleRatingResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionScaleRatingResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionScaleRatingResponsesQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      companyIds: // value for 'companyIds'
 *      surveyIds: // value for 'surveyIds'
 *      languageId: // value for 'languageId'
 *      factorIds: // value for 'factorIds'
 *      questionIds: // value for 'questionIds'
 *      inputAttributeIds: // value for 'inputAttributeIds'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      managerReportIds: // value for 'managerReportIds'
 *      requestManagerHierarchyData: // value for 'requestManagerHierarchyData'
 *      includeYesNoQuestion: // value for 'includeYesNoQuestion'
 *   },
 * });
 */
export function useQuestionScaleRatingResponsesQuery(baseOptions: Apollo.QueryHookOptions<QuestionScaleRatingResponsesQuery, QuestionScaleRatingResponsesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionScaleRatingResponsesQuery, QuestionScaleRatingResponsesQueryVariables>(QuestionScaleRatingResponsesDocument, options);
      }
export function useQuestionScaleRatingResponsesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionScaleRatingResponsesQuery, QuestionScaleRatingResponsesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionScaleRatingResponsesQuery, QuestionScaleRatingResponsesQueryVariables>(QuestionScaleRatingResponsesDocument, options);
        }
export type QuestionScaleRatingResponsesQueryHookResult = ReturnType<typeof useQuestionScaleRatingResponsesQuery>;
export type QuestionScaleRatingResponsesLazyQueryHookResult = ReturnType<typeof useQuestionScaleRatingResponsesLazyQuery>;
export type QuestionScaleRatingResponsesQueryResult = Apollo.QueryResult<QuestionScaleRatingResponsesQuery, QuestionScaleRatingResponsesQueryVariables>;
export const FetchSavedCommentsSummaryDocument = gql`
    query fetchSavedCommentsSummary($input: CommentsSummaryInput!) {
  savedCommentsSummary(input: $input) {
    id
    surveyElementId
    languageId
    overallSummary
    positiveSummary
    negativeSummary
    recommendations
    created
  }
}
    `;

/**
 * __useFetchSavedCommentsSummaryQuery__
 *
 * To run a query within a React component, call `useFetchSavedCommentsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSavedCommentsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSavedCommentsSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchSavedCommentsSummaryQuery(baseOptions: Apollo.QueryHookOptions<FetchSavedCommentsSummaryQuery, FetchSavedCommentsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSavedCommentsSummaryQuery, FetchSavedCommentsSummaryQueryVariables>(FetchSavedCommentsSummaryDocument, options);
      }
export function useFetchSavedCommentsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSavedCommentsSummaryQuery, FetchSavedCommentsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSavedCommentsSummaryQuery, FetchSavedCommentsSummaryQueryVariables>(FetchSavedCommentsSummaryDocument, options);
        }
export type FetchSavedCommentsSummaryQueryHookResult = ReturnType<typeof useFetchSavedCommentsSummaryQuery>;
export type FetchSavedCommentsSummaryLazyQueryHookResult = ReturnType<typeof useFetchSavedCommentsSummaryLazyQuery>;
export type FetchSavedCommentsSummaryQueryResult = Apollo.QueryResult<FetchSavedCommentsSummaryQuery, FetchSavedCommentsSummaryQueryVariables>;
export const FetchSelectableBenchmarkValuesDocument = gql`
    query fetchSelectableBenchmarkValues($surveyId: Int!, $benchmarkPeriod: String!) {
  findSelectableBenchmarkValues(
    surveyId: $surveyId
    benchmarkPeriod: $benchmarkPeriod
  ) {
    benchmarkAttributeId
    benchmarkAttributeName
    translationKey
    values {
      valueId
      valueName
    }
  }
}
    `;

/**
 * __useFetchSelectableBenchmarkValuesQuery__
 *
 * To run a query within a React component, call `useFetchSelectableBenchmarkValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSelectableBenchmarkValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSelectableBenchmarkValuesQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      benchmarkPeriod: // value for 'benchmarkPeriod'
 *   },
 * });
 */
export function useFetchSelectableBenchmarkValuesQuery(baseOptions: Apollo.QueryHookOptions<FetchSelectableBenchmarkValuesQuery, FetchSelectableBenchmarkValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSelectableBenchmarkValuesQuery, FetchSelectableBenchmarkValuesQueryVariables>(FetchSelectableBenchmarkValuesDocument, options);
      }
export function useFetchSelectableBenchmarkValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSelectableBenchmarkValuesQuery, FetchSelectableBenchmarkValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSelectableBenchmarkValuesQuery, FetchSelectableBenchmarkValuesQueryVariables>(FetchSelectableBenchmarkValuesDocument, options);
        }
export type FetchSelectableBenchmarkValuesQueryHookResult = ReturnType<typeof useFetchSelectableBenchmarkValuesQuery>;
export type FetchSelectableBenchmarkValuesLazyQueryHookResult = ReturnType<typeof useFetchSelectableBenchmarkValuesLazyQuery>;
export type FetchSelectableBenchmarkValuesQueryResult = Apollo.QueryResult<FetchSelectableBenchmarkValuesQuery, FetchSelectableBenchmarkValuesQueryVariables>;
export const FetchSendingEmailAddressesDocument = gql`
    query fetchSendingEmailAddresses($id: Int!) {
  getCompanyConfigDetails(id: $id) {
    id
    sendingDomains {
      domain
      sendingEmailAddress {
        id
        localPart
      }
    }
  }
}
    `;

/**
 * __useFetchSendingEmailAddressesQuery__
 *
 * To run a query within a React component, call `useFetchSendingEmailAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSendingEmailAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSendingEmailAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSendingEmailAddressesQuery(baseOptions: Apollo.QueryHookOptions<FetchSendingEmailAddressesQuery, FetchSendingEmailAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSendingEmailAddressesQuery, FetchSendingEmailAddressesQueryVariables>(FetchSendingEmailAddressesDocument, options);
      }
export function useFetchSendingEmailAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSendingEmailAddressesQuery, FetchSendingEmailAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSendingEmailAddressesQuery, FetchSendingEmailAddressesQueryVariables>(FetchSendingEmailAddressesDocument, options);
        }
export type FetchSendingEmailAddressesQueryHookResult = ReturnType<typeof useFetchSendingEmailAddressesQuery>;
export type FetchSendingEmailAddressesLazyQueryHookResult = ReturnType<typeof useFetchSendingEmailAddressesLazyQuery>;
export type FetchSendingEmailAddressesQueryResult = Apollo.QueryResult<FetchSendingEmailAddressesQuery, FetchSendingEmailAddressesQueryVariables>;
export const FetchSmsDoNotContactListDocument = gql`
    query fetchSmsDoNotContactList($employeeName: String, $limit: Int, $offset: Int) {
  employeeChannelDoNotContactList(
    filter: {channel: SMS, employeeName: $employeeName}
    limit: $limit
    offset: $offset
  ) {
    total
    entries {
      employeeId
      firstName
      lastName
      email
      channel
      reason
      addedAtTimeUTC
      addedByUser {
        userId
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useFetchSmsDoNotContactListQuery__
 *
 * To run a query within a React component, call `useFetchSmsDoNotContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSmsDoNotContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSmsDoNotContactListQuery({
 *   variables: {
 *      employeeName: // value for 'employeeName'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFetchSmsDoNotContactListQuery(baseOptions?: Apollo.QueryHookOptions<FetchSmsDoNotContactListQuery, FetchSmsDoNotContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSmsDoNotContactListQuery, FetchSmsDoNotContactListQueryVariables>(FetchSmsDoNotContactListDocument, options);
      }
export function useFetchSmsDoNotContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSmsDoNotContactListQuery, FetchSmsDoNotContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSmsDoNotContactListQuery, FetchSmsDoNotContactListQueryVariables>(FetchSmsDoNotContactListDocument, options);
        }
export type FetchSmsDoNotContactListQueryHookResult = ReturnType<typeof useFetchSmsDoNotContactListQuery>;
export type FetchSmsDoNotContactListLazyQueryHookResult = ReturnType<typeof useFetchSmsDoNotContactListLazyQuery>;
export type FetchSmsDoNotContactListQueryResult = Apollo.QueryResult<FetchSmsDoNotContactListQuery, FetchSmsDoNotContactListQueryVariables>;
export const FetchSurveyElementLanguagesDocument = gql`
    query fetchSurveyElementLanguages($surveyElementLanguagesId: Int!, $benchmarkedQuestionLanguages: Boolean) {
  surveyElementLanguages(
    id: $surveyElementLanguagesId
    benchmarkedQuestionLanguages: $benchmarkedQuestionLanguages
  ) {
    ... on SurveyElementQuestionTextLanguage {
      id
      surveyElementQuestionTextId
      languageId
      questionText
      description
      created
      updated
      deletedAt
    }
    ... on SurveyElementQuestionScaleLanguage {
      id
      surveyElementQuestionScaleId
      languageId
      questionText
      labelBefore
      labelAfter
      description
      created
      updated
      deletedAt
    }
    ... on SurveyElementQuestionOptionLanguage {
      id
      surveyElementQuestionOptionsId
      languageId
      questionText
      description
      created
      updated
      deletedAt
    }
  }
}
    `;

/**
 * __useFetchSurveyElementLanguagesQuery__
 *
 * To run a query within a React component, call `useFetchSurveyElementLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyElementLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyElementLanguagesQuery({
 *   variables: {
 *      surveyElementLanguagesId: // value for 'surveyElementLanguagesId'
 *      benchmarkedQuestionLanguages: // value for 'benchmarkedQuestionLanguages'
 *   },
 * });
 */
export function useFetchSurveyElementLanguagesQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyElementLanguagesQuery, FetchSurveyElementLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyElementLanguagesQuery, FetchSurveyElementLanguagesQueryVariables>(FetchSurveyElementLanguagesDocument, options);
      }
export function useFetchSurveyElementLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyElementLanguagesQuery, FetchSurveyElementLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyElementLanguagesQuery, FetchSurveyElementLanguagesQueryVariables>(FetchSurveyElementLanguagesDocument, options);
        }
export type FetchSurveyElementLanguagesQueryHookResult = ReturnType<typeof useFetchSurveyElementLanguagesQuery>;
export type FetchSurveyElementLanguagesLazyQueryHookResult = ReturnType<typeof useFetchSurveyElementLanguagesLazyQuery>;
export type FetchSurveyElementLanguagesQueryResult = Apollo.QueryResult<FetchSurveyElementLanguagesQuery, FetchSurveyElementLanguagesQueryVariables>;
export const GetSurveysDocument = gql`
    query getSurveys($ids: [Int]) {
  surveys(search: {ids: $ids}) {
    id
    namesPerLanguage {
      surveyName
    }
    types {
      id
    }
    questions {
      id
      companyId
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            orderIndex
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
          }
          required
          showDescription
        }
        ... on SurveyElementMessage {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSurveysQuery__
 *
 * To run a query within a React component, call `useGetSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveysQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSurveysQuery(baseOptions?: Apollo.QueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
      }
export function useGetSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveysQuery, GetSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveysQuery, GetSurveysQueryVariables>(GetSurveysDocument, options);
        }
export type GetSurveysQueryHookResult = ReturnType<typeof useGetSurveysQuery>;
export type GetSurveysLazyQueryHookResult = ReturnType<typeof useGetSurveysLazyQuery>;
export type GetSurveysQueryResult = Apollo.QueryResult<GetSurveysQuery, GetSurveysQueryVariables>;
export const FetchSurveyListWithTimezoneDocument = gql`
    query fetchSurveyListWithTimezone($companyId: Int!) {
  dashboardSurveys(search: {}, companyId: $companyId) {
    count
    results {
      id
      surveyName
      typeId
      surveyStatusId
      startTimeUTC
      supportLanguages
      timezoneId
    }
  }
}
    `;

/**
 * __useFetchSurveyListWithTimezoneQuery__
 *
 * To run a query within a React component, call `useFetchSurveyListWithTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyListWithTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyListWithTimezoneQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchSurveyListWithTimezoneQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyListWithTimezoneQuery, FetchSurveyListWithTimezoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyListWithTimezoneQuery, FetchSurveyListWithTimezoneQueryVariables>(FetchSurveyListWithTimezoneDocument, options);
      }
export function useFetchSurveyListWithTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyListWithTimezoneQuery, FetchSurveyListWithTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyListWithTimezoneQuery, FetchSurveyListWithTimezoneQueryVariables>(FetchSurveyListWithTimezoneDocument, options);
        }
export type FetchSurveyListWithTimezoneQueryHookResult = ReturnType<typeof useFetchSurveyListWithTimezoneQuery>;
export type FetchSurveyListWithTimezoneLazyQueryHookResult = ReturnType<typeof useFetchSurveyListWithTimezoneLazyQuery>;
export type FetchSurveyListWithTimezoneQueryResult = Apollo.QueryResult<FetchSurveyListWithTimezoneQuery, FetchSurveyListWithTimezoneQueryVariables>;
export const FetchSurveyMessagingChannelsDocument = gql`
    query fetchSurveyMessagingChannels($surveyId: ID!) {
  surveyMessagingChannels(surveyId: $surveyId) {
    surveyId
    channel
    enabled
    smsAttributeId
    variationKey
  }
}
    `;

/**
 * __useFetchSurveyMessagingChannelsQuery__
 *
 * To run a query within a React component, call `useFetchSurveyMessagingChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyMessagingChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyMessagingChannelsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useFetchSurveyMessagingChannelsQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyMessagingChannelsQuery, FetchSurveyMessagingChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyMessagingChannelsQuery, FetchSurveyMessagingChannelsQueryVariables>(FetchSurveyMessagingChannelsDocument, options);
      }
export function useFetchSurveyMessagingChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyMessagingChannelsQuery, FetchSurveyMessagingChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyMessagingChannelsQuery, FetchSurveyMessagingChannelsQueryVariables>(FetchSurveyMessagingChannelsDocument, options);
        }
export type FetchSurveyMessagingChannelsQueryHookResult = ReturnType<typeof useFetchSurveyMessagingChannelsQuery>;
export type FetchSurveyMessagingChannelsLazyQueryHookResult = ReturnType<typeof useFetchSurveyMessagingChannelsLazyQuery>;
export type FetchSurveyMessagingChannelsQueryResult = Apollo.QueryResult<FetchSurveyMessagingChannelsQuery, FetchSurveyMessagingChannelsQueryVariables>;
export const FetchSurveyParticipantChannelStatusesDocument = gql`
    query fetchSurveyParticipantChannelStatuses($surveyId: ID!, $employeeIds: [ID!]!) {
  surveyParticipantChannelStatuses(surveyId: $surveyId, employeeIds: $employeeIds) {
    employeeId
    channels {
      channel
      status
      lastSentAt
    }
  }
}
    `;

/**
 * __useFetchSurveyParticipantChannelStatusesQuery__
 *
 * To run a query within a React component, call `useFetchSurveyParticipantChannelStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyParticipantChannelStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyParticipantChannelStatusesQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useFetchSurveyParticipantChannelStatusesQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyParticipantChannelStatusesQuery, FetchSurveyParticipantChannelStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyParticipantChannelStatusesQuery, FetchSurveyParticipantChannelStatusesQueryVariables>(FetchSurveyParticipantChannelStatusesDocument, options);
      }
export function useFetchSurveyParticipantChannelStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyParticipantChannelStatusesQuery, FetchSurveyParticipantChannelStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyParticipantChannelStatusesQuery, FetchSurveyParticipantChannelStatusesQueryVariables>(FetchSurveyParticipantChannelStatusesDocument, options);
        }
export type FetchSurveyParticipantChannelStatusesQueryHookResult = ReturnType<typeof useFetchSurveyParticipantChannelStatusesQuery>;
export type FetchSurveyParticipantChannelStatusesLazyQueryHookResult = ReturnType<typeof useFetchSurveyParticipantChannelStatusesLazyQuery>;
export type FetchSurveyParticipantChannelStatusesQueryResult = Apollo.QueryResult<FetchSurveyParticipantChannelStatusesQuery, FetchSurveyParticipantChannelStatusesQueryVariables>;
export const FetchSurveyParticipantSmsReachabilityDocument = gql`
    query fetchSurveyParticipantSmsReachability($surveyId: ID!, $smsAttributeId: ID, $employeeIds: [ID!]) {
  surveyParticipantSmsReachability(
    surveyId: $surveyId
    smsAttributeId: $smsAttributeId
    employeeIds: $employeeIds
  ) {
    employeeId
    optedOut
    hasPhone
  }
}
    `;

/**
 * __useFetchSurveyParticipantSmsReachabilityQuery__
 *
 * To run a query within a React component, call `useFetchSurveyParticipantSmsReachabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyParticipantSmsReachabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyParticipantSmsReachabilityQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      smsAttributeId: // value for 'smsAttributeId'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useFetchSurveyParticipantSmsReachabilityQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyParticipantSmsReachabilityQuery, FetchSurveyParticipantSmsReachabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyParticipantSmsReachabilityQuery, FetchSurveyParticipantSmsReachabilityQueryVariables>(FetchSurveyParticipantSmsReachabilityDocument, options);
      }
export function useFetchSurveyParticipantSmsReachabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyParticipantSmsReachabilityQuery, FetchSurveyParticipantSmsReachabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyParticipantSmsReachabilityQuery, FetchSurveyParticipantSmsReachabilityQueryVariables>(FetchSurveyParticipantSmsReachabilityDocument, options);
        }
export type FetchSurveyParticipantSmsReachabilityQueryHookResult = ReturnType<typeof useFetchSurveyParticipantSmsReachabilityQuery>;
export type FetchSurveyParticipantSmsReachabilityLazyQueryHookResult = ReturnType<typeof useFetchSurveyParticipantSmsReachabilityLazyQuery>;
export type FetchSurveyParticipantSmsReachabilityQueryResult = Apollo.QueryResult<FetchSurveyParticipantSmsReachabilityQuery, FetchSurveyParticipantSmsReachabilityQueryVariables>;
export const FetchSurveyTemplateDocument = gql`
    query fetchSurveyTemplate($id: Int!) {
  getSurveyTemplate(id: $id) {
    id
    names {
      name
      languageId
    }
    surveyTypeId
    audienceMode
    lifecycleSurveyTypeId
    surveyType {
      id
      name
      names {
        languageId
        name
      }
    }
    surveyElements {
      id
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
        }
        ... on SurveyElementMessage {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
        }
      }
    }
    status
    updated
    surveyTemplateLanguages {
      languageId
      emailContent
      emailSubject
    }
  }
}
    `;

/**
 * __useFetchSurveyTemplateQuery__
 *
 * To run a query within a React component, call `useFetchSurveyTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSurveyTemplateQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyTemplateQuery, FetchSurveyTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyTemplateQuery, FetchSurveyTemplateQueryVariables>(FetchSurveyTemplateDocument, options);
      }
export function useFetchSurveyTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyTemplateQuery, FetchSurveyTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyTemplateQuery, FetchSurveyTemplateQueryVariables>(FetchSurveyTemplateDocument, options);
        }
export type FetchSurveyTemplateQueryHookResult = ReturnType<typeof useFetchSurveyTemplateQuery>;
export type FetchSurveyTemplateLazyQueryHookResult = ReturnType<typeof useFetchSurveyTemplateLazyQuery>;
export type FetchSurveyTemplateQueryResult = Apollo.QueryResult<FetchSurveyTemplateQuery, FetchSurveyTemplateQueryVariables>;
export const FetchSurveyTemplateElementsDocument = gql`
    query fetchSurveyTemplateElements($id: Int!) {
  getSurveyTemplate(id: $id) {
    id
    audienceMode
    lifecycleSurveyTypeId
    surveyElements {
      id
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      isFilterable
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
              language {
                id
                langISOCode
              }
            }
          }
          required
          showDescription
          choices {
            id
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
              language {
                id
                langISOCode
              }
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
              language {
                id
                langISOCode
              }
            }
          }
          required
          showDescription
        }
        ... on SurveyElementMessage {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchSurveyTemplateElementsQuery__
 *
 * To run a query within a React component, call `useFetchSurveyTemplateElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyTemplateElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyTemplateElementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSurveyTemplateElementsQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyTemplateElementsQuery, FetchSurveyTemplateElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyTemplateElementsQuery, FetchSurveyTemplateElementsQueryVariables>(FetchSurveyTemplateElementsDocument, options);
      }
export function useFetchSurveyTemplateElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyTemplateElementsQuery, FetchSurveyTemplateElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyTemplateElementsQuery, FetchSurveyTemplateElementsQueryVariables>(FetchSurveyTemplateElementsDocument, options);
        }
export type FetchSurveyTemplateElementsQueryHookResult = ReturnType<typeof useFetchSurveyTemplateElementsQuery>;
export type FetchSurveyTemplateElementsLazyQueryHookResult = ReturnType<typeof useFetchSurveyTemplateElementsLazyQuery>;
export type FetchSurveyTemplateElementsQueryResult = Apollo.QueryResult<FetchSurveyTemplateElementsQuery, FetchSurveyTemplateElementsQueryVariables>;
export const FetchSurveyTemplatesDocument = gql`
    query fetchSurveyTemplates($filterOptions: InputSurveyTemplateFilters) {
  getSurveyTemplates(filterOptions: $filterOptions) {
    names {
      languageId
      name
    }
    id
    status
    updated
    surveyTypeId
    audienceMode
    lifecycleSurveyTypeId
    surveyType {
      id
      name
      names {
        languageId
        name
      }
    }
    surveyTemplateLanguages {
      emailContent
      emailSubject
      languageId
    }
  }
}
    `;

/**
 * __useFetchSurveyTemplatesQuery__
 *
 * To run a query within a React component, call `useFetchSurveyTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyTemplatesQuery({
 *   variables: {
 *      filterOptions: // value for 'filterOptions'
 *   },
 * });
 */
export function useFetchSurveyTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<FetchSurveyTemplatesQuery, FetchSurveyTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyTemplatesQuery, FetchSurveyTemplatesQueryVariables>(FetchSurveyTemplatesDocument, options);
      }
export function useFetchSurveyTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyTemplatesQuery, FetchSurveyTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyTemplatesQuery, FetchSurveyTemplatesQueryVariables>(FetchSurveyTemplatesDocument, options);
        }
export type FetchSurveyTemplatesQueryHookResult = ReturnType<typeof useFetchSurveyTemplatesQuery>;
export type FetchSurveyTemplatesLazyQueryHookResult = ReturnType<typeof useFetchSurveyTemplatesLazyQuery>;
export type FetchSurveyTemplatesQueryResult = Apollo.QueryResult<FetchSurveyTemplatesQuery, FetchSurveyTemplatesQueryVariables>;
export const GetSurveyTypeAttributesDocument = gql`
    query getSurveyTypeAttributes($companyId: Int!, $surveyTypeId: Int!, $includePrivateAttributes: Boolean) {
  surveyTypeAttributes(
    companyId: $companyId
    surveyTypeId: $surveyTypeId
    includePrivateAttributes: $includePrivateAttributes
  ) {
    id
    baseAttributeId
    companyId
    type {
      id
      name
    }
    attributeNames {
      id
      name
    }
  }
}
    `;

/**
 * __useGetSurveyTypeAttributesQuery__
 *
 * To run a query within a React component, call `useGetSurveyTypeAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyTypeAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyTypeAttributesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyTypeId: // value for 'surveyTypeId'
 *      includePrivateAttributes: // value for 'includePrivateAttributes'
 *   },
 * });
 */
export function useGetSurveyTypeAttributesQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyTypeAttributesQuery, GetSurveyTypeAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyTypeAttributesQuery, GetSurveyTypeAttributesQueryVariables>(GetSurveyTypeAttributesDocument, options);
      }
export function useGetSurveyTypeAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyTypeAttributesQuery, GetSurveyTypeAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyTypeAttributesQuery, GetSurveyTypeAttributesQueryVariables>(GetSurveyTypeAttributesDocument, options);
        }
export type GetSurveyTypeAttributesQueryHookResult = ReturnType<typeof useGetSurveyTypeAttributesQuery>;
export type GetSurveyTypeAttributesLazyQueryHookResult = ReturnType<typeof useGetSurveyTypeAttributesLazyQuery>;
export type GetSurveyTypeAttributesQueryResult = Apollo.QueryResult<GetSurveyTypeAttributesQuery, GetSurveyTypeAttributesQueryVariables>;
export const FetchSurveyTypesWithCategoriesDocument = gql`
    query fetchSurveyTypesWithCategories($companyId: Int!, $languageIds: [Int]!, $includeBase: Boolean) {
  companySurveyTypes(
    companyId: $companyId
    languageIds: $languageIds
    includeBase: $includeBase
  ) {
    id
    threshold
    names {
      name
    }
    categories {
      categoryId
      names {
        name
      }
      isKeyFactor
      isBaseCategory
    }
  }
}
    `;

/**
 * __useFetchSurveyTypesWithCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchSurveyTypesWithCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyTypesWithCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyTypesWithCategoriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      languageIds: // value for 'languageIds'
 *      includeBase: // value for 'includeBase'
 *   },
 * });
 */
export function useFetchSurveyTypesWithCategoriesQuery(baseOptions: Apollo.QueryHookOptions<FetchSurveyTypesWithCategoriesQuery, FetchSurveyTypesWithCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyTypesWithCategoriesQuery, FetchSurveyTypesWithCategoriesQueryVariables>(FetchSurveyTypesWithCategoriesDocument, options);
      }
export function useFetchSurveyTypesWithCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyTypesWithCategoriesQuery, FetchSurveyTypesWithCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyTypesWithCategoriesQuery, FetchSurveyTypesWithCategoriesQueryVariables>(FetchSurveyTypesWithCategoriesDocument, options);
        }
export type FetchSurveyTypesWithCategoriesQueryHookResult = ReturnType<typeof useFetchSurveyTypesWithCategoriesQuery>;
export type FetchSurveyTypesWithCategoriesLazyQueryHookResult = ReturnType<typeof useFetchSurveyTypesWithCategoriesLazyQuery>;
export type FetchSurveyTypesWithCategoriesQueryResult = Apollo.QueryResult<FetchSurveyTypesWithCategoriesQuery, FetchSurveyTypesWithCategoriesQueryVariables>;
export const FetchSurveyWithSurveyElementsDocument = gql`
    query fetchSurveyWithSurveyElements($id: Int) {
  survey(id: $id) {
    id
    hashCode
    showResults
    status {
      id
      name
    }
    anonymousConversation
    namesPerLanguage {
      language {
        id
        langISOCode
      }
      surveyName
      emailSubject
      emailBody
    }
    sendingEmailAddress {
      id
    }
    timezone {
      id
      timezone
    }
    employees {
      id
      surveyInviteDate
      addedDate
    }
    fromEmailName
    startTimeUTC
    endTimeUTC
    combineLanguages
    types {
      id
    }
    questions {
      id
      companyId
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      isFilterable
      attributes {
        attributeId
        attributeValue
      }
      discontinuedDateUTC(surveyId: $id)
      addedDateUTC(surveyId: $id)
      isDiscontinued(surveyId: $id)
      question {
        ... on SurveyElementQuestionOptions {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            orderIndex
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
          }
          required
          showDescription
        }
        ... on SurveyElementMessage {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
        }
      }
    }
    disableEmailSending
    isContinuous
    audienceMode
    openSurveyUuid
    openSurveyAccessCode
    invitationExpiryIn
    lifecycleSurveyTypeId
    audienceMode
    companyEmployeeIdsInSurvey
  }
}
    `;

/**
 * __useFetchSurveyWithSurveyElementsQuery__
 *
 * To run a query within a React component, call `useFetchSurveyWithSurveyElementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveyWithSurveyElementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveyWithSurveyElementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchSurveyWithSurveyElementsQuery(baseOptions?: Apollo.QueryHookOptions<FetchSurveyWithSurveyElementsQuery, FetchSurveyWithSurveyElementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveyWithSurveyElementsQuery, FetchSurveyWithSurveyElementsQueryVariables>(FetchSurveyWithSurveyElementsDocument, options);
      }
export function useFetchSurveyWithSurveyElementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveyWithSurveyElementsQuery, FetchSurveyWithSurveyElementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveyWithSurveyElementsQuery, FetchSurveyWithSurveyElementsQueryVariables>(FetchSurveyWithSurveyElementsDocument, options);
        }
export type FetchSurveyWithSurveyElementsQueryHookResult = ReturnType<typeof useFetchSurveyWithSurveyElementsQuery>;
export type FetchSurveyWithSurveyElementsLazyQueryHookResult = ReturnType<typeof useFetchSurveyWithSurveyElementsLazyQuery>;
export type FetchSurveyWithSurveyElementsQueryResult = Apollo.QueryResult<FetchSurveyWithSurveyElementsQuery, FetchSurveyWithSurveyElementsQueryVariables>;
export const FetchSurveysStatusesDocument = gql`
    query fetchSurveysStatuses($surveyIds: [Int]) {
  surveys(search: {ids: $surveyIds}) {
    id
    status {
      id
      name
    }
  }
}
    `;

/**
 * __useFetchSurveysStatusesQuery__
 *
 * To run a query within a React component, call `useFetchSurveysStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSurveysStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSurveysStatusesQuery({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *   },
 * });
 */
export function useFetchSurveysStatusesQuery(baseOptions?: Apollo.QueryHookOptions<FetchSurveysStatusesQuery, FetchSurveysStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSurveysStatusesQuery, FetchSurveysStatusesQueryVariables>(FetchSurveysStatusesDocument, options);
      }
export function useFetchSurveysStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSurveysStatusesQuery, FetchSurveysStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSurveysStatusesQuery, FetchSurveysStatusesQueryVariables>(FetchSurveysStatusesDocument, options);
        }
export type FetchSurveysStatusesQueryHookResult = ReturnType<typeof useFetchSurveysStatusesQuery>;
export type FetchSurveysStatusesLazyQueryHookResult = ReturnType<typeof useFetchSurveysStatusesLazyQuery>;
export type FetchSurveysStatusesQueryResult = Apollo.QueryResult<FetchSurveysStatusesQuery, FetchSurveysStatusesQueryVariables>;
export const FetchTimezonesDocument = gql`
    query fetchTimezones($id: Int!) {
  getCompanyConfigDetails(id: $id) {
    id
    timezones {
      id
      timezone
    }
  }
}
    `;

/**
 * __useFetchTimezonesQuery__
 *
 * To run a query within a React component, call `useFetchTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTimezonesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchTimezonesQuery(baseOptions: Apollo.QueryHookOptions<FetchTimezonesQuery, FetchTimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTimezonesQuery, FetchTimezonesQueryVariables>(FetchTimezonesDocument, options);
      }
export function useFetchTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTimezonesQuery, FetchTimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTimezonesQuery, FetchTimezonesQueryVariables>(FetchTimezonesDocument, options);
        }
export type FetchTimezonesQueryHookResult = ReturnType<typeof useFetchTimezonesQuery>;
export type FetchTimezonesLazyQueryHookResult = ReturnType<typeof useFetchTimezonesLazyQuery>;
export type FetchTimezonesQueryResult = Apollo.QueryResult<FetchTimezonesQuery, FetchTimezonesQueryVariables>;
export const FetchTrendResultsDocument = gql`
    query fetchTrendResults($attributes: [AttributeWithValuesSearchInput], $companyIds: [Int]!, $languageId: Int!, $surveyIds: [Int]!, $factorIds: [Int], $questionIds: [Int], $aggregationType: TrendsAggregationEnum!, $isHierarchyReport: Boolean, $managerReportIds: [String]) {
  trendsResult(
    factorIds: $factorIds
    questionIds: $questionIds
    aggregationType: $aggregationType
    attributes: $attributes
    companyIds: $companyIds
    languageId: $languageId
    surveyIds: $surveyIds
    isHierarchyReport: $isHierarchyReport
    managerReportIds: $managerReportIds
  ) {
    factors {
      id
      name
      datasets {
        ids
        label
        scoreAverage
        enpsScore
        percentUnfavorable
        percentNeutral
        percentFavorable
        countUnfavorable
        countNeutral
        countFavorable
        count
      }
    }
    questions {
      id
      name
      datasets {
        ids
        label
        scoreAverage
        enpsScore
        percentUnfavorable
        percentNeutral
        percentFavorable
        countUnfavorable
        countNeutral
        countFavorable
        count
      }
      factorId
      factorName
    }
  }
}
    `;

/**
 * __useFetchTrendResultsQuery__
 *
 * To run a query within a React component, call `useFetchTrendResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTrendResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTrendResultsQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      companyIds: // value for 'companyIds'
 *      languageId: // value for 'languageId'
 *      surveyIds: // value for 'surveyIds'
 *      factorIds: // value for 'factorIds'
 *      questionIds: // value for 'questionIds'
 *      aggregationType: // value for 'aggregationType'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      managerReportIds: // value for 'managerReportIds'
 *   },
 * });
 */
export function useFetchTrendResultsQuery(baseOptions: Apollo.QueryHookOptions<FetchTrendResultsQuery, FetchTrendResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTrendResultsQuery, FetchTrendResultsQueryVariables>(FetchTrendResultsDocument, options);
      }
export function useFetchTrendResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTrendResultsQuery, FetchTrendResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTrendResultsQuery, FetchTrendResultsQueryVariables>(FetchTrendResultsDocument, options);
        }
export type FetchTrendResultsQueryHookResult = ReturnType<typeof useFetchTrendResultsQuery>;
export type FetchTrendResultsLazyQueryHookResult = ReturnType<typeof useFetchTrendResultsLazyQuery>;
export type FetchTrendResultsQueryResult = Apollo.QueryResult<FetchTrendResultsQuery, FetchTrendResultsQueryVariables>;
export const FetchUnmappedAttributeValuesDocument = gql`
    query fetchUnmappedAttributeValues($benchmarkAttributeId: Int!) {
  findUnmappedAttributeValues(benchmarkAttributeId: $benchmarkAttributeId)
}
    `;

/**
 * __useFetchUnmappedAttributeValuesQuery__
 *
 * To run a query within a React component, call `useFetchUnmappedAttributeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUnmappedAttributeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUnmappedAttributeValuesQuery({
 *   variables: {
 *      benchmarkAttributeId: // value for 'benchmarkAttributeId'
 *   },
 * });
 */
export function useFetchUnmappedAttributeValuesQuery(baseOptions: Apollo.QueryHookOptions<FetchUnmappedAttributeValuesQuery, FetchUnmappedAttributeValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUnmappedAttributeValuesQuery, FetchUnmappedAttributeValuesQueryVariables>(FetchUnmappedAttributeValuesDocument, options);
      }
export function useFetchUnmappedAttributeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUnmappedAttributeValuesQuery, FetchUnmappedAttributeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUnmappedAttributeValuesQuery, FetchUnmappedAttributeValuesQueryVariables>(FetchUnmappedAttributeValuesDocument, options);
        }
export type FetchUnmappedAttributeValuesQueryHookResult = ReturnType<typeof useFetchUnmappedAttributeValuesQuery>;
export type FetchUnmappedAttributeValuesLazyQueryHookResult = ReturnType<typeof useFetchUnmappedAttributeValuesLazyQuery>;
export type FetchUnmappedAttributeValuesQueryResult = Apollo.QueryResult<FetchUnmappedAttributeValuesQuery, FetchUnmappedAttributeValuesQueryVariables>;
export const FetchUntaggedSurveyQuestionsDocument = gql`
    query fetchUntaggedSurveyQuestions($surveyQuestionInput: SurveyQuestionInput!) {
  findUntaggedSurveyQuestions(surveyQuestionInput: $surveyQuestionInput) {
    totalCount
    surveyQuestions {
      questionId
      questionText
      surveyCount
      surveyYears
      companyIds
    }
  }
}
    `;

/**
 * __useFetchUntaggedSurveyQuestionsQuery__
 *
 * To run a query within a React component, call `useFetchUntaggedSurveyQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUntaggedSurveyQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUntaggedSurveyQuestionsQuery({
 *   variables: {
 *      surveyQuestionInput: // value for 'surveyQuestionInput'
 *   },
 * });
 */
export function useFetchUntaggedSurveyQuestionsQuery(baseOptions: Apollo.QueryHookOptions<FetchUntaggedSurveyQuestionsQuery, FetchUntaggedSurveyQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUntaggedSurveyQuestionsQuery, FetchUntaggedSurveyQuestionsQueryVariables>(FetchUntaggedSurveyQuestionsDocument, options);
      }
export function useFetchUntaggedSurveyQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUntaggedSurveyQuestionsQuery, FetchUntaggedSurveyQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUntaggedSurveyQuestionsQuery, FetchUntaggedSurveyQuestionsQueryVariables>(FetchUntaggedSurveyQuestionsDocument, options);
        }
export type FetchUntaggedSurveyQuestionsQueryHookResult = ReturnType<typeof useFetchUntaggedSurveyQuestionsQuery>;
export type FetchUntaggedSurveyQuestionsLazyQueryHookResult = ReturnType<typeof useFetchUntaggedSurveyQuestionsLazyQuery>;
export type FetchUntaggedSurveyQuestionsQueryResult = Apollo.QueryResult<FetchUntaggedSurveyQuestionsQuery, FetchUntaggedSurveyQuestionsQueryVariables>;
export const FetchUntaggedSurveyQuestionsWithAllIdsDocument = gql`
    query fetchUntaggedSurveyQuestionsWithAllIds($surveyQuestionInput: SurveyQuestionInput!) {
  findUntaggedSurveyQuestions(surveyQuestionInput: $surveyQuestionInput) {
    totalCount
    surveyQuestions {
      questionId
      questionText
      surveyCount
      surveyYears
    }
    allQuestionIds
  }
}
    `;

/**
 * __useFetchUntaggedSurveyQuestionsWithAllIdsQuery__
 *
 * To run a query within a React component, call `useFetchUntaggedSurveyQuestionsWithAllIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUntaggedSurveyQuestionsWithAllIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUntaggedSurveyQuestionsWithAllIdsQuery({
 *   variables: {
 *      surveyQuestionInput: // value for 'surveyQuestionInput'
 *   },
 * });
 */
export function useFetchUntaggedSurveyQuestionsWithAllIdsQuery(baseOptions: Apollo.QueryHookOptions<FetchUntaggedSurveyQuestionsWithAllIdsQuery, FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUntaggedSurveyQuestionsWithAllIdsQuery, FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables>(FetchUntaggedSurveyQuestionsWithAllIdsDocument, options);
      }
export function useFetchUntaggedSurveyQuestionsWithAllIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUntaggedSurveyQuestionsWithAllIdsQuery, FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUntaggedSurveyQuestionsWithAllIdsQuery, FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables>(FetchUntaggedSurveyQuestionsWithAllIdsDocument, options);
        }
export type FetchUntaggedSurveyQuestionsWithAllIdsQueryHookResult = ReturnType<typeof useFetchUntaggedSurveyQuestionsWithAllIdsQuery>;
export type FetchUntaggedSurveyQuestionsWithAllIdsLazyQueryHookResult = ReturnType<typeof useFetchUntaggedSurveyQuestionsWithAllIdsLazyQuery>;
export type FetchUntaggedSurveyQuestionsWithAllIdsQueryResult = Apollo.QueryResult<FetchUntaggedSurveyQuestionsWithAllIdsQuery, FetchUntaggedSurveyQuestionsWithAllIdsQueryVariables>;
export const FetchUsersWithPermissionsDocument = gql`
    query fetchUsersWithPermissions($userIds: [Int!]!, $companyId: Int!) {
  getUsersWithPermissions(userIds: $userIds, companyId: $companyId) {
    ...userWithPermissionsFields
  }
}
    ${UserWithPermissionsFieldsFragmentDoc}`;

/**
 * __useFetchUsersWithPermissionsQuery__
 *
 * To run a query within a React component, call `useFetchUsersWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUsersWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUsersWithPermissionsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useFetchUsersWithPermissionsQuery(baseOptions: Apollo.QueryHookOptions<FetchUsersWithPermissionsQuery, FetchUsersWithPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchUsersWithPermissionsQuery, FetchUsersWithPermissionsQueryVariables>(FetchUsersWithPermissionsDocument, options);
      }
export function useFetchUsersWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUsersWithPermissionsQuery, FetchUsersWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchUsersWithPermissionsQuery, FetchUsersWithPermissionsQueryVariables>(FetchUsersWithPermissionsDocument, options);
        }
export type FetchUsersWithPermissionsQueryHookResult = ReturnType<typeof useFetchUsersWithPermissionsQuery>;
export type FetchUsersWithPermissionsLazyQueryHookResult = ReturnType<typeof useFetchUsersWithPermissionsLazyQuery>;
export type FetchUsersWithPermissionsQueryResult = Apollo.QueryResult<FetchUsersWithPermissionsQuery, FetchUsersWithPermissionsQueryVariables>;
export const FindSurveyReminderByReminderIdDocument = gql`
    query findSurveyReminderByReminderId($reminderId: Int!) {
  findSurveyReminderByReminderId(reminderId: $reminderId) {
    id
    surveyId
    scheduledDateTime
    status
    languages {
      languageId
      emailSubject
      emailBody
    }
    survey {
      id
      startTimeUTC
      endTimeUTC
      surveyStatusId
    }
    timezone {
      id
      timezone
    }
  }
}
    `;

/**
 * __useFindSurveyReminderByReminderIdQuery__
 *
 * To run a query within a React component, call `useFindSurveyReminderByReminderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyReminderByReminderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyReminderByReminderIdQuery({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *   },
 * });
 */
export function useFindSurveyReminderByReminderIdQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyReminderByReminderIdQuery, FindSurveyReminderByReminderIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyReminderByReminderIdQuery, FindSurveyReminderByReminderIdQueryVariables>(FindSurveyReminderByReminderIdDocument, options);
      }
export function useFindSurveyReminderByReminderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyReminderByReminderIdQuery, FindSurveyReminderByReminderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyReminderByReminderIdQuery, FindSurveyReminderByReminderIdQueryVariables>(FindSurveyReminderByReminderIdDocument, options);
        }
export type FindSurveyReminderByReminderIdQueryHookResult = ReturnType<typeof useFindSurveyReminderByReminderIdQuery>;
export type FindSurveyReminderByReminderIdLazyQueryHookResult = ReturnType<typeof useFindSurveyReminderByReminderIdLazyQuery>;
export type FindSurveyReminderByReminderIdQueryResult = Apollo.QueryResult<FindSurveyReminderByReminderIdQuery, FindSurveyReminderByReminderIdQueryVariables>;
export const FindSurveyReminderDetailsBySurveyIdDocument = gql`
    query findSurveyReminderDetailsBySurveyId($id: Int) {
  survey(id: $id) {
    id
    startTimeUTC
    endTimeUTC
    status {
      id
    }
    namesPerLanguage {
      language {
        id
        langISOCode
      }
      emailSubject
      emailBody
      emailReminderSubject
      emailReminderBody
    }
    timezone {
      id
      timezone
    }
  }
}
    `;

/**
 * __useFindSurveyReminderDetailsBySurveyIdQuery__
 *
 * To run a query within a React component, call `useFindSurveyReminderDetailsBySurveyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyReminderDetailsBySurveyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyReminderDetailsBySurveyIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSurveyReminderDetailsBySurveyIdQuery(baseOptions?: Apollo.QueryHookOptions<FindSurveyReminderDetailsBySurveyIdQuery, FindSurveyReminderDetailsBySurveyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyReminderDetailsBySurveyIdQuery, FindSurveyReminderDetailsBySurveyIdQueryVariables>(FindSurveyReminderDetailsBySurveyIdDocument, options);
      }
export function useFindSurveyReminderDetailsBySurveyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyReminderDetailsBySurveyIdQuery, FindSurveyReminderDetailsBySurveyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyReminderDetailsBySurveyIdQuery, FindSurveyReminderDetailsBySurveyIdQueryVariables>(FindSurveyReminderDetailsBySurveyIdDocument, options);
        }
export type FindSurveyReminderDetailsBySurveyIdQueryHookResult = ReturnType<typeof useFindSurveyReminderDetailsBySurveyIdQuery>;
export type FindSurveyReminderDetailsBySurveyIdLazyQueryHookResult = ReturnType<typeof useFindSurveyReminderDetailsBySurveyIdLazyQuery>;
export type FindSurveyReminderDetailsBySurveyIdQueryResult = Apollo.QueryResult<FindSurveyReminderDetailsBySurveyIdQuery, FindSurveyReminderDetailsBySurveyIdQueryVariables>;
export const FindSurveyRemindersBySurveyIdDocument = gql`
    query findSurveyRemindersBySurveyId($surveyId: Int!) {
  findSurveyRemindersBySurveyId(surveyId: $surveyId) {
    surveyId
    id
    scheduledDateTime
    status
    timezone {
      id
      timezone
    }
  }
}
    `;

/**
 * __useFindSurveyRemindersBySurveyIdQuery__
 *
 * To run a query within a React component, call `useFindSurveyRemindersBySurveyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyRemindersBySurveyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyRemindersBySurveyIdQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useFindSurveyRemindersBySurveyIdQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyRemindersBySurveyIdQuery, FindSurveyRemindersBySurveyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyRemindersBySurveyIdQuery, FindSurveyRemindersBySurveyIdQueryVariables>(FindSurveyRemindersBySurveyIdDocument, options);
      }
export function useFindSurveyRemindersBySurveyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyRemindersBySurveyIdQuery, FindSurveyRemindersBySurveyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyRemindersBySurveyIdQuery, FindSurveyRemindersBySurveyIdQueryVariables>(FindSurveyRemindersBySurveyIdDocument, options);
        }
export type FindSurveyRemindersBySurveyIdQueryHookResult = ReturnType<typeof useFindSurveyRemindersBySurveyIdQuery>;
export type FindSurveyRemindersBySurveyIdLazyQueryHookResult = ReturnType<typeof useFindSurveyRemindersBySurveyIdLazyQuery>;
export type FindSurveyRemindersBySurveyIdQueryResult = Apollo.QueryResult<FindSurveyRemindersBySurveyIdQuery, FindSurveyRemindersBySurveyIdQueryVariables>;
export const FindSurveysDocument = gql`
    query findSurveys($ids: [Int!]) {
  surveys(search: {ids: $ids}) {
    id
    anonymousConversation
    namesPerLanguage {
      id
      surveyName
      language {
        langISOCode
      }
    }
    types {
      id
      threshold
    }
    startTimeUTC
    isContinuous
    audienceMode
  }
}
    `;

/**
 * __useFindSurveysQuery__
 *
 * To run a query within a React component, call `useFindSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveysQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFindSurveysQuery(baseOptions?: Apollo.QueryHookOptions<FindSurveysQuery, FindSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveysQuery, FindSurveysQueryVariables>(FindSurveysDocument, options);
      }
export function useFindSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveysQuery, FindSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveysQuery, FindSurveysQueryVariables>(FindSurveysDocument, options);
        }
export type FindSurveysQueryHookResult = ReturnType<typeof useFindSurveysQuery>;
export type FindSurveysLazyQueryHookResult = ReturnType<typeof useFindSurveysLazyQuery>;
export type FindSurveysQueryResult = Apollo.QueryResult<FindSurveysQuery, FindSurveysQueryVariables>;
export const FindUsersByEmailDocument = gql`
    query findUsersByEmail($emails: [String!]!) {
  findUsersByEmail(emails: $emails) {
    email
    status
    companyName
    companyId
  }
}
    `;

/**
 * __useFindUsersByEmailQuery__
 *
 * To run a query within a React component, call `useFindUsersByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersByEmailQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useFindUsersByEmailQuery(baseOptions: Apollo.QueryHookOptions<FindUsersByEmailQuery, FindUsersByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUsersByEmailQuery, FindUsersByEmailQueryVariables>(FindUsersByEmailDocument, options);
      }
export function useFindUsersByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUsersByEmailQuery, FindUsersByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUsersByEmailQuery, FindUsersByEmailQueryVariables>(FindUsersByEmailDocument, options);
        }
export type FindUsersByEmailQueryHookResult = ReturnType<typeof useFindUsersByEmailQuery>;
export type FindUsersByEmailLazyQueryHookResult = ReturnType<typeof useFindUsersByEmailLazyQuery>;
export type FindUsersByEmailQueryResult = Apollo.QueryResult<FindUsersByEmailQuery, FindUsersByEmailQueryVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email) {
    result
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GenThemesAnalysisDocument = gql`
    mutation genThemesAnalysis($surveyIds: [Int!]!, $surveyElementId: Int!) {
  genThemesAnalysis(surveyIds: $surveyIds, surveyElementId: $surveyElementId) {
    errorMessage
    success
  }
}
    `;
export type GenThemesAnalysisMutationFn = Apollo.MutationFunction<GenThemesAnalysisMutation, GenThemesAnalysisMutationVariables>;

/**
 * __useGenThemesAnalysisMutation__
 *
 * To run a mutation, you first call `useGenThemesAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenThemesAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [genThemesAnalysisMutation, { data, loading, error }] = useGenThemesAnalysisMutation({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *      surveyElementId: // value for 'surveyElementId'
 *   },
 * });
 */
export function useGenThemesAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<GenThemesAnalysisMutation, GenThemesAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenThemesAnalysisMutation, GenThemesAnalysisMutationVariables>(GenThemesAnalysisDocument, options);
      }
export type GenThemesAnalysisMutationHookResult = ReturnType<typeof useGenThemesAnalysisMutation>;
export type GenThemesAnalysisMutationResult = Apollo.MutationResult<GenThemesAnalysisMutation>;
export type GenThemesAnalysisMutationOptions = Apollo.BaseMutationOptions<GenThemesAnalysisMutation, GenThemesAnalysisMutationVariables>;
export const GenerateCommentsSummaryDocument = gql`
    mutation generateCommentsSummary($input: CommentsSummaryInput!) {
  generateCommentsSummary(input: $input) {
    id
    surveyElementId
    languageId
    overallSummary
    positiveSummary
    negativeSummary
    recommendations
    created
  }
}
    `;
export type GenerateCommentsSummaryMutationFn = Apollo.MutationFunction<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>;

/**
 * __useGenerateCommentsSummaryMutation__
 *
 * To run a mutation, you first call `useGenerateCommentsSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCommentsSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCommentsSummaryMutation, { data, loading, error }] = useGenerateCommentsSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateCommentsSummaryMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>(GenerateCommentsSummaryDocument, options);
      }
export type GenerateCommentsSummaryMutationHookResult = ReturnType<typeof useGenerateCommentsSummaryMutation>;
export type GenerateCommentsSummaryMutationResult = Apollo.MutationResult<GenerateCommentsSummaryMutation>;
export type GenerateCommentsSummaryMutationOptions = Apollo.BaseMutationOptions<GenerateCommentsSummaryMutation, GenerateCommentsSummaryMutationVariables>;
export const GenerateOpenSurveyAccessCodeDocument = gql`
    mutation generateOpenSurveyAccessCode($surveyId: Int!) {
  generateOpenSurveyAccessCode(surveyId: $surveyId) {
    id
    openSurveyAccessCode
  }
}
    `;
export type GenerateOpenSurveyAccessCodeMutationFn = Apollo.MutationFunction<GenerateOpenSurveyAccessCodeMutation, GenerateOpenSurveyAccessCodeMutationVariables>;

/**
 * __useGenerateOpenSurveyAccessCodeMutation__
 *
 * To run a mutation, you first call `useGenerateOpenSurveyAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpenSurveyAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpenSurveyAccessCodeMutation, { data, loading, error }] = useGenerateOpenSurveyAccessCodeMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGenerateOpenSurveyAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpenSurveyAccessCodeMutation, GenerateOpenSurveyAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpenSurveyAccessCodeMutation, GenerateOpenSurveyAccessCodeMutationVariables>(GenerateOpenSurveyAccessCodeDocument, options);
      }
export type GenerateOpenSurveyAccessCodeMutationHookResult = ReturnType<typeof useGenerateOpenSurveyAccessCodeMutation>;
export type GenerateOpenSurveyAccessCodeMutationResult = Apollo.MutationResult<GenerateOpenSurveyAccessCodeMutation>;
export type GenerateOpenSurveyAccessCodeMutationOptions = Apollo.BaseMutationOptions<GenerateOpenSurveyAccessCodeMutation, GenerateOpenSurveyAccessCodeMutationVariables>;
export const GetAiSummaryDocument = gql`
    query getAISummary($userId: Int!, $surveyId: Int!, $filters: AISummaryFiltersInput) {
  getAISummary(userId: $userId, surveyId: $surveyId, filters: $filters) {
    id
    commentsSummary
    surveyShortSummary
    status
    participationRate
    strengths
    areasToWatch
    areasOfOpportunity
    qualitativeFeedback
    recommendedActions
    errorText
    created
    updated
  }
}
    `;

/**
 * __useGetAiSummaryQuery__
 *
 * To run a query within a React component, call `useGetAiSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      surveyId: // value for 'surveyId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAiSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAiSummaryQuery, GetAiSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiSummaryQuery, GetAiSummaryQueryVariables>(GetAiSummaryDocument, options);
      }
export function useGetAiSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiSummaryQuery, GetAiSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiSummaryQuery, GetAiSummaryQueryVariables>(GetAiSummaryDocument, options);
        }
export type GetAiSummaryQueryHookResult = ReturnType<typeof useGetAiSummaryQuery>;
export type GetAiSummaryLazyQueryHookResult = ReturnType<typeof useGetAiSummaryLazyQuery>;
export type GetAiSummaryQueryResult = Apollo.QueryResult<GetAiSummaryQuery, GetAiSummaryQueryVariables>;
export const GetActivationUserDocument = gql`
    query getActivationUser($token: String!) {
  getActivationUser(token: $token) {
    email
    companyName
    preferredLanguageId
    langISOCode
    hasSSO
  }
}
    `;

/**
 * __useGetActivationUserQuery__
 *
 * To run a query within a React component, call `useGetActivationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivationUserQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetActivationUserQuery(baseOptions: Apollo.QueryHookOptions<GetActivationUserQuery, GetActivationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivationUserQuery, GetActivationUserQueryVariables>(GetActivationUserDocument, options);
      }
export function useGetActivationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivationUserQuery, GetActivationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivationUserQuery, GetActivationUserQueryVariables>(GetActivationUserDocument, options);
        }
export type GetActivationUserQueryHookResult = ReturnType<typeof useGetActivationUserQuery>;
export type GetActivationUserLazyQueryHookResult = ReturnType<typeof useGetActivationUserLazyQuery>;
export type GetActivationUserQueryResult = Apollo.QueryResult<GetActivationUserQuery, GetActivationUserQueryVariables>;
export const GetAutomaticSurveyRemindersDocument = gql`
    query getAutomaticSurveyReminders($surveyId: Int!) {
  getAutomaticSurveyReminders(surveyId: $surveyId) {
    id
    surveyId
    reminderFrequencyDays
    sendTime
    status
    automaticSurveyReminderLanguages {
      languageId
      emailSubject
      emailBody
    }
  }
}
    `;

/**
 * __useGetAutomaticSurveyRemindersQuery__
 *
 * To run a query within a React component, call `useGetAutomaticSurveyRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutomaticSurveyRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutomaticSurveyRemindersQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetAutomaticSurveyRemindersQuery(baseOptions: Apollo.QueryHookOptions<GetAutomaticSurveyRemindersQuery, GetAutomaticSurveyRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutomaticSurveyRemindersQuery, GetAutomaticSurveyRemindersQueryVariables>(GetAutomaticSurveyRemindersDocument, options);
      }
export function useGetAutomaticSurveyRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutomaticSurveyRemindersQuery, GetAutomaticSurveyRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutomaticSurveyRemindersQuery, GetAutomaticSurveyRemindersQueryVariables>(GetAutomaticSurveyRemindersDocument, options);
        }
export type GetAutomaticSurveyRemindersQueryHookResult = ReturnType<typeof useGetAutomaticSurveyRemindersQuery>;
export type GetAutomaticSurveyRemindersLazyQueryHookResult = ReturnType<typeof useGetAutomaticSurveyRemindersLazyQuery>;
export type GetAutomaticSurveyRemindersQueryResult = Apollo.QueryResult<GetAutomaticSurveyRemindersQuery, GetAutomaticSurveyRemindersQueryVariables>;
export const GetConversationMessagesDocument = gql`
    query getConversationMessages($conversationId: Int!) {
  conversationsMessages(search: {conversationId: $conversationId}) {
    ...conversationsMessages
  }
}
    ${ConversationsMessagesFragmentDoc}`;

/**
 * __useGetConversationMessagesQuery__
 *
 * To run a query within a React component, call `useGetConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationMessagesQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
      }
export function useGetConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>(GetConversationMessagesDocument, options);
        }
export type GetConversationMessagesQueryHookResult = ReturnType<typeof useGetConversationMessagesQuery>;
export type GetConversationMessagesLazyQueryHookResult = ReturnType<typeof useGetConversationMessagesLazyQuery>;
export type GetConversationMessagesQueryResult = Apollo.QueryResult<GetConversationMessagesQuery, GetConversationMessagesQueryVariables>;
export const GetConversationsListDocument = gql`
    query getConversationsList($languageId: Int!) {
  conversationsList(languageId: $languageId) {
    id
    created
    surveyId
    surveyName
    reactedLike
    reactedGreatIdea
    reactedWorkingOnIt
    response {
      id
      title
      comment
    }
  }
}
    `;

/**
 * __useGetConversationsListQuery__
 *
 * To run a query within a React component, call `useGetConversationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsListQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useGetConversationsListQuery(baseOptions: Apollo.QueryHookOptions<GetConversationsListQuery, GetConversationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsListQuery, GetConversationsListQueryVariables>(GetConversationsListDocument, options);
      }
export function useGetConversationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsListQuery, GetConversationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsListQuery, GetConversationsListQueryVariables>(GetConversationsListDocument, options);
        }
export type GetConversationsListQueryHookResult = ReturnType<typeof useGetConversationsListQuery>;
export type GetConversationsListLazyQueryHookResult = ReturnType<typeof useGetConversationsListLazyQuery>;
export type GetConversationsListQueryResult = Apollo.QueryResult<GetConversationsListQuery, GetConversationsListQueryVariables>;
export const GetCronjobRunStatusesDocument = gql`
    query getCronjobRunStatuses {
  getCronjobRunStatuses {
    name
    lastRunAt
    lastStatus
    lastDurationMs
    lastRunByUser {
      id
      firstname
      lastname
      email
    }
  }
}
    `;

/**
 * __useGetCronjobRunStatusesQuery__
 *
 * To run a query within a React component, call `useGetCronjobRunStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCronjobRunStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCronjobRunStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCronjobRunStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetCronjobRunStatusesQuery, GetCronjobRunStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCronjobRunStatusesQuery, GetCronjobRunStatusesQueryVariables>(GetCronjobRunStatusesDocument, options);
      }
export function useGetCronjobRunStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCronjobRunStatusesQuery, GetCronjobRunStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCronjobRunStatusesQuery, GetCronjobRunStatusesQueryVariables>(GetCronjobRunStatusesDocument, options);
        }
export type GetCronjobRunStatusesQueryHookResult = ReturnType<typeof useGetCronjobRunStatusesQuery>;
export type GetCronjobRunStatusesLazyQueryHookResult = ReturnType<typeof useGetCronjobRunStatusesLazyQuery>;
export type GetCronjobRunStatusesQueryResult = Apollo.QueryResult<GetCronjobRunStatusesQuery, GetCronjobRunStatusesQueryVariables>;
export const GetCronjobsDocument = gql`
    query getCronjobs {
  getCronjobs {
    name
    description
    period
    periodUnit
  }
}
    `;

/**
 * __useGetCronjobsQuery__
 *
 * To run a query within a React component, call `useGetCronjobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCronjobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCronjobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCronjobsQuery(baseOptions?: Apollo.QueryHookOptions<GetCronjobsQuery, GetCronjobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCronjobsQuery, GetCronjobsQueryVariables>(GetCronjobsDocument, options);
      }
export function useGetCronjobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCronjobsQuery, GetCronjobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCronjobsQuery, GetCronjobsQueryVariables>(GetCronjobsDocument, options);
        }
export type GetCronjobsQueryHookResult = ReturnType<typeof useGetCronjobsQuery>;
export type GetCronjobsLazyQueryHookResult = ReturnType<typeof useGetCronjobsLazyQuery>;
export type GetCronjobsQueryResult = Apollo.QueryResult<GetCronjobsQuery, GetCronjobsQueryVariables>;
export const GetTagsDocument = gql`
    query getTags {
  tags {
    id
    name
  }
}
    `;

/**
 * __useGetTagsQuery__
 *
 * To run a query within a React component, call `useGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
      }
export function useGetTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsQuery, GetTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, options);
        }
export type GetTagsQueryHookResult = ReturnType<typeof useGetTagsQuery>;
export type GetTagsLazyQueryHookResult = ReturnType<typeof useGetTagsLazyQuery>;
export type GetTagsQueryResult = Apollo.QueryResult<GetTagsQuery, GetTagsQueryVariables>;
export const GetLibraryQuestionsDocument = gql`
    query getLibraryQuestions($limit: Int, $offset: Int, $search: VendorQuestionsSearchInput!) {
  libraryQuestions(limit: $limit, offset: $offset, search: $search) {
    count
    fields {
      companyId
      id
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      surveyTypeId
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            orderIndex
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
        }
      }
    }
  }
}
    `;

/**
 * __useGetLibraryQuestionsQuery__
 *
 * To run a query within a React component, call `useGetLibraryQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLibraryQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>(GetLibraryQuestionsDocument, options);
      }
export function useGetLibraryQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>(GetLibraryQuestionsDocument, options);
        }
export type GetLibraryQuestionsQueryHookResult = ReturnType<typeof useGetLibraryQuestionsQuery>;
export type GetLibraryQuestionsLazyQueryHookResult = ReturnType<typeof useGetLibraryQuestionsLazyQuery>;
export type GetLibraryQuestionsQueryResult = Apollo.QueryResult<GetLibraryQuestionsQuery, GetLibraryQuestionsQueryVariables>;
export const GetLifecycleSurveyDoNotContactListDocument = gql`
    query getLifecycleSurveyDoNotContactList {
  getLifecycleSurveyDoNotContactList {
    id
    employeeId
    firstName
    lastName
    email
    addedAtTimeUTC
    addedByUser {
      userId
      firstName
      lastName
    }
    doNotContactReason
  }
}
    `;

/**
 * __useGetLifecycleSurveyDoNotContactListQuery__
 *
 * To run a query within a React component, call `useGetLifecycleSurveyDoNotContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleSurveyDoNotContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleSurveyDoNotContactListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLifecycleSurveyDoNotContactListQuery(baseOptions?: Apollo.QueryHookOptions<GetLifecycleSurveyDoNotContactListQuery, GetLifecycleSurveyDoNotContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleSurveyDoNotContactListQuery, GetLifecycleSurveyDoNotContactListQueryVariables>(GetLifecycleSurveyDoNotContactListDocument, options);
      }
export function useGetLifecycleSurveyDoNotContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleSurveyDoNotContactListQuery, GetLifecycleSurveyDoNotContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleSurveyDoNotContactListQuery, GetLifecycleSurveyDoNotContactListQueryVariables>(GetLifecycleSurveyDoNotContactListDocument, options);
        }
export type GetLifecycleSurveyDoNotContactListQueryHookResult = ReturnType<typeof useGetLifecycleSurveyDoNotContactListQuery>;
export type GetLifecycleSurveyDoNotContactListLazyQueryHookResult = ReturnType<typeof useGetLifecycleSurveyDoNotContactListLazyQuery>;
export type GetLifecycleSurveyDoNotContactListQueryResult = Apollo.QueryResult<GetLifecycleSurveyDoNotContactListQuery, GetLifecycleSurveyDoNotContactListQueryVariables>;
export const GetLifecycleSurveyRecipientsDocument = gql`
    query getLifecycleSurveyRecipients($surveyId: Int) {
  getLifecycleSurveyRecipients(surveyId: $surveyId) {
    id
    employeeId
    firstName
    lastName
    targetInvitationDate
    addedToListDate
    isApprovedToAdd
    lifecycleSurveyTriggerId
    targetSurvey {
      id
      name
      surveyId
    }
    triggerTypeId
    startDate
    exitDate
    requireAdminApproval
  }
}
    `;

/**
 * __useGetLifecycleSurveyRecipientsQuery__
 *
 * To run a query within a React component, call `useGetLifecycleSurveyRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleSurveyRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleSurveyRecipientsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetLifecycleSurveyRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<GetLifecycleSurveyRecipientsQuery, GetLifecycleSurveyRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleSurveyRecipientsQuery, GetLifecycleSurveyRecipientsQueryVariables>(GetLifecycleSurveyRecipientsDocument, options);
      }
export function useGetLifecycleSurveyRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleSurveyRecipientsQuery, GetLifecycleSurveyRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleSurveyRecipientsQuery, GetLifecycleSurveyRecipientsQueryVariables>(GetLifecycleSurveyRecipientsDocument, options);
        }
export type GetLifecycleSurveyRecipientsQueryHookResult = ReturnType<typeof useGetLifecycleSurveyRecipientsQuery>;
export type GetLifecycleSurveyRecipientsLazyQueryHookResult = ReturnType<typeof useGetLifecycleSurveyRecipientsLazyQuery>;
export type GetLifecycleSurveyRecipientsQueryResult = Apollo.QueryResult<GetLifecycleSurveyRecipientsQuery, GetLifecycleSurveyRecipientsQueryVariables>;
export const GetLifecycleSurveyTriggerTypesDocument = gql`
    query getLifecycleSurveyTriggerTypes {
  getLifecycleSurveyTriggerTypes {
    id
    type
    isEnabled
  }
}
    `;

/**
 * __useGetLifecycleSurveyTriggerTypesQuery__
 *
 * To run a query within a React component, call `useGetLifecycleSurveyTriggerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleSurveyTriggerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleSurveyTriggerTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLifecycleSurveyTriggerTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetLifecycleSurveyTriggerTypesQuery, GetLifecycleSurveyTriggerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleSurveyTriggerTypesQuery, GetLifecycleSurveyTriggerTypesQueryVariables>(GetLifecycleSurveyTriggerTypesDocument, options);
      }
export function useGetLifecycleSurveyTriggerTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleSurveyTriggerTypesQuery, GetLifecycleSurveyTriggerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleSurveyTriggerTypesQuery, GetLifecycleSurveyTriggerTypesQueryVariables>(GetLifecycleSurveyTriggerTypesDocument, options);
        }
export type GetLifecycleSurveyTriggerTypesQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTriggerTypesQuery>;
export type GetLifecycleSurveyTriggerTypesLazyQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTriggerTypesLazyQuery>;
export type GetLifecycleSurveyTriggerTypesQueryResult = Apollo.QueryResult<GetLifecycleSurveyTriggerTypesQuery, GetLifecycleSurveyTriggerTypesQueryVariables>;
export const GetLifecycleSurveyTriggersDocument = gql`
    query getLifecycleSurveyTriggers {
  getLifecycleSurveyTriggers {
    id
    lifecycleSurveyTypeId
    surveyId
    triggerAttributeId
    audienceType
    invitationOffsetDays
    requireAdminApproval
    timeOfDayStartUTC
    timeOfDayEndUTC
    status
    languages {
      languageId
      name
    }
    attributeAudience {
      attributeId
      attributeValue
    }
    adminApprovers {
      userId
    }
    superAdminApprovers {
      userId
    }
  }
}
    `;

/**
 * __useGetLifecycleSurveyTriggersQuery__
 *
 * To run a query within a React component, call `useGetLifecycleSurveyTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleSurveyTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleSurveyTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLifecycleSurveyTriggersQuery(baseOptions?: Apollo.QueryHookOptions<GetLifecycleSurveyTriggersQuery, GetLifecycleSurveyTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleSurveyTriggersQuery, GetLifecycleSurveyTriggersQueryVariables>(GetLifecycleSurveyTriggersDocument, options);
      }
export function useGetLifecycleSurveyTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleSurveyTriggersQuery, GetLifecycleSurveyTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleSurveyTriggersQuery, GetLifecycleSurveyTriggersQueryVariables>(GetLifecycleSurveyTriggersDocument, options);
        }
export type GetLifecycleSurveyTriggersQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTriggersQuery>;
export type GetLifecycleSurveyTriggersLazyQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTriggersLazyQuery>;
export type GetLifecycleSurveyTriggersQueryResult = Apollo.QueryResult<GetLifecycleSurveyTriggersQuery, GetLifecycleSurveyTriggersQueryVariables>;
export const GetLifecycleSurveyTypesDocument = gql`
    query getLifecycleSurveyTypes {
  getLifecycleSurveyTypes {
    id
    type
  }
}
    `;

/**
 * __useGetLifecycleSurveyTypesQuery__
 *
 * To run a query within a React component, call `useGetLifecycleSurveyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifecycleSurveyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifecycleSurveyTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLifecycleSurveyTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetLifecycleSurveyTypesQuery, GetLifecycleSurveyTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLifecycleSurveyTypesQuery, GetLifecycleSurveyTypesQueryVariables>(GetLifecycleSurveyTypesDocument, options);
      }
export function useGetLifecycleSurveyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLifecycleSurveyTypesQuery, GetLifecycleSurveyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLifecycleSurveyTypesQuery, GetLifecycleSurveyTypesQueryVariables>(GetLifecycleSurveyTypesDocument, options);
        }
export type GetLifecycleSurveyTypesQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTypesQuery>;
export type GetLifecycleSurveyTypesLazyQueryHookResult = ReturnType<typeof useGetLifecycleSurveyTypesLazyQuery>;
export type GetLifecycleSurveyTypesQueryResult = Apollo.QueryResult<GetLifecycleSurveyTypesQuery, GetLifecycleSurveyTypesQueryVariables>;
export const GetQuestionThemesDocument = gql`
    query getQuestionThemes($input: GetQuestionThemesInput!) {
  getQuestionThemes(input: $input) {
    surveyElementId
    themes {
      id
      count
      themeName
      translations {
        languageId
        name
      }
    }
  }
}
    `;

/**
 * __useGetQuestionThemesQuery__
 *
 * To run a query within a React component, call `useGetQuestionThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionThemesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuestionThemesQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionThemesQuery, GetQuestionThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionThemesQuery, GetQuestionThemesQueryVariables>(GetQuestionThemesDocument, options);
      }
export function useGetQuestionThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionThemesQuery, GetQuestionThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionThemesQuery, GetQuestionThemesQueryVariables>(GetQuestionThemesDocument, options);
        }
export type GetQuestionThemesQueryHookResult = ReturnType<typeof useGetQuestionThemesQuery>;
export type GetQuestionThemesLazyQueryHookResult = ReturnType<typeof useGetQuestionThemesLazyQuery>;
export type GetQuestionThemesQueryResult = Apollo.QueryResult<GetQuestionThemesQuery, GetQuestionThemesQueryVariables>;
export const GetRehireAttributeDocument = gql`
    query GetRehireAttribute($companyId: Int!) {
  getRehireAttribute(companyId: $companyId) {
    attributeId
  }
}
    `;

/**
 * __useGetRehireAttributeQuery__
 *
 * To run a query within a React component, call `useGetRehireAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRehireAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRehireAttributeQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetRehireAttributeQuery(baseOptions: Apollo.QueryHookOptions<GetRehireAttributeQuery, GetRehireAttributeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRehireAttributeQuery, GetRehireAttributeQueryVariables>(GetRehireAttributeDocument, options);
      }
export function useGetRehireAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRehireAttributeQuery, GetRehireAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRehireAttributeQuery, GetRehireAttributeQueryVariables>(GetRehireAttributeDocument, options);
        }
export type GetRehireAttributeQueryHookResult = ReturnType<typeof useGetRehireAttributeQuery>;
export type GetRehireAttributeLazyQueryHookResult = ReturnType<typeof useGetRehireAttributeLazyQuery>;
export type GetRehireAttributeQueryResult = Apollo.QueryResult<GetRehireAttributeQuery, GetRehireAttributeQueryVariables>;
export const GetSurveyAttributeHierarchyDocument = gql`
    query getSurveyAttributeHierarchy($surveyId: Int!) {
  getSurveyAttributeHierarchy(surveyId: $surveyId) {
    attributeHierarchy {
      employeeId
      managerId
      employeeSurveySnapshotId
      email
      fullName
    }
    snapshotHierarchy {
      employeeId
      managerId
      employeeSurveySnapshotId
      email
      fullName
    }
    notInvitedManagers {
      employeeId
      managerId
      employeeSurveySnapshotId
      email
      fullName
    }
  }
}
    `;

/**
 * __useGetSurveyAttributeHierarchyQuery__
 *
 * To run a query within a React component, call `useGetSurveyAttributeHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyAttributeHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyAttributeHierarchyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetSurveyAttributeHierarchyQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyAttributeHierarchyQuery, GetSurveyAttributeHierarchyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyAttributeHierarchyQuery, GetSurveyAttributeHierarchyQueryVariables>(GetSurveyAttributeHierarchyDocument, options);
      }
export function useGetSurveyAttributeHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyAttributeHierarchyQuery, GetSurveyAttributeHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyAttributeHierarchyQuery, GetSurveyAttributeHierarchyQueryVariables>(GetSurveyAttributeHierarchyDocument, options);
        }
export type GetSurveyAttributeHierarchyQueryHookResult = ReturnType<typeof useGetSurveyAttributeHierarchyQuery>;
export type GetSurveyAttributeHierarchyLazyQueryHookResult = ReturnType<typeof useGetSurveyAttributeHierarchyLazyQuery>;
export type GetSurveyAttributeHierarchyQueryResult = Apollo.QueryResult<GetSurveyAttributeHierarchyQuery, GetSurveyAttributeHierarchyQueryVariables>;
export const GetSurveyNameListDocument = gql`
    query getSurveyNameList($companyId: Int!) {
  dashboardSurveys(search: {}, companyId: $companyId) {
    count
    results {
      id
      surveyName
    }
  }
}
    `;

/**
 * __useGetSurveyNameListQuery__
 *
 * To run a query within a React component, call `useGetSurveyNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyNameListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetSurveyNameListQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyNameListQuery, GetSurveyNameListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyNameListQuery, GetSurveyNameListQueryVariables>(GetSurveyNameListDocument, options);
      }
export function useGetSurveyNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyNameListQuery, GetSurveyNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyNameListQuery, GetSurveyNameListQueryVariables>(GetSurveyNameListDocument, options);
        }
export type GetSurveyNameListQueryHookResult = ReturnType<typeof useGetSurveyNameListQuery>;
export type GetSurveyNameListLazyQueryHookResult = ReturnType<typeof useGetSurveyNameListLazyQuery>;
export type GetSurveyNameListQueryResult = Apollo.QueryResult<GetSurveyNameListQuery, GetSurveyNameListQueryVariables>;
export const GetSurveyParticipantsDocument = gql`
    query getSurveyParticipants($surveyId: Int!) {
  getSurveyParticipants(surveyId: $surveyId) {
    firstName
    lastName
    email
    employeeId
    employeeSurveySnapshotId
    invitedDate
    submittedResponseDate
  }
}
    `;

/**
 * __useGetSurveyParticipantsQuery__
 *
 * To run a query within a React component, call `useGetSurveyParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyParticipantsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetSurveyParticipantsQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyParticipantsQuery, GetSurveyParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyParticipantsQuery, GetSurveyParticipantsQueryVariables>(GetSurveyParticipantsDocument, options);
      }
export function useGetSurveyParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyParticipantsQuery, GetSurveyParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyParticipantsQuery, GetSurveyParticipantsQueryVariables>(GetSurveyParticipantsDocument, options);
        }
export type GetSurveyParticipantsQueryHookResult = ReturnType<typeof useGetSurveyParticipantsQuery>;
export type GetSurveyParticipantsLazyQueryHookResult = ReturnType<typeof useGetSurveyParticipantsLazyQuery>;
export type GetSurveyParticipantsQueryResult = Apollo.QueryResult<GetSurveyParticipantsQuery, GetSurveyParticipantsQueryVariables>;
export const GetTrendQuestionsDocument = gql`
    query getTrendQuestions($limit: Int, $offset: Int, $search: VendorQuestionsSearchInput!) {
  previousQuestions(limit: $limit, offset: $offset, search: $search) {
    count
    fields {
      sentTimes(isPreviousQuestion: true)
      lastSent(isPreviousQuestion: true)
      companyId
      id
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
        }
      }
    }
  }
}
    `;

/**
 * __useGetTrendQuestionsQuery__
 *
 * To run a query within a React component, call `useGetTrendQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTrendQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendQuestionsQuery, GetTrendQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendQuestionsQuery, GetTrendQuestionsQueryVariables>(GetTrendQuestionsDocument, options);
      }
export function useGetTrendQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendQuestionsQuery, GetTrendQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendQuestionsQuery, GetTrendQuestionsQueryVariables>(GetTrendQuestionsDocument, options);
        }
export type GetTrendQuestionsQueryHookResult = ReturnType<typeof useGetTrendQuestionsQuery>;
export type GetTrendQuestionsLazyQueryHookResult = ReturnType<typeof useGetTrendQuestionsLazyQuery>;
export type GetTrendQuestionsQueryResult = Apollo.QueryResult<GetTrendQuestionsQuery, GetTrendQuestionsQueryVariables>;
export const ImpersonateUserDocument = gql`
    mutation impersonateUser($userId: Int!) {
  impersonateUser(userId: $userId) {
    token
  }
}
    `;
export type ImpersonateUserMutationFn = Apollo.MutationFunction<ImpersonateUserMutation, ImpersonateUserMutationVariables>;

/**
 * __useImpersonateUserMutation__
 *
 * To run a mutation, you first call `useImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserMutation, { data, loading, error }] = useImpersonateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useImpersonateUserMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>(ImpersonateUserDocument, options);
      }
export type ImpersonateUserMutationHookResult = ReturnType<typeof useImpersonateUserMutation>;
export type ImpersonateUserMutationResult = Apollo.MutationResult<ImpersonateUserMutation>;
export type ImpersonateUserMutationOptions = Apollo.BaseMutationOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>;
export const ImportEmployeesDocument = gql`
    mutation importEmployees($employees: [EmployeeImportInput!]!, $companyId: Int!, $isUpdate: Boolean!, $hasRoleUpdate: Boolean!) {
  importEmployees(
    employees: $employees
    companyId: $companyId
    isUpdate: $isUpdate
    hasRoleUpdate: $hasRoleUpdate
  ) {
    isSuccess
    conflicts {
      attributeId
      attributeValue
      companyEmployeeIds
    }
  }
}
    `;
export type ImportEmployeesMutationFn = Apollo.MutationFunction<ImportEmployeesMutation, ImportEmployeesMutationVariables>;

/**
 * __useImportEmployeesMutation__
 *
 * To run a mutation, you first call `useImportEmployeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportEmployeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importEmployeesMutation, { data, loading, error }] = useImportEmployeesMutation({
 *   variables: {
 *      employees: // value for 'employees'
 *      companyId: // value for 'companyId'
 *      isUpdate: // value for 'isUpdate'
 *      hasRoleUpdate: // value for 'hasRoleUpdate'
 *   },
 * });
 */
export function useImportEmployeesMutation(baseOptions?: Apollo.MutationHookOptions<ImportEmployeesMutation, ImportEmployeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportEmployeesMutation, ImportEmployeesMutationVariables>(ImportEmployeesDocument, options);
      }
export type ImportEmployeesMutationHookResult = ReturnType<typeof useImportEmployeesMutation>;
export type ImportEmployeesMutationResult = Apollo.MutationResult<ImportEmployeesMutation>;
export type ImportEmployeesMutationOptions = Apollo.BaseMutationOptions<ImportEmployeesMutation, ImportEmployeesMutationVariables>;
export const LinkQuestionsForTrendingDocument = gql`
    mutation linkQuestionsForTrending($input: LinkQuestionsForTrendingInput!) {
  linkQuestionsForTrending(input: $input) {
    success
    reason
    message
    linkedQuestionId
  }
}
    `;
export type LinkQuestionsForTrendingMutationFn = Apollo.MutationFunction<LinkQuestionsForTrendingMutation, LinkQuestionsForTrendingMutationVariables>;

/**
 * __useLinkQuestionsForTrendingMutation__
 *
 * To run a mutation, you first call `useLinkQuestionsForTrendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkQuestionsForTrendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkQuestionsForTrendingMutation, { data, loading, error }] = useLinkQuestionsForTrendingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkQuestionsForTrendingMutation(baseOptions?: Apollo.MutationHookOptions<LinkQuestionsForTrendingMutation, LinkQuestionsForTrendingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkQuestionsForTrendingMutation, LinkQuestionsForTrendingMutationVariables>(LinkQuestionsForTrendingDocument, options);
      }
export type LinkQuestionsForTrendingMutationHookResult = ReturnType<typeof useLinkQuestionsForTrendingMutation>;
export type LinkQuestionsForTrendingMutationResult = Apollo.MutationResult<LinkQuestionsForTrendingMutation>;
export type LinkQuestionsForTrendingMutationOptions = Apollo.BaseMutationOptions<LinkQuestionsForTrendingMutation, LinkQuestionsForTrendingMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    user {
      id
    }
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MapValuesToBenchmarkAttributeValueDocument = gql`
    mutation mapValuesToBenchmarkAttributeValue($benchmarkAttributeValueId: Int!, $names: [String!]!) {
  addBenchmarkAttributeValueAltNames(
    benchmarkAttributeValueId: $benchmarkAttributeValueId
    names: $names
  ) {
    id
    name
  }
}
    `;
export type MapValuesToBenchmarkAttributeValueMutationFn = Apollo.MutationFunction<MapValuesToBenchmarkAttributeValueMutation, MapValuesToBenchmarkAttributeValueMutationVariables>;

/**
 * __useMapValuesToBenchmarkAttributeValueMutation__
 *
 * To run a mutation, you first call `useMapValuesToBenchmarkAttributeValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMapValuesToBenchmarkAttributeValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mapValuesToBenchmarkAttributeValueMutation, { data, loading, error }] = useMapValuesToBenchmarkAttributeValueMutation({
 *   variables: {
 *      benchmarkAttributeValueId: // value for 'benchmarkAttributeValueId'
 *      names: // value for 'names'
 *   },
 * });
 */
export function useMapValuesToBenchmarkAttributeValueMutation(baseOptions?: Apollo.MutationHookOptions<MapValuesToBenchmarkAttributeValueMutation, MapValuesToBenchmarkAttributeValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MapValuesToBenchmarkAttributeValueMutation, MapValuesToBenchmarkAttributeValueMutationVariables>(MapValuesToBenchmarkAttributeValueDocument, options);
      }
export type MapValuesToBenchmarkAttributeValueMutationHookResult = ReturnType<typeof useMapValuesToBenchmarkAttributeValueMutation>;
export type MapValuesToBenchmarkAttributeValueMutationResult = Apollo.MutationResult<MapValuesToBenchmarkAttributeValueMutation>;
export type MapValuesToBenchmarkAttributeValueMutationOptions = Apollo.BaseMutationOptions<MapValuesToBenchmarkAttributeValueMutation, MapValuesToBenchmarkAttributeValueMutationVariables>;
export const MigrateSurveyDocument = gql`
    mutation migrateSurvey($companyId: Int!, $surveyConfig: SurveyConfigInput!, $fileUrl: String!, $overwriteSurveyData: Boolean!) {
  migrateSurvey(
    companyId: $companyId
    surveyConfig: $surveyConfig
    fileUrl: $fileUrl
    overwriteSurveyData: $overwriteSurveyData
  ) {
    id
    surveyStatusId
    timezoneId
    startTimeUTC
    endTimeUTC
  }
}
    `;
export type MigrateSurveyMutationFn = Apollo.MutationFunction<MigrateSurveyMutation, MigrateSurveyMutationVariables>;

/**
 * __useMigrateSurveyMutation__
 *
 * To run a mutation, you first call `useMigrateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateSurveyMutation, { data, loading, error }] = useMigrateSurveyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      surveyConfig: // value for 'surveyConfig'
 *      fileUrl: // value for 'fileUrl'
 *      overwriteSurveyData: // value for 'overwriteSurveyData'
 *   },
 * });
 */
export function useMigrateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<MigrateSurveyMutation, MigrateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateSurveyMutation, MigrateSurveyMutationVariables>(MigrateSurveyDocument, options);
      }
export type MigrateSurveyMutationHookResult = ReturnType<typeof useMigrateSurveyMutation>;
export type MigrateSurveyMutationResult = Apollo.MutationResult<MigrateSurveyMutation>;
export type MigrateSurveyMutationOptions = Apollo.BaseMutationOptions<MigrateSurveyMutation, MigrateSurveyMutationVariables>;
export const NotifyPrivateAttributeExportDocument = gql`
    mutation notifyPrivateAttributeExport($companyId: Int!) {
  privateAttributeExportedNotifier(companyId: $companyId)
}
    `;
export type NotifyPrivateAttributeExportMutationFn = Apollo.MutationFunction<NotifyPrivateAttributeExportMutation, NotifyPrivateAttributeExportMutationVariables>;

/**
 * __useNotifyPrivateAttributeExportMutation__
 *
 * To run a mutation, you first call `useNotifyPrivateAttributeExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyPrivateAttributeExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyPrivateAttributeExportMutation, { data, loading, error }] = useNotifyPrivateAttributeExportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useNotifyPrivateAttributeExportMutation(baseOptions?: Apollo.MutationHookOptions<NotifyPrivateAttributeExportMutation, NotifyPrivateAttributeExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyPrivateAttributeExportMutation, NotifyPrivateAttributeExportMutationVariables>(NotifyPrivateAttributeExportDocument, options);
      }
export type NotifyPrivateAttributeExportMutationHookResult = ReturnType<typeof useNotifyPrivateAttributeExportMutation>;
export type NotifyPrivateAttributeExportMutationResult = Apollo.MutationResult<NotifyPrivateAttributeExportMutation>;
export type NotifyPrivateAttributeExportMutationOptions = Apollo.BaseMutationOptions<NotifyPrivateAttributeExportMutation, NotifyPrivateAttributeExportMutationVariables>;
export const OrderSurveyElementsDocument = gql`
    mutation orderSurveyElements($id: Int!, $survey: SurveyUpdateInput!) {
  updateSurveyQuestionsSorting(id: $id, survey: $survey)
}
    `;
export type OrderSurveyElementsMutationFn = Apollo.MutationFunction<OrderSurveyElementsMutation, OrderSurveyElementsMutationVariables>;

/**
 * __useOrderSurveyElementsMutation__
 *
 * To run a mutation, you first call `useOrderSurveyElementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSurveyElementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSurveyElementsMutation, { data, loading, error }] = useOrderSurveyElementsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useOrderSurveyElementsMutation(baseOptions?: Apollo.MutationHookOptions<OrderSurveyElementsMutation, OrderSurveyElementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSurveyElementsMutation, OrderSurveyElementsMutationVariables>(OrderSurveyElementsDocument, options);
      }
export type OrderSurveyElementsMutationHookResult = ReturnType<typeof useOrderSurveyElementsMutation>;
export type OrderSurveyElementsMutationResult = Apollo.MutationResult<OrderSurveyElementsMutation>;
export type OrderSurveyElementsMutationOptions = Apollo.BaseMutationOptions<OrderSurveyElementsMutation, OrderSurveyElementsMutationVariables>;
export const OverallSurveyResultsDocument = gql`
    query overallSurveyResults($attributes: [AttributeWithValuesSearchInput], $companyIds: [Int]!, $surveyIds: [Int]!, $languageId: Int!, $isHierarchyReport: Boolean, $managerReportIds: [String!], $selectedTimeframe: TimeframeInput, $selectedParticipantId: Int) {
  overallSurveyResults(
    attributes: $attributes
    companyIds: $companyIds
    surveyIds: $surveyIds
    languageId: $languageId
    isHierarchyReport: $isHierarchyReport
    managerReportIds: $managerReportIds
    selectedTimeframe: $selectedTimeframe
    selectedParticipantId: $selectedParticipantId
  ) {
    id
    surveyElementId
    type
    text
    totalAnswered
    totalRespondents
    numberOfComments
    iconPath
    minRating
    maxRating
    average
    addedDateUTC
    discontinuedDateUTC
    ratings {
      rating
      totalAnswered
      numberOfComments
      percentage
    }
    options {
      id
      text
      totalAnswered
      numberOfComments
      percentage
    }
    aggregatedCommentSentiments {
      numberOfPositiveComments
      numberOfNeutralComments
      numberOfNegativeComments
      numberOfUnknownComments
    }
  }
}
    `;

/**
 * __useOverallSurveyResultsQuery__
 *
 * To run a query within a React component, call `useOverallSurveyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverallSurveyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverallSurveyResultsQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *      companyIds: // value for 'companyIds'
 *      surveyIds: // value for 'surveyIds'
 *      languageId: // value for 'languageId'
 *      isHierarchyReport: // value for 'isHierarchyReport'
 *      managerReportIds: // value for 'managerReportIds'
 *      selectedTimeframe: // value for 'selectedTimeframe'
 *      selectedParticipantId: // value for 'selectedParticipantId'
 *   },
 * });
 */
export function useOverallSurveyResultsQuery(baseOptions: Apollo.QueryHookOptions<OverallSurveyResultsQuery, OverallSurveyResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverallSurveyResultsQuery, OverallSurveyResultsQueryVariables>(OverallSurveyResultsDocument, options);
      }
export function useOverallSurveyResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverallSurveyResultsQuery, OverallSurveyResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverallSurveyResultsQuery, OverallSurveyResultsQueryVariables>(OverallSurveyResultsDocument, options);
        }
export type OverallSurveyResultsQueryHookResult = ReturnType<typeof useOverallSurveyResultsQuery>;
export type OverallSurveyResultsLazyQueryHookResult = ReturnType<typeof useOverallSurveyResultsLazyQuery>;
export type OverallSurveyResultsQueryResult = Apollo.QueryResult<OverallSurveyResultsQuery, OverallSurveyResultsQueryVariables>;
export const RemoveEmployeeAttributeDocument = gql`
    mutation removeEmployeeAttribute($employeeAttributeId: Int!, $companyId: Int!) {
  deleteAttribute(id: $employeeAttributeId, companyId: $companyId)
}
    `;
export type RemoveEmployeeAttributeMutationFn = Apollo.MutationFunction<RemoveEmployeeAttributeMutation, RemoveEmployeeAttributeMutationVariables>;

/**
 * __useRemoveEmployeeAttributeMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeeAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeeAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeeAttributeMutation, { data, loading, error }] = useRemoveEmployeeAttributeMutation({
 *   variables: {
 *      employeeAttributeId: // value for 'employeeAttributeId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useRemoveEmployeeAttributeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeeAttributeMutation, RemoveEmployeeAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeeAttributeMutation, RemoveEmployeeAttributeMutationVariables>(RemoveEmployeeAttributeDocument, options);
      }
export type RemoveEmployeeAttributeMutationHookResult = ReturnType<typeof useRemoveEmployeeAttributeMutation>;
export type RemoveEmployeeAttributeMutationResult = Apollo.MutationResult<RemoveEmployeeAttributeMutation>;
export type RemoveEmployeeAttributeMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeeAttributeMutation, RemoveEmployeeAttributeMutationVariables>;
export const RemoveEmployeeChannelFromDoNotContactListDocument = gql`
    mutation removeEmployeeChannelFromDoNotContactList($input: RemoveEmployeeChannelFromDoNotContactListInput!) {
  removeEmployeeChannelFromDoNotContactList(input: $input) {
    success
    message
  }
}
    `;
export type RemoveEmployeeChannelFromDoNotContactListMutationFn = Apollo.MutationFunction<RemoveEmployeeChannelFromDoNotContactListMutation, RemoveEmployeeChannelFromDoNotContactListMutationVariables>;

/**
 * __useRemoveEmployeeChannelFromDoNotContactListMutation__
 *
 * To run a mutation, you first call `useRemoveEmployeeChannelFromDoNotContactListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployeeChannelFromDoNotContactListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployeeChannelFromDoNotContactListMutation, { data, loading, error }] = useRemoveEmployeeChannelFromDoNotContactListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveEmployeeChannelFromDoNotContactListMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployeeChannelFromDoNotContactListMutation, RemoveEmployeeChannelFromDoNotContactListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployeeChannelFromDoNotContactListMutation, RemoveEmployeeChannelFromDoNotContactListMutationVariables>(RemoveEmployeeChannelFromDoNotContactListDocument, options);
      }
export type RemoveEmployeeChannelFromDoNotContactListMutationHookResult = ReturnType<typeof useRemoveEmployeeChannelFromDoNotContactListMutation>;
export type RemoveEmployeeChannelFromDoNotContactListMutationResult = Apollo.MutationResult<RemoveEmployeeChannelFromDoNotContactListMutation>;
export type RemoveEmployeeChannelFromDoNotContactListMutationOptions = Apollo.BaseMutationOptions<RemoveEmployeeChannelFromDoNotContactListMutation, RemoveEmployeeChannelFromDoNotContactListMutationVariables>;
export const ScheduleAiSurveySummaryDocument = gql`
    mutation scheduleAISurveySummary($surveyId: Int!, $filters: AISummaryFiltersInput) {
  scheduleAISurveySummary(surveyId: $surveyId, filters: $filters) {
    commentsSummary
    surveyShortSummary
    status
    participationRate
    strengths
    areasToWatch
    areasOfOpportunity
    qualitativeFeedback
    recommendedActions
    errorText
  }
}
    `;
export type ScheduleAiSurveySummaryMutationFn = Apollo.MutationFunction<ScheduleAiSurveySummaryMutation, ScheduleAiSurveySummaryMutationVariables>;

/**
 * __useScheduleAiSurveySummaryMutation__
 *
 * To run a mutation, you first call `useScheduleAiSurveySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleAiSurveySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleAiSurveySummaryMutation, { data, loading, error }] = useScheduleAiSurveySummaryMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useScheduleAiSurveySummaryMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleAiSurveySummaryMutation, ScheduleAiSurveySummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleAiSurveySummaryMutation, ScheduleAiSurveySummaryMutationVariables>(ScheduleAiSurveySummaryDocument, options);
      }
export type ScheduleAiSurveySummaryMutationHookResult = ReturnType<typeof useScheduleAiSurveySummaryMutation>;
export type ScheduleAiSurveySummaryMutationResult = Apollo.MutationResult<ScheduleAiSurveySummaryMutation>;
export type ScheduleAiSurveySummaryMutationOptions = Apollo.BaseMutationOptions<ScheduleAiSurveySummaryMutation, ScheduleAiSurveySummaryMutationVariables>;
export const ScheduleEmployeeImportDocument = gql`
    mutation scheduleEmployeeImport($companyId: Int!, $fileContents: String!, $mode: EmployeeImportMode!, $fileName: String) {
  scheduleEmployeeImport(
    companyId: $companyId
    fileContents: $fileContents
    mode: $mode
    fileName: $fileName
  ) {
    taskId
  }
}
    `;
export type ScheduleEmployeeImportMutationFn = Apollo.MutationFunction<ScheduleEmployeeImportMutation, ScheduleEmployeeImportMutationVariables>;

/**
 * __useScheduleEmployeeImportMutation__
 *
 * To run a mutation, you first call `useScheduleEmployeeImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleEmployeeImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleEmployeeImportMutation, { data, loading, error }] = useScheduleEmployeeImportMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fileContents: // value for 'fileContents'
 *      mode: // value for 'mode'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useScheduleEmployeeImportMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleEmployeeImportMutation, ScheduleEmployeeImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleEmployeeImportMutation, ScheduleEmployeeImportMutationVariables>(ScheduleEmployeeImportDocument, options);
      }
export type ScheduleEmployeeImportMutationHookResult = ReturnType<typeof useScheduleEmployeeImportMutation>;
export type ScheduleEmployeeImportMutationResult = Apollo.MutationResult<ScheduleEmployeeImportMutation>;
export type ScheduleEmployeeImportMutationOptions = Apollo.BaseMutationOptions<ScheduleEmployeeImportMutation, ScheduleEmployeeImportMutationVariables>;
export const SendTestSurveyDocument = gql`
    mutation sendTestSurvey($surveyId: Int!) {
  sendTestSurvey(surveyId: $surveyId)
}
    `;
export type SendTestSurveyMutationFn = Apollo.MutationFunction<SendTestSurveyMutation, SendTestSurveyMutationVariables>;

/**
 * __useSendTestSurveyMutation__
 *
 * To run a mutation, you first call `useSendTestSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestSurveyMutation, { data, loading, error }] = useSendTestSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useSendTestSurveyMutation(baseOptions?: Apollo.MutationHookOptions<SendTestSurveyMutation, SendTestSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestSurveyMutation, SendTestSurveyMutationVariables>(SendTestSurveyDocument, options);
      }
export type SendTestSurveyMutationHookResult = ReturnType<typeof useSendTestSurveyMutation>;
export type SendTestSurveyMutationResult = Apollo.MutationResult<SendTestSurveyMutation>;
export type SendTestSurveyMutationOptions = Apollo.BaseMutationOptions<SendTestSurveyMutation, SendTestSurveyMutationVariables>;
export const SetNewPasswordWithTokenDocument = gql`
    mutation setNewPasswordWithToken($token: String!, $password: String!) {
  setNewPasswordWithToken(token: $token, password: $password) {
    result
  }
}
    `;
export type SetNewPasswordWithTokenMutationFn = Apollo.MutationFunction<SetNewPasswordWithTokenMutation, SetNewPasswordWithTokenMutationVariables>;

/**
 * __useSetNewPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useSetNewPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPasswordWithTokenMutation, { data, loading, error }] = useSetNewPasswordWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSetNewPasswordWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetNewPasswordWithTokenMutation, SetNewPasswordWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetNewPasswordWithTokenMutation, SetNewPasswordWithTokenMutationVariables>(SetNewPasswordWithTokenDocument, options);
      }
export type SetNewPasswordWithTokenMutationHookResult = ReturnType<typeof useSetNewPasswordWithTokenMutation>;
export type SetNewPasswordWithTokenMutationResult = Apollo.MutationResult<SetNewPasswordWithTokenMutation>;
export type SetNewPasswordWithTokenMutationOptions = Apollo.BaseMutationOptions<SetNewPasswordWithTokenMutation, SetNewPasswordWithTokenMutationVariables>;
export const SetOpenSurveyAccessCodeDocument = gql`
    mutation setOpenSurveyAccessCode($surveyId: Int!, $accessCode: String!) {
  setOpenSurveyAccessCode(surveyId: $surveyId, accessCode: $accessCode) {
    id
    openSurveyAccessCode
  }
}
    `;
export type SetOpenSurveyAccessCodeMutationFn = Apollo.MutationFunction<SetOpenSurveyAccessCodeMutation, SetOpenSurveyAccessCodeMutationVariables>;

/**
 * __useSetOpenSurveyAccessCodeMutation__
 *
 * To run a mutation, you first call `useSetOpenSurveyAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOpenSurveyAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOpenSurveyAccessCodeMutation, { data, loading, error }] = useSetOpenSurveyAccessCodeMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useSetOpenSurveyAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<SetOpenSurveyAccessCodeMutation, SetOpenSurveyAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOpenSurveyAccessCodeMutation, SetOpenSurveyAccessCodeMutationVariables>(SetOpenSurveyAccessCodeDocument, options);
      }
export type SetOpenSurveyAccessCodeMutationHookResult = ReturnType<typeof useSetOpenSurveyAccessCodeMutation>;
export type SetOpenSurveyAccessCodeMutationResult = Apollo.MutationResult<SetOpenSurveyAccessCodeMutation>;
export type SetOpenSurveyAccessCodeMutationOptions = Apollo.BaseMutationOptions<SetOpenSurveyAccessCodeMutation, SetOpenSurveyAccessCodeMutationVariables>;
export const SetRehireAttributeDocument = gql`
    mutation SetRehireAttribute($companyId: Int!, $attributeId: Int!) {
  setRehireAttribute(companyId: $companyId, attributeId: $attributeId)
}
    `;
export type SetRehireAttributeMutationFn = Apollo.MutationFunction<SetRehireAttributeMutation, SetRehireAttributeMutationVariables>;

/**
 * __useSetRehireAttributeMutation__
 *
 * To run a mutation, you first call `useSetRehireAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRehireAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRehireAttributeMutation, { data, loading, error }] = useSetRehireAttributeMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useSetRehireAttributeMutation(baseOptions?: Apollo.MutationHookOptions<SetRehireAttributeMutation, SetRehireAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRehireAttributeMutation, SetRehireAttributeMutationVariables>(SetRehireAttributeDocument, options);
      }
export type SetRehireAttributeMutationHookResult = ReturnType<typeof useSetRehireAttributeMutation>;
export type SetRehireAttributeMutationResult = Apollo.MutationResult<SetRehireAttributeMutation>;
export type SetRehireAttributeMutationOptions = Apollo.BaseMutationOptions<SetRehireAttributeMutation, SetRehireAttributeMutationVariables>;
export const SlackOAuthAuthorizeUrlDocument = gql`
    query slackOAuthAuthorizeUrl {
  slackOAuthAuthorizeUrl
}
    `;

/**
 * __useSlackOAuthAuthorizeUrlQuery__
 *
 * To run a query within a React component, call `useSlackOAuthAuthorizeUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackOAuthAuthorizeUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackOAuthAuthorizeUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useSlackOAuthAuthorizeUrlQuery(baseOptions?: Apollo.QueryHookOptions<SlackOAuthAuthorizeUrlQuery, SlackOAuthAuthorizeUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlackOAuthAuthorizeUrlQuery, SlackOAuthAuthorizeUrlQueryVariables>(SlackOAuthAuthorizeUrlDocument, options);
      }
export function useSlackOAuthAuthorizeUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlackOAuthAuthorizeUrlQuery, SlackOAuthAuthorizeUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlackOAuthAuthorizeUrlQuery, SlackOAuthAuthorizeUrlQueryVariables>(SlackOAuthAuthorizeUrlDocument, options);
        }
export type SlackOAuthAuthorizeUrlQueryHookResult = ReturnType<typeof useSlackOAuthAuthorizeUrlQuery>;
export type SlackOAuthAuthorizeUrlLazyQueryHookResult = ReturnType<typeof useSlackOAuthAuthorizeUrlLazyQuery>;
export type SlackOAuthAuthorizeUrlQueryResult = Apollo.QueryResult<SlackOAuthAuthorizeUrlQuery, SlackOAuthAuthorizeUrlQueryVariables>;
export const SwitchCompanyDocument = gql`
    mutation switchCompany($companyId: Int!) {
  switchAccount(companyId: $companyId) {
    token
  }
}
    `;
export type SwitchCompanyMutationFn = Apollo.MutationFunction<SwitchCompanyMutation, SwitchCompanyMutationVariables>;

/**
 * __useSwitchCompanyMutation__
 *
 * To run a mutation, you first call `useSwitchCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchCompanyMutation, { data, loading, error }] = useSwitchCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSwitchCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SwitchCompanyMutation, SwitchCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchCompanyMutation, SwitchCompanyMutationVariables>(SwitchCompanyDocument, options);
      }
export type SwitchCompanyMutationHookResult = ReturnType<typeof useSwitchCompanyMutation>;
export type SwitchCompanyMutationResult = Apollo.MutationResult<SwitchCompanyMutation>;
export type SwitchCompanyMutationOptions = Apollo.BaseMutationOptions<SwitchCompanyMutation, SwitchCompanyMutationVariables>;
export const TrendingLinkCandidatesDocument = gql`
    query trendingLinkCandidates($surveyIds: [Int!]!) {
  trendingLinkCandidates(surveyIds: $surveyIds) {
    questionText
    questionType
    perSurvey {
      surveyId
      surveyElementId
      questionId
    }
    validation {
      ok
      reason
    }
    externalSurveys {
      surveyId
      surveyName
      created
    }
    languageWarning {
      surveyId
      missingLanguageCodes
    }
  }
}
    `;

/**
 * __useTrendingLinkCandidatesQuery__
 *
 * To run a query within a React component, call `useTrendingLinkCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingLinkCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingLinkCandidatesQuery({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *   },
 * });
 */
export function useTrendingLinkCandidatesQuery(baseOptions: Apollo.QueryHookOptions<TrendingLinkCandidatesQuery, TrendingLinkCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrendingLinkCandidatesQuery, TrendingLinkCandidatesQueryVariables>(TrendingLinkCandidatesDocument, options);
      }
export function useTrendingLinkCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrendingLinkCandidatesQuery, TrendingLinkCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrendingLinkCandidatesQuery, TrendingLinkCandidatesQueryVariables>(TrendingLinkCandidatesDocument, options);
        }
export type TrendingLinkCandidatesQueryHookResult = ReturnType<typeof useTrendingLinkCandidatesQuery>;
export type TrendingLinkCandidatesLazyQueryHookResult = ReturnType<typeof useTrendingLinkCandidatesLazyQuery>;
export type TrendingLinkCandidatesQueryResult = Apollo.QueryResult<TrendingLinkCandidatesQuery, TrendingLinkCandidatesQueryVariables>;
export const TriggerCronjobDocument = gql`
    mutation triggerCronjob($name: String!) {
  triggerCronjob(name: $name) {
    name
    success
    durationMs
    error
    logs
  }
}
    `;
export type TriggerCronjobMutationFn = Apollo.MutationFunction<TriggerCronjobMutation, TriggerCronjobMutationVariables>;

/**
 * __useTriggerCronjobMutation__
 *
 * To run a mutation, you first call `useTriggerCronjobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerCronjobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerCronjobMutation, { data, loading, error }] = useTriggerCronjobMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTriggerCronjobMutation(baseOptions?: Apollo.MutationHookOptions<TriggerCronjobMutation, TriggerCronjobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerCronjobMutation, TriggerCronjobMutationVariables>(TriggerCronjobDocument, options);
      }
export type TriggerCronjobMutationHookResult = ReturnType<typeof useTriggerCronjobMutation>;
export type TriggerCronjobMutationResult = Apollo.MutationResult<TriggerCronjobMutation>;
export type TriggerCronjobMutationOptions = Apollo.BaseMutationOptions<TriggerCronjobMutation, TriggerCronjobMutationVariables>;
export const UpdateAutomaticSurveyReminderDocument = gql`
    mutation updateAutomaticSurveyReminder($automaticSurveyReminder: AutomaticSurveyReminderInput) {
  updateAutomaticSurveyReminder(automaticSurveyReminder: $automaticSurveyReminder) {
    id
    surveyId
    reminderFrequencyDays
    status
    automaticSurveyReminderLanguages {
      languageId
      emailSubject
      emailBody
    }
  }
}
    `;
export type UpdateAutomaticSurveyReminderMutationFn = Apollo.MutationFunction<UpdateAutomaticSurveyReminderMutation, UpdateAutomaticSurveyReminderMutationVariables>;

/**
 * __useUpdateAutomaticSurveyReminderMutation__
 *
 * To run a mutation, you first call `useUpdateAutomaticSurveyReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomaticSurveyReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomaticSurveyReminderMutation, { data, loading, error }] = useUpdateAutomaticSurveyReminderMutation({
 *   variables: {
 *      automaticSurveyReminder: // value for 'automaticSurveyReminder'
 *   },
 * });
 */
export function useUpdateAutomaticSurveyReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomaticSurveyReminderMutation, UpdateAutomaticSurveyReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomaticSurveyReminderMutation, UpdateAutomaticSurveyReminderMutationVariables>(UpdateAutomaticSurveyReminderDocument, options);
      }
export type UpdateAutomaticSurveyReminderMutationHookResult = ReturnType<typeof useUpdateAutomaticSurveyReminderMutation>;
export type UpdateAutomaticSurveyReminderMutationResult = Apollo.MutationResult<UpdateAutomaticSurveyReminderMutation>;
export type UpdateAutomaticSurveyReminderMutationOptions = Apollo.BaseMutationOptions<UpdateAutomaticSurveyReminderMutation, UpdateAutomaticSurveyReminderMutationVariables>;
export const UpdateCompanyDefaultAttributeValueDocument = gql`
    mutation updateCompanyDefaultAttributeValue($companyId: Int!, $benchmarkAttributeValueId: Int!, $ungroupedValue: String) {
  updateCompanyBenchmarkAttributeValue(
    companyId: $companyId
    benchmarkAttributeValueId: $benchmarkAttributeValueId
    ungroupedValue: $ungroupedValue
  ) {
    id
    benchmarkAttributeId
    benchmarkAttributeValueId
    name
    ungroupedValue
  }
}
    `;
export type UpdateCompanyDefaultAttributeValueMutationFn = Apollo.MutationFunction<UpdateCompanyDefaultAttributeValueMutation, UpdateCompanyDefaultAttributeValueMutationVariables>;

/**
 * __useUpdateCompanyDefaultAttributeValueMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyDefaultAttributeValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyDefaultAttributeValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyDefaultAttributeValueMutation, { data, loading, error }] = useUpdateCompanyDefaultAttributeValueMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      benchmarkAttributeValueId: // value for 'benchmarkAttributeValueId'
 *      ungroupedValue: // value for 'ungroupedValue'
 *   },
 * });
 */
export function useUpdateCompanyDefaultAttributeValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyDefaultAttributeValueMutation, UpdateCompanyDefaultAttributeValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyDefaultAttributeValueMutation, UpdateCompanyDefaultAttributeValueMutationVariables>(UpdateCompanyDefaultAttributeValueDocument, options);
      }
export type UpdateCompanyDefaultAttributeValueMutationHookResult = ReturnType<typeof useUpdateCompanyDefaultAttributeValueMutation>;
export type UpdateCompanyDefaultAttributeValueMutationResult = Apollo.MutationResult<UpdateCompanyDefaultAttributeValueMutation>;
export type UpdateCompanyDefaultAttributeValueMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyDefaultAttributeValueMutation, UpdateCompanyDefaultAttributeValueMutationVariables>;
export const UpdateCompanyEmployeeIdsDocument = gql`
    mutation updateCompanyEmployeeIds($companyId: Int!, $updateEmployeeIdInput: [UpdateEmployeeIds!]!) {
  updateCompanyEmployeeIds(
    companyId: $companyId
    updateEmployeeIdInput: $updateEmployeeIdInput
  ) {
    status
    error {
      message
      translationKey
      failedId
    }
  }
}
    `;
export type UpdateCompanyEmployeeIdsMutationFn = Apollo.MutationFunction<UpdateCompanyEmployeeIdsMutation, UpdateCompanyEmployeeIdsMutationVariables>;

/**
 * __useUpdateCompanyEmployeeIdsMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyEmployeeIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyEmployeeIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyEmployeeIdsMutation, { data, loading, error }] = useUpdateCompanyEmployeeIdsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      updateEmployeeIdInput: // value for 'updateEmployeeIdInput'
 *   },
 * });
 */
export function useUpdateCompanyEmployeeIdsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyEmployeeIdsMutation, UpdateCompanyEmployeeIdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyEmployeeIdsMutation, UpdateCompanyEmployeeIdsMutationVariables>(UpdateCompanyEmployeeIdsDocument, options);
      }
export type UpdateCompanyEmployeeIdsMutationHookResult = ReturnType<typeof useUpdateCompanyEmployeeIdsMutation>;
export type UpdateCompanyEmployeeIdsMutationResult = Apollo.MutationResult<UpdateCompanyEmployeeIdsMutation>;
export type UpdateCompanyEmployeeIdsMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyEmployeeIdsMutation, UpdateCompanyEmployeeIdsMutationVariables>;
export const UpdateCompanyMessagingConfigDocument = gql`
    mutation updateCompanyMessagingConfig($input: UpdateCompanyMessagingConfigInput!) {
  updateCompanyMessagingConfig(input: $input) {
    companyId
    channel
    enabled
    isConnected
    created
    updated
  }
}
    `;
export type UpdateCompanyMessagingConfigMutationFn = Apollo.MutationFunction<UpdateCompanyMessagingConfigMutation, UpdateCompanyMessagingConfigMutationVariables>;

/**
 * __useUpdateCompanyMessagingConfigMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMessagingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMessagingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMessagingConfigMutation, { data, loading, error }] = useUpdateCompanyMessagingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMessagingConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMessagingConfigMutation, UpdateCompanyMessagingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMessagingConfigMutation, UpdateCompanyMessagingConfigMutationVariables>(UpdateCompanyMessagingConfigDocument, options);
      }
export type UpdateCompanyMessagingConfigMutationHookResult = ReturnType<typeof useUpdateCompanyMessagingConfigMutation>;
export type UpdateCompanyMessagingConfigMutationResult = Apollo.MutationResult<UpdateCompanyMessagingConfigMutation>;
export type UpdateCompanyMessagingConfigMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMessagingConfigMutation, UpdateCompanyMessagingConfigMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($employeeId: Int!, $companyId: Int!, $employee: EmployeeEditInput!) {
  updateEmployee(
    employeeId: $employeeId
    companyId: $companyId
    employee: $employee
  ) {
    id
    languageId
    enabled
    attributesWithValues {
      attribute {
        id
        attributeNames {
          id
          name
          language {
            id
            langISOCode
          }
        }
      }
      attributeValues
    }
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      companyId: // value for 'companyId'
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateEmployeeAttributeDocument = gql`
    mutation updateEmployeeAttribute($employeeAttributeId: Int!, $companyId: Int!, $attribute: AttributeUpdateInput!) {
  updateAttribute(
    id: $employeeAttributeId
    companyId: $companyId
    attribute: $attribute
  ) {
    ...employeeAttributeFields
  }
}
    ${EmployeeAttributeFieldsFragmentDoc}`;
export type UpdateEmployeeAttributeMutationFn = Apollo.MutationFunction<UpdateEmployeeAttributeMutation, UpdateEmployeeAttributeMutationVariables>;

/**
 * __useUpdateEmployeeAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeAttributeMutation, { data, loading, error }] = useUpdateEmployeeAttributeMutation({
 *   variables: {
 *      employeeAttributeId: // value for 'employeeAttributeId'
 *      companyId: // value for 'companyId'
 *      attribute: // value for 'attribute'
 *   },
 * });
 */
export function useUpdateEmployeeAttributeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeAttributeMutation, UpdateEmployeeAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeAttributeMutation, UpdateEmployeeAttributeMutationVariables>(UpdateEmployeeAttributeDocument, options);
      }
export type UpdateEmployeeAttributeMutationHookResult = ReturnType<typeof useUpdateEmployeeAttributeMutation>;
export type UpdateEmployeeAttributeMutationResult = Apollo.MutationResult<UpdateEmployeeAttributeMutation>;
export type UpdateEmployeeAttributeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeAttributeMutation, UpdateEmployeeAttributeMutationVariables>;
export const UpdateLifecycleSurveyRecipientsDocument = gql`
    mutation UpdateLifecycleSurveyRecipients($lifecycleSurveyRecipients: [InputLifecycleSurveyRecipients!]!) {
  updateLifecycleSurveyRecipients(
    lifecycleSurveyRecipients: $lifecycleSurveyRecipients
  ) {
    success
    message
  }
}
    `;
export type UpdateLifecycleSurveyRecipientsMutationFn = Apollo.MutationFunction<UpdateLifecycleSurveyRecipientsMutation, UpdateLifecycleSurveyRecipientsMutationVariables>;

/**
 * __useUpdateLifecycleSurveyRecipientsMutation__
 *
 * To run a mutation, you first call `useUpdateLifecycleSurveyRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLifecycleSurveyRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLifecycleSurveyRecipientsMutation, { data, loading, error }] = useUpdateLifecycleSurveyRecipientsMutation({
 *   variables: {
 *      lifecycleSurveyRecipients: // value for 'lifecycleSurveyRecipients'
 *   },
 * });
 */
export function useUpdateLifecycleSurveyRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLifecycleSurveyRecipientsMutation, UpdateLifecycleSurveyRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLifecycleSurveyRecipientsMutation, UpdateLifecycleSurveyRecipientsMutationVariables>(UpdateLifecycleSurveyRecipientsDocument, options);
      }
export type UpdateLifecycleSurveyRecipientsMutationHookResult = ReturnType<typeof useUpdateLifecycleSurveyRecipientsMutation>;
export type UpdateLifecycleSurveyRecipientsMutationResult = Apollo.MutationResult<UpdateLifecycleSurveyRecipientsMutation>;
export type UpdateLifecycleSurveyRecipientsMutationOptions = Apollo.BaseMutationOptions<UpdateLifecycleSurveyRecipientsMutation, UpdateLifecycleSurveyRecipientsMutationVariables>;
export const UpdateReactionsDocument = gql`
    mutation updateReactions($conversationReaction: ConversationReactionInput!) {
  updateConversationReaction(conversationReaction: $conversationReaction) {
    like
    greatIdea
    workingOnIt
    conversation {
      id
    }
  }
}
    `;
export type UpdateReactionsMutationFn = Apollo.MutationFunction<UpdateReactionsMutation, UpdateReactionsMutationVariables>;

/**
 * __useUpdateReactionsMutation__
 *
 * To run a mutation, you first call `useUpdateReactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReactionsMutation, { data, loading, error }] = useUpdateReactionsMutation({
 *   variables: {
 *      conversationReaction: // value for 'conversationReaction'
 *   },
 * });
 */
export function useUpdateReactionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReactionsMutation, UpdateReactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReactionsMutation, UpdateReactionsMutationVariables>(UpdateReactionsDocument, options);
      }
export type UpdateReactionsMutationHookResult = ReturnType<typeof useUpdateReactionsMutation>;
export type UpdateReactionsMutationResult = Apollo.MutationResult<UpdateReactionsMutation>;
export type UpdateReactionsMutationOptions = Apollo.BaseMutationOptions<UpdateReactionsMutation, UpdateReactionsMutationVariables>;
export const UpdateRecipientListDocument = gql`
    mutation updateRecipientList($surveyId: Int!, $employeeIds: [Int]!) {
  updateRecipientList(surveyId: $surveyId, employeeIds: $employeeIds) {
    employees {
      id
      surveyInviteDate
      addedDate
    }
  }
}
    `;
export type UpdateRecipientListMutationFn = Apollo.MutationFunction<UpdateRecipientListMutation, UpdateRecipientListMutationVariables>;

/**
 * __useUpdateRecipientListMutation__
 *
 * To run a mutation, you first call `useUpdateRecipientListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecipientListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecipientListMutation, { data, loading, error }] = useUpdateRecipientListMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useUpdateRecipientListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecipientListMutation, UpdateRecipientListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecipientListMutation, UpdateRecipientListMutationVariables>(UpdateRecipientListDocument, options);
      }
export type UpdateRecipientListMutationHookResult = ReturnType<typeof useUpdateRecipientListMutation>;
export type UpdateRecipientListMutationResult = Apollo.MutationResult<UpdateRecipientListMutation>;
export type UpdateRecipientListMutationOptions = Apollo.BaseMutationOptions<UpdateRecipientListMutation, UpdateRecipientListMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation updateSurvey($id: Int!, $survey: SurveyUpdateInput!) {
  updateSurvey(id: $id, survey: $survey) {
    id
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      survey: // value for 'survey'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const UpdateSurveyElementDocument = gql`
    mutation UpdateSurveyElement($surveyId: Int, $surveyElement: SurveyElementUpdateInput!) {
  updateSurveyElement(surveyId: $surveyId, surveyElement: $surveyElement) {
    id
    companyId
    orderIndex
    isLibraryQuestion
    isPreviousQuestion
    isBenchmarkedQuestion
    type {
      name
    }
    showSkipButton
    isAttributeBased
    hideReporting
    isFilterable
    attributes {
      attributeId
      attributeValue
    }
    discontinuedDateUTC(surveyId: $surveyId)
    addedDateUTC(surveyId: $surveyId)
    isDiscontinued(surveyId: $surveyId)
    question {
      ... on SurveyElementQuestionOptions {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
        category {
          id
          categoryNames {
            name
          }
        }
        required
        showDescription
        choices {
          id
          orderIndex
          messagesPerLanguage {
            language {
              id
            }
            message
          }
        }
        minSelectedOption
        maxSelectedOption
        showTextComment
      }
      ... on SurveyElementQuestionScale {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
          labelBefore
          labelAfter
        }
        category {
          id
          categoryNames {
            name
          }
        }
        icon {
          id
          name
        }
        ratingOptionLowest
        ratingOptionHighest
        required
        showDescription
        showTextComment
        showLabels
      }
      ... on SurveyElementQuestionText {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
        category {
          id
        }
        required
        showDescription
      }
      ... on SurveyElementMessage {
        messagesPerLanguage {
          language {
            id
            langISOCode
          }
          message
          description
        }
      }
    }
  }
}
    `;
export type UpdateSurveyElementMutationFn = Apollo.MutationFunction<UpdateSurveyElementMutation, UpdateSurveyElementMutationVariables>;

/**
 * __useUpdateSurveyElementMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyElementMutation, { data, loading, error }] = useUpdateSurveyElementMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      surveyElement: // value for 'surveyElement'
 *   },
 * });
 */
export function useUpdateSurveyElementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyElementMutation, UpdateSurveyElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyElementMutation, UpdateSurveyElementMutationVariables>(UpdateSurveyElementDocument, options);
      }
export type UpdateSurveyElementMutationHookResult = ReturnType<typeof useUpdateSurveyElementMutation>;
export type UpdateSurveyElementMutationResult = Apollo.MutationResult<UpdateSurveyElementMutation>;
export type UpdateSurveyElementMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyElementMutation, UpdateSurveyElementMutationVariables>;
export const UpdateSurveyTemplateDocument = gql`
    mutation updateSurveyTemplate($id: Int!, $names: [InputSurveyTemplateNames], $surveyElements: [InputSurveyElement], $status: String, $email: InputSurveyTemplateEmail, $audienceMode: String, $lifecycleSurveyTypeId: Int) {
  updateSurveyTemplate(
    id: $id
    names: $names
    surveyElements: $surveyElements
    status: $status
    email: $email
    audienceMode: $audienceMode
    lifecycleSurveyTypeId: $lifecycleSurveyTypeId
  ) {
    id
    names {
      name
      languageId
    }
    surveyTypeId
    audienceMode
    lifecycleSurveyTypeId
    surveyType {
      id
      name
      names {
        languageId
        name
      }
    }
    surveyElements {
      id
      orderIndex
      isLibraryQuestion
      isPreviousQuestion
      isBenchmarkedQuestion
      type {
        name
      }
      showSkipButton
      isAttributeBased
      hideReporting
      attributes {
        attributeId
        attributeValue
      }
      question {
        ... on SurveyElementQuestionOptions {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
            categoryNames {
              name
            }
          }
          required
          showDescription
          choices {
            id
            messagesPerLanguage {
              language {
                id
              }
              message
            }
          }
          minSelectedOption
          maxSelectedOption
          showTextComment
        }
        ... on SurveyElementQuestionScale {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
            labelBefore
            labelAfter
          }
          category {
            id
            categoryNames {
              name
            }
          }
          icon {
            id
            name
          }
          ratingOptionLowest
          ratingOptionHighest
          required
          showDescription
          showTextComment
          showLabels
        }
        ... on SurveyElementQuestionText {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
          category {
            id
          }
          required
          showDescription
        }
        ... on SurveyElementMessage {
          id
          messagesPerLanguage {
            language {
              id
              langISOCode
            }
            message
            description
          }
        }
      }
    }
    status
    updated
    surveyTemplateLanguages {
      languageId
      emailContent
      emailSubject
    }
  }
}
    `;
export type UpdateSurveyTemplateMutationFn = Apollo.MutationFunction<UpdateSurveyTemplateMutation, UpdateSurveyTemplateMutationVariables>;

/**
 * __useUpdateSurveyTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyTemplateMutation, { data, loading, error }] = useUpdateSurveyTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      names: // value for 'names'
 *      surveyElements: // value for 'surveyElements'
 *      status: // value for 'status'
 *      email: // value for 'email'
 *      audienceMode: // value for 'audienceMode'
 *      lifecycleSurveyTypeId: // value for 'lifecycleSurveyTypeId'
 *   },
 * });
 */
export function useUpdateSurveyTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyTemplateMutation, UpdateSurveyTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyTemplateMutation, UpdateSurveyTemplateMutationVariables>(UpdateSurveyTemplateDocument, options);
      }
export type UpdateSurveyTemplateMutationHookResult = ReturnType<typeof useUpdateSurveyTemplateMutation>;
export type UpdateSurveyTemplateMutationResult = Apollo.MutationResult<UpdateSurveyTemplateMutation>;
export type UpdateSurveyTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyTemplateMutation, UpdateSurveyTemplateMutationVariables>;
export const UpdateSurveyTemplateStatusDocument = gql`
    mutation updateSurveyTemplateStatus($templateId: Int!, $newStatus: SurveyTemplateStatus!) {
  updateSurveyTemplateStatus(templateId: $templateId, newStatus: $newStatus) {
    success
    updated
  }
}
    `;
export type UpdateSurveyTemplateStatusMutationFn = Apollo.MutationFunction<UpdateSurveyTemplateStatusMutation, UpdateSurveyTemplateStatusMutationVariables>;

/**
 * __useUpdateSurveyTemplateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyTemplateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyTemplateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyTemplateStatusMutation, { data, loading, error }] = useUpdateSurveyTemplateStatusMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateSurveyTemplateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyTemplateStatusMutation, UpdateSurveyTemplateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyTemplateStatusMutation, UpdateSurveyTemplateStatusMutationVariables>(UpdateSurveyTemplateStatusDocument, options);
      }
export type UpdateSurveyTemplateStatusMutationHookResult = ReturnType<typeof useUpdateSurveyTemplateStatusMutation>;
export type UpdateSurveyTemplateStatusMutationResult = Apollo.MutationResult<UpdateSurveyTemplateStatusMutation>;
export type UpdateSurveyTemplateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyTemplateStatusMutation, UpdateSurveyTemplateStatusMutationVariables>;
export const UpsertLifecycleSurveyTriggerDocument = gql`
    mutation upsertLifecycleSurveyTrigger($lifecycleSurveyTrigger: InputLifecycleSurveyTrigger!) {
  upsertLifecycleSurveyTrigger(lifecycleSurveyTrigger: $lifecycleSurveyTrigger) {
    id
    lifecycleSurveyTypeId
    surveyId
    triggerAttributeId
    audienceType
    invitationOffsetDays
    requireAdminApproval
    timeOfDayStartUTC
    timeOfDayEndUTC
    status
    languages {
      languageId
      name
    }
    attributeAudience {
      attributeId
      attributeValue
    }
    adminApprovers {
      userId
    }
    superAdminApprovers {
      userId
    }
  }
}
    `;
export type UpsertLifecycleSurveyTriggerMutationFn = Apollo.MutationFunction<UpsertLifecycleSurveyTriggerMutation, UpsertLifecycleSurveyTriggerMutationVariables>;

/**
 * __useUpsertLifecycleSurveyTriggerMutation__
 *
 * To run a mutation, you first call `useUpsertLifecycleSurveyTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLifecycleSurveyTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLifecycleSurveyTriggerMutation, { data, loading, error }] = useUpsertLifecycleSurveyTriggerMutation({
 *   variables: {
 *      lifecycleSurveyTrigger: // value for 'lifecycleSurveyTrigger'
 *   },
 * });
 */
export function useUpsertLifecycleSurveyTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLifecycleSurveyTriggerMutation, UpsertLifecycleSurveyTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLifecycleSurveyTriggerMutation, UpsertLifecycleSurveyTriggerMutationVariables>(UpsertLifecycleSurveyTriggerDocument, options);
      }
export type UpsertLifecycleSurveyTriggerMutationHookResult = ReturnType<typeof useUpsertLifecycleSurveyTriggerMutation>;
export type UpsertLifecycleSurveyTriggerMutationResult = Apollo.MutationResult<UpsertLifecycleSurveyTriggerMutation>;
export type UpsertLifecycleSurveyTriggerMutationOptions = Apollo.BaseMutationOptions<UpsertLifecycleSurveyTriggerMutation, UpsertLifecycleSurveyTriggerMutationVariables>;
export const UpsertLifecycleSurveyTriggerTypesDocument = gql`
    mutation upsertLifecycleSurveyTriggerTypes($lifecycleSurveyTriggerTypes: [InputLifecycleSurveyTriggerType!]!) {
  upsertLifecycleSurveyTriggerTypes(
    lifecycleSurveyTriggerTypes: $lifecycleSurveyTriggerTypes
  ) {
    id
    type
    isEnabled
  }
}
    `;
export type UpsertLifecycleSurveyTriggerTypesMutationFn = Apollo.MutationFunction<UpsertLifecycleSurveyTriggerTypesMutation, UpsertLifecycleSurveyTriggerTypesMutationVariables>;

/**
 * __useUpsertLifecycleSurveyTriggerTypesMutation__
 *
 * To run a mutation, you first call `useUpsertLifecycleSurveyTriggerTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLifecycleSurveyTriggerTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLifecycleSurveyTriggerTypesMutation, { data, loading, error }] = useUpsertLifecycleSurveyTriggerTypesMutation({
 *   variables: {
 *      lifecycleSurveyTriggerTypes: // value for 'lifecycleSurveyTriggerTypes'
 *   },
 * });
 */
export function useUpsertLifecycleSurveyTriggerTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLifecycleSurveyTriggerTypesMutation, UpsertLifecycleSurveyTriggerTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLifecycleSurveyTriggerTypesMutation, UpsertLifecycleSurveyTriggerTypesMutationVariables>(UpsertLifecycleSurveyTriggerTypesDocument, options);
      }
export type UpsertLifecycleSurveyTriggerTypesMutationHookResult = ReturnType<typeof useUpsertLifecycleSurveyTriggerTypesMutation>;
export type UpsertLifecycleSurveyTriggerTypesMutationResult = Apollo.MutationResult<UpsertLifecycleSurveyTriggerTypesMutation>;
export type UpsertLifecycleSurveyTriggerTypesMutationOptions = Apollo.BaseMutationOptions<UpsertLifecycleSurveyTriggerTypesMutation, UpsertLifecycleSurveyTriggerTypesMutationVariables>;
export const UpsertSurveyMessagingDocument = gql`
    mutation upsertSurveyMessaging($input: UpsertSurveyMessagingInput!) {
  upsertSurveyMessaging(input: $input) {
    surveyId
    channel
    enabled
    smsAttributeId
    variationKey
  }
}
    `;
export type UpsertSurveyMessagingMutationFn = Apollo.MutationFunction<UpsertSurveyMessagingMutation, UpsertSurveyMessagingMutationVariables>;

/**
 * __useUpsertSurveyMessagingMutation__
 *
 * To run a mutation, you first call `useUpsertSurveyMessagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSurveyMessagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSurveyMessagingMutation, { data, loading, error }] = useUpsertSurveyMessagingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSurveyMessagingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSurveyMessagingMutation, UpsertSurveyMessagingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSurveyMessagingMutation, UpsertSurveyMessagingMutationVariables>(UpsertSurveyMessagingDocument, options);
      }
export type UpsertSurveyMessagingMutationHookResult = ReturnType<typeof useUpsertSurveyMessagingMutation>;
export type UpsertSurveyMessagingMutationResult = Apollo.MutationResult<UpsertSurveyMessagingMutation>;
export type UpsertSurveyMessagingMutationOptions = Apollo.BaseMutationOptions<UpsertSurveyMessagingMutation, UpsertSurveyMessagingMutationVariables>;